(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as ZF, getPartnerDevApiHeaders as eI, WidgetContextProvider as nI, makeExecuteQuery as tI, makeUseLazyQuery as rI, makeUseQuery as iI, makeUseMutation as aI, useWidgetSettingsMutations as dr, useWidgetSettingsQuery as ur, useRenderConditions as mr, PartnerSettingsWrapper as pr, handleWidgetSubmit as fr, MisconfigurationBanner as hr, validateApiHostName as bl, PartnerHookFormSecretText as Er, WidgetSettingsFormFooter as yr, useTracking as Fn, useWidgetContext as yn, hasDownstreamApiForbiddenError as xl, hasDownstreamApiAuthorizationError as _l, DisplayErrors as Tn, settingsToFormValues as Sl, useCopyWithDelay as Qt, defaultDateFormat as jt, displayAttributeValue as Li, OAuthSettings as hi, useData as fy, isDownstreamApiNotFoundError as oI, isDownstreamApiAuthorizationError as pw, isDownstreamApiPermissionError as sI, capitalizeFirstCharacter as fw, humanizeKey as lI, hasDownstreamApiTooManyRequestsError as cI, hasDownstreamApiPermissionError as hw, PartnerHookFormBasicAuth as dI, hasDownstreamApiNotFoundError as ba, getCountryNameFromCountryCode as uI, parseBoolean as mI, parseString as pI, IntegrationModal as yw, useInboundOAuthContext as fI, getWidgetConfigurationByIdQuery as hI, createWidgetConfigurationMutation as yI, updateWidgetConfigurationMutation as gI, trackRenderConditionsSaved as vI, deleteWidgetConfigurationMutation as kI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Yn, useState as de, useEffect as Qe, useRef as ri, useCallback as yt, useReducer as bI, useLayoutEffect as xI, useContext as hy, isValidElement as gw, Fragment as vw, createContext as kw, createElement as _I } from "react";
import { FlexBox as b, Switch as Io, FieldLabel as bw, FieldWrapper as He, InputText as cr, InputSelectionList as ni, FormGrid as nt, FormField as Z, Text as $, Spinner as hn, Icon as ye, Tooltip as Ze, List as Xe, Badge as Bn, Button as et, IconButton as ir, Tag as Qn, NavigationButton as Lt, Select as $r, CollapseCard as xr, Box as lt, Modal as wt, ModalHead as Ct, ModalBody as Ft, ModalFoot as Et, Textarea as Nh, TagsInput as Nl, Image as xa, Banner as jl, FieldSwitch as wl, SelectionList as ut, Divider as Cl, FieldText as tr, FieldTextarea as SI, CopyToClipboardButton as NI, getSelectionListContext as jI, Avatar as yy, Timestamp as wI, Attachment as CI, EmptyState as Eo, Table as ot, Checkbox as Xg, TextWithHighlight as xw, ErrorBoundaryContext as _w } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as gy, Observable as Sw, ApolloClient as FI, InMemoryCache as II, createHttpLink as EI, ApolloProvider as $I, useApolloClient as TI, ApolloConsumer as DI, NetworkStatus as rr, isApolloError as Nw, gql as Fl, ApolloError as jw, useQuery as OI, useMutation as Zg } from "@apollo/client";
import RI from "cross-fetch";
import { config as $o } from "lib-shared-backend-config";
import Jn from "moment";
import "moment-timezone";
import { __rest as PI, __assign as ec } from "tslib";
import { useLocation as AI } from "react-router-dom";
function vy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xo = { exports: {} }, Oa = {};
var ev;
function LI() {
  if (ev) return Oa;
  ev = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Oa.Fragment = r, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var Ra = {};
var nv;
function VI() {
  return nv || (nv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c, E));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ra.Fragment = i, Ra.jsx = Un, Ra.jsxs = Kn;
  })()), Ra;
}
var tv;
function zI() {
  return tv || (tv = 1, process.env.NODE_ENV === "production" ? Xo.exports = LI() : Xo.exports = VI()), Xo.exports;
}
var Ke = zI();
function ww(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: UI } = Object.prototype, { getPrototypeOf: fa } = Object, { iterator: Po, toStringTag: Cw } = Symbol, Qs = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), To = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), Qs(r, n))
      return !0;
    r = fa(r);
  }
  return !1;
}, MI = (e, n) => e != null && To(e, n) ? e[n] : void 0, ky = /* @__PURE__ */ ((e) => (n) => {
  const r = UI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Tr = (e) => (e = e.toLowerCase(), (n) => ky(n) === e), Il = (e) => (n) => typeof n === e, { isArray: Vi } = Array, ha = Il("undefined");
function _a(e) {
  return e !== null && !ha(e) && e.constructor !== null && !ha(e.constructor) && er(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Fw = Tr("ArrayBuffer");
function BI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Fw(e.buffer), n;
}
const qI = Il("string"), er = Il("function"), Iw = Il("number"), Sa = (e) => e !== null && typeof e == "object", HI = (e) => e === !0 || e === !1, Os = (e) => {
  if (!Sa(e))
    return !1;
  const n = fa(e);
  return (n === null || n === Object.prototype || fa(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !To(e, Cw) && !To(e, Po);
}, WI = (e) => {
  if (!Sa(e) || _a(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, KI = Tr("Date"), GI = Tr("File"), YI = (e) => !!(e && typeof e.uri < "u"), QI = (e) => e && typeof e.getParts < "u", JI = Tr("Blob"), XI = Tr("FileList"), ZI = (e) => Sa(e) && er(e.pipe);
function eE() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const rv = eE(), iv = typeof rv.FormData < "u" ? rv.FormData : void 0, nE = (e) => {
  if (!e) return !1;
  if (iv && e instanceof iv) return !0;
  const n = fa(e);
  if (!n || n === Object.prototype || !er(e.append)) return !1;
  const r = ky(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && er(e.toString) && e.toString() === "[object FormData]";
}, tE = Tr("URLSearchParams"), [rE, iE, aE, oE] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Tr), sE = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ao(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Vi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (_a(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Ew(e, n) {
  if (_a(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const $i = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, $w = (e) => !ha(e) && e !== $i;
function jh(...e) {
  const { caseless: n, skipUndefined: r } = $w(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && Ew(i, s) || s, d = Qs(i, l) ? i[l] : void 0;
    Os(d) && Os(o) ? i[l] = jh(d, o) : Os(o) ? i[l] = jh({}, o) : Vi(o) ? i[l] = o.slice() : (!r || !ha(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || _a(l) || (Ao(l, a), typeof l != "object" || Vi(l)))
      continue;
    const d = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < d.length; m++) {
      const u = d[m];
      kE.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const lE = (e, n, r, { allOwnKeys: i } = {}) => (Ao(
  n,
  (a, o) => {
    r && er(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: ww(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), cE = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), dE = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, uE = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && fa(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, mE = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, pE = (e) => {
  if (!e) return null;
  if (Vi(e)) return e;
  let n = e.length;
  if (!Iw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, fE = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && fa(Uint8Array)), hE = (e, n) => {
  const i = (e && e[Po]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, yE = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, gE = Tr("HTMLFormElement"), vE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: kE } = Object.prototype, bE = Tr("RegExp"), Tw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Ao(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, xE = (e) => {
  Tw(e, (n, r) => {
    if (er(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (er(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, _E = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Vi(e) ? i(e) : i(String(e).split(n)), r;
}, SE = () => {
}, NE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function jE(e) {
  return !!(e && er(e.append) && e[Cw] === "FormData" && e[Po]);
}
const wE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Sa(i)) {
      if (n.has(i))
        return;
      if (_a(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Vi(i) ? [] : {};
        return Ao(i, (o, s) => {
          const l = r(o);
          !ha(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, CE = Tr("AsyncFunction"), FE = (e) => e && (Sa(e) || er(e)) && er(e.then) && er(e.catch), Dw = ((e, n) => e ? setImmediate : n ? ((r, i) => ($i.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === $i && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), $i.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", er($i.postMessage)), IE = typeof queueMicrotask < "u" ? queueMicrotask.bind($i) : typeof process < "u" && process.nextTick || Dw, Ow = (e) => e != null && er(e[Po]), EE = (e) => e != null && To(e, Po) && Ow(e), fe = {
  isArray: Vi,
  isArrayBuffer: Fw,
  isBuffer: _a,
  isFormData: nE,
  isArrayBufferView: BI,
  isString: qI,
  isNumber: Iw,
  isBoolean: HI,
  isObject: Sa,
  isPlainObject: Os,
  isEmptyObject: WI,
  isReadableStream: rE,
  isRequest: iE,
  isResponse: aE,
  isHeaders: oE,
  isUndefined: ha,
  isDate: KI,
  isFile: GI,
  isReactNativeBlob: YI,
  isReactNative: QI,
  isBlob: JI,
  isRegExp: bE,
  isFunction: er,
  isStream: ZI,
  isURLSearchParams: tE,
  isTypedArray: fE,
  isFileList: XI,
  forEach: Ao,
  merge: jh,
  extend: lE,
  trim: sE,
  stripBOM: cE,
  inherits: dE,
  toFlatObject: uE,
  kindOf: ky,
  kindOfTest: Tr,
  endsWith: mE,
  toArray: pE,
  forEachEntry: hE,
  matchAll: yE,
  isHTMLForm: gE,
  hasOwnProperty: Qs,
  hasOwnProp: Qs,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: To,
  getSafeProp: MI,
  reduceDescriptors: Tw,
  freezeMethods: xE,
  toObjectSet: _E,
  toCamelCase: vE,
  noop: SE,
  toFiniteNumber: NE,
  findKey: Ew,
  global: $i,
  isContextDefined: $w,
  isSpecCompliantForm: jE,
  toJSONObject: wE,
  isAsyncFn: CE,
  isThenable: FE,
  setImmediate: Dw,
  asap: IE,
  isIterable: Ow,
  isSafeIterable: EE
}, $E = fe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), TE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && $E[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function DE(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const OE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), RE = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function by(e, n) {
  return fe.isArray(e) ? e.map((r) => by(r, n)) : DE(String(e).replace(n, ""));
}
const PE = (e) => by(e, OE), AE = (e) => by(e, RE);
function Rw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return fe.forEach(e.toJSON(), (r, i) => {
    n[i] = AE(r);
  }), n;
}
const av = /* @__PURE__ */ Symbol("internals");
function Pa(e) {
  return e && String(e).trim().toLowerCase();
}
function Rs(e) {
  return e === !1 || e == null ? e : fe.isArray(e) ? e.map(Rs) : PE(String(e));
}
function LE(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const VE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function nc(e, n, r, i, a) {
  if (fe.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!fe.isString(n)) {
    if (fe.isString(i))
      return n.indexOf(i) !== -1;
    if (fe.isRegExp(i))
      return i.test(n);
  }
}
function zE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function UE(e, n) {
  const r = fe.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Pa(d);
      if (!u)
        return;
      const f = fe.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Rs(l));
    }
    const s = (l, d) => fe.forEach(l, (m, u) => o(m, u, d));
    if (fe.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (fe.isString(n) && (n = n.trim()) && !VE(n))
      s(TE(n), r);
    else if (fe.isObject(n) && fe.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), d, m;
      for (const u of n) {
        if (!fe.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        m = u[0], fe.hasOwnProp(l, m) ? (d = l[m], l[m] = fe.isArray(d) ? [...d, u[1]] : [d, u[1]]) : l[m] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Pa(n), n) {
      const i = fe.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return LE(a);
        if (fe.isFunction(r))
          return r.call(this, a, i);
        if (fe.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Pa(n), n) {
      const i = fe.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || nc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Pa(s), s) {
        const l = fe.findKey(i, s);
        l && (!r || nc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return fe.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || nc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return fe.forEach(this, (a, o) => {
      const s = fe.findKey(i, o);
      if (s) {
        r[s] = Rs(a), delete r[o];
        return;
      }
      const l = n ? zE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Rs(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return fe.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && fe.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[av] = this[av] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Pa(s);
      i[l] || (UE(a, s), i[l] = !0);
    }
    return fe.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
fe.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
fe.freezeMethods(Ut);
const ME = "[REDACTED ****]";
function BE(e) {
  if (fe.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (fe.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function qE(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || fe.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (fe.isArray(o))
      s = [], o.forEach((l, d) => {
        const m = a(l);
        fe.isUndefined(m) || (s[d] = m);
      });
    else {
      if (!fe.isPlainObject(o) && BE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, d] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? ME : a(d);
        fe.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let ln = class Pw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Pw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && fe.hasOwnProp(n, "redact") ? n.redact : void 0, i = fe.isArray(r) && r.length > 0 ? qE(n, r) : fe.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
ln.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
ln.ERR_BAD_OPTION = "ERR_BAD_OPTION";
ln.ECONNABORTED = "ECONNABORTED";
ln.ETIMEDOUT = "ETIMEDOUT";
ln.ECONNREFUSED = "ECONNREFUSED";
ln.ERR_NETWORK = "ERR_NETWORK";
ln.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
ln.ERR_DEPRECATED = "ERR_DEPRECATED";
ln.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
ln.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
ln.ERR_CANCELED = "ERR_CANCELED";
ln.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
ln.ERR_INVALID_URL = "ERR_INVALID_URL";
ln.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const HE = null, Aw = 100;
function wh(e) {
  return fe.isPlainObject(e) || fe.isArray(e);
}
function Lw(e) {
  return fe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function tc(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Lw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function WE(e) {
  return fe.isArray(e) && !e.some(wh);
}
const KE = fe.toFlatObject(fe, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function El(e, n, r) {
  if (!fe.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = fe.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, O) {
      return !fe.isUndefined(O[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || F, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? Aw : r.maxDepth, m = l && fe.isSpecCompliantForm(n), u = [];
  if (!fe.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(x) {
    if (x === null) return "";
    if (fe.isDate(x))
      return x.toISOString();
    if (fe.isBoolean(x))
      return x.toString();
    if (!m && fe.isBlob(x))
      throw new ln("Blob is not supported. Use a Buffer instead.");
    return fe.isArrayBuffer(x) || fe.isTypedArray(x) ? m && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function h(x) {
    if (x > d)
      throw new ln(
        "Object is too deeply nested (" + x + " levels). Max depth: " + d,
        ln.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function k(x, g) {
    if (d === 1 / 0)
      return JSON.stringify(x);
    const O = [];
    return JSON.stringify(x, function(C, w) {
      if (!fe.isObject(w))
        return w;
      for (; O.length && O[O.length - 1] !== this; )
        O.pop();
      return O.push(w), h(g + O.length - 1), w;
    });
  }
  function F(x, g, O) {
    let I = x;
    if (fe.isReactNative(n) && fe.isReactNativeBlob(x))
      return n.append(tc(O, g, o), f(x)), !1;
    if (x && !O && typeof x == "object") {
      if (fe.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), x = k(x, 1);
      else if (fe.isArray(x) && WE(x) || (fe.isFileList(x) || fe.endsWith(g, "[]")) && (I = fe.toArray(x)))
        return g = Lw(g), I.forEach(function(w, A) {
          !(fe.isUndefined(w) || w === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? tc([g], A, o) : s === null ? g : g + "[]",
            f(w)
          );
        }), !1;
    }
    return wh(x) ? !0 : (n.append(tc(O, g, o), f(x)), !1);
  }
  const j = Object.assign(KE, {
    defaultVisitor: F,
    convertValue: f,
    isVisitable: wh
  });
  function N(x, g, O = 0) {
    if (!fe.isUndefined(x)) {
      if (h(O), u.indexOf(x) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(x), fe.forEach(x, function(C, w) {
        (!(fe.isUndefined(C) || C === null) && a.call(n, C, fe.isString(w) ? w.trim() : w, g, j)) === !0 && N(C, g ? g.concat(w) : [w], O + 1);
      }), u.pop();
    }
  }
  if (!fe.isObject(e))
    throw new TypeError("data must be an object");
  return N(e), n;
}
function ov(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function xy(e, n) {
  this._pairs = [], e && El(e, this, n);
}
const Vw = xy.prototype;
Vw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Vw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, ov);
  } : ov;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function GE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function zw(e, n, r) {
  if (!n)
    return e;
  const i = fe.isFunction(r) ? {
    serialize: r
  } : r, a = fe.getSafeProp(i, "encode") || GE, o = fe.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = fe.isURLSearchParams(n) ? n.toString() : new xy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class sv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    fe.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const _y = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, YE = typeof URLSearchParams < "u" ? URLSearchParams : xy, QE = typeof FormData < "u" ? FormData : null, JE = typeof Blob < "u" ? Blob : null, XE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: YE,
    FormData: QE,
    Blob: JE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Sy = typeof window < "u" && typeof document < "u", Ch = typeof navigator == "object" && navigator || void 0, ZE = Sy && (!Ch || ["ReactNative", "NativeScript", "NS"].indexOf(Ch.product) < 0), e$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", n$ = Sy && window.location.href || "http://localhost", t$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Sy,
  hasStandardBrowserEnv: ZE,
  hasStandardBrowserWebWorkerEnv: e$,
  navigator: Ch,
  origin: n$
}, Symbol.toStringTag, { value: "Module" })), Pt = {
  ...t$,
  ...XE
};
function r$(e, n) {
  return El(e, new Pt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Pt.isNode && fe.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const lv = Aw;
function Uw(e) {
  if (e > lv)
    throw new ln(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + lv,
      ln.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function i$(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Uw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function a$(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Mw(e) {
  function n(r, i, a, o) {
    Uw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && fe.isArray(a) ? a.length : s, d ? (fe.hasOwnProp(a, s) ? a[s] = fe.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!fe.hasOwnProp(a, s) || !fe.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && fe.isArray(a[s]) && (a[s] = a$(a[s])), !l);
  }
  if (fe.isFormData(e) && fe.isFunction(e.entries)) {
    const r = {};
    return fe.forEachEntry(e, (i, a) => {
      n(i$(i), a, r, 0);
    }), r;
  }
  return null;
}
const Gi = (e, n) => e != null && fe.hasOwnProp(e, n) ? e[n] : void 0;
function o$(e, n, r) {
  if (fe.isString(e))
    try {
      return (n || JSON.parse)(e), fe.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Lo = {
  transitional: _y,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = fe.isObject(n);
      if (o && fe.isHTMLForm(n) && (n = new FormData(n)), fe.isFormData(n))
        return a ? JSON.stringify(Mw(n)) : n;
      if (fe.isArrayBuffer(n) || fe.isBuffer(n) || fe.isStream(n) || fe.isFile(n) || fe.isBlob(n) || fe.isReadableStream(n))
        return n;
      if (fe.isArrayBufferView(n))
        return n.buffer;
      if (fe.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Gi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return r$(n, d).toString();
        if ((l = fe.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Gi(this, "env"), u = m && m.FormData;
          return El(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), o$(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Gi(this, "transitional") || Lo.transitional, i = r && r.forcedJSONParsing, a = Gi(this, "responseType"), o = a === "json";
      if (fe.isResponse(n) || fe.isReadableStream(n))
        return n;
      if (n && fe.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Gi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? ln.from(d, ln.ERR_BAD_RESPONSE, this, null, Gi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Pt.classes.FormData,
    Blob: Pt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
fe.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Lo.headers[e] = {};
});
function rc(e, n) {
  const r = this || Lo, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return fe.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Bw(e) {
  return !!(e && e.__CANCEL__);
}
let Vo = class extends ln {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", ln.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function qw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new ln(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? ln.ERR_BAD_REQUEST : ln.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function s$(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function l$(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const k = u && m - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function c$(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Js = (e, n, r = 3) => {
  let i = 0;
  const a = l$(50, 250);
  return c$((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, cv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, dv = (e) => (...n) => fe.asap(() => e(...n)), d$ = Pt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Pt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Pt.origin),
  Pt.navigator && /(msie|trident)/i.test(Pt.navigator.userAgent)
) : () => !0, u$ = Pt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      fe.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), fe.isString(i) && l.push(`path=${i}`), fe.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), fe.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function m$(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function p$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const f$ = /^https?:(?!\/\/)/i, h$ = /[\t\n\r]/g;
function y$(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function g$(e) {
  return y$(e).replace(h$, "");
}
function uv(e, n) {
  if (typeof e == "string" && f$.test(g$(e)))
    throw new ln(
      'Invalid URL: missing "//" after protocol',
      ln.ERR_INVALID_URL,
      n
    );
}
function Hw(e, n, r, i) {
  uv(n, i);
  let a = !m$(n);
  return e && (a || r === !1) ? (uv(e, i), p$(e, n)) : n;
}
const mv = (e) => e instanceof Ut ? { ...e } : e;
function zi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, k) {
    return fe.isPlainObject(u) && fe.isPlainObject(f) ? fe.merge.call({ caseless: k }, u, f) : fe.isPlainObject(f) ? fe.merge({}, f) : fe.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, k) {
    if (fe.isUndefined(f)) {
      if (!fe.isUndefined(u))
        return i(void 0, u, h, k);
    } else return i(u, f, h, k);
  }
  function o(u, f) {
    if (!fe.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (fe.isUndefined(f)) {
      if (!fe.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = fe.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!fe.isUndefined(f))
      if (fe.isPlainObject(f)) {
        if (fe.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = fe.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (fe.isPlainObject(h) && fe.hasOwnProp(h, u))
      return h[u];
  }
  function d(u, f, h) {
    if (fe.hasOwnProp(n, h))
      return i(u, f);
    if (fe.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: d,
    headers: (u, f, h) => a(mv(u), mv(f), h, !0)
  };
  return fe.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = fe.hasOwnProp(m, f) ? m[f] : a, k = fe.hasOwnProp(e, f) ? e[f] : void 0, F = fe.hasOwnProp(n, f) ? n[f] : void 0, j = h(k, F, f);
    fe.isUndefined(j) && h !== d || (r[f] = j);
  }), fe.hasOwnProp(n, "validateStatus") && fe.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (fe.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const v$ = ["content-type", "content-length"];
function k$(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    v$.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const b$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Ww(e) {
  const n = zi({}, e), r = (h) => fe.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = zw(
    Hw(m, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), d) {
    const h = fe.getSafeProp(d, "username") || "", k = fe.getSafeProp(d, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (k ? b$(k) : ""))
    );
  }
  if (fe.isFormData(i) && (Pt.hasStandardBrowserEnv || Pt.hasStandardBrowserWebWorkerEnv || fe.isReactNative(i) ? l.setContentType(void 0) : fe.isFunction(i.getHeaders) && k$(l, i.getHeaders(), r("formDataHeaderPolicy"))), Pt.hasStandardBrowserEnv && (fe.isFunction(a) && (a = a(n)), a === !0 || a == null && d$(n.url))) {
    const k = o && s && u$.read(s);
    k && l.set(o, k);
  }
  return n;
}
const x$ = typeof XMLHttpRequest < "u", _$ = x$ && function(e) {
  return new Promise(function(r, i) {
    const a = Ww(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, k, F;
    function j() {
      k && k(), F && F(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function x() {
      if (!N)
        return;
      const O = Ut.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: O,
        config: e,
        request: N
      };
      qw(
        function(A) {
          r(A), j();
        },
        function(A) {
          i(A), j();
        },
        C
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = x : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.startsWith("file:")) || setTimeout(x);
    }, N.onabort = function() {
      N && (i(new ln("Request aborted", ln.ECONNABORTED, e, N)), j(), N = null);
    }, N.onerror = function(I) {
      const C = I && I.message ? I.message : "Network Error", w = new ln(C, ln.ERR_NETWORK, e, N);
      w.event = I || null, i(w), j(), N = null;
    }, N.ontimeout = function() {
      let I = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || _y;
      a.timeoutErrorMessage && (I = a.timeoutErrorMessage), i(
        new ln(
          I,
          C.clarifyTimeoutError ? ln.ETIMEDOUT : ln.ECONNABORTED,
          e,
          N
        )
      ), j(), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && fe.forEach(Rw(s), function(I, C) {
      N.setRequestHeader(C, I);
    }), fe.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, F] = Js(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, k] = Js(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (O) => {
      N && (i(!O || O.type ? new Vo(null, e, N) : O), N.abort(), j(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = s$(a.url);
    if (g && !Pt.protocols.includes(g)) {
      i(
        new ln(
          "Unsupported protocol " + g + ":",
          ln.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, S$ = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(d) {
    if (!i) {
      i = !0, s();
      const m = d instanceof Error ? d : this.reason;
      r.abort(
        m instanceof ln ? m : new Vo(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new ln(`timeout of ${n}ms exceeded`, ln.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((d) => {
      d.unsubscribe ? d.unsubscribe(a) : d.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((d) => d.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => fe.asap(s), l;
}, N$ = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, j$ = async function* (e, n) {
  for await (const r of w$(e))
    yield* N$(r, n);
}, w$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, pv = (e, n, r, i) => {
  const a = j$(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Xs = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, C$ = (e, n, r) => n + 2 < r && Xs(e.charCodeAt(n + 1)) && Xs(e.charCodeAt(n + 2));
function F$(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let k = 0; k < l; k++)
      if (i.charCodeAt(k) === 37 && k + 2 < l) {
        const F = i.charCodeAt(k + 1), j = i.charCodeAt(k + 2);
        Xs(F) && Xs(j) && (s -= 2, k += 2);
      }
    let d = 0, m = l - 1;
    const u = (k) => k >= 2 && i.charCodeAt(k - 2) === 37 && // '%'
    i.charCodeAt(k - 1) === 51 && // '3'
    (i.charCodeAt(k) === 68 || i.charCodeAt(k) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (d++, m--) : u(m) && (d++, m -= 3)), d === 1 && m >= 0 && (i.charCodeAt(m) === 61 || u(m)) && d++;
    const h = Math.floor(s / 4) * 3 - (d || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const d = i.charCodeAt(s);
    if (d === 37 && C$(i, s, l))
      o += 1, s += 2;
    else if (d < 128)
      o += 1;
    else if (d < 2048)
      o += 2;
    else if (d >= 55296 && d <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const Ny = "1.18.0", fv = 64 * 1024, { isFunction: Zo } = fe, I$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), hv = (e) => {
  if (!fe.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, yv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, E$ = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, $$ = (e) => {
  const n = fe.global !== void 0 && fe.global !== null ? fe.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = fe.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? Zo(a) : typeof fetch == "function", d = Zo(o), m = Zo(s);
  if (!l)
    return !1;
  const u = l && Zo(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((x) => (g) => x.encode(g))(new i()) : async (x) => new Uint8Array(await new o(x).arrayBuffer())), h = d && u && yv(() => {
    let x = !1;
    const g = new o(Pt.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return x = !0, "half";
      }
    }), O = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), x && !O;
  }), k = m && u && yv(() => fe.isReadableStream(new s("").body)), F = {
    stream: k && ((x) => x.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((x) => {
    !F[x] && (F[x] = (g, O) => {
      let I = g && g[x];
      if (I)
        return I.call(g);
      throw new ln(
        `Response type '${x}' is not supported`,
        ln.ERR_NOT_SUPPORT,
        O
      );
    });
  });
  const j = async (x) => {
    if (x == null)
      return 0;
    if (fe.isBlob(x))
      return x.size;
    if (fe.isSpecCompliantForm(x))
      return (await new o(Pt.origin, {
        method: "POST",
        body: x
      }).arrayBuffer()).byteLength;
    if (fe.isArrayBufferView(x) || fe.isArrayBuffer(x))
      return x.byteLength;
    if (fe.isURLSearchParams(x) && (x = x + ""), fe.isString(x))
      return (await f(x)).byteLength;
  }, N = async (x, g) => {
    const O = fe.toFiniteNumber(x.getContentLength());
    return O ?? j(g);
  };
  return async (x) => {
    let {
      url: g,
      method: O,
      data: I,
      signal: C,
      cancelToken: w,
      timeout: A,
      onDownloadProgress: B,
      onUploadProgress: K,
      responseType: ee,
      headers: G,
      withCredentials: H = "same-origin",
      fetchOptions: R,
      maxContentLength: q,
      maxBodyLength: te
    } = Ww(x);
    const we = fe.isNumber(q) && q > -1, ve = fe.isNumber(te) && te > -1, ue = (Fe) => fe.hasOwnProp(x, Fe) ? x[Fe] : void 0;
    let ge = a || fetch;
    ee = ee ? (ee + "").toLowerCase() : "text";
    let U = S$(
      [C, w && w.toAbortSignal()],
      A
    ), be = null;
    const $e = U && U.unsubscribe && (() => {
      U.unsubscribe();
    });
    let W, Ge = null;
    const sn = () => new ln(
      "Request body larger than maxBodyLength limit",
      ln.ERR_BAD_REQUEST,
      x,
      be
    );
    try {
      let Fe;
      const Ue = ue("auth");
      if (Ue) {
        const le = fe.getSafeProp(Ue, "username") || "", Se = fe.getSafeProp(Ue, "password") || "";
        Fe = {
          username: le,
          password: Se
        };
      }
      if (E$(g)) {
        const le = new URL(g, Pt.origin);
        if (!Fe && (le.username || le.password)) {
          const Se = hv(le.username), Le = hv(le.password);
          Fe = {
            username: Se,
            password: Le
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", g = le.href);
      }
      if (Fe && (G.delete("authorization"), G.set(
        "Authorization",
        "Basic " + btoa(I$((Fe.username || "") + ":" + (Fe.password || "")))
      )), we && typeof g == "string" && g.startsWith("data:") && F$(g) > q)
        throw new ln(
          "maxContentLength size of " + q + " exceeded",
          ln.ERR_BAD_RESPONSE,
          x,
          be
        );
      if (ve && O !== "get" && O !== "head") {
        const le = await j(I);
        if (typeof le == "number" && isFinite(le) && (W = le, le > te))
          throw sn();
      }
      const Re = ve && (fe.isReadableStream(I) || fe.isStream(I)), Be = (le, Se, Le) => pv(
        le,
        fv,
        (Pe) => {
          if (ve && Pe > te)
            throw Ge = sn();
          Se && Se(Pe);
        },
        Le
      );
      if (h && O !== "get" && O !== "head" && (K || Re)) {
        if (W = W ?? await N(G, I), W !== 0 || Re) {
          let le = new o(g, {
            method: "POST",
            body: I,
            duplex: "half"
          }), Se;
          if (fe.isFormData(I) && (Se = le.headers.get("content-type")) && G.setContentType(Se), le.body) {
            const [Le, Pe] = K && cv(
              W,
              Js(dv(K))
            ) || [];
            I = Be(le.body, Le, Pe);
          }
        }
      } else if (Re && !d && u && O !== "get" && O !== "head")
        I = Be(I);
      else if (Re && d && !h && O !== "get" && O !== "head")
        throw new ln(
          "Stream request bodies are not supported by the current fetch implementation",
          ln.ERR_NOT_SUPPORT,
          x,
          be
        );
      fe.isString(H) || (H = H ? "include" : "omit");
      const Ae = d && "credentials" in o.prototype;
      if (fe.isFormData(I)) {
        const le = G.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && G.delete("content-type");
      }
      G.set("User-Agent", "axios/" + Ny, !1);
      const Je = {
        ...R,
        signal: U,
        method: O.toUpperCase(),
        headers: Rw(G.normalize()),
        body: I,
        duplex: "half",
        credentials: Ae ? H : void 0
      };
      be = d && new o(g, Je);
      let Ce = await (d ? ge(be, R) : ge(g, Je));
      const Me = Ut.from(Ce.headers);
      if (we) {
        const le = fe.toFiniteNumber(Me.getContentLength());
        if (le != null && le > q)
          throw new ln(
            "maxContentLength size of " + q + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            be
          );
      }
      const nn = k && (ee === "stream" || ee === "response");
      if (k && Ce.body && (B || we || nn && $e)) {
        const le = {};
        ["status", "statusText", "headers"].forEach((T) => {
          le[T] = Ce[T];
        });
        const Se = fe.toFiniteNumber(Me.getContentLength()), [Le, Pe] = B && cv(
          Se,
          Js(dv(B), !0)
        ) || [];
        let gn = 0;
        const J = (T) => {
          if (we && (gn = T, gn > q))
            throw new ln(
              "maxContentLength size of " + q + " exceeded",
              ln.ERR_BAD_RESPONSE,
              x,
              be
            );
          Le && Le(T);
        };
        Ce = new s(
          pv(Ce.body, fv, J, () => {
            Pe && Pe(), $e && $e();
          }),
          le
        );
      }
      ee = ee || "text";
      let se = await F[fe.findKey(F, ee) || "text"](
        Ce,
        x
      );
      if (we && !k && !nn) {
        let le;
        if (se != null && (typeof se.byteLength == "number" ? le = se.byteLength : typeof se.size == "number" ? le = se.size : typeof se == "string" && (le = typeof i == "function" ? new i().encode(se).byteLength : se.length)), typeof le == "number" && le > q)
          throw new ln(
            "maxContentLength size of " + q + " exceeded",
            ln.ERR_BAD_RESPONSE,
            x,
            be
          );
      }
      return !nn && $e && $e(), await new Promise((le, Se) => {
        qw(le, Se, {
          data: se,
          headers: Ut.from(Ce.headers),
          status: Ce.status,
          statusText: Ce.statusText,
          config: x,
          request: be
        });
      });
    } catch (Fe) {
      if ($e && $e(), U && U.aborted && U.reason instanceof ln) {
        const Ue = U.reason;
        throw Ue.config = x, be && (Ue.request = be), Fe !== Ue && (Ue.cause = Fe), Ue;
      }
      throw Ge ? (be && !Ge.request && (Ge.request = be), Ge) : Fe instanceof ln ? (be && !Fe.request && (Fe.request = be), Fe) : Fe && Fe.name === "TypeError" && /Load failed|fetch/i.test(Fe.message) ? Object.assign(
        new ln(
          "Network Error",
          ln.ERR_NETWORK,
          x,
          be,
          Fe && Fe.response
        ),
        {
          cause: Fe.cause || Fe
        }
      ) : ln.from(Fe, Fe && Fe.code, x, be, Fe && Fe.response);
    }
  };
}, T$ = /* @__PURE__ */ new Map(), Kw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = T$;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : $$(n)), u = m;
  return m;
};
Kw();
const jy = {
  http: HE,
  xhr: _$,
  fetch: {
    get: Kw
  }
};
fe.forEach(jy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const gv = (e) => `- ${e}`, D$ = (e) => fe.isFunction(e) || e === null || e === !1;
function O$(e, n) {
  e = fe.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !D$(i) && (a = jy[(l = String(i)).toLowerCase()], a === void 0))
      throw new ln(`Unknown adapter '${l}'`);
    if (a && (fe.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(gv).join(`
`) : " " + gv(s[0]) : "as no adapter specified";
    throw new ln(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Gw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: O$,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: jy
};
function ic(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Vo(null, e);
}
function vv(e) {
  return ic(e), e.headers = Ut.from(e.headers), e.data = rc.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Gw.getAdapter(e.adapter || Lo.adapter, e)(e).then(
    function(i) {
      ic(e), e.response = i;
      try {
        i.data = rc.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Bw(i) && (ic(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = rc.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const $l = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  $l[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const kv = {};
$l.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Ny + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new ln(
        a(s, " has been removed" + (r ? " in " + r : "")),
        ln.ERR_DEPRECATED
      );
    return r && !kv[s] && (kv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
$l.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function R$(e, n, r) {
  if (typeof e != "object")
    throw new ln("options must be an object", ln.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new ln(
          "option " + o + " must be " + d,
          ln.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new ln("Unknown option " + o, ln.ERR_BAD_OPTION);
  }
}
const Ps = {
  assertOptions: R$,
  validators: $l
}, zt = Ps.validators;
let Oi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new sv(),
      response: new sv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = zi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ps.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (fe.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ps.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ps.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && fe.merge(o.common, o[r.method]);
    o && fe.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (F) => {
      delete o[F];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(j) {
      if (typeof j.runWhen == "function" && j.runWhen(r) === !1)
        return;
      d = d && j.synchronous;
      const N = r.transitional || _y;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(j.fulfilled, j.rejected) : l.push(j.fulfilled, j.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(j) {
      m.push(j.fulfilled, j.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const F = [vv.bind(this), void 0];
      for (F.unshift(...l), F.push(...m), h = F.length, u = Promise.resolve(r); f < h; )
        u = u.then(F[f++], F[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const F = l[f++], j = l[f++];
      try {
        k = F(k);
      } catch (N) {
        j.call(this, N);
        break;
      }
    }
    try {
      u = vv.call(this, k);
    } catch (F) {
      return Promise.reject(F);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = zi(this.defaults, n);
    const r = Hw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return zw(r, n.params, n.paramsSerializer);
  }
};
fe.forEach(["delete", "get", "head", "options"], function(n) {
  Oi.prototype[n] = function(r, i) {
    return this.request(
      zi(i || {}, {
        method: n,
        url: r,
        data: i && fe.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
fe.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        zi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  Oi.prototype[n] = r(), n !== "query" && (Oi.prototype[n + "Form"] = r(!0));
});
let P$ = class Yw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Vo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Yw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function A$(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function L$(e) {
  return fe.isObject(e) && e.isAxiosError === !0;
}
const Fh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Fh).forEach(([e, n]) => {
  Fh[n] = e;
});
function Qw(e) {
  const n = new Oi(e), r = ww(Oi.prototype.request, n);
  return fe.extend(r, Oi.prototype, n, { allOwnKeys: !0 }), fe.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Qw(zi(e, a));
  }, r;
}
const kt = Qw(Lo);
kt.Axios = Oi;
kt.CanceledError = Vo;
kt.CancelToken = P$;
kt.isCancel = Bw;
kt.VERSION = Ny;
kt.toFormData = El;
kt.AxiosError = ln;
kt.Cancel = kt.CanceledError;
kt.all = function(n) {
  return Promise.all(n);
};
kt.spread = A$;
kt.isAxiosError = L$;
kt.mergeConfig = zi;
kt.AxiosHeaders = Ut;
kt.formToJSON = (e) => Mw(fe.isHTMLForm(e) ? new FormData(e) : e);
kt.getAdapter = Gw.getAdapter;
kt.HttpStatusCode = Fh;
kt.default = kt;
const {
  Axios: z8,
  AxiosError: U8,
  CanceledError: M8,
  isCancel: B8,
  CancelToken: q8,
  VERSION: H8,
  all: W8,
  Cancel: K8,
  isAxiosError: V$,
  spread: G8,
  toFormData: Y8,
  AxiosHeaders: Q8,
  HttpStatusCode: J8,
  formToJSON: X8,
  getAdapter: Z8,
  mergeConfig: eY,
  create: nY
} = kt;
class z$ {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const bv = new z$();
function U$(e, n) {
  return xv(e), xv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function xv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const M$ = Object.prototype.toString;
function B$(e, n) {
  return M$.call(e) === `[object ${n}]`;
}
function q$(e) {
  return B$(e, "Object");
}
function H$(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const ko = "8.36.0", ii = globalThis;
function wy(e, n, r) {
  const i = r || ii, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[ko] = a[ko] || {};
  return o[e] || (o[e] = n());
}
const Jw = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, W$ = "Sentry Logger ", _v = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Sv = {};
function Xw(e) {
  if (!("console" in ii))
    return e();
  const n = ii.console, r = {}, i = Object.keys(Sv);
  i.forEach((a) => {
    const o = Sv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function K$() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Jw ? _v.forEach((r) => {
    n[r] = (...i) => {
      e && Xw(() => {
        ii.console[r](`${W$}[${r}]:`, ...i);
      });
    };
  }) : _v.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const As = wy("logger", K$);
function G$(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Jw && As.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Zw = 1e3;
function Cy() {
  return Date.now() / Zw;
}
function Y$() {
  const { performance: e } = ii;
  if (!e || !e.now)
    return Cy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Zw;
}
const Q$ = Y$();
(() => {
  const { performance: e } = ii;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function la() {
  const e = ii, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Nv() {
  return {
    traceId: la(),
    spanId: la().substring(16)
  };
}
function Fy() {
  return Iy(ii), ii;
}
function Iy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || ko, n[ko] = n[ko] || {};
}
function J$(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Q$(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : la()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Ih = "_sentrySpan";
function jv(e, n) {
  n ? G$(e, Ih, n) : delete e[Ih];
}
function wv(e) {
  return e[Ih];
}
const X$ = 100;
class Ey {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Nv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Ey();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, jv(n, wv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && J$(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof ya ? [r.getScopeData(), r.getRequestSession()] : q$(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, jv(this, void 0), this._attachments = [], this._propagationContext = Nv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : X$;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Cy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: wv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    if (!this._client)
      return As.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : la();
    if (!this._client)
      return As.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : la();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (As.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ya = Ey;
function Z$() {
  return wy("defaultCurrentScope", () => new ya());
}
function eT() {
  return wy("defaultIsolationScope", () => new ya());
}
class nT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new ya();
    let a;
    r ? a = r : a = new ya(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return H$(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ga() {
  const e = Fy(), n = Iy(e);
  return n.stack = n.stack || new nT(Z$(), eT());
}
function tT(e) {
  return ga().withScope(e);
}
function rT(e, n) {
  const r = ga();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Cv(e) {
  return ga().withScope(() => e(ga().getIsolationScope()));
}
function iT() {
  return {
    withIsolationScope: Cv,
    withScope: tT,
    withSetScope: rT,
    withSetIsolationScope: (e, n) => Cv(n),
    getCurrentScope: () => ga().getScope(),
    getIsolationScope: () => ga().getIsolationScope()
  };
}
function eC(e) {
  const n = Iy(e);
  return n.acs ? n.acs : iT();
}
function $y() {
  const e = Fy();
  return eC(e).getCurrentScope();
}
function nC() {
  const e = Fy();
  return eC(e).getIsolationScope();
}
function aT() {
  return $y().getClient();
}
function oT(e) {
  if (e)
    return sT(e) ? { captureContext: e } : cT(e) ? {
      captureContext: e
    } : e;
}
function sT(e) {
  return e instanceof ya || typeof e == "function";
}
const lT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function cT(e) {
  return Object.keys(e).some((n) => lT.includes(n));
}
function Fv(e, n) {
  return $y().captureException(e, oT(n));
}
function dT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return $y().captureMessage(e, r, i);
}
function uT(e, n) {
  nC().setContext(e, n);
}
const mT = 100;
function Fi(e, n) {
  const r = aT(), i = nC();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = mT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Cy(), ...e }, d = a ? Xw(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Do;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Do || (Do = {}));
function ca(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const pT = $o.backendDomain ? {
  "backend-domain": $o.backendDomain
} : void 0;
function Ls() {
  const e = new URLSearchParams({
    noToken: "true",
    ...pT
  }).toString();
  document.location.href = `${$o.url.logIn}?${e}`;
}
const ac = "authData", oc = 30, fT = 600, sc = 5;
class hT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= sc || this.clientServerTimeDiff <= -sc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + fT, a = ca(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > sc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(ac, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(ac), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(ac);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - oc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = ca(n), i = r.exp - oc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - oc - this.estimatedServerTime()) * 1e3;
  }
}
const $t = new hT();
async function yT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? ca(o).exp : "None", l = await Tl.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? ca(m).exp : "None", h = u ? ca(u).exp : "None", k = typeof s == "number" ? d - s : "Unknown", F = typeof f == "number" ? d - f : "Unknown", j = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      uT("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: F,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: j,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    dT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Do.Platform,
        domain: n
      }
    });
  }
}
const lc = /* @__PURE__ */ new Map(), gT = 3;
function vT(e) {
  e.interceptors.response.use((n) => (lc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Eh.Unauthorized:
          if (!Tl.isRefreshTokenExpired() && n.config) {
            Fi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = lc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= gT)
              return lc.set(n.config.url, i + 1), e(n.config);
          }
          yT(n), console.error("401 unauthorized interceptor"), Ls();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const tC = kt.create();
vT(tC);
const Yr = console.log;
async function Iv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class kT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function bT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const xT = 5;
class _T {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      $t.setAuthData(r);
    else {
      const i = $t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new kT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = $t.getAccessToken();
    if (!n)
      return {};
    const r = ca(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return $t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = $t.getAuthData();
    return r ? $t.isAccessTokenExpired() ? (Fi({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && $t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return $t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return $t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return $t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = $t.getAuthData();
    return n ? $t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!bv.isElectron())
      return !0;
    const n = await bv.getVersion();
    return U$(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = xT) {
    try {
      return await tC.post(`${$o.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Yr("AUTH", "Network connection offline - waiting..."), Fi({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Iv(5);
    n && (Yr("AUTH", "Network connection restored"), Fi({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = bT(this.retryCount);
    return Yr("AUTH", `Retrying in ${i} seconds`), await Iv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if ($t.isRefreshTokenExpired(r))
      return Yr("AUTH", "Refresh token expired"), Fi({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), $t.removeAuthData(), Ls(), null;
    if (V$(n)) {
      if (n.message === "timeout exceeded")
        return Yr("AUTH", "Timeout exceeded"), Fi({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Yr("AUTH", "Network error"), Fi({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Yr("AUTH", "Refresh token invalid (401)"), $t.removeAuthData(), Ls(), null;
      Fv(n, {
        level: "error",
        tags: {
          team: Do.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Yr("AUTH", "Retries exhausted, logging out"), Fv(n, {
      level: "error",
      tags: {
        team: Do.Platform,
        errorSource: "authManager.refresh"
      }
    }), $t.removeAuthData(), Ls(), null) : (Yr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return $t.accessTokenExpiresInMs();
  }
}
const Tl = new _T();
var Eh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Eh || (Eh = {}));
const ST = new gy((e, n) => new Sw((r) => {
  Tl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), NT = new gy(
  (e, n) => new Sw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Tl.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...ZF($o.url.partnerIntegrations) && d?.access_token && eI(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), jT = new AbortController(), rC = (e) => new FI({
  queryDeduplication: !1,
  cache: new II(),
  link: gy.from([
    ST,
    NT,
    EI({
      uri: `${e}/graphql`,
      fetch: RI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: jT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), wT = ({
  configuration: e,
  children: n
}) => {
  const r = Yn(
    () => rC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ke.jsx($I, { client: r, children: n });
};
function CT() {
  try {
    return TI(), !0;
  } catch {
    return !1;
  }
}
const FT = ({
  configuration: e,
  children: n
}) => CT() ? n : /* @__PURE__ */ Ke.jsx(wT, { configuration: e, children: n }), IT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ke.jsx(DI, { children: (o) => /* @__PURE__ */ Ke.jsx(
  nI,
  {
    value: {
      useMutation: aI(e, n),
      useQuery: iI(e, n),
      useLazyQuery: rI(e, n),
      executeQuery: tI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), iC = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ke.jsx(FT, { configuration: r, children: s ? /* @__PURE__ */ Ke.jsx(
    IT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, ET = "_unmatchedHeader_qcj19_1", $T = {
  unmatchedHeader: ET
};
var zo = (e) => e.type === "checkbox", Ti = (e) => e instanceof Date, Gt = (e) => e == null;
const aC = (e) => typeof e == "object";
var gt = (e) => !Gt(e) && !Array.isArray(e) && aC(e) && !Ti(e), oC = (e) => gt(e) && e.target ? zo(e.target) ? e.target.checked : e.target.value : e, TT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, sC = (e, n) => e.has(TT(n)), DT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, Ty = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ot(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ty && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !DT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ot(e[a]));
  else
    return e;
  return n;
}
var Dl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ft = (e) => e === void 0, rn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = Dl(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ft(i) || i === e ? ft(e[n]) ? r : e[n] : i;
}, or = (e) => typeof e == "boolean", Dy = (e) => /^\w*$/.test(e), lC = (e) => Dl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Dy(n) ? [n] : lC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = gt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Zs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Qr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, cC = qe.createContext(null), Dr = () => qe.useContext(cC), Oy = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(cC.Provider, { value: r }, n);
};
var dC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function OT(e) {
  const n = Dr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => dC(s, r, d.current, !1), [s, r]);
}
var Ur = (e) => typeof e == "string", uC = (e, n, r, i, a) => Ur(e) ? (i && n.watch.add(e), rn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), rn(r, o))) : (i && (n.watchAll = !0), r);
function fi(e) {
  const n = Dr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(uC(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Ry(e) {
  const n = Dr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = sC(a._names.array, r), l = fi({
    control: a,
    name: r,
    defaultValue: rn(a._formValues, r, rn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = OT({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...or(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!rn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!rn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!rn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!rn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => rn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((N) => u.current.onChange({
    target: {
      value: oC(N),
      name: r
    },
    type: Zs.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: rn(a._formValues, r),
      name: r
    },
    type: Zs.BLUR
  }), [r, a._formValues]), F = qe.useCallback((N) => {
    const x = rn(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...or(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: F
  }), [r, i, d.disabled, h, k, F, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...or(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (g, O) => {
      const I = rn(a._fields, g);
      I && I._f && (I._f.mount = O);
    };
    if (x(r, !0), N) {
      const g = Ot(rn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ft(rn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
const xt = (e) => e.render(Ry(e));
var RT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, bo = (e) => Array.isArray(e) ? e : [e], Ev = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, $h = (e) => Gt(e) || !aC(e);
function ui(e, n) {
  if ($h(e) || $h(n))
    return e === n;
  if (Ti(e) && Ti(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ti(o) && Ti(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !ui(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => gt(e) && !Object.keys(e).length, Py = (e) => e.type === "file", wr = (e) => typeof e == "function", el = (e) => {
  if (!Ty)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, mC = (e) => e.type === "select-multiple", Ay = (e) => e.type === "radio", PT = (e) => Ay(e) || zo(e), cc = (e) => el(e) && e.isConnected;
function AT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ft(e) ? i++ : e[n[i++]];
  return e;
}
function LT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ft(e[n]))
      return !1;
  return !0;
}
function St(e, n) {
  const r = Array.isArray(n) ? n : Dy(n) ? [n] : lC(n), i = r.length === 1 ? e : AT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Wt(i) || Array.isArray(i) && LT(i)) && St(e, r.slice(0, -1)), e;
}
var pC = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function nl(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !pC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, nl(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function fC(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !pC(e[a]) ? ft(n) || $h(r[a]) ? r[a] = Array.isArray(e[a]) ? nl(e[a], []) : { ...nl(e[a]) } : fC(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !ui(e[a], n[a]);
  return r;
}
var Aa = (e, n) => fC(e, n, nl(n));
const $v = {
  value: !1,
  isValid: !1
}, Tv = { value: !0, isValid: !0 };
var hC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ft(e[0].attributes.value) ? ft(e[0].value) || e[0].value === "" ? Tv : { value: e[0].value, isValid: !0 } : Tv
    ) : $v;
  }
  return $v;
}, yC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ft(e) ? e : n ? e === "" ? NaN : e && +e : r && Ur(e) ? new Date(e) : i ? i(e) : e;
const Dv = {
  isValid: !1,
  value: null
};
var gC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Dv) : Dv;
function Ov(e) {
  const n = e.ref;
  return Py(n) ? n.files : Ay(n) ? gC(e.refs).value : mC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : zo(n) ? hC(e.refs).value : yC(ft(n.value) ? e.ref.value : n.value, e);
}
var VT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = rn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, tl = (e) => e instanceof RegExp, La = (e) => ft(e) ? e : tl(e) ? e.source : gt(e) ? tl(e.value) ? e.value.source : e.value : e, Rv = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const Pv = "AsyncFunction";
var zT = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === Pv || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Pv)), UT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Av = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const xo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = rn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (xo(l, n))
          break;
      } else if (gt(l) && xo(l, n))
        break;
    }
  }
};
function Lv(e, n, r) {
  const i = rn(e, r);
  if (i || Dy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = rn(n, o), l = rn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var MT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, BT = (e, n, r) => !e || !n || e === n || bo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), qT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, HT = (e, n) => !Dl(rn(e, n)).length && St(e, n), WT = (e, n, r) => {
  const i = bo(rn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, Vs = (e) => Ur(e);
function Vv(e, n, r = "validate") {
  if (Vs(e) || Array.isArray(e) && e.every(Vs) || or(e) && !e)
    return {
      type: r,
      message: Vs(e) ? e : "",
      ref: n
    };
}
var Yi = (e) => gt(e) && !tl(e) ? e : {
  value: e,
  message: ""
}, zv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: F, name: j, valueAsNumber: N, mount: x } = e._f, g = rn(r, j);
  if (!x || n.has(j))
    return {};
  const O = l ? l[0] : s, I = (H) => {
    a && O.reportValidity && (O.setCustomValidity(or(H) ? "" : H || ""), O.reportValidity());
  }, C = {}, w = Ay(s), A = zo(s), B = w || A, K = (N || Py(s)) && ft(s.value) && ft(g) || el(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = RT.bind(null, j, i, C), G = (H, R, q, te = Qr.maxLength, we = Qr.minLength) => {
    const ve = H ? R : q;
    C[j] = {
      type: H ? te : we,
      message: ve,
      ref: s,
      ...ee(H ? te : we, ve)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!B && (K || Gt(g)) || or(g) && !g || A && !hC(l).isValid || w && !gC(l).isValid)) {
    const { value: H, message: R } = Vs(d) ? { value: !!d, message: d } : Yi(d);
    if (H && (C[j] = {
      type: Qr.required,
      message: R,
      ref: O,
      ...ee(Qr.required, R)
    }, !i))
      return I(R), C;
  }
  if (!K && (!Gt(f) || !Gt(h))) {
    let H, R;
    const q = Yi(h), te = Yi(f);
    if (!Gt(g) && !isNaN(g)) {
      const we = s.valueAsNumber || g && +g;
      Gt(q.value) || (H = we > q.value), Gt(te.value) || (R = we < te.value);
    } else {
      const we = s.valueAsDate || new Date(g), ve = (U) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + U), ue = s.type == "time", ge = s.type == "week";
      Ur(q.value) && g && (H = ue ? ve(g) > ve(q.value) : ge ? g > q.value : we > new Date(q.value)), Ur(te.value) && g && (R = ue ? ve(g) < ve(te.value) : ge ? g < te.value : we < new Date(te.value));
    }
    if ((H || R) && (G(!!H, q.message, te.message, Qr.max, Qr.min), !i))
      return I(C[j].message), C;
  }
  if ((m || u) && !K && (Ur(g) || o && Array.isArray(g))) {
    const H = Yi(m), R = Yi(u), q = !Gt(H.value) && g.length > +H.value, te = !Gt(R.value) && g.length < +R.value;
    if ((q || te) && (G(q, H.message, R.message), !i))
      return I(C[j].message), C;
  }
  if (k && !K && Ur(g)) {
    const { value: H, message: R } = Yi(k);
    if (tl(H) && !g.match(H) && (C[j] = {
      type: Qr.pattern,
      message: R,
      ref: s,
      ...ee(Qr.pattern, R)
    }, !i))
      return I(R), C;
  }
  if (F) {
    if (wr(F)) {
      const H = await F(g, r), R = Vv(H, O);
      if (R && (C[j] = {
        ...R,
        ...ee(Qr.validate, R.message)
      }, !i))
        return I(R.message), C;
    } else if (gt(F)) {
      let H = {};
      for (const R in F) {
        if (!Wt(H) && !i)
          break;
        const q = Vv(await F[R](g, r), O, R);
        q && (H = {
          ...q,
          ...ee(R, q.message)
        }, I(q.message), i && (C[j] = H));
      }
      if (!Wt(H) && (C[j] = {
        ref: O,
        ...H
      }, !i))
        return C;
    }
  }
  return I(!0), C;
};
const KT = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function GT(e = {}) {
  let n = {
    ...KT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Ot(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ot(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Ev(),
    state: Ev()
  }, k = Rv(n.mode), F = Rv(n.reValidateMode), j = n.criteriaMode === jr.all, N = (T) => (z) => {
    clearTimeout(m), m = setTimeout(T, z);
  }, x = async (T) => {
    if (!n.disabled && (u.isValid || f.isValid || T)) {
      const z = n.resolver ? Wt((await K()).errors) : await G(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = (T, z) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((X) => {
      X && (z ? it(r.validatingFields, X, z) : St(r.validatingFields, X));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, O = (T, z = [], X, ae, V = !0, Q = !0) => {
    if (ae && X && !n.disabled) {
      if (s.action = !0, Q && Array.isArray(rn(i, T))) {
        const me = X(rn(i, T), ae.argA, ae.argB);
        V && it(i, T, me);
      }
      if (Q && Array.isArray(rn(r.errors, T))) {
        const me = X(rn(r.errors, T), ae.argA, ae.argB);
        V && it(r.errors, T, me), HT(r.errors, T);
      }
      if ((u.touchedFields || f.touchedFields) && Q && Array.isArray(rn(r.touchedFields, T))) {
        const me = X(rn(r.touchedFields, T), ae.argA, ae.argB);
        V && it(r.touchedFields, T, me);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Aa(a, o)), h.state.next({
        name: T,
        isDirty: R(T, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, T, z);
  }, I = (T, z) => {
    it(r.errors, T, z), h.state.next({
      errors: r.errors
    });
  }, C = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = (T, z, X, ae) => {
    const V = rn(i, T);
    if (V) {
      const Q = rn(o, T, ft(X) ? rn(a, T) : X);
      ft(Q) || ae && ae.defaultChecked || z ? it(o, T, z ? Q : Ov(V._f)) : we(T, Q), s.mount && x();
    }
  }, A = (T, z, X, ae, V) => {
    let Q = !1, me = !1;
    const _e = {
      name: T
    };
    if (!n.disabled) {
      if (!X || ae) {
        (u.isDirty || f.isDirty) && (me = r.isDirty, r.isDirty = _e.isDirty = R(), Q = me !== _e.isDirty);
        const Te = ui(rn(a, T), z);
        me = !!rn(r.dirtyFields, T), Te ? St(r.dirtyFields, T) : it(r.dirtyFields, T, !0), _e.dirtyFields = r.dirtyFields, Q = Q || (u.dirtyFields || f.dirtyFields) && me !== !Te;
      }
      if (X) {
        const Te = rn(r.touchedFields, T);
        Te || (it(r.touchedFields, T, X), _e.touchedFields = r.touchedFields, Q = Q || (u.touchedFields || f.touchedFields) && Te !== X);
      }
      Q && V && h.state.next(_e);
    }
    return Q ? _e : {};
  }, B = (T, z, X, ae) => {
    const V = rn(r.errors, T), Q = (u.isValid || f.isValid) && or(z) && r.isValid !== z;
    if (n.delayError && X ? (d = N(() => I(T, X)), d(n.delayError)) : (clearTimeout(m), d = null, X ? it(r.errors, T, X) : St(r.errors, T)), (X ? !ui(V, X) : V) || !Wt(ae) || Q) {
      const me = {
        ...ae,
        ...Q && or(z) ? { isValid: z } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...me
      }, h.state.next(me);
    }
  }, K = async (T) => {
    g(T, !0);
    const z = await n.resolver(o, n.context, VT(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(T), z;
  }, ee = async (T) => {
    const { errors: z } = await K(T);
    if (T)
      for (const X of T) {
        const ae = rn(z, X);
        ae ? it(r.errors, X, ae) : St(r.errors, X);
      }
    else
      r.errors = z;
    return z;
  }, G = async (T, z, X = {
    valid: !0
  }) => {
    for (const ae in T) {
      const V = T[ae];
      if (V) {
        const { _f: Q, ...me } = V;
        if (Q) {
          const _e = l.array.has(Q.name), Te = V._f && zT(V._f);
          Te && u.validatingFields && g([ae], !0);
          const tn = await zv(V, l.disabled, o, j, n.shouldUseNativeValidation && !z, _e);
          if (Te && u.validatingFields && g([ae]), tn[Q.name] && (X.valid = !1, z))
            break;
          !z && (rn(tn, Q.name) ? _e ? WT(r.errors, tn, Q.name) : it(r.errors, Q.name, tn[Q.name]) : St(r.errors, Q.name));
        }
        !Wt(me) && await G(me, z, X);
      }
    }
    return X.valid;
  }, H = () => {
    for (const T of l.unMount) {
      const z = rn(i, T);
      z && (z._f.refs ? z._f.refs.every((X) => !cc(X)) : !cc(z._f.ref)) && Be(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (T, z) => !n.disabled && (T && z && it(o, T, z), !ui($e(), a)), q = (T, z, X) => uC(T, l, {
    ...s.mount ? o : ft(z) ? a : Ur(T) ? { [T]: z } : z
  }, X, z), te = (T) => Dl(rn(s.mount ? o : a, T, n.shouldUnregister ? rn(a, T, []) : [])), we = (T, z, X = {}) => {
    const ae = rn(i, T);
    let V = z;
    if (ae) {
      const Q = ae._f;
      Q && (!Q.disabled && it(o, T, yC(z, Q)), V = el(Q.ref) && Gt(z) ? "" : z, mC(Q.ref) ? [...Q.ref.options].forEach((me) => me.selected = V.includes(me.value)) : Q.refs ? zo(Q.ref) ? Q.refs.length > 1 ? Q.refs.forEach((me) => (!me.defaultChecked || !me.disabled) && (me.checked = Array.isArray(V) ? !!V.find((_e) => _e === me.value) : V === me.value)) : Q.refs[0] && (Q.refs[0].checked = !!V) : Q.refs.forEach((me) => me.checked = me.value === V) : Py(Q.ref) ? Q.ref.value = "" : (Q.ref.value = V, Q.ref.type || h.state.next({
        name: T,
        values: Ot(o)
      })));
    }
    (X.shouldDirty || X.shouldTouch) && A(T, V, X.shouldTouch, X.shouldDirty, !0), X.shouldValidate && be(T);
  }, ve = (T, z, X) => {
    for (const ae in z) {
      const V = z[ae], Q = `${T}.${ae}`, me = rn(i, Q);
      (l.array.has(T) || gt(V) || me && !me._f) && !Ti(V) ? ve(Q, V, X) : we(Q, V, X);
    }
  }, ue = (T, z, X = {}) => {
    const ae = rn(i, T), V = l.array.has(T), Q = Ot(z);
    it(o, T, Q), V ? (h.array.next({
      name: T,
      values: Ot(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && X.shouldDirty && h.state.next({
      name: T,
      dirtyFields: Aa(a, o),
      isDirty: R(T, Q)
    })) : ae && !ae._f && !Gt(Q) ? ve(T, Q, X) : we(T, Q, X), Av(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: Ot(o)
    });
  }, ge = async (T) => {
    s.mount = !0;
    const z = T.target;
    let X = z.name, ae = !0;
    const V = rn(i, X), Q = (me) => {
      ae = Number.isNaN(me) || Ti(me) && isNaN(me.getTime()) || ui(me, rn(o, X, me));
    };
    if (V) {
      let me, _e;
      const Te = z.type ? Ov(V._f) : oC(T), tn = T.type === Zs.BLUR || T.type === Zs.FOCUS_OUT, vn = !UT(V._f) && !n.resolver && !rn(r.errors, X) && !V._f.deps || qT(tn, rn(r.touchedFields, X), r.isSubmitted, F, k), on = Av(X, l, tn);
      it(o, X, Te), tn ? (V._f.onBlur && V._f.onBlur(T), d && d(0)) : V._f.onChange && V._f.onChange(T);
      const pn = A(X, Te, tn), In = !Wt(pn) || on;
      if (!tn && h.state.next({
        name: X,
        type: T.type,
        values: Ot(o)
      }), vn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? tn && x() : tn || x()), In && h.state.next({ name: X, ...on ? {} : pn });
      if (!tn && on && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await K([X]);
        if (Q(Te), ae) {
          const En = Lv(r.errors, i, X), en = Lv(_n, i, En.name || X);
          me = en.error, X = en.name, _e = Wt(_n);
        }
      } else
        g([X], !0), me = (await zv(V, l.disabled, o, j, n.shouldUseNativeValidation))[X], g([X]), Q(Te), ae && (me ? _e = !1 : (u.isValid || f.isValid) && (_e = await G(i, !0)));
      ae && (V._f.deps && be(V._f.deps), B(X, _e, me, pn));
    }
  }, U = (T, z) => {
    if (rn(r.errors, z) && T.focus)
      return T.focus(), 1;
  }, be = async (T, z = {}) => {
    let X, ae;
    const V = bo(T);
    if (n.resolver) {
      const Q = await ee(ft(T) ? T : V);
      X = Wt(Q), ae = T ? !V.some((me) => rn(Q, me)) : X;
    } else T ? (ae = (await Promise.all(V.map(async (Q) => {
      const me = rn(i, Q);
      return await G(me && me._f ? { [Q]: me } : me);
    }))).every(Boolean), !(!ae && !r.isValid) && x()) : ae = X = await G(i);
    return h.state.next({
      ...!Ur(T) || (u.isValid || f.isValid) && X !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: X } : {},
      errors: r.errors
    }), z.shouldFocus && !ae && xo(i, U, T ? V : l.mount), ae;
  }, $e = (T) => {
    const z = {
      ...s.mount ? o : a
    };
    return ft(T) ? z : Ur(T) ? rn(z, T) : T.map((X) => rn(z, X));
  }, W = (T, z) => ({
    invalid: !!rn((z || r).errors, T),
    isDirty: !!rn((z || r).dirtyFields, T),
    error: rn((z || r).errors, T),
    isValidating: !!rn(r.validatingFields, T),
    isTouched: !!rn((z || r).touchedFields, T)
  }), Ge = (T) => {
    T && bo(T).forEach((z) => St(r.errors, z)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, sn = (T, z, X) => {
    const ae = (rn(i, T, { _f: {} })._f || {}).ref, V = rn(r.errors, T) || {}, { ref: Q, message: me, type: _e, ...Te } = V;
    it(r.errors, T, {
      ...Te,
      ...z,
      ref: ae
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), X && X.shouldFocus && ae && ae.focus && ae.focus();
  }, Fe = (T, z) => wr(T) ? h.state.subscribe({
    next: (X) => T(q(void 0, z), X)
  }) : q(T, z, !0), Ue = (T) => h.state.subscribe({
    next: (z) => {
      BT(T.name, z.name, T.exact) && MT(z, T.formState || u, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, Re = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Ue({
    ...T,
    formState: f
  })), Be = (T, z = {}) => {
    for (const X of T ? bo(T) : l.mount)
      l.mount.delete(X), l.array.delete(X), z.keepValue || (St(i, X), St(o, X)), !z.keepError && St(r.errors, X), !z.keepDirty && St(r.dirtyFields, X), !z.keepTouched && St(r.touchedFields, X), !z.keepIsValidating && St(r.validatingFields, X), !n.shouldUnregister && !z.keepDefaultValue && St(a, X);
    h.state.next({
      values: Ot(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: R() } : {}
    }), !z.keepIsValid && x();
  }, Ae = ({ disabled: T, name: z }) => {
    (or(T) && s.mount || T || l.disabled.has(z)) && (T ? l.disabled.add(z) : l.disabled.delete(z));
  }, Je = (T, z = {}) => {
    let X = rn(i, T);
    const ae = or(z.disabled) || or(n.disabled);
    return it(i, T, {
      ...X || {},
      _f: {
        ...X && X._f ? X._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...z
      }
    }), l.mount.add(T), X ? Ae({
      disabled: or(z.disabled) ? z.disabled : n.disabled,
      name: T
    }) : w(T, !0, z.value), {
      ...ae ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: La(z.min),
        max: La(z.max),
        minLength: La(z.minLength),
        maxLength: La(z.maxLength),
        pattern: La(z.pattern)
      } : {},
      name: T,
      onChange: ge,
      onBlur: ge,
      ref: (V) => {
        if (V) {
          Je(T, z), X = rn(i, T);
          const Q = ft(V.value) && V.querySelectorAll && V.querySelectorAll("input,select,textarea")[0] || V, me = PT(Q), _e = X._f.refs || [];
          if (me ? _e.find((Te) => Te === Q) : Q === X._f.ref)
            return;
          it(i, T, {
            _f: {
              ...X._f,
              ...me ? {
                refs: [
                  ..._e.filter(cc),
                  Q,
                  ...Array.isArray(rn(a, T)) ? [{}] : []
                ],
                ref: { type: Q.type, name: T }
              } : { ref: Q }
            }
          }), w(T, !1, void 0, Q);
        } else
          X = rn(i, T, {}), X._f && (X._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(sC(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Ce = () => n.shouldFocusError && xo(i, U, l.mount), Me = (T) => {
    or(T) && (h.state.next({ disabled: T }), xo(i, (z, X) => {
      const ae = rn(i, X);
      ae && (z.disabled = ae._f.disabled || T, Array.isArray(ae._f.refs) && ae._f.refs.forEach((V) => {
        V.disabled = ae._f.disabled || T;
      }));
    }, 0, !1));
  }, nn = (T, z) => async (X) => {
    let ae;
    X && (X.preventDefault && X.preventDefault(), X.persist && X.persist());
    let V = Ot(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: Q, values: me } = await K();
      r.errors = Q, V = me;
    } else
      await G(i);
    if (l.disabled.size)
      for (const Q of l.disabled)
        it(V, Q, void 0);
    if (St(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(V, X);
      } catch (Q) {
        ae = Q;
      }
    } else
      z && await z({ ...r.errors }, X), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ae,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ae)
      throw ae;
  }, se = (T, z = {}) => {
    rn(i, T) && (ft(z.defaultValue) ? ue(T, Ot(rn(a, T))) : (ue(T, z.defaultValue), it(a, T, Ot(z.defaultValue))), z.keepTouched || St(r.touchedFields, T), z.keepDirty || (St(r.dirtyFields, T), r.isDirty = z.defaultValue ? R(T, Ot(rn(a, T))) : R()), z.keepError || (St(r.errors, T), u.isValid && x()), h.state.next({ ...r }));
  }, le = (T, z = {}) => {
    const X = T ? Ot(T) : a, ae = Ot(X), V = Wt(T), Q = V ? a : ae;
    if (z.keepDefaultValues || (a = X), !z.keepValues) {
      if (z.keepDirtyValues) {
        const me = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Aa(a, o))
        ]);
        for (const _e of Array.from(me))
          rn(r.dirtyFields, _e) ? it(Q, _e, rn(o, _e)) : ue(_e, rn(Q, _e));
      } else {
        if (Ty && ft(T))
          for (const me of l.mount) {
            const _e = rn(i, me);
            if (_e && _e._f) {
              const Te = Array.isArray(_e._f.refs) ? _e._f.refs[0] : _e._f.ref;
              if (el(Te)) {
                const tn = Te.closest("form");
                if (tn) {
                  tn.reset();
                  break;
                }
              }
            }
          }
        for (const me of l.mount)
          ue(me, rn(Q, me));
      }
      o = Ot(Q), h.array.next({
        values: { ...Q }
      }), h.state.next({
        values: { ...Q }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: V ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !ui(T, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: V ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Aa(a, o) : r.dirtyFields : z.keepDefaultValues && T ? Aa(a, T) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (T, z) => le(wr(T) ? T(o) : T, z), Le = (T, z = {}) => {
    const X = rn(i, T), ae = X && X._f;
    if (ae) {
      const V = ae.refs ? ae.refs[0] : ae.ref;
      V.focus && (V.focus(), z.shouldSelect && wr(V.select) && V.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, J = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: W,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: K,
      _getWatch: q,
      _getDirty: R,
      _setValid: x,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: te,
      _reset: le,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then((T) => {
        Se(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: H,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Re,
    trigger: be,
    register: Je,
    handleSubmit: nn,
    watch: Fe,
    setValue: ue,
    getValues: $e,
    reset: Se,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Le,
    getFieldState: W
  };
  return {
    ...J,
    formControl: J
  };
}
function mt(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : GT(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !ui(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = dC(i, o), n.current;
}
var es = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dc = { exports: {} }, Va = {}, Uv;
function YT() {
  if (Uv) return Va;
  Uv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Va.Fragment = r, Va.jsx = s, Va.jsxs = s, Va;
}
var ns = {}, Mv;
function QT() {
  return Mv || (Mv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ns.Fragment = i, ns.jsx = Un, ns.jsxs = Kn;
  })()), ns;
}
var Bv;
function JT() {
  return Bv || (Bv = 1, process.env.NODE_ENV === "production" ? dc.exports = YT() : dc.exports = QT()), dc.exports;
}
var Ri = JT();
function XT(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var uc, qv;
function yi() {
  if (qv) return uc;
  qv = 1;
  var e = Array.isArray;
  return uc = e, uc;
}
var mc, Hv;
function kC() {
  if (Hv) return mc;
  Hv = 1;
  var e = typeof es == "object" && es && es.Object === Object && es;
  return mc = e, mc;
}
var pc, Wv;
function Hr() {
  if (Wv) return pc;
  Wv = 1;
  var e = kC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return pc = r, pc;
}
var fc, Kv;
function Uo() {
  if (Kv) return fc;
  Kv = 1;
  var e = Hr(), n = e.Symbol;
  return fc = n, fc;
}
var hc, Gv;
function ZT() {
  if (Gv) return hc;
  Gv = 1;
  var e = Uo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return hc = o, hc;
}
var yc, Yv;
function eD() {
  if (Yv) return yc;
  Yv = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return yc = r, yc;
}
var gc, Qv;
function Na() {
  if (Qv) return gc;
  Qv = 1;
  var e = Uo(), n = ZT(), r = eD(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return gc = s, gc;
}
var vc, Jv;
function Ui() {
  if (Jv) return vc;
  Jv = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return vc = e, vc;
}
var kc, Xv;
function Ly() {
  if (Xv) return kc;
  Xv = 1;
  var e = Na(), n = Ui(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return kc = i, kc;
}
var bc, Zv;
function nD() {
  if (Zv) return bc;
  Zv = 1;
  var e = yi(), n = Ly(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return bc = a, bc;
}
var xc, ek;
function ja() {
  if (ek) return xc;
  ek = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return xc = e, xc;
}
var _c, nk;
function bC() {
  if (nk) return _c;
  nk = 1;
  var e = Na(), n = ja(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return _c = s, _c;
}
var Sc, tk;
function tD() {
  if (tk) return Sc;
  tk = 1;
  var e = Hr(), n = e["__core-js_shared__"];
  return Sc = n, Sc;
}
var Nc, rk;
function rD() {
  if (rk) return Nc;
  rk = 1;
  var e = tD(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Nc = r, Nc;
}
var jc, ik;
function xC() {
  if (ik) return jc;
  ik = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return jc = r, jc;
}
var wc, ak;
function iD() {
  if (ak) return wc;
  ak = 1;
  var e = bC(), n = rD(), r = ja(), i = xC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return wc = f, wc;
}
var Cc, ok;
function aD() {
  if (ok) return Cc;
  ok = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Cc = e, Cc;
}
var Fc, sk;
function Mi() {
  if (sk) return Fc;
  sk = 1;
  var e = iD(), n = aD();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Fc = r, Fc;
}
var Ic, lk;
function Ol() {
  if (lk) return Ic;
  lk = 1;
  var e = Mi(), n = e(Object, "create");
  return Ic = n, Ic;
}
var Ec, ck;
function oD() {
  if (ck) return Ec;
  ck = 1;
  var e = Ol();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ec = n, Ec;
}
var $c, dk;
function sD() {
  if (dk) return $c;
  dk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return $c = e, $c;
}
var Tc, uk;
function lD() {
  if (uk) return Tc;
  uk = 1;
  var e = Ol(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Tc = a, Tc;
}
var Dc, mk;
function cD() {
  if (mk) return Dc;
  mk = 1;
  var e = Ol(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Dc = i, Dc;
}
var Oc, pk;
function dD() {
  if (pk) return Oc;
  pk = 1;
  var e = Ol(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Oc = r, Oc;
}
var Rc, fk;
function uD() {
  if (fk) return Rc;
  fk = 1;
  var e = oD(), n = sD(), r = lD(), i = cD(), a = dD();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Rc = o, Rc;
}
var Pc, hk;
function mD() {
  if (hk) return Pc;
  hk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Pc = e, Pc;
}
var Ac, yk;
function _C() {
  if (yk) return Ac;
  yk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Ac = e, Ac;
}
var Lc, gk;
function Rl() {
  if (gk) return Lc;
  gk = 1;
  var e = _C();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Lc = n, Lc;
}
var Vc, vk;
function pD() {
  if (vk) return Vc;
  vk = 1;
  var e = Rl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Vc = i, Vc;
}
var zc, kk;
function fD() {
  if (kk) return zc;
  kk = 1;
  var e = Rl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return zc = n, zc;
}
var Uc, bk;
function hD() {
  if (bk) return Uc;
  bk = 1;
  var e = Rl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Uc = n, Uc;
}
var Mc, xk;
function yD() {
  if (xk) return Mc;
  xk = 1;
  var e = Rl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Mc = n, Mc;
}
var Bc, _k;
function Pl() {
  if (_k) return Bc;
  _k = 1;
  var e = mD(), n = pD(), r = fD(), i = hD(), a = yD();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Bc = o, Bc;
}
var qc, Sk;
function Vy() {
  if (Sk) return qc;
  Sk = 1;
  var e = Mi(), n = Hr(), r = e(n, "Map");
  return qc = r, qc;
}
var Hc, Nk;
function gD() {
  if (Nk) return Hc;
  Nk = 1;
  var e = uD(), n = Pl(), r = Vy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Hc = i, Hc;
}
var Wc, jk;
function vD() {
  if (jk) return Wc;
  jk = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Wc = e, Wc;
}
var Kc, wk;
function Al() {
  if (wk) return Kc;
  wk = 1;
  var e = vD();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Kc = n, Kc;
}
var Gc, Ck;
function kD() {
  if (Ck) return Gc;
  Ck = 1;
  var e = Al();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Gc = n, Gc;
}
var Yc, Fk;
function bD() {
  if (Fk) return Yc;
  Fk = 1;
  var e = Al();
  function n(r) {
    return e(this, r).get(r);
  }
  return Yc = n, Yc;
}
var Qc, Ik;
function xD() {
  if (Ik) return Qc;
  Ik = 1;
  var e = Al();
  function n(r) {
    return e(this, r).has(r);
  }
  return Qc = n, Qc;
}
var Jc, Ek;
function _D() {
  if (Ek) return Jc;
  Ek = 1;
  var e = Al();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Jc = n, Jc;
}
var Xc, $k;
function SC() {
  if ($k) return Xc;
  $k = 1;
  var e = gD(), n = kD(), r = bD(), i = xD(), a = _D();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Xc = o, Xc;
}
var Zc, Tk;
function SD() {
  if (Tk) return Zc;
  Tk = 1;
  var e = SC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Zc = r, Zc;
}
var ed, Dk;
function ND() {
  if (Dk) return ed;
  Dk = 1;
  var e = SD(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return ed = r, ed;
}
var nd, Ok;
function jD() {
  if (Ok) return nd;
  Ok = 1;
  var e = ND(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return nd = i, nd;
}
var td, Rk;
function NC() {
  if (Rk) return td;
  Rk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return td = e, td;
}
var rd, Pk;
function wD() {
  if (Pk) return rd;
  Pk = 1;
  var e = Uo(), n = NC(), r = yi(), i = Ly(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return rd = s, rd;
}
var id, Ak;
function CD() {
  if (Ak) return id;
  Ak = 1;
  var e = wD();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return id = n, id;
}
var ad, Lk;
function wa() {
  if (Lk) return ad;
  Lk = 1;
  var e = yi(), n = nD(), r = jD(), i = CD();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return ad = a, ad;
}
var od, Vk;
function Ll() {
  if (Vk) return od;
  Vk = 1;
  var e = Ly();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return od = n, od;
}
var sd, zk;
function jC() {
  if (zk) return sd;
  zk = 1;
  var e = wa(), n = Ll();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return sd = r, sd;
}
var ld, Uk;
function wC() {
  if (Uk) return ld;
  Uk = 1;
  var e = Mi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return ld = n, ld;
}
var cd, Mk;
function CC() {
  if (Mk) return cd;
  Mk = 1;
  var e = wC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return cd = n, cd;
}
var dd, Bk;
function zy() {
  if (Bk) return dd;
  Bk = 1;
  var e = CC(), n = _C(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return dd = a, dd;
}
var ud, qk;
function Uy() {
  if (qk) return ud;
  qk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return ud = r, ud;
}
var md, Hk;
function FD() {
  if (Hk) return md;
  Hk = 1;
  var e = zy(), n = wa(), r = Uy(), i = ja(), a = Ll();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var F = a(l[u]), j = d;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (u != h) {
        var N = k[F];
        j = m ? m(N, F, k) : void 0, j === void 0 && (j = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(k, F, j), k = k[F];
    }
    return s;
  }
  return md = o, md;
}
var pd, Wk;
function ID() {
  if (Wk) return pd;
  Wk = 1;
  var e = jC(), n = FD(), r = wa();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return pd = i, pd;
}
var fd, Kk;
function ED() {
  if (Kk) return fd;
  Kk = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return fd = e, fd;
}
var hd, Gk;
function $D() {
  if (Gk) return hd;
  Gk = 1;
  var e = Na(), n = Ui(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return hd = i, hd;
}
var yd, Yk;
function My() {
  if (Yk) return yd;
  Yk = 1;
  var e = $D(), n = Ui(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return yd = o, yd;
}
var gd, Qk;
function By() {
  if (Qk) return gd;
  Qk = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return gd = n, gd;
}
var vd, Jk;
function TD() {
  if (Jk) return vd;
  Jk = 1;
  var e = wa(), n = My(), r = yi(), i = Uy(), a = By(), o = Ll();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return vd = s, vd;
}
var kd, Xk;
function DD() {
  if (Xk) return kd;
  Xk = 1;
  var e = ED(), n = TD();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return kd = r, kd;
}
var bd, Zk;
function OD() {
  if (Zk) return bd;
  Zk = 1;
  var e = ID(), n = DD();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return bd = r, bd;
}
var xd, eb;
function qy() {
  if (eb) return xd;
  eb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return xd = e, xd;
}
var _d, nb;
function RD() {
  if (nb) return _d;
  nb = 1;
  var e = Uo(), n = My(), r = yi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return _d = a, _d;
}
var Sd, tb;
function PD() {
  if (tb) return Sd;
  tb = 1;
  var e = qy(), n = RD();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Sd = r, Sd;
}
var Nd, rb;
function AD() {
  if (rb) return Nd;
  rb = 1;
  var e = PD();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Nd = n, Nd;
}
var jd, ib;
function LD() {
  if (ib) return jd;
  ib = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return jd = e, jd;
}
var wd, ab;
function VD() {
  if (ab) return wd;
  ab = 1;
  var e = LD(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return wd = r, wd;
}
var Cd, ob;
function zD() {
  if (ob) return Cd;
  ob = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Cd = e, Cd;
}
var Fd, sb;
function FC() {
  if (sb) return Fd;
  sb = 1;
  function e(n) {
    return n;
  }
  return Fd = e, Fd;
}
var Id, lb;
function UD() {
  if (lb) return Id;
  lb = 1;
  var e = zD(), n = wC(), r = FC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Id = i, Id;
}
var Ed, cb;
function MD() {
  if (cb) return Ed;
  cb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ed = i, Ed;
}
var $d, db;
function BD() {
  if (db) return $d;
  db = 1;
  var e = UD(), n = MD(), r = n(e);
  return $d = r, $d;
}
var Td, ub;
function IC() {
  if (ub) return Td;
  ub = 1;
  var e = AD(), n = VD(), r = BD();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Td = i, Td;
}
var Dd, mb;
function qD() {
  if (mb) return Dd;
  mb = 1;
  var e = OD(), n = IC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Dd = r, Dd;
}
var HD = qD();
const EC = /* @__PURE__ */ vC(HD), WD = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function $C(e) {
  const n = EC(e, WD);
  return {
    controller: Ry(n),
    controllerProps: n
  };
}
const KD = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function TC(e) {
  const { controller: n, controllerProps: r } = $C(e), i = {
    ...EC(e, KD),
    required: XT(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Od, pb;
function GD() {
  if (pb) return Od;
  pb = 1;
  var e = Pl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Od = n, Od;
}
var Rd, fb;
function YD() {
  if (fb) return Rd;
  fb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Rd = e, Rd;
}
var Pd, hb;
function QD() {
  if (hb) return Pd;
  hb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Pd = e, Pd;
}
var Ad, yb;
function JD() {
  if (yb) return Ad;
  yb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Ad = e, Ad;
}
var Ld, gb;
function XD() {
  if (gb) return Ld;
  gb = 1;
  var e = Pl(), n = Vy(), r = SC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Ld = a, Ld;
}
var Vd, vb;
function ZD() {
  if (vb) return Vd;
  vb = 1;
  var e = Pl(), n = GD(), r = YD(), i = QD(), a = JD(), o = XD();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Vd = s, Vd;
}
var zd, kb;
function eO() {
  if (kb) return zd;
  kb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return zd = e, zd;
}
var Ud, bb;
function Mo() {
  if (bb) return Ud;
  bb = 1;
  var e = zy(), n = CC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Ud = r, Ud;
}
var Md, xb;
function nO() {
  if (xb) return Md;
  xb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Md = e, Md;
}
var zs = { exports: {} }, Bd, _b;
function tO() {
  if (_b) return Bd;
  _b = 1;
  function e() {
    return !1;
  }
  return Bd = e, Bd;
}
zs.exports;
var Sb;
function DC() {
  return Sb || (Sb = 1, (function(e, n) {
    var r = Hr(), i = tO(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(zs, zs.exports)), zs.exports;
}
var qd, Nb;
function rO() {
  if (Nb) return qd;
  Nb = 1;
  var e = Na(), n = By(), r = Ui(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", F = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", I = "[object Int8Array]", C = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", B = "[object Uint8ClampedArray]", K = "[object Uint16Array]", ee = "[object Uint32Array]", G = {};
  G[g] = G[O] = G[I] = G[C] = G[w] = G[A] = G[B] = G[K] = G[ee] = !0, G[i] = G[a] = G[N] = G[o] = G[x] = G[s] = G[l] = G[d] = G[m] = G[u] = G[f] = G[h] = G[k] = G[F] = G[j] = !1;
  function H(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return qd = H, qd;
}
var Hd, jb;
function Hy() {
  if (jb) return Hd;
  jb = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Hd = e, Hd;
}
var Us = { exports: {} };
Us.exports;
var wb;
function Wy() {
  return wb || (wb = 1, (function(e, n) {
    var r = kC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Us, Us.exports)), Us.exports;
}
var Wd, Cb;
function iO() {
  if (Cb) return Wd;
  Cb = 1;
  var e = rO(), n = Hy(), r = Wy(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Wd = a, Wd;
}
var Kd, Fb;
function OC() {
  if (Fb) return Kd;
  Fb = 1;
  var e = nO(), n = My(), r = yi(), i = DC(), a = Uy(), o = iO(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), F = !f && !h && !k && o(m), j = f || h || k || F, N = j ? e(m.length, String) : [], x = N.length;
    for (var g in m)
      (u || l.call(m, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return Kd = d, Kd;
}
var Gd, Ib;
function Ky() {
  if (Ib) return Gd;
  Ib = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Gd = n, Gd;
}
var Yd, Eb;
function RC() {
  if (Eb) return Yd;
  Eb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Yd = e, Yd;
}
var Qd, $b;
function aO() {
  if ($b) return Qd;
  $b = 1;
  var e = RC(), n = e(Object.keys, Object);
  return Qd = n, Qd;
}
var Jd, Tb;
function oO() {
  if (Tb) return Jd;
  Tb = 1;
  var e = Ky(), n = aO(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Jd = a, Jd;
}
var Xd, Db;
function PC() {
  if (Db) return Xd;
  Db = 1;
  var e = bC(), n = By();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Xd = r, Xd;
}
var Zd, Ob;
function Gy() {
  if (Ob) return Zd;
  Ob = 1;
  var e = OC(), n = oO(), r = PC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Zd = i, Zd;
}
var eu, Rb;
function sO() {
  if (Rb) return eu;
  Rb = 1;
  var e = Mo(), n = Gy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return eu = r, eu;
}
var nu, Pb;
function lO() {
  if (Pb) return nu;
  Pb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return nu = e, nu;
}
var tu, Ab;
function cO() {
  if (Ab) return tu;
  Ab = 1;
  var e = ja(), n = Ky(), r = lO(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return tu = o, tu;
}
var ru, Lb;
function Yy() {
  if (Lb) return ru;
  Lb = 1;
  var e = OC(), n = cO(), r = PC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return ru = i, ru;
}
var iu, Vb;
function dO() {
  if (Vb) return iu;
  Vb = 1;
  var e = Mo(), n = Yy();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return iu = r, iu;
}
var Ms = { exports: {} };
Ms.exports;
var zb;
function uO() {
  return zb || (zb = 1, (function(e, n) {
    var r = Hr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Ms, Ms.exports)), Ms.exports;
}
var au, Ub;
function mO() {
  if (Ub) return au;
  Ub = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return au = e, au;
}
var ou, Mb;
function pO() {
  if (Mb) return ou;
  Mb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ou = e, ou;
}
var su, Bb;
function AC() {
  if (Bb) return su;
  Bb = 1;
  function e() {
    return [];
  }
  return su = e, su;
}
var lu, qb;
function Qy() {
  if (qb) return lu;
  qb = 1;
  var e = pO(), n = AC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return lu = o, lu;
}
var cu, Hb;
function fO() {
  if (Hb) return cu;
  Hb = 1;
  var e = Mo(), n = Qy();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return cu = r, cu;
}
var du, Wb;
function Jy() {
  if (Wb) return du;
  Wb = 1;
  var e = RC(), n = e(Object.getPrototypeOf, Object);
  return du = n, du;
}
var uu, Kb;
function LC() {
  if (Kb) return uu;
  Kb = 1;
  var e = qy(), n = Jy(), r = Qy(), i = AC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return uu = o, uu;
}
var mu, Gb;
function hO() {
  if (Gb) return mu;
  Gb = 1;
  var e = Mo(), n = LC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return mu = r, mu;
}
var pu, Yb;
function VC() {
  if (Yb) return pu;
  Yb = 1;
  var e = qy(), n = yi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return pu = r, pu;
}
var fu, Qb;
function yO() {
  if (Qb) return fu;
  Qb = 1;
  var e = VC(), n = Qy(), r = Gy();
  function i(a) {
    return e(a, r, n);
  }
  return fu = i, fu;
}
var hu, Jb;
function zC() {
  if (Jb) return hu;
  Jb = 1;
  var e = VC(), n = LC(), r = Yy();
  function i(a) {
    return e(a, r, n);
  }
  return hu = i, hu;
}
var yu, Xb;
function gO() {
  if (Xb) return yu;
  Xb = 1;
  var e = Mi(), n = Hr(), r = e(n, "DataView");
  return yu = r, yu;
}
var gu, Zb;
function vO() {
  if (Zb) return gu;
  Zb = 1;
  var e = Mi(), n = Hr(), r = e(n, "Promise");
  return gu = r, gu;
}
var vu, ex;
function kO() {
  if (ex) return vu;
  ex = 1;
  var e = Mi(), n = Hr(), r = e(n, "Set");
  return vu = r, vu;
}
var ku, nx;
function bO() {
  if (nx) return ku;
  nx = 1;
  var e = Mi(), n = Hr(), r = e(n, "WeakMap");
  return ku = r, ku;
}
var bu, tx;
function Xy() {
  if (tx) return bu;
  tx = 1;
  var e = gO(), n = Vy(), r = vO(), i = kO(), a = bO(), o = Na(), s = xC(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), F = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var I = o(O), C = I == d ? O.constructor : void 0, w = C ? s(C) : "";
    if (w)
      switch (w) {
        case k:
          return h;
        case F:
          return l;
        case j:
          return m;
        case N:
          return u;
        case x:
          return f;
      }
    return I;
  }), bu = g, bu;
}
var xu, rx;
function xO() {
  if (rx) return xu;
  rx = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return xu = r, xu;
}
var _u, ix;
function _O() {
  if (ix) return _u;
  ix = 1;
  var e = Hr(), n = e.Uint8Array;
  return _u = n, _u;
}
var Su, ax;
function Zy() {
  if (ax) return Su;
  ax = 1;
  var e = _O();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Su = n, Su;
}
var Nu, ox;
function SO() {
  if (ox) return Nu;
  ox = 1;
  var e = Zy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Nu = n, Nu;
}
var ju, sx;
function NO() {
  if (sx) return ju;
  sx = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return ju = n, ju;
}
var wu, lx;
function jO() {
  if (lx) return wu;
  lx = 1;
  var e = Uo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return wu = i, wu;
}
var Cu, cx;
function wO() {
  if (cx) return Cu;
  cx = 1;
  var e = Zy();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Cu = n, Cu;
}
var Fu, dx;
function CO() {
  if (dx) return Fu;
  dx = 1;
  var e = Zy(), n = SO(), r = NO(), i = jO(), a = wO(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", F = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", I = "[object Uint8Array]", C = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function B(K, ee, G) {
    var H = K.constructor;
    switch (ee) {
      case k:
        return e(K);
      case o:
      case s:
        return new H(+K);
      case F:
        return n(K, G);
      case j:
      case N:
      case x:
      case g:
      case O:
      case I:
      case C:
      case w:
      case A:
        return a(K, G);
      case l:
        return new H();
      case d:
      case f:
        return new H(K);
      case m:
        return r(K);
      case u:
        return new H();
      case h:
        return i(K);
    }
  }
  return Fu = B, Fu;
}
var Iu, ux;
function FO() {
  if (ux) return Iu;
  ux = 1;
  var e = ja(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Iu = r, Iu;
}
var Eu, mx;
function IO() {
  if (mx) return Eu;
  mx = 1;
  var e = FO(), n = Jy(), r = Ky();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Eu = i, Eu;
}
var $u, px;
function EO() {
  if (px) return $u;
  px = 1;
  var e = Xy(), n = Ui(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return $u = i, $u;
}
var Tu, fx;
function $O() {
  if (fx) return Tu;
  fx = 1;
  var e = EO(), n = Hy(), r = Wy(), i = r && r.isMap, a = i ? n(i) : e;
  return Tu = a, Tu;
}
var Du, hx;
function TO() {
  if (hx) return Du;
  hx = 1;
  var e = Xy(), n = Ui(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Du = i, Du;
}
var Ou, yx;
function DO() {
  if (yx) return Ou;
  yx = 1;
  var e = TO(), n = Hy(), r = Wy(), i = r && r.isSet, a = i ? n(i) : e;
  return Ou = a, Ou;
}
var Ru, gx;
function OO() {
  if (gx) return Ru;
  gx = 1;
  var e = ZD(), n = eO(), r = zy(), i = sO(), a = dO(), o = uO(), s = mO(), l = fO(), d = hO(), m = yO(), u = zC(), f = Xy(), h = xO(), k = CO(), F = IO(), j = yi(), N = DC(), x = $O(), g = ja(), O = DO(), I = Gy(), C = Yy(), w = 1, A = 2, B = 4, K = "[object Arguments]", ee = "[object Array]", G = "[object Boolean]", H = "[object Date]", R = "[object Error]", q = "[object Function]", te = "[object GeneratorFunction]", we = "[object Map]", ve = "[object Number]", ue = "[object Object]", ge = "[object RegExp]", U = "[object Set]", be = "[object String]", $e = "[object Symbol]", W = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Fe = "[object Float32Array]", Ue = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", se = {};
  se[K] = se[ee] = se[Ge] = se[sn] = se[G] = se[H] = se[Fe] = se[Ue] = se[Re] = se[Be] = se[Ae] = se[we] = se[ve] = se[ue] = se[ge] = se[U] = se[be] = se[$e] = se[Je] = se[Ce] = se[Me] = se[nn] = !0, se[R] = se[q] = se[W] = !1;
  function le(Se, Le, Pe, gn, J, T) {
    var z, X = Le & w, ae = Le & A, V = Le & B;
    if (Pe && (z = J ? Pe(Se, gn, J, T) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var Q = j(Se);
    if (Q) {
      if (z = h(Se), !X)
        return s(Se, z);
    } else {
      var me = f(Se), _e = me == q || me == te;
      if (N(Se))
        return o(Se, X);
      if (me == ue || me == K || _e && !J) {
        if (z = ae || _e ? {} : F(Se), !X)
          return ae ? d(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[me])
          return J ? Se : {};
        z = k(Se, me, X);
      }
    }
    T || (T = new e());
    var Te = T.get(Se);
    if (Te)
      return Te;
    T.set(Se, z), O(Se) ? Se.forEach(function(on) {
      z.add(le(on, Le, Pe, on, Se, T));
    }) : x(Se) && Se.forEach(function(on, pn) {
      z.set(pn, le(on, Le, Pe, pn, Se, T));
    });
    var tn = V ? ae ? u : m : ae ? C : I, vn = Q ? void 0 : tn(Se);
    return n(vn || Se, function(on, pn) {
      vn && (pn = on, on = Se[pn]), r(z, pn, le(on, Le, Pe, pn, Se, T));
    }), z;
  }
  return Ru = le, Ru;
}
var Pu, vx;
function RO() {
  if (vx) return Pu;
  vx = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Pu = e, Pu;
}
var Au, kx;
function PO() {
  if (kx) return Au;
  kx = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Au = e, Au;
}
var Lu, bx;
function AO() {
  if (bx) return Lu;
  bx = 1;
  var e = jC(), n = PO();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Lu = r, Lu;
}
var Vu, xx;
function LO() {
  if (xx) return Vu;
  xx = 1;
  var e = wa(), n = RO(), r = AO(), i = Ll(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Vu = s, Vu;
}
var zu, _x;
function VO() {
  if (_x) return zu;
  _x = 1;
  var e = Na(), n = Jy(), r = Ui(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return zu = m, zu;
}
var Uu, Sx;
function zO() {
  if (Sx) return Uu;
  Sx = 1;
  var e = VO();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Uu = n, Uu;
}
var Mu, Nx;
function UO() {
  if (Nx) return Mu;
  Nx = 1;
  var e = NC(), n = OO(), r = LO(), i = wa(), a = Mo(), o = zO(), s = IC(), l = zC(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var F = {};
    if (h == null)
      return F;
    var j = !1;
    k = e(k, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), F), j && (F = n(F, d | m | u, o));
    for (var N = k.length; N--; )
      r(F, k[N]);
    return F;
  });
  return Mu = f, Mu;
}
UO();
const _r = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = TC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ Ri.jsx(He, { ...a, children: /* @__PURE__ */ Ri.jsx(
    ni,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: He.getStatus(a.meta),
      children: e
    }
  ) });
};
var MO = FC();
const BO = /* @__PURE__ */ vC(MO), xn = ({
  transformValue: e = BO,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = $C(a);
  return /* @__PURE__ */ Ri.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ri.jsx(
      Io,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ri.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, An = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = TC(e);
  return /* @__PURE__ */ Ri.jsx(He, { ...i, children: /* @__PURE__ */ Ri.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bu = { exports: {} }, za = {}, jx;
function qO() {
  if (jx) return za;
  jx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var ts = {}, wx;
function HO() {
  return wx || (wx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ts.Fragment = i, ts.jsx = Un, ts.jsxs = Kn;
  })()), ts;
}
var Cx;
function WO() {
  return Cx || (Cx = 1, process.env.NODE_ENV === "production" ? Bu.exports = qO() : Bu.exports = HO()), Bu.exports;
}
var re = WO();
const KO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, GO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, YO = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": KO,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": GO
};
function UC(e) {
  return YO[e] ?? {};
}
const QO = UC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), JO = UC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), XO = "_copyIcon_10dvk_54", ZO = "_list_10dvk_59", eR = "_listItem_10dvk_69", nR = "_collapsible_10dvk_78", tR = "_collapsibleIsOpen_10dvk_86", rR = "_collapsibleHeader_10dvk_89", iR = "_collapsibleIconTrue_10dvk_92", aR = "_collapsibleIconFalse_10dvk_95", Mn = {
  copyIcon: XO,
  list: ZO,
  listItem: eR,
  collapsible: nR,
  collapsibleIsOpen: tR,
  collapsibleHeader: rR,
  collapsibleIconTrue: iR,
  collapsibleIconFalse: aR
}, oR = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx($.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ re.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Xe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: Jn(d).format(jt) })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: Jn(m).format(jt) })
          ] }) })
        ] })
      ]
    }
  );
}, sR = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(oR, { app: r, openByDefault: i === 0 }, i))
  ] });
}, lR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: i }),
          Li(a)
        ] })
      },
      o
    )) })
  ] }) });
}, cR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Ze,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Jn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Jn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, rl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ re.jsx(Ze, { content: n ? null : l(), children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(ye, { size: 14, name: o(), color: s() }) }) });
}, dR = "_wrapper_1xucg_1", uR = "_externalLink_1xucg_7", qu = {
  wrapper: dR,
  externalLink: uR
}, mR = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Qt(), { isCopied: i, copy: a } = Qt(), { isCopied: o, copy: s } = Qt(), { isCopied: l, copy: d } = Qt(), { isCopied: m, copy: u } = Qt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: F,
    home_city: j,
    country: N,
    email: x,
    phone: g,
    dob: O,
    created_at: I,
    email_subscribe: C,
    push_subscribe: w
  } = e, A = 14, B = `${k || ""} ${F || ""}`.trim() || "A customer has no name", K = `${j ? `${j} /` : ""} ${N || ""}`.trim(), ee = O ? Jn(O).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { className: qu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: qu.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-2", children: B }),
          ee && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    I && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: Jn(I).format(jt) })
    ] }),
    K && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "map-pin" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: K })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy location", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ye,
        {
          size: A,
          name: o ? "done" : "copy",
          onClick: () => s(K),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    x && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "mail" }),
        /* @__PURE__ */ re.jsx("span", { className: qu.externalLink, children: x })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ye,
        {
          size: A,
          name: n ? "done" : "copy",
          onClick: () => r(x),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "phone" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ye,
        {
          size: A,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "user" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ re.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy Braze ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ye,
        {
          size: A,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "tag" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ re.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ re.jsx(Ze, { content: "Copy External ID", children: /* @__PURE__ */ re.jsx(b, { alignItems: "center", children: /* @__PURE__ */ re.jsx(
        ye,
        {
          size: A,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    C && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "sync" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { state: C })
    ] }),
    w && /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: A, name: "bell" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { isPush: !0, state: w })
    ] })
  ] }) });
}, pR = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ re.jsxs(
    b,
    {
      className: dt(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ re.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ re.jsx($.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ re.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ re.jsxs(Xe, { className: Mn.list, children: [
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ re.jsx(
              ye,
              {
                size: a,
                className: dt({
                  [Mn.collapsibleIconTrue]: d,
                  [Mn.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ re.jsx(Ze, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Ze, { content: "For iOS", children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, fR = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ re.jsx(Bn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ re.jsx(pR, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ua = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, rs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = Fn(), { useMutation: a } = yn(), [o, s] = de(!1), [l] = a(
    JO,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ua[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ re.jsx(Ze, { content: Ua[n].tooltipContent, children: /* @__PURE__ */ re.jsx(
    et,
    {
      variant: "secondary",
      color: Ua[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(
          rl,
          {
            noTooltip: !0,
            state: Ua[n].parameter
          }
        ),
        Ua[n].label
      ] })
    }
  ) });
}, hR = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ re.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: /* @__PURE__ */ re.jsx(Xe.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ re.jsx(ye, { size: 14, name: "sync" }),
        /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ re.jsx(rl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ re.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
        /* @__PURE__ */ re.jsx(
          rs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ re.jsx(
          rs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ re.jsx(
        rs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ re.jsx(
        rs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, yR = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ re.jsx(re.Fragment, { children: /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ re.jsx($.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ re.jsx(Xe, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ re.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ re.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ re.jsx(
            Ze,
            {
              content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ re.jsx(b, { children: `First ${Jn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ re.jsx(b, { children: `Last ${Jn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ re.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ re.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, gR = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Fn(), { useMutation: i } = yn(), [a, o] = de(), [s, l] = de(!1), [d, m] = de(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, F = n.displayCustomAttributes ?? !1, j = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, x = n.displayDevices ?? !1, g = n.displayApps ?? !1, O = !h && !k && !F && !j && !N, [I, { error: C }] = i(
    QO,
    {
      onError: () => {
      },
      onCompleted: (A) => {
        const B = A?.Braze?.exportUserDetails?.users?.[0];
        B ? (o(B), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), w = async () => {
    u || f ? await I({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Qe(() => {
    async function A() {
      m(!0), await w();
    }
    A().finally(() => m(!1));
  }, [u, f]), C) {
    const A = C.graphQLErrors;
    return xl({ errors: A }) ? /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: A }) ? /* @__PURE__ */ re.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ re.jsx(Tn, { error: C });
  }
  return d ? /* @__PURE__ */ re.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ re.jsx(hn, {}) }) : O ? /* @__PURE__ */ re.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ re.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ re.jsx(mR, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ re.jsx(
          hR,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await w()
          }
        ),
        F && !!a && /* @__PURE__ */ re.jsx(lR, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ re.jsx(cR, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ re.jsx(yR, { customerDetails: a }),
        x && !!a && /* @__PURE__ */ re.jsx(fR, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ re.jsx(sR, { apps: a?.apps })
      ]
    }
  );
}, il = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], vR = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...Sl([], il)
}, kR = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: vR
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: il,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: il,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ re.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ re.jsx(hr, { cause: h }),
        /* @__PURE__ */ re.jsxs(nt, { children: [
          /* @__PURE__ */ re.jsx(Z, { children: /* @__PURE__ */ re.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            An,
            {
              name: "apiHostName",
              label: "API endpoint",
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (B) => bl(B) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(
            Er,
            {
              name: "brazeApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer details", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display the button to change the email subscription state", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of custom attributes", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of custom events", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display a list of purchases", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer devices", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          /* @__PURE__ */ re.jsx(Z, { span: 3, children: /* @__PURE__ */ re.jsx(He, { label: "Display customer apps", children: /* @__PURE__ */ re.jsx(
            xn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ re.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          yr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function bR() {
  var e = ri(!1), n = yt(function() {
    return e.current;
  }, []);
  return Qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var xR = function(e) {
  e === void 0 && (e = {});
  var n = de(e), r = n[0], i = n[1], a = yt(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, _R = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, Fx = function(e) {
  return bI(_R, e);
}, Hu, Ix;
function SR() {
  return Ix || (Ix = 1, Hu = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Hu;
}
var Wu, Ex;
function NR() {
  if (Ex) return Wu;
  Ex = 1;
  var e = SR(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(j) {
        if (j.stopPropagation(), s.format)
          if (j.preventDefault(), typeof j.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            j.clipboardData.clearData(), j.clipboardData.setData(s.format, o);
        s.onCopy && (j.preventDefault(), s.onCopy(j.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var F = document.execCommand("copy");
      if (!F)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (j) {
      l && console.error("unable to copy using execCommand: ", j), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return k;
  }
  return Wu = a, Wu;
}
var jR = NR();
const wR = /* @__PURE__ */ vy(jR);
var MC = function() {
  var e = bR(), n = xR({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = yt(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = wR(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function CR(e, n) {
  n === void 0 && (n = 0);
  var r = ri(!1), i = ri(), a = ri(e), o = yt(function() {
    return r.current;
  }, []), s = yt(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = yt(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Qe(function() {
    a.current = e;
  }, [e]), Qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function gi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = CR(e, n), a = i[0], o = i[1], s = i[2];
  return Qe(s, r), [a, o];
}
var FR = function(e) {
  Qe(e, []);
}, IR = function(e, n) {
  var r = ri(function() {
  });
  Qe(function() {
    r.current = e;
  }), Qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, ER = function(e) {
  e === void 0 && (e = {});
  var n = de(e), r = n[0], i = n[1], a = Yn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return ec(ec({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = PI(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = ec({ get: yt(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, $R = function(e) {
  var n = ri(e);
  n.current = e, FR(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ku = { exports: {} }, Ma = {}, $x;
function TR() {
  if ($x) return Ma;
  $x = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var is = {}, Tx;
function DR() {
  return Tx || (Tx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    is.Fragment = i, is.jsx = Un, is.jsxs = Kn;
  })()), is;
}
var Dx;
function OR() {
  return Dx || (Dx = 1, process.env.NODE_ENV === "production" ? Ku.exports = TR() : Ku.exports = DR()), Ku.exports;
}
var xe = OR();
const RR = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, PR = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, AR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, LR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, VR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, zR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, UR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, MR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, BR = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": AR,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": LR,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": VR,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": RR,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": PR,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zR,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": UR,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": MR
};
function Ca(e) {
  return BR[e] ?? {};
}
const qR = Ca(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), HR = Ca(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), WR = Ca(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Ox = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, kr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, KR = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Rx = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Th = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function GR({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = de(
    []
  ), [o, s] = de([]), [l, d] = de([]), [m, u] = de([]), [f, h] = de(), { showNotification: k, showModal: F, executeQuery: j } = yn(), { track: N } = Fn(), {
    loading: x,
    data: g,
    error: O,
    store: I
  } = fy(e ?? null), C = g?.github?.issues || [], w = g?.github?.pullRequests || [], [A, B] = de(!1), [K, ee] = de();
  Qe(
    () => h(O || K || void 0),
    [O, K]
  ), Qe(
    () => {
      !x && (C?.length || w?.length) ? (a(C), s(w), H(C, w)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const G = async (ge, U) => {
    await I(ge).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: U.success.title,
        text: U.success.text
      });
    }).catch((be) => {
      k({
        title: U.error.title,
        text: `${U.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, H = (ge, U) => {
    if (!ge?.length && !U?.length) {
      d([]), u([]);
      return;
    }
    const be = (ge || []).map(
      (Ge) => j(HR, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        issueNumber: Ge.number
      })
    ), $e = (U || []).map(
      (Ge) => j(WR, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        prNumber: Ge.number
      })
    ), W = [...be, ...$e];
    B(!0), Promise.all(W).then((Ge) => {
      const sn = [], Fe = [];
      Ge.forEach((Ue) => {
        const Re = Ue?.data?.GitHub;
        if (!Re) {
          d([]), u([]);
          return;
        }
        Object.keys(Re).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = Re[Be];
            Object.keys(Ae).forEach((Je) => {
              const Ce = Ae[Je], Me = {
                number: Ce?.number,
                owner: Ce?.repository?.owner?.login,
                repository: Ce?.repository?.name
              };
              Je.startsWith("issue") && sn.push({
                ...Ce,
                type: "ISSUE",
                key: Me
              }), Je.startsWith("pullRequest") && Fe.push({
                ...Ce,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), d(sn), u(Fe);
    }).catch(ee).finally(() => {
      B(!1);
    });
  }, R = ({ key: ge, type: U }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (C.length || w.length) ? g : r, $e = U === "ISSUE" ? "issues" : "pullRequests";
    be.github[$e] = Array.from(
      new Set(be.github[$e]).add(ge)
    ), G(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${kr(
          ge
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${kr(ge)} failed. Please try again.`
      }
    });
  }, q = async ({ key: ge, type: U }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (C.length || w.length) ? g : r, $e = U === "ISSUE" ? "issues" : "pullRequests";
    be.github[$e] = Array.from(
      new Set(be.github[$e]).add(ge)
    ), await I(be).catch((W) => {
      k({
        title: "Linking failed",
        text: `Linking ${ge} failed. Please try again. ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, te = ({ key: ge, type: U }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = U === "ISSUE" ? "issue" : "pull request";
    F({
      headline: `Unlink ${be} ${kr(ge)}?`,
      text: `You are about to unlink the ${be} ${kr(
        ge
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const $e = U === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const W = {
          ...g,
          github: {
            ...g?.github,
            [$e]: g?.github?.[$e].filter(
              (Ge) => Ge.number !== ge.number || Ge.owner !== ge.owner || Ge.repository !== ge.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), G(W, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${kr(
              ge
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${kr(ge)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, we = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), F({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), G(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = C.filter(
    (ge) => !i?.includes(ge)
  ) || [], ue = w.filter(
    (ge) => !o?.includes(ge)
  ) || [];
  return {
    linkGithubItem: R,
    linkGithubItemQuietly: q,
    unlinkGithubItem: te,
    loadGithubItems: H,
    removeDanglingGithubItemLinks: () => {
      const ge = {
        ...g,
        github: {
          ...g?.github,
          issues: C.filter(
            (U) => !ve.includes(U)
          ) || [],
          pullRequests: w.filter(
            (U) => !ue.includes(U)
          ) || []
        }
      };
      I(ge);
    },
    unlinkAllGithubItems: we,
    isLoadingGithubItemLinks: x,
    danglingIssueLinks: ve,
    danglingPullRequestLinks: ue,
    isLoadingGithubItems: A,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const YR = "_contentWrapper_1vx3c_1", QR = "_contentWrapperHeadline_1vx3c_4", JR = "_contentWrapperBody_1vx3c_11", XR = "_contentWrapperAssigneeIcon_1vx3c_15", ZR = "_contentWrapperStatusTag_1vx3c_20", Jr = {
  contentWrapper: YR,
  contentWrapperHeadline: QR,
  contentWrapperBody: JR,
  contentWrapperAssigneeIcon: XR,
  contentWrapperStatusTag: ZR
}, BC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(lt, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: Jr.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(lt, { className: Jr.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(lt, { className: Jr.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: Jr.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(lt, { className: Jr.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(lt, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: Jr.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(lt, { className: Jr.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      Qn,
      {
        className: Jr.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), eP = "_collapse_1bdjy_1", nP = "_collapseHeader_1bdjy_10", tP = "_collapseHeaderKey_1bdjy_31", rP = "_collapseHeaderKeyIcon_1bdjy_36", iP = "_collapseHeaderKeyLink_1bdjy_41", aP = "_collapseHeaderIcon_1bdjy_44", oP = "_collapseHeaderTitle_1bdjy_49", sP = "_collapseContent_1bdjy_57", lP = "_collapseContentButtonSpacer_1bdjy_60", cP = "_collapseContentButtonLink_1bdjy_63", Or = {
  collapse: eP,
  collapseHeader: nP,
  collapseHeaderKey: tP,
  collapseHeaderKeyIcon: rP,
  collapseHeaderKeyLink: iP,
  collapseHeaderIcon: aP,
  collapseHeaderTitle: oP,
  collapseContent: sP,
  collapseContentButtonSpacer: lP,
  collapseContentButtonLink: cP
}, dP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = de(i), { track: s } = Fn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: F,
      type: j,
      state: N,
      assignees: x,
      labels: g
    } = d, O = a[m];
    return /* @__PURE__ */ xe.jsxs(
      xr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: O,
        className: Or.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(xr.Header, { className: Or.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(lt, { children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Or.collapseHeaderKey, children: [
                  Th(
                    j,
                    N,
                    Or.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: Ox(f),
                      className: Or.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (I) => {
                        I.stopPropagation();
                      },
                      children: [
                        kr(f),
                        /* @__PURE__ */ xe.jsx(
                          ye,
                          {
                            className: Or.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(lt, { className: Or.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(xr.Content, { className: Or.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              BC,
              {
                description: k,
                assignees: x,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Or.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: F?.owner.login,
                    repository: d.repository.name
                  },
                  type: j
                }),
                children: [
                  "Unlink ",
                  Rx(j)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              Lt,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(ye, { name: "external-link" }),
                variant: "tertiary",
                className: Or.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Ox(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Rx(j),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, uP = "_result_1uaom_1", mP = "_resultName_1uaom_21", pP = "_resultItemIcon_1uaom_29", fP = "_resultDescription_1uaom_34", hP = "_resultLinkIcon_1uaom_46", yP = "_tooltip_1uaom_55", gP = "_tooltipName_1uaom_61", vP = "_tooltipTag_1uaom_71", Xr = {
  result: uP,
  resultName: mP,
  resultItemIcon: pP,
  resultDescription: fP,
  resultLinkIcon: hP,
  tooltip: yP,
  tooltipName: gP,
  tooltipTag: vP
}, kP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = de(!1);
  return /* @__PURE__ */ xe.jsx(
    Ze,
    {
      className: Xr.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Xr.tooltipName, children: [
                Th(a, o, Xr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(Qn, { className: Xr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          BC,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: Xr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Xr.resultName, children: [
                    Th(a, o, Xr.resultItemIcon),
                    kr(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(lt, { className: Xr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              ye,
              {
                className: Xr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, bP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(ye, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), al = "[a-zA-z0-9_.-]+", qC = "[0-9]+", xP = new RegExp(
  `(${al})/(${al})/(?:issues|pull)/(${qC})`,
  "i"
), Px = new RegExp(`^${xP.source}$`), Ax = new RegExp(
  `https://github.com/(${al})/(${al})/(?:issues|pull)/(${qC})`,
  "i"
), _P = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Yn(() => r?.map((w) => w.id) || [], [r]), o = Yn(() => i?.map((w) => w.id) || [], [i]), [s, l] = de([]), { useLazyQuery: d } = yn(), [m, u] = de(), [f, { loading: h, error: k, data: F, networkStatus: j }] = d(qR, {
    notifyOnNetworkStatusChange: !0
  });
  gi(
    () => {
      !h && m && j === rr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Qe(() => {
    let w = F?.GitHub?.issues?.nodes || [], A = F?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (w = w.filter((B) => !a.includes(B.id))), o.length > 0 && (A = A.filter(
      (B) => !o.includes(B.id)
    )), l([
      ...w.map((B) => ({
        ...B,
        type: "ISSUE",
        key: {
          number: B.number,
          owner: B.repository.owner.login,
          repository: B.repository.name
        }
      })),
      ...A.map((B) => ({
        ...B,
        type: "PR",
        key: {
          number: B.number,
          owner: B.repository.owner.login,
          repository: B.repository.name
        }
      }))
    ]);
  }, [F, a, o]);
  function N(w) {
    const A = w?.trim();
    if (Px.test(A)) {
      const [B, K, ee, G] = A.match(Px) || [];
      return K !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(G)
      };
    }
    if (Ax.test(A)) {
      const [B, K, ee, G] = A.match(Ax) || [];
      return K !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(G)
      };
    }
  }
  const x = (w) => {
    e({
      key: KR(w),
      type: w.type
    }), u(void 0);
  }, g = (w) => {
    const A = N(w);
    u(
      A ? `org:${A.owner} repo:${A.repository} ${A.number}` : `org:${n} ${w}`
    );
  }, O = () => {
    u(void 0);
  }, I = ({ className: w, searched: A }) => /* @__PURE__ */ xe.jsx(
    bP,
    {
      className: w,
      searched: A,
      githubOrganization: n
    }
  ), C = ({ item: w, onSelect: A }) => /* @__PURE__ */ xe.jsx(kP, { item: w, onSelect: A });
  return !h && k ? /* @__PURE__ */ xe.jsx(Tn, { error: k }) : /* @__PURE__ */ xe.jsx(
    $r,
    {
      items: s?.map((w) => ({ name: w.title, ...w })),
      loading: h,
      onSearch: g,
      onSelect: x,
      onClear: O,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: I,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, SP = "_itemButton_3sxfy_1", NP = "_result_3sxfy_6", jP = "_resultName_3sxfy_30", wP = "_resultCheckIcon_3sxfy_38", CP = "_resultAssigneeIcon_3sxfy_41", Ba = {
  itemButton: SP,
  result: NP,
  resultName: jP,
  resultCheckIcon: wP,
  resultAssigneeIcon: CP
}, HC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Ba.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: Ba.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(lt, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: Ba.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(lt, { className: Ba.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(lt, { className: Ba.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(ye, { name: "done" }) })
        ] })
      }
    )
  }
), FP = Ca(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), IP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = de([]), [l, d] = de(""), m = 2, [u, { loading: f, error: h, data: k, networkStatus: F }] = a(
    FP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return gi(
    () => {
      !f && l && l.length >= m && F === rr.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const j = k?.GitHub?.organization?.teams || { edges: [] }, N = [];
    j?.edges?.forEach((x) => {
      const g = x?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((O) => {
        const I = O?.node;
        I && (I?.id && N.find((C) => C.id === I.id) || N.push(I));
      });
    }), s(
      N.sort((x, g) => {
        const O = x.name?.toLowerCase() || x.login?.toLowerCase(), I = g.name?.toLowerCase() || g.login?.toLowerCase();
        return O.localeCompare(I, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ xe.jsx(Tn, { error: h }) : /* @__PURE__ */ xe.jsx(
    $r,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: j, name: N, login: x, avatarUrl: g }) => ({
        id: j,
        name: N || x,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (j) => d(j),
      onChange: (j, N) => {
        const x = j.id;
        i ? (N && !n.find(
          (g) => g.id === x
        ) && n.push(j), N || (n = n.filter(
          (g) => g.id !== x
        ))) : n = N ? [j] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ xe.jsx(
        HC,
        {
          item: j,
          checked: x,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, EP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(cr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        $r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Nl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(cr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        $r,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(cr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Nh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        IP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, $P = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: EP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), TP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs($.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(ye, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(He, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          cr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, DP = "_modalBody_1hk1o_1", OP = "_modalBodyFormFields_1hk1o_4", Gu = {
  modalBody: DP,
  modalBodyFormFields: OP
}, RP = Ca(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), PP = Ca(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), AP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], LP = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = yn(), { track: d } = Fn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = mt(), [F, j] = de(""), [N, x] = de([]), [g, O] = de(), [I, C] = de(!1), [w, A] = de(!1), [B, K] = MC(), [
    ee,
    {
      loading: G,
      error: H,
      networkStatus: R
    }
  ] = s(RP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: ($e) => {
      x(
        $e.GitHub.search?.edges?.map((W) => W?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), x([]);
    }
  });
  gi(
    () => {
      !G && F && R === rr.ready ? ee({
        variables: {
          query: F,
          maxResults: 10
        }
      }) : x([]);
    },
    500,
    [F]
  );
  const [q, { error: te }] = l(
    PP,
    {
      onError: ($e) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", $e);
      },
      onCompleted: ($e) => {
        C(!1);
        const W = $e.GitHub.createIssue?.issue;
        O(W), o({
          title: "Success",
          text: `GitHub issue '${W.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: W.repository.name,
          number: W.number
        });
      }
    }
  ), we = ($e) => {
    j(`org:${a} ${$e}`);
  }, ve = ($e, W) => {
    W($e), j("");
  }, ue = () => {
    j("");
  }, ge = ($e) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), q({
      variables: {
        input: {
          repositoryId: $e.repository.id,
          title: $e.title,
          body: $e.body,
          assigneeIds: $e.assignees?.length > 0 ? $e.assignees.map((W) => W.id) : void 0
        }
      }
    });
  };
  Qe(() => {
    const $e = w ? window.setTimeout(() => A(!1), 2e3) : void 0;
    return () => window.clearTimeout($e);
  }, [w]);
  const U = () => {
    j(""), x([]), O(void 0), C(!1), A(!1);
  }, be = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), U(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          Ct,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(Ft, { className: Gu.modalBody, children: [
          !G && H && /* @__PURE__ */ xe.jsx(Tn, { error: H }),
          !I && te && /* @__PURE__ */ xe.jsx(Tn, { error: te }),
          g ? /* @__PURE__ */ xe.jsx(
            TP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: w,
              setIssueLinkCopied: A,
              copyToClipboard: K
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(ge),
              children: /* @__PURE__ */ xe.jsxs(nt, { children: [
                /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(He, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  xt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: $e, value: W } }) => /* @__PURE__ */ xe.jsx(
                      $r,
                      {
                        className: Gu.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: G,
                        onSearch: we,
                        onSelect: (Ge) => ve(Ge, $e),
                        onClear: ue,
                        selectedItems: [W],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: H ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: Ge, onSelect: sn, checked: Fe }) => /* @__PURE__ */ xe.jsx(
                          HC,
                          {
                            item: Ge,
                            checked: Fe,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(Z, { className: Gu.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  $P,
                  {
                    control: m,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: AP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          Et,
          {
            confirmOnClick: g ? be : u(ge),
            confirmProps: {
              isLoading: I,
              loadingIndicator: /* @__PURE__ */ xe.jsx(hn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, VP = "_wrapper_19v8w_1", zP = "_inputWrapper_19v8w_6", UP = "_buttonLink_19v8w_19", MP = "_noItemsFound_19v8w_23", BP = "_createIssueButton_19v8w_28", Qi = {
  wrapper: VP,
  inputWrapper: zP,
  buttonLink: UP,
  noItemsFound: MP,
  createIssueButton: BP
}, qP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de(!1), { track: a } = Fn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: F,
    danglingPullRequestLinks: j,
    isLoadingGithubItems: N,
    issues: x,
    pullRequests: g,
    error: O
  } = GR({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), I = (K) => d({ key: K, type: "ISSUE" }), C = !(!!x?.length).valueOf() && !(!!g?.length).valueOf() && !(!!F?.length).valueOf() && !(!!j?.length).valueOf(), w = !k && !N && !!F?.length && !!j?.length && !!n?.showDanglingLinks, A = n?.enableCreateIssue, B = !!x?.length || !!g?.length;
  return !N && O ? /* @__PURE__ */ xe.jsx(Tn, { error: O, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: Qi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: Qi.inputWrapper, flexDirection: "column", children: [
        A && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            et,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Qi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: Qi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          _P,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: x,
            linkedPullRequests: g
          }
        )
      ] }),
      N ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(hn, { "data-testid": "github-widget-item-spinner" }) }) : B ? /* @__PURE__ */ xe.jsx(
        dP,
        {
          items: [...x, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx($.Paragraph, { align: "center", className: Qi.noItemsFound, children: "No linked items found." }),
      w && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              F.map((K) => /* @__PURE__ */ xe.jsx(
                Qn,
                {
                  onDelete: () => m({
                    key: K,
                    type: "ISSUE"
                  }),
                  children: kr(K)
                },
                kr(K)
              )),
              j.map((K) => /* @__PURE__ */ xe.jsx(
                Qn,
                {
                  onDelete: () => m({ key: K, type: "PR" }),
                  children: kr(K)
                },
                kr(K)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && B && /* @__PURE__ */ xe.jsx(
        et,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(ye, { name: "external-link" }),
          variant: "tertiary",
          className: Qi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      LP,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: I,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Dh = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], xi = "GITHUB", HP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, WP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: HP
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: xi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: Dh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = (K) => fr(K, {
    fieldDefinitions: Dh,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), B = l.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ xe.jsx(hr, { cause: k }),
        /* @__PURE__ */ xe.jsxs(nt, { children: [
          /* @__PURE__ */ xe.jsx(Z, { children: /* @__PURE__ */ xe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(
            An,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ xe.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ xe.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: xi,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ xe.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          yr,
          {
            integrationType: xi,
            integrationId: e,
            widgetName: B,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ xe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ xe.jsx(
                ye,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  xi,
                  " integration, all links between Dixa and ",
                  xi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  xi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  xi,
                  " ",
                  'integration "',
                  B,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Yu = { exports: {} }, qa = {}, Lx;
function KP() {
  if (Lx) return qa;
  Lx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return qa.Fragment = r, qa.jsx = s, qa.jsxs = s, qa;
}
var as = {}, Vx;
function GP() {
  return Vx || (Vx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    as.Fragment = i, as.jsx = Un, as.jsxs = Kn;
  })()), as;
}
var zx;
function YP() {
  return zx || (zx = 1, process.env.NODE_ENV === "production" ? Yu.exports = KP() : Yu.exports = GP()), Yu.exports;
}
var je = YP(), go = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(go || {}), Ii = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Ii || {}), Xt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Xt || {});
const QP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JP = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": QP
};
function XP(e) {
  return JP[e] ?? {};
}
const ZP = XP(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Ux = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, WC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, eA = "_listItem_16pij_4", nA = "_clickableIcon_16pij_15", Oo = {
  listItem: eA,
  clickableIcon: nA
}, KC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = de(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ je.jsx(ye, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Oo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ je.jsx(
              ye,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ je.jsx(Xe, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: k } = l, F = l.currency ?? r;
      return /* @__PURE__ */ je.jsx(
        Xe.Item,
        {
          contentLeft: /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ je.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ je.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "tertiary", children: WC(f / 100, F) })
          ] }),
          contentRight: h && /* @__PURE__ */ je.jsx(xa, { src: h, alt: m ?? "Product image" }),
          className: Oo.listItem
        },
        `item-${d}-${k}`
      );
    }) })
  ] }) });
}, tA = "_boxWrapper_89s7l_1", rA = "_trackButton_89s7l_10", Mx = {
  boxWrapper: tA,
  trackButton: rA
}, iA = {
  [Xt.StepUnknown]: "Unknown",
  [Xt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Xt.StepPreparedByMerchant]: "Prepared by merchant",
  [Xt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Xt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Xt.StepOnRoute]: "On route",
  [Xt.StepDeliveredToPickupPoint]: "At pickup point",
  [Xt.StepDeliveredToConsumer]: "Delivered to customer",
  [Xt.StepDeliveredToMerchant]: "Returned to merchant",
  [Xt.StepReturnRequested]: "Return requested",
  [Xt.StepSentBack]: "Sent back",
  [Xt.StepTerminated]: "Terminated",
  [Xt.StepAwaitingSupplier]: "Awaiting supplier"
}, aA = {
  [Ii.Delivery]: "Home delivery",
  [Ii.Pickup]: "Pickup point",
  [Ii.Instore]: "In-store pickup",
  [Ii.Mailbox]: "Mailbox",
  [Ii.Inwarehouse]: "Warehouse",
  [Ii.Unknown]: "Unknown"
}, oA = {
  [go.Outbound]: "From merchant to customer",
  [go.Return]: "Return from customer to merchant",
  [go.Unspecified]: "Unspecified",
  [go.UnknownDirectionType]: "Unknown"
}, sA = (e) => e ? iA[e] ?? e : "", lA = (e) => e ? aA[e] ?? e : "", cA = (e) => e ? oA[e] ?? e : "", dA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, uA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Qt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = m || l || i, F = a?.filter((I) => I?.time !== ""), j = sA(F?.[0]?.step), N = lA(u), x = cA(f), g = dA(e.location?.address), O = 14;
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Mx.boxWrapper,
      children: [
        /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(
              ye,
              {
                size: O,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
            ye,
            {
              size: O,
              name: n ? "done" : "copy",
              className: Oo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        j && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(ye, { size: O, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        x && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(ye, { size: O, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: x })
          ] })
        ] }),
        h && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(ye, { size: O, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ je.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
              Ux(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: Ux(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(ye, { size: O, name: "info", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        g && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ je.jsx(ye, { size: O, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ je.jsx(KC, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ je.jsxs(
          Lt,
          {
            variant: "secondary",
            className: Mx.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ je.jsx(ye, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, mA = "_order_135ze_1", pA = "_orderIsOpen_135ze_9", fA = "_orderHeader_135ze_12", Qu = {
  order: mA,
  orderIsOpen: pA,
  orderHeader: fA
}, Bx = "No order number found", hA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), { isCopied: a, copy: o } = Qt(), { isCopied: s, copy: l } = Qt();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), k = d?.currency || "", F = d?.prices?.total?.price ?? 0, j = WC(F / 100, k), N = 14, x = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      className: dt(Qu.order, {
        [Qu.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Qu.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsxs($.Paragraph, { variant: "4", children: [
                  "From ",
                  x
                ] }),
                h ? /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: /* @__PURE__ */ je.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Bx })
              ] }),
              /* @__PURE__ */ je.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(ye, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Bx }) })
              ] })
            ] }),
            h && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ je.jsx(
              ye,
              {
                size: N,
                name: s ? "done" : "copy",
                className: Oo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ je.jsx(
                ye,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ je.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ je.jsx(Ze, { content: "Copy tracking ID", children: /* @__PURE__ */ je.jsx(
              ye,
              {
                size: N,
                name: a ? "done" : "copy",
                className: Oo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(ye, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(ye, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", children: j })
            ] })
          ] }),
          /* @__PURE__ */ je.jsx(
            KC,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((g) => g),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ je.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((g, O) => /* @__PURE__ */ je.jsx(
              uA,
              {
                parcel: g
              },
              `parcel-${O}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, yA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, qx = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, gA = (e) => [...e].sort(
  (n, r) => qx(r) - qx(n)
), vA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = yn(), [r, i] = de([]), a = !e, { data: o, loading: s, error: l } = n(ZP, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? oI({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? pw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      gA(
        yA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ je.jsx(hn, {}) }) : m || !d && !l ? /* @__PURE__ */ je.jsx($.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ je.jsx($.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ je.jsx(Tn, { error: l }) : /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ je.jsx(Bn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ je.jsx(
      hA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, kA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ je.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ je.jsx(vA, { customerEmail: n })
    }
  );
}, Oh = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], bA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, xA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: bA
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: Oh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: Oh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ je.jsx(hr, { cause: h }),
        /* @__PURE__ */ je.jsxs(nt, { children: [
          /* @__PURE__ */ je.jsx(Z, { children: /* @__PURE__ */ je.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(He, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ je.jsx(
            xn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
            An,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          /* @__PURE__ */ je.jsx(Z, { span: 3, children: /* @__PURE__ */ je.jsx(
            Er,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ je.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          yr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ju = { exports: {} }, Ha = {}, Hx;
function _A() {
  if (Hx) return Ha;
  Hx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var os = {}, Wx;
function SA() {
  return Wx || (Wx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    os.Fragment = i, os.jsx = Un, os.jsxs = Kn;
  })()), os;
}
var Kx;
function NA() {
  return Kx || (Kx = 1, process.env.NODE_ENV === "production" ? Ju.exports = _A() : Ju.exports = SA()), Ju.exports;
}
var pe = NA();
const eg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => eg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, jA = "_jiraCode_h30p6_1", wA = "_jiraCodeInline_h30p6_8", Xu = {
  jiraCode: jA,
  jiraCodeInline: wA
}, GC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ pe.jsx(pe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ pe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ pe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ pe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ pe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ pe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ pe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ pe.jsx("pre", { children: /* @__PURE__ */ pe.jsx("code", { className: Xu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ pe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ pe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ pe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ pe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ pe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ pe.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ pe.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ pe.jsx("code", { className: dt(Xu.jiraCode, Xu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ol = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = de(!1);
  return !e || i ? /* @__PURE__ */ pe.jsx(ye, { size: r, name: "question", className: n }) : /* @__PURE__ */ pe.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, CA = "_collapse_m2gjh_1", FA = "_collapseHeader_m2gjh_10", IA = "_collapseHeaderLink_m2gjh_31", EA = "_collapseHeaderStatus_m2gjh_40", $A = "_collapseHeaderTitle_m2gjh_51", TA = "_collapseContent_m2gjh_59", DA = "_collapseContentHeadline_m2gjh_62", OA = "_collapseContentButtonSpacer_m2gjh_68", RA = "_collapseContentButtonLink_m2gjh_71", PA = "_collapseContentStatusTag_m2gjh_74", AA = "_collapseContentDescription_m2gjh_77", Nr = {
  collapse: CA,
  collapseHeader: FA,
  collapseHeaderLink: IA,
  collapseHeaderStatus: EA,
  collapseHeaderTitle: $A,
  collapseContent: TA,
  collapseContentHeadline: DA,
  collapseContentButtonSpacer: OA,
  collapseContentButtonLink: RA,
  collapseContentStatusTag: PA,
  collapseContentDescription: AA
}, YC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, LA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = de(i), { track: s } = Fn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ pe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, k = YC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), F = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ pe.jsxs(
      xr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: F,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ pe.jsx(xr.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ pe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ pe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ pe.jsx(ol, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ pe.jsx(
                      "a",
                      {
                        className: Nr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (j) => {
                          j.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ pe.jsx(ye, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ pe.jsx("span", { className: Nr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ pe.jsx(Qn, { className: Nr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ pe.jsx("div", { className: Nr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ pe.jsx(xr.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ pe.jsx("div", { className: Nr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ pe.jsx(lt, { className: Nr.collapseContentDescription, children: u ? eg(u, GC) : "" }),
            /* @__PURE__ */ pe.jsx(
              et,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ pe.jsx(
              Lt,
              {
                slotEnd: /* @__PURE__ */ pe.jsx(ye, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ pe.jsx(pe.Fragment, {}) });
}, VA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, zA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, UA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, MA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, BA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, qA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, HA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, WA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': VA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": zA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": UA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": MA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': BA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': qA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": HA
};
function Bi(e) {
  return WA[e] ?? {};
}
const QC = Bi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), KA = Bi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), GA = Bi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), YA = Bi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), QA = Bi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), JA = Bi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), XA = Bi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), ng = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), ZA = new RegExp(`^${ng.source}$`), e2 = new RegExp(`/${ng.source}$`), Gx = new RegExp(
  `.+?[&?]selectedIssue=(${ng.source})[&?]?.*`
);
function JC(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = de([]), [o, s] = de([]), [l, d] = de(), { track: m } = Fn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = yn(), {
    loading: F,
    data: j,
    error: N,
    store: x
  } = fy(e ?? null), [
    g,
    { loading: O, error: I, data: C }
  ] = h(QC, {
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    const ue = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ue?.length && (s(ue), a(ue.map((ge) => ge?.key).filter(Boolean)));
  }, [C]), Qe(
    () => d(N || I || void 0),
    [N, I]
  ), Qe(
    () => {
      F || H();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [j?.jira?.issues, F]
  );
  const w = async (ue, ge) => {
    await x(ue).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: ge.success.title,
        text: ge.success.text
      });
    }).catch((U) => {
      u({
        title: ge.error.title,
        text: `${ge.error.text} ${U.message && " (" + U.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [A] = k(KA, {
    onError: (ue) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ue.message && " (" + ue.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), B = (ue, ge) => {
    const U = window.location.href, be = ge ? U.replace(
      e?.toString() ?? "",
      ge?.toString()
    ) : U, $e = ge ? `# ${ge}` : `# ${e}`;
    A({
      variables: {
        issueKey: ue,
        title: $e,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [K] = k(GA, {
    onError: (ue) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ue.message && " (" + ue.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (ue) => {
    const ge = window.location.href;
    K({
      variables: {
        issueKey: ue,
        globalId: `system=${ge}`
      }
    });
  }, G = (ue) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ue
  }), H = () => {
    j && j.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${j?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, R = async (ue, ge) => {
    m("jira:issue:link:clicked", G(ue));
    const U = j?.jira?.issues ? j : r;
    U.jira.issues = Array.from(
      new Set(U.jira.issues).add(ue)
    ), await x(U, ge?.toString()).then(() => B(ue, ge)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${ue} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (ue) => {
    m("jira:issue:link:clicked", G(ue));
    const ge = j?.jira?.issues ? j : r;
    ge.jira.issues = Array.from(
      new Set(ge.jira.issues).add(ue)
    ), w(ge, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ue} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ue} failed. Please try again.`
      }
    }).then(() => B(ue));
  }, te = (ue) => {
    m("jira:issue:unlink:clicked", G(ue)), f({
      headline: `Unlink issue ${ue}?`,
      text: `You are about to unlink the issue ${ue}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", G(ue));
        const ge = {
          ...j,
          jira: {
            ...j?.jira,
            issues: j?.jira?.issues.filter((U) => U !== ue) || []
          }
        };
        w(ge, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ue}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ue} failed.`
          }
        }).then(() => ee(ue));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", G(ue))
    });
  }, we = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ue) => ue?.key && ee(ue.key)), w(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ve = j?.jira?.issues?.filter(
    (ue) => !i?.includes(ue)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: R,
    unlinkIssue: te,
    loadIssues: H,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ue = {
        ...j,
        jira: {
          ...j?.jira,
          issues: j?.jira?.issues.filter(
            (ge) => !ve.includes(ge)
          ) || []
        }
      };
      x(ue);
    },
    unlinkAllIssues: we,
    maybeExtractIssueKey: (ue) => {
      const ge = ue.replace(/\s/g, "");
      if (ZA.test(ge))
        return ge;
      if (Gx.test(ue))
        return ue.match(Gx)?.[1];
      if (ue.startsWith(n) && e2.test(ue))
        return ue.substring(ue.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: F,
    danglingIssueLinks: ve,
    isLoadingIssues: O,
    issues: o,
    error: l
  };
}
function n2(e = !1, n) {
  const [r, i] = de(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const t2 = "_result_1wiub_54", r2 = "_resultName_1wiub_74", i2 = "_resultNameIcon_1wiub_82", a2 = "_resultDescription_1wiub_87", o2 = "_resultLinkIcon_1wiub_99", s2 = "_tooltip_1wiub_108", l2 = "_tooltipContent_1wiub_114", c2 = "_tooltipName_1wiub_121", d2 = "_tooltipNameIcon_1wiub_126", u2 = "_tooltipDescription_1wiub_131", m2 = "_tooltipSummary_1wiub_139", p2 = "_tooltipTag_1wiub_143", vr = {
  result: t2,
  resultName: r2,
  resultNameIcon: i2,
  resultDescription: a2,
  resultLinkIcon: o2,
  tooltip: s2,
  tooltipContent: l2,
  tooltipName: c2,
  tooltipNameIcon: d2,
  tooltipDescription: u2,
  tooltipSummary: m2,
  tooltipTag: p2
}, f2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = de(!1), h = YC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ pe.jsx(
    Ze,
    {
      disabled: i,
      className: vr.tooltip,
      content: /* @__PURE__ */ pe.jsxs("div", { className: vr.tooltipContent, children: [
        /* @__PURE__ */ pe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ pe.jsxs("span", { className: vr.tooltipName, children: [
                /* @__PURE__ */ pe.jsx(
                  ol,
                  {
                    width: 16,
                    iconUrl: h,
                    className: vr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ pe.jsx(Qn, { className: vr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ pe.jsx("div", { className: vr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ pe.jsx("div", { className: vr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ pe.jsxs(
        "button",
        {
          ...a,
          className: vr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ pe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ pe.jsxs("span", { className: vr.resultName, children: [
                    /* @__PURE__ */ pe.jsx(
                      ol,
                      {
                        width: 16,
                        iconUrl: h,
                        className: vr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ pe.jsx("div", { className: vr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ pe.jsx(
              ye,
              {
                className: vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, h2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ pe.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ pe.jsx(ye, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), y2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = de([]), [l, d] = de(""), [m, { loading: u, error: f, data: h, networkStatus: k }] = a(QC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: F } = JC(null, n);
  gi(
    () => {
      !u && l && k === rr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const I = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      I.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? eg(C?.fields.description, GC) : /* @__PURE__ */ pe.jsx(pe.Fragment, {})
      }))
    );
  }, [h]);
  const j = (I) => {
    e(I.id), d("");
  }, N = (I) => {
    const C = I.trim(), w = F(C);
    if (w) {
      const A = w.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${A}'`);
    } else C !== "" && d(
      `text ~ '${C}'${r ? " and project = " + r : ""}`
    );
  }, x = () => {
    d("");
  }, g = (I) => /* @__PURE__ */ pe.jsx(h2, { ...I, jiraInstanceUrl: n }), O = (I) => /* @__PURE__ */ pe.jsx(
    f2,
    {
      ...I,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ pe.jsx(Tn, { error: f }) : /* @__PURE__ */ pe.jsx(
    $r,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: j,
      onClear: x,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: O,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, g2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = de(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ pe.jsx(
    $r,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, v2 = "_itemButton_1hl53_1", k2 = "_result_1hl53_6", b2 = "_resultIcon_1hl53_26", x2 = "_resultName_1hl53_30", _2 = "_resultCheckIcon_1hl53_38", Wa = {
  itemButton: v2,
  result: k2,
  resultIcon: b2,
  resultName: x2,
  resultCheckIcon: _2
}, Rh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ pe.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ pe.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Wa.itemButton,
          children: /* @__PURE__ */ pe.jsxs(b, { className: Wa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ pe.jsx(
              ol,
              {
                width: 36,
                iconUrl: o || "",
                className: Wa.resultIcon
              }
            ),
            /* @__PURE__ */ pe.jsx(lt, { className: Wa.resultName, children: e.name }),
            n && /* @__PURE__ */ pe.jsx(lt, { className: Wa.resultCheckIcon, children: /* @__PURE__ */ pe.jsx(ye, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, S2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = yn(), [o, s] = de([]), [l, d] = de(), m = 2, [u, { loading: f, error: h, data: k, networkStatus: F }] = a(XA, {
    notifyOnNetworkStatusChange: !0
  });
  return gi(
    () => {
      !f && l && l.length >= m && F === rr.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((j) => {
      if (j?.data?.Jira.findUsers?.length === 1) {
        const N = j?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), Qe(() => {
    const j = k?.Jira?.findUsers || [];
    s(
      j.filter(({ active: N }) => N).map(({ accountId: N, displayName: x, avatarUrls: g, active: O }) => ({
        id: N,
        name: x,
        avatarUrls: g,
        active: O
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ pe.jsx(Tn, { error: h }) : /* @__PURE__ */ pe.jsx(
    $r,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (j) => d(j),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: j, onSelect: N, checked: x }) => /* @__PURE__ */ pe.jsx(
        Rh,
        {
          item: j,
          checked: x,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Yx = ({
  field: e
}) => {
  const [n, r] = de(!1), [i, a] = MC();
  return Qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ pe.jsx(b, { children: /* @__PURE__ */ pe.jsx(ye, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ pe.jsx($.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ pe.jsx(Ze, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ pe.jsx(
      ir,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, N2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ pe.jsx(Yx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ pe.jsx(cr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ pe.jsx(Nh, { onChange: n, value: r }) : /* @__PURE__ */ pe.jsx(cr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ pe.jsx(Nh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ pe.jsx(cr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ pe.jsx(
        S2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ pe.jsx(
        $r,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ pe.jsx(g2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ pe.jsx(Yx, { field: e });
  }
}, j2 = ["description", "reporter", "summary"], w2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ pe.jsx(pe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || j2.includes(o)
).map((o) => /* @__PURE__ */ pe.jsx(
  xt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ pe.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: N2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), C2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ pe.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ pe.jsxs(
          $.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ pe.jsx(ye, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ pe.jsx(He, { label: "Jira issue link", children: /* @__PURE__ */ pe.jsx(
        cr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), F2 = "_modalBody_1hk1o_1", I2 = "_modalBodyFormFields_1hk1o_4", Qx = {
  modalBody: F2,
  modalBodyFormFields: I2
}, E2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), $2 = (e) => e?.custom?.split(":")?.[1] || null, T2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, D2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = T2(a, n), l = $2(s) ?? a;
        return r.includes(l) ? i[a] = E2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, O2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = de([]), [m, u] = de(), [f, h] = de(0), [k, F] = de([]), [j, N] = de([]), [x, g] = de(!1), [O, I] = de(!1), [C, w] = de({}), { track: A } = Fn(), { isCopied: B, copyToClipboard: K } = n2(), ee = Yn(() => i?.conversationId, [e]), { useMutation: G, useLazyQuery: H, showNotification: R } = yn(), {
    control: q,
    handleSubmit: te,
    formState: { errors: we },
    reset: ve,
    setValue: ue,
    getValues: ge
  } = mt({
    defaultValues: s
  }), U = j.length > 0, be = `${a}/browse`, $e = Object.keys(C).length > 0, [W, { loading: Ge, error: sn }] = H(YA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      d(le.Jira.getAllProjects);
    },
    onError: (le) => {
      R({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), d([]);
    }
  }), [
    Fe,
    { loading: Ue, error: Re }
  ] = H(QA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const Se = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (Se) {
        const Le = Se?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        F(Le || []), ue(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        R({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), F([]), N([]);
    },
    onError: (le) => {
      R({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), F([]), N([]), h(0);
    }
  }), [Be, { error: Ae }] = G(
    JA,
    {
      onError: () => {
        g(!1), R({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), A("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          u(le?.Jira?.createIssue), R({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), A("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), ee && r(
            le.Jira.createIssue.key,
            ee
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const Se = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Se), R({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Je = (le) => {
    g(!0), w({}), Be({
      variables: {
        input: D2(le, j)
      }
    });
  };
  Qe(() => {
    if (e)
      try {
        W();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), Qe(() => {
    const le = O ? window.setTimeout(() => I(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [O]), Qe(() => {
    if (k?.length > 0) {
      ue("issuetype", k[f]);
      const le = k[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const Se = le.map(
          ({ value: J }) => J
        ), Le = (o ? Se.sort(({ name: J }, { name: T }) => J.localeCompare(T)) : Se).sort(
          ({ required: J }, { required: T }) => Number(T) - Number(J)
        ), { project: Pe, issuetype: gn } = ge();
        ve({ project: Pe, issuetype: gn }), N(Le);
      }
    } else
      N([]), ue("issuetype", void 0);
  }, [k, ue, f]), Qe(() => {
    if (Ae && Nw(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = Ae, Se = le[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(Se);
          if (Le?.errors) {
            const Pe = Object.keys(Le.errors).reduce(
              (gn, J) => ({
                ...gn,
                [J]: {
                  type: "required",
                  message: Le.errors[J],
                  ref: {
                    name: J
                  }
                }
              }),
              {}
            );
            w(Pe);
          }
        } catch {
        }
      }
    } else
      w({});
  }, [Ae]);
  const Ce = () => {
    d([]), N([]), F([]), u(void 0), h(0), g(!1), w({});
  }, Me = () => {
    Ce(), ve(s), n();
  }, nn = (le) => {
    le && Fe({
      variables: {
        projectKey: le
      }
    });
  }, se = (le) => {
    const Se = k.map((Le) => Le.id).indexOf(le);
    h(Se ?? 0);
  };
  return /* @__PURE__ */ pe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ pe.jsx(
          Ct,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ pe.jsxs(Ft, { className: Qx.modalBody, children: [
          !Ge && sn && /* @__PURE__ */ pe.jsx(Tn, { error: sn, retry: W }),
          !Ue && Re && /* @__PURE__ */ pe.jsx(
            Tn,
            {
              error: Re,
              retry: Fe
            }
          ),
          !x && $e && /* @__PURE__ */ pe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ pe.jsx(
            jl,
            {
              variant: "warning",
              description: /* @__PURE__ */ pe.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ pe.jsx($.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ pe.jsx(
                      et,
                      {
                        icon: B ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => K(JSON.stringify(j, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ pe.jsx(
            C2,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: O,
              setIssueLinkCopied: I,
              copyToClipboard: K
            }
          ) : /* @__PURE__ */ pe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: te(Je),
              children: /* @__PURE__ */ pe.jsxs(nt, { children: [
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: "Project", required: !0, children: /* @__PURE__ */ pe.jsx(
                  xt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: Se } }) => /* @__PURE__ */ pe.jsx(
                      $r,
                      {
                        searchable: !0,
                        loading: Ge,
                        onSelect: (Le) => {
                          nn(Le.key), le(Le);
                        },
                        selectedItems: [Se],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Pe, checked: gn }) => /* @__PURE__ */ pe.jsx(
                          Rh,
                          {
                            item: Le,
                            checked: gn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: "Issue type", required: !0, children: /* @__PURE__ */ pe.jsx(
                  xt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: Se } }) => /* @__PURE__ */ pe.jsx(
                      $r,
                      {
                        disabled: k.length === 0,
                        loading: Ue,
                        onSelect: (Le) => {
                          se(Le.id), le(Le);
                        },
                        selectedItems: [Se],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Re ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Le, onSelect: Pe, checked: gn }) => /* @__PURE__ */ pe.jsx(
                          Rh,
                          {
                            item: Le,
                            checked: gn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                U && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ pe.jsx(Z, { className: Qx.modalBodyFormFields, children: /* @__PURE__ */ pe.jsx(
                  w2,
                  {
                    control: q,
                    errors: { ...we, ...C },
                    getValues: ge,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: j
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          Et,
          {
            confirmOnClick: m ? Me : te(Je),
            confirmProps: {
              disabled: !U,
              isLoading: x,
              loadingIndicator: /* @__PURE__ */ pe.jsx(hn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Me
          }
        )
      ]
    }
  );
}, R2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, P2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, A2 = "_wrapper_1bylq_1", L2 = "_inputWrapper_1bylq_6", V2 = "_inputSeparator_1bylq_18", z2 = "_buttonLink_1bylq_23", U2 = "_noIssuesFound_1bylq_27", Ka = {
  wrapper: A2,
  inputWrapper: L2,
  inputSeparator: V2,
  buttonLink: z2,
  noIssuesFound: U2
}, M2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Fn(), i = R2(n?.jiraSiteUrl), [a, o] = de(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: F,
    isLoadingIssues: j,
    issues: N,
    error: x
  } = JC(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, O = !!n?.enableSortIssueTypeByLabel, I = !!(N?.length || k?.length), C = !!n?.enableRemoveAllLinks && I, w = !F && !j && k?.length > 0 && !!n?.showDanglingLinks;
  return !j && x ? /* @__PURE__ */ pe.jsx(Tn, { error: x, retry: () => f() }) : /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
    /* @__PURE__ */ pe.jsxs(b, { className: Ka.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ pe.jsxs(b, { className: Ka.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
          /* @__PURE__ */ pe.jsx(
            et,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ pe.jsx("div", { className: Ka.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ pe.jsx(
          y2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      j ? /* @__PURE__ */ pe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ pe.jsx(hn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ pe.jsx(
        LA,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ pe.jsx($.Paragraph, { align: "center", className: Ka.noIssuesFound, children: "No linked issues found" }),
      C && N?.length > 0 && /* @__PURE__ */ pe.jsx(
        et,
        {
          variant: "secondary",
          disabled: !N?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      w && /* @__PURE__ */ pe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ pe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((A) => /* @__PURE__ */ pe.jsx(Qn, { onDelete: () => m(A), children: A }, A)) }),
            /* @__PURE__ */ pe.jsx(
              et,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ pe.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ pe.jsx(ye, { name: "external-link" }),
          variant: "tertiary",
          className: Ka.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ pe.jsx(
      O2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: O
      }
    )
  ] });
}, Ph = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], B2 = (e) => {
  const n = P2(e);
  return typeof n == "string" ? n : !0;
}, _i = "JIRA", q2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, H2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: q2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: _i,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: Ph,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = (K) => fr(K, {
    fieldDefinitions: Ph,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), B = l.watch("name");
  return /* @__PURE__ */ pe.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ pe.jsx(hr, { cause: k }),
        /* @__PURE__ */ pe.jsxs(nt, { children: [
          /* @__PURE__ */ pe.jsx(Z, { children: /* @__PURE__ */ pe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pe.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            An,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (K) => B2(K)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ pe.jsx(
            xn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ pe.jsx(
            xn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ pe.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(He, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ pe.jsx(
            xn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ pe.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: _i,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ pe.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ pe.jsx(
          yr,
          {
            integrationType: _i,
            integrationId: e,
            widgetName: B,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ pe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ pe.jsx(
                ye,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ pe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  _i,
                  " integration, all links between Dixa and ",
                  _i,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  _i,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  _i,
                  " ",
                  'integration "',
                  B,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Zu = { exports: {} }, Ga = {}, Jx;
function W2() {
  if (Jx) return Ga;
  Jx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var ss = {}, Xx;
function K2() {
  return Xx || (Xx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    ss.Fragment = i, ss.jsx = Un, ss.jsxs = Kn;
  })()), ss;
}
var Zx;
function G2() {
  return Zx || (Zx = 1, process.env.NODE_ENV === "production" ? Zu.exports = W2() : Zu.exports = K2()), Zu.exports;
}
var he = G2();
function Y2({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = yn(), [a, o] = de([]), [s] = i(e, n), [l, d] = de(
    []
  );
  return Qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((F) => {
        const j = setTimeout(F, r);
        d([...l, j]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
var XC = /* @__PURE__ */ ((e) => (e.List = "list", e))(XC || {}), Ah = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Ah || {}), Lh = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Lh || {}), Vh = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Vh || {});
const Q2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, J2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, X2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, Z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, eL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, cL = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Z2,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": Q2,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": J2,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": nL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": X2,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": tL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": rL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": oL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": sL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": lL
};
function Wr(e) {
  return cL[e] ?? {};
}
const dL = Wr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), uL = Wr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), mL = Wr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), pL = Wr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), fL = Wr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), hL = Wr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), yL = Wr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), gL = Wr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vL = Wr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function zh(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function e_(e) {
  return zh(e) && e?.attributes?.event_properties?.$message;
}
function kL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function n_(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function bL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function xL(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function _L(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function SL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function NL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function jL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function t_(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function wL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function CL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const FL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function IL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function EL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function $L({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = yn(), { track: a } = Fn(), [o, s] = de(null), [l, d] = de(
    null
  ), [m, u] = de(null), [f, h] = de(null), [k, F] = de(
    null
  ), [j, N] = de([]), {
    data: x,
    error: g,
    loading: O,
    networkStatus: I
  } = i(mL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: w,
      error: A,
      loading: B,
      networkStatus: K
    }
  ] = r(dL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    if (x && !O && I === rr.ready) {
      const ee = bL(x);
      s(
        ee.find((G) => G?.attributes?.name === "Received Email")?.id || null
      ), d(
        ee.find((G) => G?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ee.find((G) => G?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ee.find((G) => G?.attributes?.name === "Bounced Email")?.id || null
      ), F(
        ee.find((G) => G?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), F(null);
  }, [x]), Qe(() => {
    o && l && m && f && k && !B && K === rr.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    k
  ]), Qe(() => {
    if (!B && w) {
      const ee = xL(w), G = SL(
        w
      ).map(
        (ve) => ve?.attributes?.event_properties.$message
      ), H = NL(
        w
      ).map(
        (ve) => ve?.attributes?.event_properties.$message
      );
      ee.forEach((ve) => {
        const ue = ve.attributes?.event_properties.$message;
        ve.opened = G.includes(ue), ve.clicked = H.includes(ue);
      });
      const R = _L(w), q = jL(w), te = [
        ...ee,
        ...q,
        ...R
      ].sort((ve, ue) => {
        const ge = n_(ve), U = n_(ue);
        return ge == null && U == null ? 0 : ge == null ? 1 : U == null ? -1 : U - ge;
      }).slice(0, n);
      N(te);
      const we = te.map((ve) => ve.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (ve) => we.includes(ve.id)
        ).length,
        emailsBounced: q.filter(
          (ve) => we.includes(ve.id)
        ).length,
        smsReceived: R.filter(
          (ve) => we.includes(ve.id)
        ).length,
        total: we.length
      });
    } else
      N([]);
  }, [B, w]), Yn(
    () => ({
      receivedMessages: j,
      isLoading: O || B,
      error: g || A
    }),
    [
      j,
      O,
      B,
      g,
      A
    ]
  );
}
function TL({ profileId: e }) {
  const { useQuery: n } = yn(), [r, i] = de(), [a, o] = de(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(fL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Qe(() => {
    l && o(l);
  }, [l]), Qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Yn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function DL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = Fn(), { useLazyQuery: i } = yn(), [a, o] = de(), [s, l] = de(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(pL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    if (!f && m) {
      const k = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, F = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(k, F);
    }
  }, [f, m]);
  const h = (k, F) => {
    const j = k?.data?.length === 1 && k.data[0]?.id || void 0, N = F?.data?.length === 1 && F.data[0]?.id || void 0, x = j || N, g = !j || !N || j === N;
    if (x && g) {
      o(j || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${j}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Yn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const r_ = 800, OL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, RL = 3, PL = 1.5, AL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = RL,
  useDelayRange: a = !1
}) => {
  const o = (A) => Math.floor(Math.random() * (A.max - A.min) + A.min), [s, l] = de(0), [d, m] = de(n || r_), [u, f] = de(r || OL), [h, k] = de(!1), [F, j] = de(!1), N = a || !!r, x = N ? o(u) : n || r_, [g, O] = de(x);
  IR(
    async () => {
      const A = s + 1, B = PL ** A;
      l(A), O(
        (N ? o(u) : d) * B
      ), await e().then(() => {
        j(!0), w();
      });
    },
    h ? g : null
  ), $R(() => w());
  const I = yt(() => {
    l(0), O(x);
  }, [x]), C = yt(
    (A = {}) => {
      const { delay: B, delayRange: K } = A;
      j(!1), I(), K && (f(K), O(o(K))), B && (m(B), O(B)), k(!0);
    },
    [I]
  ), w = yt(() => {
    k(!1), I();
  }, [I]);
  return Qe(() => {
    s >= i && w();
  }, [s, i, w]), Yn(
    () => ({ isRunning: h, isSuccessful: F, start: C, stop: w }),
    [h, F, C, w]
  );
}, LL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, VL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function zL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = yn(), [i, a] = de(), [o, s] = de(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? hL : yL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: F
  } = AL({
    query: u,
    useDelayRange: !0
  }), j = m || h;
  return Qe(() => {
    if (d)
      if (cI({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = LL(d);
          k({
            ...N && {
              delayRange: VL(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), Qe(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, x = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (x = l?.Klaviyo?.get_segments_for_profile), (N?.data || x?.data) && (F(), a(
        (n === "lists" ? N?.data : x?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Yn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: j,
      error: o,
      networkStatus: f
    }),
    [i, j, o, f, k]
  );
}
const UL = "_notificationText_1polx_1", tg = {
  notificationText: UL
}, Vl = ({ error: e }) => {
  const { track: n } = Fn();
  let r = e;
  if (Nw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && pw({ error: i[0] }), o = i.length === 1 && sI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ he.jsx(Tn, { error: e });
  }
  return /* @__PURE__ */ he.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ he.jsx(
    Xe.Item,
    {
      contentLeft: /* @__PURE__ */ he.jsx(ye, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, ML = "_message_zrl8q_54", BL = "_messageIsOpen_zrl8q_62", qL = "_messageHeader_zrl8q_65", HL = "_messageLabel_zrl8q_71", WL = "_messageText_zrl8q_74", da = {
  message: ML,
  messageIsOpen: BL,
  messageHeader: qL,
  messageLabel: HL,
  messageText: WL
}, KL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && wL(e.flowMessage);
  return /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", className: da.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ he.jsx($.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ he.jsx(hn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ he.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(
            $.Paragraph,
            {
              variant: "4",
              className: da.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", className: da.messageText, children: i })
        ]
      }
    )
  ] });
}, GL = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ he.jsx(he.Fragment, { children: /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ he.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, YL = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = de(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Yn(
    () => () => l ? Jn(l).format(m) : d ? Jn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, F = f && e.clicked, j = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], x = f ? "mail" : "sms";
  return /* @__PURE__ */ he.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(da.message, {
        [da.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ he.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: da.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ he.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ he.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ he.jsx(ye, { size: 16, name: x }),
                  " ",
                  FL(s),
                  u && /* @__PURE__ */ he.jsx(Bn, { size: "small", variant: "info", children: u })
                ] }),
                j && j,
                N && N
              ] }),
              /* @__PURE__ */ he.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ he.jsx(Cl, {}),
          kL(e) && /* @__PURE__ */ he.jsx(b, { children: /* @__PURE__ */ he.jsx(Bn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
            /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ he.jsx(Qn, { children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ he.jsx(
                  ye,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ he.jsx(Qn, { children: /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ he.jsx(
                  ye,
                  {
                    size: 16,
                    color: F ? "green.400" : "red.400",
                    name: F ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ he.jsx(KL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ he.jsx(GL, { event: e })
        ] })
      ]
    }
  );
}, QL = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, JL = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = de(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = $L({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = Y2({
    query: uL,
    options: QL,
    delayMs: 1e3
  }), [m, u] = de([]);
  Qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => zh(k)).map((k) => e_(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && zh(h) && !h.flowMessage) {
          const k = e_(h), F = d.find((N) => (N.data && t_(N.data))?.id === k), j = F?.data && t_(F.data);
          if (j)
            return {
              ...CL(h),
              flowMessage: j
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ he.jsx(he.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ he.jsx(
    Tn,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ he.jsx(
    Vl,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(hn, {}) }) : /* @__PURE__ */ he.jsx(he.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ he.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, k) => /* @__PURE__ */ he.jsx(
      YL,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ he.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: tg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, XL = "_list_ld0hf_1", ZL = "_listItem_ld0hf_4", ti = {
  list: XL,
  listItem: ZL
}, eV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ he.jsx(Xe, { className: ti.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", children: lI(a) }),
          /* @__PURE__ */ he.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Li(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, i_ = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = de(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = zL({ profileId: e, query: n });
  Qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ he.jsx(Vl, { error: o }) : s ? /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsx(hn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ he.jsx(he.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ he.jsx(Qn, { children: fw(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ he.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ he.jsx(ye, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ he.jsxs($.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ he.jsx(Ze, { content: "Refresh lists and segments", children: /* @__PURE__ */ he.jsx(et, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ he.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, nV = 0.7, tV = 0.3, rV = (e) => e >= nV ? { variant: "error", label: "High risk" } : e >= tV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, iV = (e) => /* @__PURE__ */ he.jsx($.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), aV = (e) => {
  const n = rV(e);
  return /* @__PURE__ */ he.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ he.jsx(Bn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ he.jsx($.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, oV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: iV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Li(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: aV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Li(o)
      }
    ] : []
  ];
}, sV = ({
  profile: e
}) => {
  const n = oV(e);
  return /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ he.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ he.jsx(Xe, { className: ti.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ he.jsx(Xe.Text, { variant: "dense", className: ti.listItem, children: /* @__PURE__ */ he.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ he.jsx($.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, lV = "_tagHover_kzbzk_1", cV = "_channelUnsubscribed_kzbzk_6", a_ = {
  tagHover: lV,
  channelUnsubscribed: cV
}, o_ = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ he.jsx(
    Ze,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ he.jsx(
        Qn,
        {
          className: a_.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ he.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [a_.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ he.jsx(hn, { size: 16 }) : /* @__PURE__ */ he.jsx(ye, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, dV = "_subscriptionError_1qhhx_1", uV = {
  subscriptionError: dV
}, mV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = de(!1), [d, m] = de(!1), [u, f] = de(), { track: h } = Fn(), [k, F] = ER({
    channel: null,
    request: null
  }), j = IL(n), N = EL(n), x = !!e, { useMutation: g } = yn(), [O] = g(
    gL
  ), [I] = g(
    vL
  ), C = (B) => {
    h("klaviyo:profile:subscribe:clicked", { channel: B }), F.setAll({
      channel: B,
      request: "subscribed"
    }), ((K) => O({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Ah.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...K === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Lh.Subscribed
                        }
                      }
                    },
                    ...K === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Lh.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: XC.List,
              id: e
            }
          }
        }
      }
    }))(B).then(
      (K) => A({
        channel: B,
        mutationResponse: K,
        isSubscriptionRequest: !0
      })
    ).catch(
      (K) => A({
        channel: B,
        mutationErrorResponse: K,
        isSubscriptionRequest: !0
      })
    );
  }, w = (B) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: B }), F.setAll({
      channel: B,
      request: "unsubscribed"
    }), I({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Ah.Profile,
                attributes: {
                  ...B === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...B === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...B === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Vh.Unsubscribed
                        }
                      }
                    },
                    ...B === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Vh.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (K) => A({
        channel: B,
        mutationResponse: K,
        isSubscriptionRequest: !1
      })
    ).catch(
      (K) => A({
        channel: B,
        mutationErrorResponse: K,
        isSubscriptionRequest: !1
      })
    );
  }, A = async ({
    channel: B,
    mutationResponse: K,
    mutationErrorResponse: ee,
    isSubscriptionRequest: G
  }) => {
    const H = ee?.networkError, R = H ? H?.statusCode : NaN, q = K?.errors, te = !!q && hw({
      errors: q
    });
    R === 202 ? (h(
      G ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: B }
    ), await o()) : te ? (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: B,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${G ? "opt-in" : "opt-out"}.`
    )) : (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: B,
        reason: H?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${G ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Qe(() => {
    if (k.request === "subscribed") {
      const B = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(B), F.reset()), k.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(B), F.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ he.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ he.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ he.jsx(
            o_,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: j,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                l(!0), f(void 0), j ? w("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ he.jsx(
            o_,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: x,
              handleAction: () => {
                m(!0), f(void 0), N ? w("SMS") : C("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ he.jsx(b, { className: uV.subscriptionError, children: u })
      ] })
    }
  );
}, pV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: k
  } = TL({ profileId: e });
  return f ? /* @__PURE__ */ he.jsx(Vl, { error: f }) : h ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(hn, {}) }) : !u && !h ? /* @__PURE__ */ he.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: tg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ he.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ he.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ he.jsx($.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ he.jsxs(Xe, { className: ti.list, children: [
        i && /* @__PURE__ */ he.jsx(i_, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ he.jsx(
          i_,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ he.jsx(
      mV,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: k,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ he.jsx(sV, { profile: u }),
    u && s && /* @__PURE__ */ he.jsx(eV, { profile: u }),
    /* @__PURE__ */ he.jsx(
      JL,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, fV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: k,
    error: F
  } = DL({ email: r, phoneNumber: i });
  return xI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : k ? /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(hn, {}) }) : F ? /* @__PURE__ */ he.jsx(Vl, { error: F }) : f ? /* @__PURE__ */ he.jsx(
    pV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ he.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: tg.notificationText,
      children: "No profile ID found"
    }
  );
}, s_ = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], hV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ he.jsx(
  _r,
  {
    name: n,
    control: e,
    label: "Choose how many messages to show",
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = s_.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ he.jsx($.Paragraph, { children: i }) : null;
      }
    },
    children: s_.map((r) => /* @__PURE__ */ he.jsx(ut.Item, { value: r.value, children: r.label }, r.value))
  }
), yV = "_settingsWrapper_eleyu_1", gV = {
  settingsWrapper: yV
}, vV = Wr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), l_ = [], kV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = yn(), [i, a] = de(l_), [o, s] = de(!!e), {
    data: l,
    error: d,
    loading: m
  } = r(vV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    e && s(!0);
  }, [e]), Qe(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !m && !d) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || l_;
      a(f);
    }
  }, [o, l, m, d]), /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
    /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: gV.settingsWrapper,
        children: [
          /* @__PURE__ */ he.jsx(He, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ he.jsx(
            wl,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && d && !m && /* @__PURE__ */ he.jsx(He, { children: /* @__PURE__ */ he.jsx(Tn, { error: d }) }),
          o && !d && m && /* @__PURE__ */ he.jsx(He, { children: /* @__PURE__ */ he.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ he.jsx(hn, {}) }) }),
          o && !d && !m && i && /* @__PURE__ */ he.jsx(He, { label: "Available lists to subscribe to", children: /* @__PURE__ */ he.jsx(
            ni,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ he.jsx($.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ he.jsx(ut.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ he.jsx(Z, { span: 3 })
  ] });
}, sl = [
  {
    key: "klaviyoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], bV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: hi
  }
], xV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], em = "KLAVIYO", _V = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    sl
  )
}, SV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: _V
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: em,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: sl,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = s || !!O?.additionalProperties?.isUsingOAuth, B = (ee) => fr(ee, {
    fieldDefinitions: sl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), K = l.watch("name");
  return /* @__PURE__ */ he.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: B,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ he.jsx(hr, { cause: k }),
        /* @__PURE__ */ he.jsxs(nt, { children: [
          /* @__PURE__ */ he.jsx(Z, { children: /* @__PURE__ */ he.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          !A && /* @__PURE__ */ he.jsxs(he.Fragment, { children: [
            /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
              Er,
              {
                name: "klaviyoApiKey",
                label: "API key",
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ he.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show Klaviyo lists for a profile", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show Klaviyo segments for a profile", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show subscription channels for Klaviyo messages", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show custom properties for a profile", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(He, { label: "Show predictive analytics for a profile", children: /* @__PURE__ */ he.jsx(
            xn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          !s && /* @__PURE__ */ he.jsx(
            xt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: ee }) => /* @__PURE__ */ he.jsx(
                kV,
                {
                  value: ee.value,
                  onChange: ee.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ he.jsx(Z, { span: 3, children: /* @__PURE__ */ he.jsx(
            hV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ he.jsx(Z, { span: 3 }),
          A && !s && e && /* @__PURE__ */ he.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: em,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ he.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ he.jsx(
          yr,
          {
            integrationType: em,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function NV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const jV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, wV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, CV = {};
function c_(e, n) {
  return (CV.jsx ? wV : jV).test(e);
}
const FV = /[ \t\n\f\r]/g;
function IV(e) {
  return typeof e == "object" ? e.type === "text" ? d_(e.value) : !1 : d_(e);
}
function d_(e) {
  return e.replace(FV, "") === "";
}
class Bo {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
Bo.prototype.property = {};
Bo.prototype.normal = {};
Bo.prototype.space = null;
function ZC(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new Bo(r, i, n);
}
function Uh(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let EV = 0;
const Dn = qi(), bt = qi(), e1 = qi(), Ye = qi(), st = qi(), ua = qi(), ar = qi();
function qi() {
  return 2 ** ++EV;
}
const Mh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Dn,
  booleanish: bt,
  commaOrSpaceSeparated: ar,
  commaSeparated: ua,
  number: Ye,
  overloadedBoolean: e1,
  spaceSeparated: st
}, Symbol.toStringTag, { value: "Module" })), nm = Object.keys(Mh);
class rg extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), u_(this, "space", a), typeof i == "number")
      for (; ++o < nm.length; ) {
        const s = nm[o];
        u_(this, nm[o], (i & Mh[s]) === Mh[s]);
      }
  }
}
rg.prototype.defined = !0;
function u_(e, n, r) {
  r && (e[n] = r);
}
const $V = {}.hasOwnProperty;
function Fa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if ($V.call(e.properties, i)) {
      const a = e.properties[i], o = new rg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Uh(i)] = i, r[Uh(o.attribute)] = i;
    }
  return new Bo(n, r, e.space);
}
const n1 = Fa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), t1 = Fa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function r1(e, n) {
  return n in e ? e[n] : n;
}
function i1(e, n) {
  return r1(e, n.toLowerCase());
}
const a1 = Fa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: i1,
  properties: { xmlns: null, xmlnsXLink: null }
}), o1 = Fa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: bt,
    ariaAutoComplete: null,
    ariaBusy: bt,
    ariaChecked: bt,
    ariaColCount: Ye,
    ariaColIndex: Ye,
    ariaColSpan: Ye,
    ariaControls: st,
    ariaCurrent: null,
    ariaDescribedBy: st,
    ariaDetails: null,
    ariaDisabled: bt,
    ariaDropEffect: st,
    ariaErrorMessage: null,
    ariaExpanded: bt,
    ariaFlowTo: st,
    ariaGrabbed: bt,
    ariaHasPopup: null,
    ariaHidden: bt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: st,
    ariaLevel: Ye,
    ariaLive: null,
    ariaModal: bt,
    ariaMultiLine: bt,
    ariaMultiSelectable: bt,
    ariaOrientation: null,
    ariaOwns: st,
    ariaPlaceholder: null,
    ariaPosInSet: Ye,
    ariaPressed: bt,
    ariaReadOnly: bt,
    ariaRelevant: null,
    ariaRequired: bt,
    ariaRoleDescription: st,
    ariaRowCount: Ye,
    ariaRowIndex: Ye,
    ariaRowSpan: Ye,
    ariaSelected: bt,
    ariaSetSize: Ye,
    ariaSort: null,
    ariaValueMax: Ye,
    ariaValueMin: Ye,
    ariaValueNow: Ye,
    ariaValueText: null,
    role: null
  }
}), TV = Fa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: i1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ua,
    acceptCharset: st,
    accessKey: st,
    action: null,
    allow: null,
    allowFullScreen: Dn,
    allowPaymentRequest: Dn,
    allowUserMedia: Dn,
    alt: null,
    as: null,
    async: Dn,
    autoCapitalize: null,
    autoComplete: st,
    autoFocus: Dn,
    autoPlay: Dn,
    blocking: st,
    capture: null,
    charSet: null,
    checked: Dn,
    cite: null,
    className: st,
    cols: Ye,
    colSpan: null,
    content: null,
    contentEditable: bt,
    controls: Dn,
    controlsList: st,
    coords: Ye | ua,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Dn,
    defer: Dn,
    dir: null,
    dirName: null,
    disabled: Dn,
    download: e1,
    draggable: bt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Dn,
    formTarget: null,
    headers: st,
    height: Ye,
    hidden: Dn,
    high: Ye,
    href: null,
    hrefLang: null,
    htmlFor: st,
    httpEquiv: st,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Dn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Dn,
    itemId: null,
    itemProp: st,
    itemRef: st,
    itemScope: Dn,
    itemType: st,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Dn,
    low: Ye,
    manifest: null,
    max: null,
    maxLength: Ye,
    media: null,
    method: null,
    min: null,
    minLength: Ye,
    multiple: Dn,
    muted: Dn,
    name: null,
    nonce: null,
    noModule: Dn,
    noValidate: Dn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Dn,
    optimum: Ye,
    pattern: null,
    ping: st,
    placeholder: null,
    playsInline: Dn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Dn,
    referrerPolicy: null,
    rel: st,
    required: Dn,
    reversed: Dn,
    rows: Ye,
    rowSpan: Ye,
    sandbox: st,
    scope: null,
    scoped: Dn,
    seamless: Dn,
    selected: Dn,
    shadowRootClonable: Dn,
    shadowRootDelegatesFocus: Dn,
    shadowRootMode: null,
    shape: null,
    size: Ye,
    sizes: null,
    slot: null,
    span: Ye,
    spellCheck: bt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ye,
    step: null,
    style: null,
    tabIndex: Ye,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Dn,
    useMap: null,
    value: bt,
    width: Ye,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: st,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ye,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ye,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Dn,
    // Lists. Use CSS to reduce space between items instead
    declare: Dn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ye,
    // `<img>` and `<object>`
    leftMargin: Ye,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ye,
    // `<body>`
    marginWidth: Ye,
    // `<body>`
    noResize: Dn,
    // `<frame>`
    noHref: Dn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Dn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Dn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ye,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: bt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ye,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ye,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Dn,
    disableRemotePlayback: Dn,
    prefix: null,
    property: null,
    results: Ye,
    security: null,
    unselectable: null
  }
}), DV = Fa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: r1,
  properties: {
    about: ar,
    accentHeight: Ye,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ye,
    amplitude: Ye,
    arabicForm: null,
    ascent: Ye,
    attributeName: null,
    attributeType: null,
    azimuth: Ye,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ye,
    by: null,
    calcMode: null,
    capHeight: Ye,
    className: st,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ye,
    diffuseConstant: Ye,
    direction: null,
    display: null,
    dur: null,
    divisor: Ye,
    dominantBaseline: null,
    download: Dn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ye,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ye,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ye,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ua,
    g2: ua,
    glyphName: ua,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ye,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ye,
    horizOriginX: Ye,
    horizOriginY: Ye,
    id: null,
    ideographic: Ye,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ye,
    k: Ye,
    k1: Ye,
    k2: Ye,
    k3: Ye,
    k4: Ye,
    kernelMatrix: ar,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ye,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ye,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ye,
    overlineThickness: Ye,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ye,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: st,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ye,
    pointsAtY: Ye,
    pointsAtZ: Ye,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ar,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ar,
    rev: ar,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ar,
    requiredFeatures: ar,
    requiredFonts: ar,
    requiredFormats: ar,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ye,
    specularExponent: Ye,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ye,
    strikethroughThickness: Ye,
    string: null,
    stroke: null,
    strokeDashArray: ar,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ye,
    strokeOpacity: Ye,
    strokeWidth: null,
    style: null,
    surfaceScale: Ye,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ar,
    tabIndex: Ye,
    tableValues: null,
    target: null,
    targetX: Ye,
    targetY: Ye,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ar,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ye,
    underlineThickness: Ye,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ye,
    values: null,
    vAlphabetic: Ye,
    vMathematical: Ye,
    vectorEffect: null,
    vHanging: Ye,
    vIdeographic: Ye,
    version: null,
    vertAdvY: Ye,
    vertOriginX: Ye,
    vertOriginY: Ye,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ye,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), OV = /^data[-\w.:]+$/i, m_ = /-[a-z]/g, RV = /[A-Z]/g;
function PV(e, n) {
  const r = Uh(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && OV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(m_, LV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!m_.test(o)) {
        let s = o.replace(RV, AV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = rg;
  }
  return new a(i, n);
}
function AV(e) {
  return "-" + e.toLowerCase();
}
function LV(e) {
  return e.charAt(1).toUpperCase();
}
const VV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, zV = ZC([t1, n1, a1, o1, TV], "html"), ig = ZC([t1, n1, a1, o1, DV], "svg");
function UV(e) {
  return e.join(" ").trim();
}
var Ji = {}, tm, p_;
function MV() {
  if (p_) return tm;
  p_ = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", k = "declaration";
  tm = function(j, N) {
    if (typeof j != "string")
      throw new TypeError("First argument must be a string");
    if (!j) return [];
    N = N || {};
    var x = 1, g = 1;
    function O(R) {
      var q = R.match(n);
      q && (x += q.length);
      var te = R.lastIndexOf(d);
      g = ~te ? R.length - te : g + R.length;
    }
    function I() {
      var R = { line: x, column: g };
      return function(q) {
        return q.position = new C(R), B(), q;
      };
    }
    function C(R) {
      this.start = R, this.end = { line: x, column: g }, this.source = N.source;
    }
    C.prototype.content = j;
    function w(R) {
      var q = new Error(
        N.source + ":" + x + ":" + g + ": " + R
      );
      if (q.reason = R, q.filename = N.source, q.line = x, q.column = g, q.source = j, !N.silent) throw q;
    }
    function A(R) {
      var q = R.exec(j);
      if (q) {
        var te = q[0];
        return O(te), j = j.slice(te.length), q;
      }
    }
    function B() {
      A(r);
    }
    function K(R) {
      var q;
      for (R = R || []; q = ee(); )
        q !== !1 && R.push(q);
      return R;
    }
    function ee() {
      var R = I();
      if (!(m != j.charAt(0) || u != j.charAt(1))) {
        for (var q = 2; f != j.charAt(q) && (u != j.charAt(q) || m != j.charAt(q + 1)); )
          ++q;
        if (q += 2, f === j.charAt(q - 1))
          return w("End of comment missing");
        var te = j.slice(2, q - 2);
        return g += 2, O(te), j = j.slice(q), g += 2, R({
          type: h,
          comment: te
        });
      }
    }
    function G() {
      var R = I(), q = A(i);
      if (q) {
        if (ee(), !A(a)) return w("property missing ':'");
        var te = A(o), we = R({
          type: k,
          property: F(q[0].replace(e, f)),
          value: te ? F(te[0].replace(e, f)) : f
        });
        return A(s), we;
      }
    }
    function H() {
      var R = [];
      K(R);
      for (var q; q = G(); )
        q !== !1 && (R.push(q), K(R));
      return R;
    }
    return B(), H();
  };
  function F(j) {
    return j ? j.replace(l, f) : f;
  }
  return tm;
}
var f_;
function BV() {
  if (f_) return Ji;
  f_ = 1;
  var e = Ji && Ji.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.default = r;
  var n = e(MV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ji;
}
var qV = BV();
const h_ = /* @__PURE__ */ vy(qV), HV = h_.default || h_, s1 = l1("end"), ag = l1("start");
function l1(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function WV(e) {
  const n = ag(e), r = s1(e);
  if (n && r)
    return { start: n, end: r };
}
function _o(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? y_(e.position) : "start" in e || "end" in e ? y_(e) : "line" in e || "column" in e ? Bh(e) : "";
}
function Bh(e) {
  return g_(e && e.line) + ":" + g_(e && e.column);
}
function y_(e) {
  return Bh(e && e.start) + "-" + Bh(e && e.end);
}
function g_(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = _o(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const og = {}.hasOwnProperty, KV = /* @__PURE__ */ new Map(), GV = /[A-Z]/g, YV = /-([a-z])/g, QV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), JV = /* @__PURE__ */ new Set(["td", "th"]), c1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function XV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = o3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = a3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ig : zV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = d1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function d1(e, n, r) {
  if (n.type === "element")
    return ZV(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return e3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return t3(e, n, r);
  if (n.type === "mdxjsEsm")
    return n3(e, n);
  if (n.type === "root")
    return r3(e, n, r);
  if (n.type === "text")
    return i3(e, n);
}
function ZV(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = ig, e.schema = a), e.ancestors.push(n);
  const o = m1(e, n.tagName, !1), s = s3(e, n);
  let l = lg(e, n);
  return QV.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !IV(d) : !0;
  })), u1(e, s, o, n), sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function e3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Ro(e, n.position);
}
function n3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Ro(e, n.position);
}
function t3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = ig, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : m1(e, n.name, !0), s = l3(e, n), l = lg(e, n);
  return u1(e, s, o, n), sg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function r3(e, n, r) {
  const i = {};
  return sg(i, lg(e, n)), e.create(n, e.Fragment, i, r);
}
function i3(e, n) {
  return n.value;
}
function u1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function sg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function a3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function o3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = ag(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function s3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && og.call(n.properties, a)) {
      const o = c3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && JV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function l3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Ro(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Ro(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function lg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : KV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = d1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function c3(e, n, r) {
  const i = PV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? NV(r) : UV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : d3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = u3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? VV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function d3(e, n) {
  const r = {};
  try {
    HV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = c1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(YV, p3)), r[s] = o;
  }
}
function m1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = c_(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = c_(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return og.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Ro(e);
}
function Ro(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = c1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function u3(e) {
  const n = {};
  let r;
  for (r in e)
    og.call(e, r) && (n[m3(r)] = e[r]);
  return n;
}
function m3(e) {
  let n = e.replace(GV, f3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function p3(e, n) {
  return n.toUpperCase();
}
function f3(e) {
  return "-" + e.toLowerCase();
}
const rm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, h3 = {};
function y3(e, n) {
  const r = h3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return p1(e, i, a);
}
function p1(e, n, r) {
  if (g3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return v_(e.children, n, r);
  }
  return Array.isArray(e) ? v_(e, n, r) : "";
}
function v_(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = p1(e[a], n, r);
  return i.join("");
}
function g3(e) {
  return !!(e && typeof e == "object");
}
const k_ = document.createElement("i");
function cg(e) {
  const n = "&" + e + ";";
  k_.innerHTML = n;
  const r = k_.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function qr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function br(e, n) {
  return e.length > 0 ? (qr(e, e.length, 0, n), e) : n;
}
const b_ = {}.hasOwnProperty;
function v3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    k3(n, e[r]);
  return n;
}
function k3(e, n) {
  let r;
  for (r in n) {
    const a = (b_.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        b_.call(a, s) || (a[s] = []);
        const l = o[s];
        b3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function b3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  qr(e, 0, 0, i);
}
function f1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ma(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Vr = vi(/[A-Za-z]/), lr = vi(/[\dA-Za-z]/), x3 = vi(/[#-'*+\--9=?A-Z^-~]/);
function qh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Hh = vi(/\d/), _3 = vi(/[\dA-Fa-f]/), S3 = vi(/[!-/:-@[-`{-~]/);
function $n(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Xn(e) {
  return e === -2 || e === -1 || e === 32;
}
const N3 = vi(new RegExp("\\p{P}|\\p{S}", "u")), j3 = vi(/\s/);
function vi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Ia(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && lr(e.charCodeAt(r + 1)) && lr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function ct(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return Xn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return Xn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const w3 = {
  tokenize: C3
};
function C3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return $n(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const F3 = {
  tokenize: I3
}, x_ = {
  tokenize: E3
};
function I3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(O) {
    if (i < r.length) {
      const I = r[i];
      return n.containerState = I[1], e.attempt(I[0].continuation, d, m)(O);
    }
    return m(O);
  }
  function d(O) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const I = n.events.length;
      let C = I, w;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          w = n.events[C][1].end;
          break;
        }
      x(i);
      let A = I;
      for (; A < n.events.length; )
        n.events[A][1].end = {
          ...w
        }, A++;
      return qr(n.events, C + 1, 0, n.events.slice(I)), n.events.length = A, m(O);
    }
    return l(O);
  }
  function m(O) {
    if (i === r.length) {
      if (!a)
        return h(O);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return F(O);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(x_, u, f)(O);
  }
  function u(O) {
    return a && g(), x(i), h(O);
  }
  function f(O) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, F(O);
  }
  function h(O) {
    return n.containerState = {}, e.attempt(x_, k, F)(O);
  }
  function k(O) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(O);
  }
  function F(O) {
    if (O === null) {
      a && g(), x(0), e.consume(O);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), j(O);
  }
  function j(O) {
    if (O === null) {
      N(e.exit("chunkFlow"), !0), x(0), e.consume(O);
      return;
    }
    return $n(O) ? (e.consume(O), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(O), j);
  }
  function N(O, I) {
    const C = n.sliceStream(O);
    if (I && C.push(null), O.previous = o, o && (o.next = O), o = O, a.defineSkip(O.start), a.write(C), n.parser.lazy[O.start.line]) {
      let w = a.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          a.events[w][1].start.offset < s && // …and either is not ended yet…
          (!a.events[w][1].end || // …or ends after it.
          a.events[w][1].end.offset > s)
        )
          return;
      const A = n.events.length;
      let B = A, K, ee;
      for (; B--; )
        if (n.events[B][0] === "exit" && n.events[B][1].type === "chunkFlow") {
          if (K) {
            ee = n.events[B][1].end;
            break;
          }
          K = !0;
        }
      for (x(i), w = A; w < n.events.length; )
        n.events[w][1].end = {
          ...ee
        }, w++;
      qr(n.events, B + 1, 0, n.events.slice(A)), n.events.length = w;
    }
  }
  function x(O) {
    let I = r.length;
    for (; I-- > O; ) {
      const C = r[I];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    r.length = O;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function E3(e, n, r) {
  return ct(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function __(e) {
  if (e === null || nr(e) || j3(e))
    return 1;
  if (N3(e))
    return 2;
}
function dg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const Wh = {
  name: "attention",
  resolveAll: $3,
  tokenize: T3
};
function $3(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          S_(f, -d), S_(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = br(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = br(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = br(m, dg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = br(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = br(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, qr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function T3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = __(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = __(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function S_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const D3 = {
  name: "autolink",
  tokenize: O3
};
function O3(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return Vr(k) ? (e.consume(k), s) : k === 64 ? r(k) : m(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || lr(k) ? (i = 1, l(k)) : m(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, d) : (k === 43 || k === 45 || k === 46 || lr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, m(k));
  }
  function d(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || qh(k) ? r(k) : (e.consume(k), d);
  }
  function m(k) {
    return k === 64 ? (e.consume(k), u) : x3(k) ? (e.consume(k), m) : r(k);
  }
  function u(k) {
    return lr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || lr(k)) && i++ < 63) {
      const F = k === 45 ? h : f;
      return e.consume(k), F;
    }
    return r(k);
  }
}
const zl = {
  partial: !0,
  tokenize: R3
};
function R3(e, n, r) {
  return i;
  function i(o) {
    return Xn(o) ? ct(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || $n(o) ? n(o) : r(o);
  }
}
const h1 = {
  continuation: {
    tokenize: A3
  },
  exit: L3,
  name: "blockQuote",
  tokenize: P3
};
function P3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Xn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function A3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Xn(s) ? ct(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(h1, n, r)(s);
  }
}
function L3(e) {
  e.exit("blockQuote");
}
const y1 = {
  name: "characterEscape",
  tokenize: V3
};
function V3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return S3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const g1 = {
  name: "characterReference",
  tokenize: z3
};
function z3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = lr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = _3, u) : (e.enter("characterReferenceValue"), o = 7, s = Hh, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === lr && !cg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const N_ = {
  partial: !0,
  tokenize: M3
}, j_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: U3
};
function U3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return d;
  function d(w) {
    return m(w);
  }
  function m(w) {
    const A = i.events[i.events.length - 1];
    return o = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, l = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(w);
  }
  function u(w) {
    return w === l ? (s++, e.consume(w), u) : s < 3 ? r(w) : (e.exit("codeFencedFenceSequence"), Xn(w) ? ct(e, f, "whitespace")(w) : f(w));
  }
  function f(w) {
    return w === null || $n(w) ? (e.exit("codeFencedFence"), i.interrupt ? n(w) : e.check(N_, j, I)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(w));
  }
  function h(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(w)) : Xn(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ct(e, k, "whitespace")(w)) : w === 96 && w === l ? r(w) : (e.consume(w), h);
  }
  function k(w) {
    return w === null || $n(w) ? f(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), F(w));
  }
  function F(w) {
    return w === null || $n(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(w)) : w === 96 && w === l ? r(w) : (e.consume(w), F);
  }
  function j(w) {
    return e.attempt(a, I, N)(w);
  }
  function N(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), x;
  }
  function x(w) {
    return o > 0 && Xn(w) ? ct(e, g, "linePrefix", o + 1)(w) : g(w);
  }
  function g(w) {
    return w === null || $n(w) ? e.check(N_, j, I)(w) : (e.enter("codeFlowValue"), O(w));
  }
  function O(w) {
    return w === null || $n(w) ? (e.exit("codeFlowValue"), g(w)) : (e.consume(w), O);
  }
  function I(w) {
    return e.exit("codeFenced"), n(w);
  }
  function C(w, A, B) {
    let K = 0;
    return ee;
    function ee(te) {
      return w.enter("lineEnding"), w.consume(te), w.exit("lineEnding"), G;
    }
    function G(te) {
      return w.enter("codeFencedFence"), Xn(te) ? ct(w, H, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(te) : H(te);
    }
    function H(te) {
      return te === l ? (w.enter("codeFencedFenceSequence"), R(te)) : B(te);
    }
    function R(te) {
      return te === l ? (K++, w.consume(te), R) : K >= s ? (w.exit("codeFencedFenceSequence"), Xn(te) ? ct(w, q, "whitespace")(te) : q(te)) : B(te);
    }
    function q(te) {
      return te === null || $n(te) ? (w.exit("codeFencedFence"), A(te)) : B(te);
    }
  }
}
function M3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const im = {
  name: "codeIndented",
  tokenize: q3
}, B3 = {
  partial: !0,
  tokenize: H3
};
function q3(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), ct(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : $n(m) ? e.attempt(B3, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || $n(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function H3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : ct(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : $n(s) ? a(s) : r(s);
  }
}
const W3 = {
  name: "codeText",
  previous: G3,
  resolve: K3,
  tokenize: Y3
};
function K3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function G3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Y3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : $n(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || $n(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class Q3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ya(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ya(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ya(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ya(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ya(this.left, r.reverse());
      }
  }
}
function Ya(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function v1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new Q3(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, J3(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return qr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function J3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, k = r, F = 0, j = 0;
  const N = [j];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (j = h + 1, N.push(j), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const x = l.slice(N[h], N[h + 1]), g = o.pop();
    d.push([g, g + x.length - 1]), e.splice(g, 2, x);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[F + d[h][0]] = F + d[h][1], F += d[h][1] - d[h][0] - 1;
  return m;
}
const X3 = {
  resolve: ez,
  tokenize: nz
}, Z3 = {
  partial: !0,
  tokenize: tz
};
function ez(e) {
  return v1(e), e;
}
function nz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : $n(l) ? e.check(Z3, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function tz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ct(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || $n(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function k1(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(x) {
    return x === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(x), e.exit(o), h) : x === null || x === 32 || x === 41 || qh(x) ? r(x) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), j(x));
  }
  function h(x) {
    return x === 62 ? (e.enter(o), e.consume(x), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(x));
  }
  function k(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(l), h(x)) : x === null || x === 60 || $n(x) ? r(x) : (e.consume(x), x === 92 ? F : k);
  }
  function F(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), k) : k(x);
  }
  function j(x) {
    return !u && (x === null || x === 41 || nr(x)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(x)) : u < m && x === 40 ? (e.consume(x), u++, j) : x === 41 ? (e.consume(x), u--, j) : x === null || x === 32 || x === 40 || qh(x) ? r(x) : (e.consume(x), x === 92 ? N : j);
  }
  function N(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), j) : j(x);
  }
}
function b1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : $n(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || $n(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), d || (d = !Xn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function x1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : $n(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), ct(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || $n(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function So(e, n) {
  let r;
  return i;
  function i(a) {
    return $n(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Xn(a) ? ct(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const rz = {
  name: "definition",
  tokenize: az
}, iz = {
  partial: !0,
  tokenize: oz
};
function az(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return b1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), d) : r(k);
  }
  function d(k) {
    return nr(k) ? So(e, m)(k) : m(k);
  }
  function m(k) {
    return k1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(iz, f, f)(k);
  }
  function f(k) {
    return Xn(k) ? ct(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || $n(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function oz(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? So(e, a)(l) : r(l);
  }
  function a(l) {
    return x1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Xn(l) ? ct(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || $n(l) ? n(l) : r(l);
  }
}
const sz = {
  name: "hardBreakEscape",
  tokenize: lz
};
function lz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return $n(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const cz = {
  name: "headingAtx",
  resolve: dz,
  tokenize: uz
};
function dz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, qr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function uz(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || nr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || $n(u) ? (e.exit("atxHeading"), n(u)) : Xn(u) ? ct(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || nr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const mz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], w_ = ["pre", "script", "style", "textarea"], pz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: yz,
  tokenize: gz
}, fz = {
  partial: !0,
  tokenize: kz
}, hz = {
  partial: !0,
  tokenize: vz
};
function yz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function gz(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(W) {
    return u(W);
  }
  function u(W) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(W), f;
  }
  function f(W) {
    return W === 33 ? (e.consume(W), h) : W === 47 ? (e.consume(W), o = !0, j) : W === 63 ? (e.consume(W), a = 3, i.interrupt ? n : U) : Vr(W) ? (e.consume(W), s = String.fromCharCode(W), N) : r(W);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), a = 2, k) : W === 91 ? (e.consume(W), a = 5, l = 0, F) : Vr(W) ? (e.consume(W), a = 4, i.interrupt ? n : U) : r(W);
  }
  function k(W) {
    return W === 45 ? (e.consume(W), i.interrupt ? n : U) : r(W);
  }
  function F(W) {
    const Ge = "CDATA[";
    return W === Ge.charCodeAt(l++) ? (e.consume(W), l === Ge.length ? i.interrupt ? n : H : F) : r(W);
  }
  function j(W) {
    return Vr(W) ? (e.consume(W), s = String.fromCharCode(W), N) : r(W);
  }
  function N(W) {
    if (W === null || W === 47 || W === 62 || nr(W)) {
      const Ge = W === 47, sn = s.toLowerCase();
      return !Ge && !o && w_.includes(sn) ? (a = 1, i.interrupt ? n(W) : H(W)) : mz.includes(s.toLowerCase()) ? (a = 6, Ge ? (e.consume(W), x) : i.interrupt ? n(W) : H(W)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(W) : o ? g(W) : O(W));
    }
    return W === 45 || lr(W) ? (e.consume(W), s += String.fromCharCode(W), N) : r(W);
  }
  function x(W) {
    return W === 62 ? (e.consume(W), i.interrupt ? n : H) : r(W);
  }
  function g(W) {
    return Xn(W) ? (e.consume(W), g) : ee(W);
  }
  function O(W) {
    return W === 47 ? (e.consume(W), ee) : W === 58 || W === 95 || Vr(W) ? (e.consume(W), I) : Xn(W) ? (e.consume(W), O) : ee(W);
  }
  function I(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || lr(W) ? (e.consume(W), I) : C(W);
  }
  function C(W) {
    return W === 61 ? (e.consume(W), w) : Xn(W) ? (e.consume(W), C) : O(W);
  }
  function w(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), d = W, A) : Xn(W) ? (e.consume(W), w) : B(W);
  }
  function A(W) {
    return W === d ? (e.consume(W), d = null, K) : W === null || $n(W) ? r(W) : (e.consume(W), A);
  }
  function B(W) {
    return W === null || W === 34 || W === 39 || W === 47 || W === 60 || W === 61 || W === 62 || W === 96 || nr(W) ? C(W) : (e.consume(W), B);
  }
  function K(W) {
    return W === 47 || W === 62 || Xn(W) ? O(W) : r(W);
  }
  function ee(W) {
    return W === 62 ? (e.consume(W), G) : r(W);
  }
  function G(W) {
    return W === null || $n(W) ? H(W) : Xn(W) ? (e.consume(W), G) : r(W);
  }
  function H(W) {
    return W === 45 && a === 2 ? (e.consume(W), we) : W === 60 && a === 1 ? (e.consume(W), ve) : W === 62 && a === 4 ? (e.consume(W), be) : W === 63 && a === 3 ? (e.consume(W), U) : W === 93 && a === 5 ? (e.consume(W), ge) : $n(W) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(fz, $e, R)(W)) : W === null || $n(W) ? (e.exit("htmlFlowData"), R(W)) : (e.consume(W), H);
  }
  function R(W) {
    return e.check(hz, q, $e)(W);
  }
  function q(W) {
    return e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), te;
  }
  function te(W) {
    return W === null || $n(W) ? R(W) : (e.enter("htmlFlowData"), H(W));
  }
  function we(W) {
    return W === 45 ? (e.consume(W), U) : H(W);
  }
  function ve(W) {
    return W === 47 ? (e.consume(W), s = "", ue) : H(W);
  }
  function ue(W) {
    if (W === 62) {
      const Ge = s.toLowerCase();
      return w_.includes(Ge) ? (e.consume(W), be) : H(W);
    }
    return Vr(W) && s.length < 8 ? (e.consume(W), s += String.fromCharCode(W), ue) : H(W);
  }
  function ge(W) {
    return W === 93 ? (e.consume(W), U) : H(W);
  }
  function U(W) {
    return W === 62 ? (e.consume(W), be) : W === 45 && a === 2 ? (e.consume(W), U) : H(W);
  }
  function be(W) {
    return W === null || $n(W) ? (e.exit("htmlFlowData"), $e(W)) : (e.consume(W), be);
  }
  function $e(W) {
    return e.exit("htmlFlow"), n(W);
  }
}
function vz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return $n(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function kz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(zl, n, r);
  }
}
const bz = {
  name: "htmlText",
  tokenize: xz
};
function xz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(U) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(U), d;
  }
  function d(U) {
    return U === 33 ? (e.consume(U), m) : U === 47 ? (e.consume(U), C) : U === 63 ? (e.consume(U), O) : Vr(U) ? (e.consume(U), B) : r(U);
  }
  function m(U) {
    return U === 45 ? (e.consume(U), u) : U === 91 ? (e.consume(U), o = 0, F) : Vr(U) ? (e.consume(U), g) : r(U);
  }
  function u(U) {
    return U === 45 ? (e.consume(U), k) : r(U);
  }
  function f(U) {
    return U === null ? r(U) : U === 45 ? (e.consume(U), h) : $n(U) ? (s = f, ve(U)) : (e.consume(U), f);
  }
  function h(U) {
    return U === 45 ? (e.consume(U), k) : f(U);
  }
  function k(U) {
    return U === 62 ? we(U) : U === 45 ? h(U) : f(U);
  }
  function F(U) {
    const be = "CDATA[";
    return U === be.charCodeAt(o++) ? (e.consume(U), o === be.length ? j : F) : r(U);
  }
  function j(U) {
    return U === null ? r(U) : U === 93 ? (e.consume(U), N) : $n(U) ? (s = j, ve(U)) : (e.consume(U), j);
  }
  function N(U) {
    return U === 93 ? (e.consume(U), x) : j(U);
  }
  function x(U) {
    return U === 62 ? we(U) : U === 93 ? (e.consume(U), x) : j(U);
  }
  function g(U) {
    return U === null || U === 62 ? we(U) : $n(U) ? (s = g, ve(U)) : (e.consume(U), g);
  }
  function O(U) {
    return U === null ? r(U) : U === 63 ? (e.consume(U), I) : $n(U) ? (s = O, ve(U)) : (e.consume(U), O);
  }
  function I(U) {
    return U === 62 ? we(U) : O(U);
  }
  function C(U) {
    return Vr(U) ? (e.consume(U), w) : r(U);
  }
  function w(U) {
    return U === 45 || lr(U) ? (e.consume(U), w) : A(U);
  }
  function A(U) {
    return $n(U) ? (s = A, ve(U)) : Xn(U) ? (e.consume(U), A) : we(U);
  }
  function B(U) {
    return U === 45 || lr(U) ? (e.consume(U), B) : U === 47 || U === 62 || nr(U) ? K(U) : r(U);
  }
  function K(U) {
    return U === 47 ? (e.consume(U), we) : U === 58 || U === 95 || Vr(U) ? (e.consume(U), ee) : $n(U) ? (s = K, ve(U)) : Xn(U) ? (e.consume(U), K) : we(U);
  }
  function ee(U) {
    return U === 45 || U === 46 || U === 58 || U === 95 || lr(U) ? (e.consume(U), ee) : G(U);
  }
  function G(U) {
    return U === 61 ? (e.consume(U), H) : $n(U) ? (s = G, ve(U)) : Xn(U) ? (e.consume(U), G) : K(U);
  }
  function H(U) {
    return U === null || U === 60 || U === 61 || U === 62 || U === 96 ? r(U) : U === 34 || U === 39 ? (e.consume(U), a = U, R) : $n(U) ? (s = H, ve(U)) : Xn(U) ? (e.consume(U), H) : (e.consume(U), q);
  }
  function R(U) {
    return U === a ? (e.consume(U), a = void 0, te) : U === null ? r(U) : $n(U) ? (s = R, ve(U)) : (e.consume(U), R);
  }
  function q(U) {
    return U === null || U === 34 || U === 39 || U === 60 || U === 61 || U === 96 ? r(U) : U === 47 || U === 62 || nr(U) ? K(U) : (e.consume(U), q);
  }
  function te(U) {
    return U === 47 || U === 62 || nr(U) ? K(U) : r(U);
  }
  function we(U) {
    return U === 62 ? (e.consume(U), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(U);
  }
  function ve(U) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(U), e.exit("lineEnding"), ue;
  }
  function ue(U) {
    return Xn(U) ? ct(e, ge, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(U) : ge(U);
  }
  function ge(U) {
    return e.enter("htmlTextData"), s(U);
  }
}
const ug = {
  name: "labelEnd",
  resolveAll: jz,
  resolveTo: wz,
  tokenize: Cz
}, _z = {
  tokenize: Fz
}, Sz = {
  tokenize: Iz
}, Nz = {
  tokenize: Ez
};
function jz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && qr(e, 0, e.length, r), e;
}
function wz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = br(l, e.slice(o + 1, o + i + 3)), l = br(l, [["enter", u, n]]), l = br(l, dg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = br(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = br(l, e.slice(s + 1)), l = br(l, [["exit", d, n]]), qr(e, o, e.length, l), e;
}
function Cz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ma(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(_z, u, s ? u : f)(h) : h === 91 ? e.attempt(Sz, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(Nz, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function Fz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? So(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : k1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? So(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? x1(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return nr(f) ? So(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function Iz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return b1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ma(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function Ez(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const $z = {
  name: "labelStartImage",
  resolveAll: ug.resolveAll,
  tokenize: Tz
};
function Tz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const Dz = {
  name: "labelStartLink",
  resolveAll: ug.resolveAll,
  tokenize: Oz
};
function Oz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const am = {
  name: "lineEnding",
  tokenize: Rz
};
function Rz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), ct(e, n, "linePrefix");
  }
}
const Bs = {
  name: "thematicBreak",
  tokenize: Pz
};
function Pz(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || $n(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), Xn(m) ? ct(e, l, "whitespace")(m) : l(m));
  }
}
const Zt = {
  continuation: {
    tokenize: zz
  },
  exit: Mz,
  name: "list",
  tokenize: Vz
}, Az = {
  partial: !0,
  tokenize: Bz
}, Lz = {
  partial: !0,
  tokenize: Uz
};
function Vz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const F = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (F === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : Hh(k)) {
      if (i.containerState.type || (i.containerState.type = F, e.enter(F, {
        _container: !0
      })), F === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(Bs, r, m)(k) : m(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(k);
    }
    return r(k);
  }
  function d(k) {
    return Hh(k) && ++s < 10 ? (e.consume(k), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), m(k)) : r(k);
  }
  function m(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      zl,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(Az, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return Xn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function zz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(zl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, ct(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Xn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(Lz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, ct(e, e.attempt(Zt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Uz(e, n, r) {
  const i = this;
  return ct(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Mz(e) {
  e.exit(this.containerState.type);
}
function Bz(e, n, r) {
  const i = this;
  return ct(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Xn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const C_ = {
  name: "setextUnderline",
  resolveTo: qz,
  tokenize: Hz
};
function qz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Hz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Xn(m) ? ct(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || $n(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const Wz = {
  tokenize: Kz
};
function Kz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    zl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, ct(e, e.attempt(this.parser.constructs.flow, a, e.attempt(X3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const Gz = {
  resolveAll: S1()
}, Yz = _1("string"), Qz = _1("text");
function _1(e) {
  return {
    resolveAll: S1(e === "text" ? Jz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function S1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Jz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Xz = {
  42: Zt,
  43: Zt,
  45: Zt,
  48: Zt,
  49: Zt,
  50: Zt,
  51: Zt,
  52: Zt,
  53: Zt,
  54: Zt,
  55: Zt,
  56: Zt,
  57: Zt,
  62: h1
}, Zz = {
  91: rz
}, eU = {
  [-2]: im,
  [-1]: im,
  32: im
}, nU = {
  35: cz,
  42: Bs,
  45: [C_, Bs],
  60: pz,
  61: C_,
  95: Bs,
  96: j_,
  126: j_
}, tU = {
  38: g1,
  92: y1
}, rU = {
  [-5]: am,
  [-4]: am,
  [-3]: am,
  33: $z,
  38: g1,
  42: Wh,
  60: [D3, bz],
  91: Dz,
  92: [sz, y1],
  93: ug,
  95: Wh,
  96: W3
}, iU = {
  null: [Wh, Gz]
}, aU = {
  null: [42, 95]
}, oU = {
  null: []
}, sU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: aU,
  contentInitial: Zz,
  disable: oU,
  document: Xz,
  flow: nU,
  flowInitial: eU,
  insideSpan: iU,
  string: tU,
  text: rU
}, Symbol.toStringTag, { value: "Module" }));
function lU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: A(C),
    check: A(w),
    consume: g,
    enter: O,
    exit: I,
    interrupt: A(w, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: j,
    events: [],
    now: F,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(G) {
    return s = br(s, G), N(), s[s.length - 1] !== null ? [] : (B(n, 0), m.events = dg(o, m.events, m), m.events);
  }
  function h(G, H) {
    return dU(k(G), H);
  }
  function k(G) {
    return cU(s, G);
  }
  function F() {
    const {
      _bufferIndex: G,
      _index: H,
      line: R,
      column: q,
      offset: te
    } = i;
    return {
      _bufferIndex: G,
      _index: H,
      line: R,
      column: q,
      offset: te
    };
  }
  function j(G) {
    a[G.line] = G.column, ee();
  }
  function N() {
    let G;
    for (; i._index < s.length; ) {
      const H = s[i._index];
      if (typeof H == "string")
        for (G = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === G && i._bufferIndex < H.length; )
          x(H.charCodeAt(i._bufferIndex));
      else
        x(H);
    }
  }
  function x(G) {
    u = u(G);
  }
  function g(G) {
    $n(G) ? (i.line++, i.column = 1, i.offset += G === -3 ? 2 : 1, ee()) : G !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = G;
  }
  function O(G, H) {
    const R = H || {};
    return R.type = G, R.start = F(), m.events.push(["enter", R, m]), l.push(R), R;
  }
  function I(G) {
    const H = l.pop();
    return H.end = F(), m.events.push(["exit", H, m]), H;
  }
  function C(G, H) {
    B(G, H.from);
  }
  function w(G, H) {
    H.restore();
  }
  function A(G, H) {
    return R;
    function R(q, te, we) {
      let ve, ue, ge, U;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        $e(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        $e([
          /** @type {Construct} */
          q
        ])
      ) : be(q);
      function be(Fe) {
        return Ue;
        function Ue(Re) {
          const Be = Re !== null && Fe[Re], Ae = Re !== null && Fe.null, Je = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return $e(Je)(Re);
        }
      }
      function $e(Fe) {
        return ve = Fe, ue = 0, Fe.length === 0 ? we : W(Fe[ue]);
      }
      function W(Fe) {
        return Ue;
        function Ue(Re) {
          return U = K(), ge = Fe, Fe.partial || (m.currentConstruct = Fe), Fe.name && m.parser.constructs.disable.null.includes(Fe.name) ? sn() : Fe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            H ? Object.assign(Object.create(m), H) : m,
            d,
            Ge,
            sn
          )(Re);
        }
      }
      function Ge(Fe) {
        return G(ge, U), te;
      }
      function sn(Fe) {
        return U.restore(), ++ue < ve.length ? W(ve[ue]) : we;
      }
    }
  }
  function B(G, H) {
    G.resolveAll && !o.includes(G) && o.push(G), G.resolve && qr(m.events, H, m.events.length - H, G.resolve(m.events.slice(H), m)), G.resolveTo && (m.events = G.resolveTo(m.events, m));
  }
  function K() {
    const G = F(), H = m.previous, R = m.currentConstruct, q = m.events.length, te = Array.from(l);
    return {
      from: q,
      restore: we
    };
    function we() {
      i = G, m.previous = H, m.currentConstruct = R, m.events.length = q, l = te, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function cU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function dU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function uU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      v3([sU, ...(e || {}).extensions || []])
    ),
    content: a(w3),
    defined: [],
    document: a(F3),
    flow: a(Wz),
    lazy: {},
    string: a(Yz),
    text: a(Qz)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return lU(i, o, l);
    }
  }
}
function mU(e) {
  for (; !v1(e); )
    ;
  return e;
}
const F_ = /[\0\t\n\r]/g;
function pU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (F_.lastIndex = f, m = F_.exec(o), h = m && m.index !== void 0 ? m.index : o.length, k = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const fU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function hU(e) {
  return e.replace(fU, yU);
}
function yU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return f1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return cg(r) || e;
}
const N1 = {}.hasOwnProperty;
function gU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), vU(r)(mU(uU(r).document().write(pU()(e, n, !0))));
}
function vU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: K,
      autolinkEmail: K,
      atxHeading: o(se),
      blockQuote: o(Ae),
      characterEscape: K,
      characterReference: K,
      codeFenced: o(Je),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Je, s),
      codeText: o(Ce, s),
      codeTextData: K,
      data: K,
      codeFlowValue: K,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(nn),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(Se, s),
      htmlFlowData: K,
      htmlText: o(Se, s),
      htmlTextData: K,
      image: o(Le),
      label: s,
      link: o(Pe),
      listItem: o(J),
      listItemValue: h,
      listOrdered: o(gn, f),
      listUnordered: o(gn),
      paragraph: o(T),
      reference: W,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(z),
      thematicBreak: o(ae)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: C,
      autolink: d(),
      autolinkEmail: Be,
      autolinkProtocol: Re,
      blockQuote: d(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Fe,
      characterReference: Ue,
      codeFenced: d(N),
      codeFencedFence: j,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: F,
      codeFlowValue: ee,
      codeIndented: d(x),
      codeText: d(te),
      codeTextData: ee,
      data: ee,
      definition: d(),
      definitionDestinationString: I,
      definitionLabelString: g,
      definitionTitleString: O,
      emphasis: d(),
      hardBreakEscape: d(H),
      hardBreakTrailing: d(H),
      htmlFlow: d(R),
      htmlFlowData: ee,
      htmlText: d(q),
      htmlTextData: ee,
      image: d(ve),
      label: ge,
      labelText: ue,
      lineEnding: G,
      link: d(we),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Ge,
      resourceDestinationString: U,
      resourceTitleString: be,
      resource: $e,
      setextHeading: d(B),
      setextHeadingLineSequence: A,
      setextHeadingText: w,
      strong: d(),
      thematicBreak: d()
    }
  };
  j1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(V) {
    let Q = {
      type: "root",
      children: []
    };
    const me = {
      stack: [Q],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, _e = [];
    let Te = -1;
    for (; ++Te < V.length; )
      if (V[Te][1].type === "listOrdered" || V[Te][1].type === "listUnordered")
        if (V[Te][0] === "enter")
          _e.push(Te);
        else {
          const tn = _e.pop();
          Te = a(V, tn, Te);
        }
    for (Te = -1; ++Te < V.length; ) {
      const tn = n[V[Te][0]];
      N1.call(tn, V[Te][1].type) && tn[V[Te][1].type].call(Object.assign({
        sliceSerialize: V[Te][2].sliceSerialize
      }, me), V[Te][1]);
    }
    if (me.tokenStack.length > 0) {
      const tn = me.tokenStack[me.tokenStack.length - 1];
      (tn[1] || I_).call(me, void 0, tn[0]);
    }
    for (Q.position = {
      start: li(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: li(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Te = -1; ++Te < n.transforms.length; )
      Q = n.transforms[Te](Q) || Q;
    return Q;
  }
  function a(V, Q, me) {
    let _e = Q - 1, Te = -1, tn = !1, vn, on, pn, In;
    for (; ++_e <= me; ) {
      const _n = V[_e];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Te++ : Te--, In = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (vn && !In && !Te && !pn && (pn = _e), In = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          In = void 0;
      }
      if (!Te && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Te === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (vn) {
          let En = _e;
          for (on = void 0; En--; ) {
            const en = V[En];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              on && (V[on][1].type = "lineEndingBlank", tn = !0), en[1].type = "lineEnding", on = En;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          pn && (!on || pn < on) && (vn._spread = !0), vn.end = Object.assign({}, on ? V[on][1].start : _n[1].end), V.splice(on || _e, 0, ["exit", vn, _n[2]]), _e++, me++;
        }
        if (_n[1].type === "listItemPrefix") {
          const En = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          vn = En, V.splice(_e, 0, ["enter", En, _n[2]]), _e++, me++, pn = void 0, In = !0;
        }
      }
    }
    return V[Q][1]._spread = tn, me;
  }
  function o(V, Q) {
    return me;
    function me(_e) {
      l.call(this, V(_e), _e), Q && Q.call(this, _e);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(V, Q, me) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([Q, me || void 0]), V.position = {
      start: li(Q.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(V) {
    return Q;
    function Q(me) {
      V && V.call(this, me), m.call(this, me);
    }
  }
  function m(V, Q) {
    const me = this.stack.pop(), _e = this.tokenStack.pop();
    if (_e)
      _e[0].type !== V.type && (Q ? Q.call(this, V, _e[0]) : (_e[1] || I_).call(this, V, _e[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + _o({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    me.position.end = li(V.end);
  }
  function u() {
    return y3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(V) {
    if (this.data.expectingFirstListItemValue) {
      const Q = this.stack[this.stack.length - 2];
      Q.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.lang = V;
  }
  function F() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.meta = V;
  }
  function j() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function g(V) {
    const Q = this.resume(), me = this.stack[this.stack.length - 1];
    me.label = Q, me.identifier = ma(this.sliceSerialize(V)).toLowerCase();
  }
  function O() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.title = V;
  }
  function I() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.url = V;
  }
  function C(V) {
    const Q = this.stack[this.stack.length - 1];
    if (!Q.depth) {
      const me = this.sliceSerialize(V).length;
      Q.depth = me;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function A(V) {
    const Q = this.stack[this.stack.length - 1];
    Q.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function B() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function K(V) {
    const me = this.stack[this.stack.length - 1].children;
    let _e = me[me.length - 1];
    (!_e || _e.type !== "text") && (_e = X(), _e.position = {
      start: li(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, me.push(_e)), this.stack.push(_e);
  }
  function ee(V) {
    const Q = this.stack.pop();
    Q.value += this.sliceSerialize(V), Q.position.end = li(V.end);
  }
  function G(V) {
    const Q = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const me = Q.children[Q.children.length - 1];
      me.position.end = li(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(Q.type) && (K.call(this, V), ee.call(this, V));
  }
  function H() {
    this.data.atHardBreak = !0;
  }
  function R() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.value = V;
  }
  function q() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.value = V;
  }
  function te() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.value = V;
  }
  function we() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Q = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = Q, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function ve() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Q = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = Q, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function ue(V) {
    const Q = this.sliceSerialize(V), me = this.stack[this.stack.length - 2];
    me.label = hU(Q), me.identifier = ma(Q).toLowerCase();
  }
  function ge() {
    const V = this.stack[this.stack.length - 1], Q = this.resume(), me = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, me.type === "link") {
      const _e = V.children;
      me.children = _e;
    } else
      me.alt = Q;
  }
  function U() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.url = V;
  }
  function be() {
    const V = this.resume(), Q = this.stack[this.stack.length - 1];
    Q.title = V;
  }
  function $e() {
    this.data.inReference = void 0;
  }
  function W() {
    this.data.referenceType = "collapsed";
  }
  function Ge(V) {
    const Q = this.resume(), me = this.stack[this.stack.length - 1];
    me.label = Q, me.identifier = ma(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(V) {
    this.data.characterReferenceType = V.type;
  }
  function Fe(V) {
    const Q = this.sliceSerialize(V), me = this.data.characterReferenceType;
    let _e;
    me ? (_e = f1(Q, me === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : _e = cg(Q);
    const Te = this.stack[this.stack.length - 1];
    Te.value += _e;
  }
  function Ue(V) {
    const Q = this.stack.pop();
    Q.position.end = li(V.end);
  }
  function Re(V) {
    ee.call(this, V);
    const Q = this.stack[this.stack.length - 1];
    Q.url = this.sliceSerialize(V);
  }
  function Be(V) {
    ee.call(this, V);
    const Q = this.stack[this.stack.length - 1];
    Q.url = "mailto:" + this.sliceSerialize(V);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Je() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ce() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function nn() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function Se() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function gn(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function J(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function T() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function X() {
    return {
      type: "text",
      value: ""
    };
  }
  function ae() {
    return {
      type: "thematicBreak"
    };
  }
}
function li(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function j1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? j1(e, i) : kU(e, i);
  }
}
function kU(e, n) {
  let r;
  for (r in n)
    if (N1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function I_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + _o({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + _o({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function bU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return gU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function xU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function _U(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function SU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function NU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function jU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function wU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ia(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function CU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function FU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function w1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function IU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return w1(e, n);
  const a = { src: Ia(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function EU(e, n) {
  const r = { src: Ia(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function $U(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function TU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return w1(e, n);
  const a = { href: Ia(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function DU(e, n) {
  const r = { href: Ia(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function OU(e, n, r) {
  const i = e.all(n), a = r ? RU(r) : C1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function RU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = C1(r[i]);
  }
  return n;
}
function C1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function PU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function AU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function LU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function VU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function zU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = ag(n.children[1]), d = s1(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function UU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, k = s ? s[d] : void 0;
    k && (h.align = k);
    let F = { type: "element", tagName: o, properties: h, children: [] };
    f && (F.children = e.all(f), e.patch(f, F), F = e.applyData(f, F)), m.push(F);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function MU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const E_ = 9, $_ = 32;
function BU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      T_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(T_(n.slice(a), a > 0, !1)), o.join("");
}
function T_(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === E_ || o === $_; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === E_ || o === $_; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function qU(e, n) {
  const r = { type: "text", value: BU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function HU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const WU = {
  blockquote: xU,
  break: _U,
  code: SU,
  delete: NU,
  emphasis: jU,
  footnoteReference: wU,
  heading: CU,
  html: FU,
  imageReference: IU,
  image: EU,
  inlineCode: $U,
  linkReference: TU,
  link: DU,
  listItem: OU,
  list: PU,
  paragraph: AU,
  // @ts-expect-error: root is different, but hard to type.
  root: LU,
  strong: VU,
  table: zU,
  tableCell: MU,
  tableRow: UU,
  text: qU,
  thematicBreak: HU,
  toml: ls,
  yaml: ls,
  definition: ls,
  footnoteDefinition: ls
};
function ls() {
}
const F1 = -1, Ul = 0, ll = 1, cl = 2, mg = 3, pg = 4, fg = 5, hg = 6, I1 = 7, E1 = 8, D_ = typeof self == "object" ? self : globalThis, KU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Ul:
      case F1:
        return r(s, a);
      case ll: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case cl: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case mg:
        return r(new Date(s), a);
      case pg: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case fg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case hg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case I1: {
        const { name: l, message: d } = s;
        return r(new D_[l](d), a);
      }
      case E1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new D_[o](s), a);
  };
  return i;
}, O_ = (e) => KU(/* @__PURE__ */ new Map(), e)(0), Xi = "", { toString: GU } = {}, { keys: YU } = Object, Qa = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ul, n];
  const r = GU.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [ll, Xi];
    case "Object":
      return [cl, Xi];
    case "Date":
      return [mg, Xi];
    case "RegExp":
      return [pg, Xi];
    case "Map":
      return [fg, Xi];
    case "Set":
      return [hg, Xi];
  }
  return r.includes("Array") ? [ll, r] : r.includes("Error") ? [I1, r] : [cl, r];
}, cs = ([e, n]) => e === Ul && (n === "function" || n === "symbol"), QU = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = Qa(s);
    switch (l) {
      case Ul: {
        let u = s;
        switch (d) {
          case "bigint":
            l = E1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([F1], s);
        }
        return a([l, u], s);
      }
      case ll: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case cl: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of YU(s))
          (e || !cs(Qa(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case mg:
        return a([l, s.toISOString()], s);
      case pg: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case fg: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(cs(Qa(h)) || cs(Qa(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case hg: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !cs(Qa(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, R_ = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return QU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, dl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? O_(R_(e, n)) : structuredClone(e)
) : (e, n) => O_(R_(e, n));
function JU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function XU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function ZU(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || JU, i = e.options.footnoteBackLabel || XU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Ia(f.toLowerCase());
    let k = 0;
    const F = [], j = e.footnoteCounts.get(f);
    for (; j !== void 0 && ++k <= j; ) {
      F.length > 0 && F.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, k);
      typeof g == "string" && (g = { type: "text", value: g }), F.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const g = N.children[N.children.length - 1];
      g && g.type === "text" ? g.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...F);
    } else
      u.push(...F);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, x), l.push(x);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...dl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const $1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return rM;
    if (typeof e == "function")
      return Ml(e);
    if (typeof e == "object")
      return Array.isArray(e) ? eM(e) : nM(e);
    if (typeof e == "string")
      return tM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function eM(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = $1(e[r]);
  return Ml(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function nM(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Ml(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function tM(e) {
  return Ml(n);
  function n(r) {
    return r && r.type === e;
  }
}
function Ml(e) {
  return n;
  function n(r, i, a) {
    return !!(iM(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function rM() {
  return !0;
}
function iM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const T1 = [], aM = !0, P_ = !1, oM = "skip";
function sM(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = $1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = T1, F, j, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (k = lM(r(d, u)), k[0] === P_))
        return k;
      if ("children" in d && d.children) {
        const x = (
          /** @type {UnistParent} */
          d
        );
        if (x.children && k[0] !== oM)
          for (j = (i ? x.children.length : -1) + s, N = u.concat(x); j > -1 && j < x.children.length; ) {
            const g = x.children[j];
            if (F = l(g, j, N)(), F[0] === P_)
              return F;
            j = typeof F[1] == "number" ? F[1] : j + s;
          }
      }
      return k;
    }
  }
}
function lM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [aM, e] : e == null ? T1 : [e];
}
function D1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), sM(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const Kh = {}.hasOwnProperty, cM = {};
function dM(e, n) {
  const r = n || cM, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...WU, ...r.handlers }, l = {
    all: m,
    applyData: mM,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: uM,
    wrap: fM
  };
  return D1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, k = l.handlers[h];
    if (Kh.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: j, ...N } = u, x = dl(N);
        return x.children = l.all(u), x;
      }
      return dl(u);
    }
    return (l.options.unknownHandler || pM)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const F = l.one(h[k], u);
        if (F) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(F) && F.type === "text" && (F.value = A_(F.value)), !Array.isArray(F) && F.type === "element")) {
            const j = F.children[0];
            j && j.type === "text" && (j.value = A_(j.value));
          }
          Array.isArray(F) ? f.push(...F) : f.push(F);
        }
      }
    }
    return f;
  }
}
function uM(e, n) {
  e.position && (n.position = WV(e));
}
function mM(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, dl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function pM(e, n) {
  const r = n.data || {}, i = "value" in n && !(Kh.call(r, "hProperties") || Kh.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function fM(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function A_(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function L_(e, n) {
  const r = dM(e, n), i = r.one(e, void 0), a = ZU(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function hM(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      L_(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      L_(r, { file: i, ...e || n })
    );
  };
}
function V_(e) {
  if (e)
    throw e;
}
var om, z_;
function yM() {
  if (z_) return om;
  z_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return om = function d() {
    var m, u, f, h, k, F, j = arguments[0], N = 1, x = arguments.length, g = !1;
    for (typeof j == "boolean" && (g = j, j = arguments[1] || {}, N = 2), (j == null || typeof j != "object" && typeof j != "function") && (j = {}); N < x; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(j, u), h = l(m, u), j !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, F = f && a(f) ? f : []) : F = f && o(f) ? f : {}, s(j, { name: u, newValue: d(g, F, h) })) : typeof h < "u" && s(j, { name: u, newValue: h }));
    return j;
  }, om;
}
var gM = yM();
const sm = /* @__PURE__ */ vy(gM);
function Gh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function vM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? kM(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function kM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ar = { basename: bM, dirname: xM, extname: _M, join: SM, sep: "/" };
function bM(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  qo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function xM(e) {
  if (qo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function _M(e) {
  qo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function SM(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    qo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : NM(r);
}
function NM(e) {
  qo(e);
  const n = e.codePointAt(0) === 47;
  let r = jM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function jM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function qo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const wM = { cwd: CM };
function CM() {
  return "/";
}
function Yh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function FM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Yh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return IM(e);
}
function IM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const lm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class O1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Yh(n) ? r = { path: n } : typeof n == "string" || EM(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : wM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < lm.length; ) {
      const o = lm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      lm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ar.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    dm(n, "basename"), cm(n, "basename"), this.path = Ar.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ar.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    U_(this.basename, "dirname"), this.path = Ar.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ar.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (cm(n, "extname"), U_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ar.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Yh(n) && (n = FM(n)), dm(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ar.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    dm(n, "stem"), cm(n, "stem"), this.path = Ar.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function cm(e, n) {
  if (e && e.includes(Ar.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ar.sep + "`"
    );
}
function dm(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function U_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function EM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const $M = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), TM = {}.hasOwnProperty;
class yg extends $M {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = vM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new yg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(sm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (pm("data", this.frozen), this.namespace[n] = r, this) : TM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (pm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = ds(n), i = this.parser || this.Parser;
    return um("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), um("process", this.parser || this.Parser), mm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = ds(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), F = i.stringify(k, h);
        RM(F) ? h.value = F : h.result = F, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), um("processSync", this.parser || this.Parser), mm("processSync", this.compiler || this.Compiler), this.process(n, a), B_("processSync", "process", r), i;
    function a(o, s) {
      r = !0, V_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    M_(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = ds(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), B_("runSync", "run", i), a;
    function o(s, l) {
      V_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = ds(r), a = this.compiler || this.Compiler;
    return mm("stringify", a), M_(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (pm("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = sm(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [k, ...F] = u;
        const j = i[h][1];
        Gh(j) && Gh(k) && (k = sm(!0, j, k)), i[h] = [m, k, ...F];
      }
    }
  }
}
const DM = new yg().freeze();
function um(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function mm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function pm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function M_(e) {
  if (!Gh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function B_(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function ds(e) {
  return OM(e) ? e : new O1(e);
}
function OM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function RM(e) {
  return typeof e == "string" || PM(e);
}
function PM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const AM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", q_ = [], H_ = { allowDangerousHtml: !0 }, LM = /^(https?|ircs?|mailto|xmpp)$/i, VM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function zM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || q_, d = e.remarkPlugins || q_, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...H_ } : H_, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || UM, k = DM().use(bU).use(d).use(hM, m).use(l), F = new O1();
  typeof i == "string" && (F.value = i);
  for (const g of VM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + AM + g.id, void 0);
  const j = k.parse(F);
  let N = k.runSync(j, F);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), D1(N, x), XV(N, {
    Fragment: Ke.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ke.jsx,
    jsxs: Ke.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function x(g, O, I) {
    if (g.type === "raw" && I && typeof O == "number")
      return u ? I.children.splice(O, 1) : I.children[O] = { type: "text", value: g.value }, O;
    if (g.type === "element") {
      let C;
      for (C in rm)
        if (Object.hasOwn(rm, C) && Object.hasOwn(g.properties, C)) {
          const w = g.properties[C], A = rm[C];
          (A === null || A.includes(g.tagName)) && (g.properties[C] = h(String(w || ""), C, g));
        }
    }
    if (g.type === "element") {
      let C = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!C && r && typeof O == "number" && (C = !r(g, O, I)), C && I && typeof O == "number")
        return f && g.children ? I.children.splice(O, 1, ...g.children) : I.children.splice(O, 1), O;
    }
  }
}
function UM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    LM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fm = { exports: {} }, Ja = {}, W_;
function MM() {
  if (W_) return Ja;
  W_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var us = {}, K_;
function BM() {
  return K_ || (K_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    us.Fragment = i, us.jsx = Un, us.jsxs = Kn;
  })()), us;
}
var G_;
function qM() {
  return G_ || (G_ = 1, process.env.NODE_ENV === "production" ? fm.exports = MM() : fm.exports = BM()), fm.exports;
}
var oe = qM();
const HM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, WM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, KM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, GM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, YM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, QM = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": HM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": WM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": KM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": GM,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": YM
};
function Ho(e) {
  return QM[e] ?? {};
}
const JM = Ho(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), XM = Ho(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), ms = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), ZM = "_issueAvatar_kc0sw_1", e4 = "_issueField_kc0sw_9", n4 = "_issueDescription_kc0sw_12", ps = {
  issueAvatar: ZM,
  issueField: e4,
  issueDescription: n4
}, R1 = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(ms, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: ps.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          yy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(ms, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ps.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(ms, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: ps.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(ms, { title: "Description", children: /* @__PURE__ */ oe.jsx(zM, { className: ps.issueDescription, children: e.description }) })
] }), t4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), r4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), i4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), a4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), o4 = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), P1 = {
  0: t4,
  1: o4,
  2: a4,
  3: i4,
  4: r4
}, s4 = (e) => e in P1, ul = ({ priority: e }) => s4(e) ? P1[e] : /* @__PURE__ */ oe.jsx(Qn, { "data-testid": "defaultPriorityTag", children: e }), l4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), c4 = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), d4 = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), u4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), m4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), p4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Qh = {
  backlog: (e, n) => l4(e, n),
  unstarted: (e, n) => c4(e, n),
  started: (e, n) => d4(e, n),
  done: (e, n) => u4(e, n),
  canceled: (e, n) => m4(e, n),
  completed: (e, n) => p4(e, n)
}, f4 = (e) => e in Qh, ml = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => f4(e) ? Qh[e](n, r) : Qh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), h4 = "_wrapper_e0qj3_1", y4 = "_resultTitle_e0qj3_21", g4 = "_resultTooltipTitle_e0qj3_28", v4 = "_resultLinkIcon_e0qj3_31", Xa = {
  wrapper: h4,
  resultTitle: y4,
  resultTooltipTitle: g4,
  resultLinkIcon: v4
}, k4 = ({
  issue: e
}) => {
  const [n, r] = de(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = hy(jI()), o = yt(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Ze,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: Xa.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              ml,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(ul, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Qn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            $.Heading,
            {
              variant: "heading-3",
              className: Xa.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(R1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        ut.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Xa.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    ml,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(ul, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "4", className: Xa.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  ye,
                  {
                    className: Xa.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, b4 = "_loader_13xpk_1", x4 = "_dropdown_13xpk_8", _4 = "_loadMore_13xpk_13", hm = {
  loader: b4,
  dropdown: x4,
  loadMore: _4
}, S4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = de(), [a, o] = de([]), [s, l] = de(""), [d, m] = de(!1), { useLazyQuery: u } = yn(), [f, { data: h, loading: k, networkStatus: F }] = u(
    JM,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  gi(
    () => {
      !k && s !== "" && F === rr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Qe(() => {
    k || o([]);
  }, [s]), Qe(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: I }) => I
      ), x = a.filter(
        (I) => !n.find((C) => C.id === I.id)
      ), g = x.filter(
        (I) => !N.find(
          (C) => C.id === I.id
        )
      ), O = N.filter(
        (I) => !n.find((C) => C.id === I.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...O] : O
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...x, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const j = () => {
    !k && s !== "" && F === rr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    ni,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: hm.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const x = N.target.value;
          l(x);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ oe.jsx(k4, { issue: N }, N.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => j(),
            className: hm.loadMore,
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: hm.loader, children: /* @__PURE__ */ oe.jsx(hn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, N4 = "_collapse_su0f9_1", j4 = "_collapseHeader_su0f9_8", w4 = "_collapseContent_su0f9_31", C4 = "_url_su0f9_35", F4 = "_externalLink_su0f9_51", I4 = "_emptyState_su0f9_55", ci = {
  collapse: N4,
  collapseHeader: j4,
  collapseContent: w4,
  url: C4,
  externalLink: F4,
  emptyState: I4
}, E4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = de(s), { track: m } = Fn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          $.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ci.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            xr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: ci.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(xr.Header, { className: ci.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Ze, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        ml,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        $.ExternalLink,
                        {
                          className: ci.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(ye, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Ze, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(ul, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Qn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(xr.Content, { className: ci.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Qn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(R1, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    et,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(ye, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    Lt,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
                      variant: "tertiary",
                      className: ci.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          et,
          {
            slotStart: /* @__PURE__ */ oe.jsx(ye, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(ye, { name: "external-link" }),
            variant: "tertiary",
            className: ci.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, $4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, A1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => A1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, T4 = "_modalBody_iv3ua_1", D4 = "_error_iv3ua_5", O4 = "_dropdown_iv3ua_16", Zi = {
  modalBody: T4,
  error: D4,
  dropdown: O4
}, R4 = Ho(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), P4 = Ho(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), A4 = Ho(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), L4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = yn(), { control: m, handleSubmit: u, reset: f } = mt(), [h, k] = de([]), [F, j] = de(), [N, x] = de([]), [g, O] = de(), [I, C] = de([]), [w, A] = de(), [B, K] = de([]), [ee, G] = de(), [H, R] = de([]), [q, te] = de(), [we, ve] = de(!1), { useMutation: ue } = yn(), { track: ge } = Fn(), [U, { loading: be }] = ue(
    R4,
    {
      onError: () => {
        ve(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ce) => {
        const Me = {
          identifier: Ce.Linear?.issueCreate?.issue?.identifier,
          url: Ce.Linear?.issueCreate?.issue?.url
        };
        Ce.Linear && Ce.Linear?.issueCreate?.issue?.id && (a(Ce.Linear?.issueCreate?.issue?.id), Be(Me), ve(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ce.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ge("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    $e,
    { data: W, loading: Ge, error: sn }
  ] = l(P4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const Me = Ce.Linear.teams.edges.map(
        ({ node: nn }) => nn
      );
      k(Me), K(Ce.Linear.issuePriorityValues), s(`${K4}${Ce.Linear.organization.urlKey}`);
    }
  }), [Fe, { data: Ue, loading: Re }] = l(A4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ce) => {
      const Me = Ce?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      x(Me);
      const nn = Ce?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      C(nn);
      const se = Ce?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      R(
        se.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Be = (Ce) => {
    r(!1), O(void 0), j(void 0), A(void 0), G(void 0), te(void 0), Ce && (e(Ce), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ce) => {
    W && !Ge && (U({
      variables: {
        issueTitle: Ce.title,
        issueDescription: Ce?.description,
        teamId: Ce.team.id,
        projectId: Ce?.project?.id,
        statusId: Ce?.status?.id,
        priority: Ce?.priority?.priority
      }
    }), ve(!0));
  };
  Qe(() => {
    n && $e();
  }, [n]);
  const Je = () => {
    ge("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        Je(), Be();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Je(), Be();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Ft,
          {
            className: Zi.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ oe.jsx(Tn, { error: sn }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(nt, { children: [
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ce, onChange: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    He,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: nn?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        ni,
                        {
                          dropdownProps: { className: Zi.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [Zi.error]: nn }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            O(void 0), A(void 0), G(void 0), te(void 0), j(se.selectedValues[0]), Fe({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Me(se.selectedValues[0]);
                          },
                          value: F ? [Ce] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ oe.jsx(
                            ut.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Re ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          O(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: g ? [Ce] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Re && N.map((se) => /* @__PURE__ */ oe.jsx(
                            ut.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 6, children: /* @__PURE__ */ oe.jsx(He, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                ni,
                {
                  clearable: !0,
                  dropdownProps: { className: Zi.dropdown },
                  disabled: !F || Re,
                  placeholder: F ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ce) => Ce?.name,
                  onChange: (Ce) => {
                    if (Ce.selectedValues.length > 0) {
                      te(Ce.selectedValues[0]);
                      const Me = JSON.parse(
                        Ce.selectedValues[0].templateData
                      ), nn = B.filter(
                        (Le) => Le.priority === Me.priority
                      );
                      G(
                        nn ? nn[0] : void 0
                      );
                      const se = I.filter(
                        (Le) => Le.id === Me.stateId
                      );
                      A(
                        se ? se[0] : void 0
                      );
                      const le = N.filter(
                        (Le) => Le.id === Me.projectId
                      );
                      O(
                        le ? le[0] : void 0
                      );
                      const Se = Me.description;
                      f({
                        title: Me?.title,
                        priority: nn[0],
                        status: se[0],
                        project: le[0],
                        description: Se ? A1(Se, $4) : "",
                        team: F
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: F
                      }), O(void 0), G(void 0), A(void 0), te(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: H?.map((Ce) => /* @__PURE__ */ oe.jsx(
                    ut.Item,
                    {
                      value: Ce,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: Ce.name })
                    },
                    Ce.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 6, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ce, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    tr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Re ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        dropdownProps: { className: Zi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          A(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: w ? [Ce] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          Ue && !Re && I.map((se) => /* @__PURE__ */ oe.jsx(
                            ut.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ml,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ce, onChange: Me } }) => {
                    const nn = Ge ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      ni,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: F === void 0,
                        placeholder: F ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          G(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: ee ? [Ce] : nn,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          Re && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(hn, { size: 24 })
                            }
                          ),
                          W && !Ge && B.map((se) => /* @__PURE__ */ oe.jsx(
                            ut.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      ul,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(Z, { children: /* @__PURE__ */ oe.jsx(
                xt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ce, value: Me },
                    fieldState: { error: nn }
                  }) => /* @__PURE__ */ oe.jsx(
                    SI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: Ce
                      },
                      meta: {
                        error: nn?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Et,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: be || !W,
              isLoading: we || Ge || Re,
              loadingIndicator: /* @__PURE__ */ oe.jsx(hn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Je(), Be();
            }
          }
        )
      ]
    }
  );
}, V4 = "_modalWrapper_4kh9u_1", z4 = "_copyButton_4kh9u_6", U4 = "_copyWrapper_4kh9u_15", M4 = "_copyField_4kh9u_24", B4 = "_externalLink_4kh9u_47", q4 = "_externalLinkIcon_4kh9u_52", H4 = "_textWrapper_4kh9u_56", Si = {
  modalWrapper: V4,
  copyButton: z4,
  copyWrapper: U4,
  copyField: M4,
  externalLink: B4,
  externalLinkIcon: q4,
  textWrapper: H4
}, W4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: Si.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(Ft, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs($.Paragraph, { className: Si.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                $.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Si.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(ye, { name: "external-link", className: Si.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(He, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Si.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    cr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Si.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    NI,
                    {
                      className: Si.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        Et,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), K4 = "https://linear.app/", G4 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de([]), [a, o] = de([]), [s, l] = de(!1), [d, m] = de(!1), [u, f] = de(!1), [h, k] = de(), { useLazyQuery: F } = yn(), [j, N] = de(""), x = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: O } = Fn(), {
    loading: I,
    data: C,
    error: w,
    store: A
  } = fy(e?.conversationId ?? null), [
    B,
    {
      data: K,
      loading: ee,
      networkStatus: G,
      error: H
    }
  ] = F(XM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    !I && !w && C && C?.linear?.issues?.length > 0 ? (o(C.linear.issues), B({
      variables: {
        linkedIssues: C.linear.issues
      }
    })) : !I && !w && (i([]), o([]));
  }, [C, I, w]), Qe(() => {
    K && K?.Linear && !ee && G === rr.ready && Object.keys(K).length > 0 && i(K.Linear.issues?.edges?.map(({ node: ve }) => ve));
  }, [K, ee, G]);
  const R = (ve) => {
    ve && ve?.team?.organization?.urlKey && O("linear:link:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ve.id
    });
    const ue = (ge) => ge.id === ve?.id;
    r.some((ge) => ge && ue(ge)) || (C && a.length === 0 && o([]), A({
      linear: {
        issues: [...a, ve.id]
      }
    }));
  }, q = (ve) => {
    const ue = C?.linear.issues.filter((ge) => ge !== ve) || [];
    O("linear:unlink:issue:clicked", {
      linearInstanceUrl: j,
      linearIssueKey: ve
    }), i(r.filter(({ id: ge }) => ge !== ve)), o(ue), A({
      linear: {
        issues: ue
      }
    });
  }, te = () => {
    l(!1), i([]), o([]), A({
      linear: {
        issues: []
      }
    });
  }, we = I || ee || !C && !w || (C?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !I && !ee && (H || w) ? /* @__PURE__ */ oe.jsx(Tn, { error: H || w }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            Et,
            {
              confirmOnClick: () => te(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      L4,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ve) => m(ve),
        setIsCreationSuccessfulModalOpen: (ve) => f(ve),
        addToLinkedIssueIds: (ve) => {
          A({
            linear: {
              issues: [...a, ve]
            }
          });
        },
        setCreatedIssue: (ve) => k(ve),
        organizationUrl: j,
        setOrganizationUrl: (ve) => N(ve)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      W4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ve) => f(ve),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          x && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              et,
              {
                variant: "primary",
                onClick: () => {
                  O("linear:create:new:issue:clicked", {
                    linearInstanceUrl: j
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx($.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(S4, { handleSelect: R, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      E4,
      {
        linkedIssues: r,
        isLoading: we,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (ve) => l(ve),
        showUnlinkAllButton: g,
        organizationUrl: j
      }
    )
  ] });
}, Jh = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ni = "LINEAR", Y4 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, Q4 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: Y4
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: Ni,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: Jh,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = (K) => fr(K, {
    fieldDefinitions: Jh,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), B = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ oe.jsx(hr, { cause: k }),
        /* @__PURE__ */ oe.jsxs(nt, { children: [
          /* @__PURE__ */ oe.jsx(Z, { children: /* @__PURE__ */ oe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(He, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ oe.jsx(
            xn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3, children: /* @__PURE__ */ oe.jsx(He, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ oe.jsx(
            xn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ni,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ oe.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          yr,
          {
            integrationType: Ni,
            integrationId: e,
            widgetName: B,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                ye,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ni,
                  " integration, all links between Dixa and ",
                  Ni,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ni,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ni,
                  " ",
                  'integration "',
                  B,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ym = { exports: {} }, Za = {}, Y_;
function J4() {
  if (Y_) return Za;
  Y_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var fs = {}, Q_;
function X4() {
  return Q_ || (Q_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    fs.Fragment = i, fs.jsx = Un, fs.jsxs = Kn;
  })()), fs;
}
var J_;
function Z4() {
  return J_ || (J_ = 1, process.env.NODE_ENV === "production" ? ym.exports = J4() : ym.exports = X4()), ym.exports;
}
var Ee = Z4();
const e5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, n5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, t5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, r5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, i5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, a5 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": e5,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": n5,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": t5,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": r5,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": i5
};
function Bl(e) {
  return a5[e] ?? {};
}
const o5 = Bl(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), s5 = Bl(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), l5 = Bl(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), c5 = Bl(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function gm(e = !1, n) {
  const [r, i] = de(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const d5 = "_wrapper_27vny_1", u5 = "_copyIcon_27vny_12", eo = {
  wrapper: d5,
  copyIcon: u5
}, m5 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = gm(), { isCopied: i, copy: a } = gm(), { isCopied: o, copy: s } = gm();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: F,
    referral_url: j
  } = e, N = f ? Jn(f).isSame(Date.now(), "day") : !1, { name: x, first_name: g, last_name: O } = m ?? {}, I = x ?? (`${g} ${O}`.trim() || "A customer has no name"), C = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { className: eo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: eo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-2", children: I }),
          N && /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: Jn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ Ee.jsx(b, { gap: "200", children: /* @__PURE__ */ Ee.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Jn(F).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ye, { size: l, name: "mail" }),
        /* @__PURE__ */ Ee.jsx($.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ye,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: eo.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ye, { size: l, name: "link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Shopify shop", children: /* @__PURE__ */ Ee.jsx(
          $.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ye,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: eo.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Ee.jsx(ye, { size: l, name: "external-link" }),
        /* @__PURE__ */ Ee.jsx(Ze, { content: "Referral link", children: /* @__PURE__ */ Ee.jsx(
          $.ExternalLink,
          {
            href: j,
            target: "_blank",
            rel: "noreferrer",
            children: j.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Ee.jsx(Ze, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Ee.jsx(
        ye,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: eo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, p5 = "_list_1q5b5_5", f5 = "_listItem_1q5b5_8", h5 = "_listItemEdit_1q5b5_15", y5 = "_notificationText_1q5b5_19", va = {
  list: p5,
  listItem: f5,
  listItemEdit: h5,
  notificationText: y5
}, g5 = "_modalBody_1clhs_1", v5 = {
  modalBody: g5
}, k5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = de(n), [u, f] = de(""), [h, k] = de(), [F, { loading: j }] = o(
    l5,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), G();
      }
    }
  ), [N, { loading: x }] = o(c5), g = j || x, O = !!h, I = n === d ? "Change the value to update the points" : "", C = isNaN(d), w = C ? "Points can not be empty" : "", A = d > n && d - n > 1e6, B = A ? "Points can not exceed 1,000,000" : "", K = () => {
    if (!r) {
      k(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && F({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((H) => {
      const R = H?.networkError;
      (R ? R?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((H) => {
      H.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : "errors" in H && (l("loyaltylion:remove:points:failed"), k(
        H.errors?.map((R) => R.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    C && m(n), f(""), i();
  }, G = () => {
    a(), ee();
  };
  return /* @__PURE__ */ Ee.jsxs(
    wt,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Ee.jsx(Ct, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ Ee.jsxs(Ft, { className: v5.modalBody, children: [
          /* @__PURE__ */ Ee.jsxs(nt, { children: [
            /* @__PURE__ */ Ee.jsx(Z, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: B || w,
                  warning: I
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (H) => m(H?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Ee.jsx(Z, { span: 6, children: /* @__PURE__ */ Ee.jsx(
              tr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (H) => f(H?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && O && /* @__PURE__ */ Ee.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Ee.jsx(Xe, { children: h?.map((H, R) => /* @__PURE__ */ Ee.jsx(
            Xe.Item,
            {
              variant: "dense",
              title: H,
              contentLeft: /* @__PURE__ */ Ee.jsx(
                ye,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            R
          )) }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => K(),
            confirmProps: {
              isLoading: g,
              disabled: C || A || n === d,
              loadingIndicator: /* @__PURE__ */ Ee.jsx(hn, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, b5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Ee.jsx(Xe.Text, { variant: "dense", className: va.listItem, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ye, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Ee.jsx($.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Ee.jsx(Ze, { content: "Edit points", children: /* @__PURE__ */ Ee.jsx(
        ye,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: va.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Ee.jsx(Bn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, x5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = de(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Ee.jsx(Xe, { className: va.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ Ee.jsx(
      b5,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ Ee.jsx(
      k5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, _5 = "_reward_1wxia_1", S5 = {
  reward: _5
}, N5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Ee.jsx(b, { gap: "100", flexDirection: "column", className: S5.reward, children: /* @__PURE__ */ Ee.jsx(Ze, { content: a ?? "No description", children: /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(ye, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Ee.jsxs(Bn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Ee.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ye, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Ee.jsx(
        $.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, j5 = ({ customer: e }) => {
  const { useQuery: n } = yn(), [r, i] = de(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(s5, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return ba({ errors: d }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "No rewards found"
      }
    ) : hw({ errors: d }) ? /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: va.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Ee.jsx(Tn, { error: s });
  }
  return /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : /* @__PURE__ */ Ee.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Ee.jsx(N5, { reward: d }, d.id)) })
  ] });
}, w5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Qn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(
        ye,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Qn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ye, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Ee.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Ee.jsx(Ze, { content: "Insights segment", children: /* @__PURE__ */ Ee.jsx(Qn, { children: /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Ee.jsx(ye, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, C5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Fn(), [a, o] = de(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: k,
    data: F,
    refetch: j
  } = r(o5, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Qe(() => {
    if (F && !h) {
      const N = (F?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [F, h]), s?.email ? k ? ba({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ Ee.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: va.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Ee.jsx(Tn, { error: k }) : h ? /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(hn, {}) }) : f ? /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
        l && /* @__PURE__ */ Ee.jsx(m5, { customer: a }),
        d && /* @__PURE__ */ Ee.jsx(w5, { customer: a }),
        m && /* @__PURE__ */ Ee.jsx(
          x5,
          {
            customer: a,
            refetchCustomerData: j
          }
        ),
        u && /* @__PURE__ */ Ee.jsx(j5, { customer: a })
      ] }) : /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Ee.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Xh = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], X_ = "LOYALTYLION", F5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, I5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: F5
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: X_,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: Xh,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: Xh,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ Ee.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ee.jsx(hr, { cause: h }),
        /* @__PURE__ */ Ee.jsxs(nt, { children: [
          /* @__PURE__ */ Ee.jsx(Z, { children: /* @__PURE__ */ Ee.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(
            dI,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show customer summary", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show tags", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show points balance", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3, children: /* @__PURE__ */ Ee.jsx(He, { label: "Show available rewards", children: /* @__PURE__ */ Ee.jsx(
            xn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ee.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Ee.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ee.jsx(
          yr,
          {
            integrationType: X_,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vm = { exports: {} }, no = {}, Z_;
function E5() {
  if (Z_) return no;
  Z_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var hs = {}, eS;
function $5() {
  return eS || (eS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    hs.Fragment = i, hs.jsx = Un, hs.jsxs = Kn;
  })()), hs;
}
var nS;
function T5() {
  return nS || (nS = 1, process.env.NODE_ENV === "production" ? vm.exports = E5() : vm.exports = $5()), vm.exports;
}
var fn = T5();
const D5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, O5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": D5
};
function R5(e) {
  return O5[e] ?? {};
}
function tS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function P5(e) {
  if (Array.isArray(e)) return e;
}
function A5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], d = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(d = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); d = !0) ;
    } catch (u) {
      m = !0, a = u;
    } finally {
      try {
        if (!d && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function L5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V5(e, n) {
  return P5(e) || A5(e, n) || z5(e, n) || L5();
}
function z5(e, n) {
  if (e) {
    if (typeof e == "string") return tS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? tS(e, n) : void 0;
  }
}
const L1 = Object.entries, rS = Object.setPrototypeOf, U5 = Object.isFrozen, M5 = Object.getPrototypeOf, B5 = Object.getOwnPropertyDescriptor;
let At = Object.freeze, Vt = Object.seal, aa = Object.create, V1 = typeof Reflect < "u" && Reflect, Zh = V1.apply, ey = V1.construct;
At || (At = function(e) {
  return e;
});
Vt || (Vt = function(e) {
  return e;
});
Zh || (Zh = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
ey || (ey = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const to = _t(Array.prototype.forEach), q5 = _t(Array.prototype.lastIndexOf), iS = _t(Array.prototype.pop), ea = _t(Array.prototype.push), H5 = _t(Array.prototype.splice), mi = Array.isArray, vo = _t(String.prototype.toLowerCase), km = _t(String.prototype.toString), aS = _t(String.prototype.match), ro = _t(String.prototype.replace), oS = _t(String.prototype.indexOf), W5 = _t(String.prototype.trim), K5 = _t(Number.prototype.toString), G5 = _t(Boolean.prototype.toString), sS = typeof BigInt > "u" ? null : _t(BigInt.prototype.toString), lS = typeof Symbol > "u" ? null : _t(Symbol.prototype.toString), It = _t(Object.prototype.hasOwnProperty), io = _t(Object.prototype.toString), Tt = _t(RegExp.prototype.test), ji = Y5(TypeError);
function _t(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Zh(e, n, i);
  };
}
function Y5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return ey(e, r);
  };
}
function Wn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vo;
  if (rS && rS(e, null), !mi(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (U5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function Q5(e) {
  for (let n = 0; n < e.length; n++)
    It(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = aa(null);
  for (const i of L1(e)) {
    var r = V5(i, 2);
    const a = r[0], o = r[1];
    It(e, a) && (mi(o) ? n[a] = Q5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function J5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return K5(e);
    case "boolean":
      return G5(e);
    case "bigint":
      return sS ? sS(e) : "0";
    case "symbol":
      return lS ? lS(e) : "Symbol()";
    case "undefined":
      return io(e);
    case "function":
    case "object": {
      if (e === null)
        return io(e);
      const n = e, r = Pr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : io(i);
      }
      return io(e);
    }
    default:
      return io(e);
  }
}
function Pr(e, n) {
  for (; e !== null; ) {
    const i = B5(e, n);
    if (i) {
      if (i.get)
        return _t(i.get);
      if (typeof i.value == "function")
        return _t(i.value);
    }
    e = M5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function X5(e) {
  try {
    return Tt(e, ""), !0;
  } catch {
    return !1;
  }
}
const cS = At(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), bm = At(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), xm = At(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Z5 = At(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), _m = At(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), eB = At(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), dS = At(["#text"]), uS = At(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Sm = At(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), mS = At(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ys = At(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), nB = Vt(/{{[\w\W]*|^[\w\W]*}}/g), tB = Vt(/<%[\w\W]*|^[\w\W]*%>/g), rB = Vt(/\${[\w\W]*/g), iB = Vt(/^data-[\-\w.\u00B7-\uFFFF]+$/), aB = Vt(/^aria-[\-\w]+$/), pS = Vt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), oB = Vt(/^(?:\w+script|data):/i), sB = Vt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), lB = Vt(/^html$/i), cB = Vt(/^[a-z][.\w]*(-[.\w]+)+$/i), fS = Vt(/<[/\w!]/g), dB = Vt(/<[/\w]/g), uB = Vt(/<\/no(script|embed|frames)/i), mB = Vt(/\/>/i), Rr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, pB = function() {
  return typeof window > "u" ? null : window;
}, fB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, hS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, di = function(e, n, r, i) {
  return It(e, n) && mi(e[n]) ? Wn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function z1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pB();
  const n = (Y) => z1(Y);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Rr.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, d = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, k = Pr(h, "cloneNode"), F = Pr(h, "remove"), j = Pr(h, "nextSibling"), N = Pr(h, "childNodes"), x = Pr(h, "parentNode"), g = Pr(h, "shadowRoot"), O = Pr(h, "attributes"), I = s && s.prototype ? Pr(s.prototype, "nodeType") : null, C = s && s.prototype ? Pr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const Y = r.createElement("template");
    Y.content && Y.content.ownerDocument && (r = Y.content.ownerDocument);
  }
  let w, A = "", B, K = !1, ee = 0;
  const G = function() {
    if (ee > 0)
      throw ji('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, H = function(Y) {
    G(), ee++;
    try {
      return w.createHTML(Y);
    } finally {
      ee--;
    }
  }, R = function(Y) {
    G(), ee++;
    try {
      return w.createScriptURL(Y);
    } finally {
      ee--;
    }
  }, q = function() {
    return K || (B = fB(f, a), K = !0), B;
  }, te = r, we = te.implementation, ve = te.createNodeIterator, ue = te.createDocumentFragment, ge = te.getElementsByTagName, U = i.importNode;
  let be = hS();
  n.isSupported = typeof L1 == "function" && typeof x == "function" && we && we.createHTMLDocument !== void 0;
  const $e = nB, W = tB, Ge = rB, sn = iB, Fe = aB, Ue = oB, Re = sB, Be = cB;
  let Ae = pS, Je = null;
  const Ce = Wn({}, [...cS, ...bm, ...xm, ..._m, ...dS]);
  let Me = null;
  const nn = Wn({}, [...uS, ...Sm, ...mS, ...ys]);
  let se = Object.seal(aa(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, Se = null;
  const Le = Object.seal(aa(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, gn = !0, J = !1, T = !0, z = !1, X = !0, ae = !1, V = !1, Q = null, me = null, _e = !1, Te = !1, tn = !1, vn = !1, on = !0, pn = !1;
  const In = "user-content-";
  let _n = !0, En = !1, en = {}, kn = null;
  const Ve = Wn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let dn = null;
  const un = Wn({}, ["audio", "video", "img", "source", "image", "track"]);
  let jn = null;
  const qn = Wn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nn = "http://www.w3.org/1998/Math/MathML", Pn = "http://www.w3.org/2000/svg", bn = "http://www.w3.org/1999/xhtml";
  let Sn = bn, Ln = !1, Vn = null;
  const Cn = Wn({}, [Nn, Pn, bn], km), wn = At(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Wn({}, wn);
  const Hn = At(["annotation-xml"]);
  let Un = Wn({}, Hn);
  const Kn = Wn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], p = "text/html";
  let y = null, E = null;
  const D = r.createElement("form"), S = function(Y) {
    return Y instanceof RegExp || Y instanceof Function;
  }, _ = function() {
    let Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (E && E === Y)
      return;
    (!Y || typeof Y != "object") && (Y = {}), Y = Ht(Y), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(Y.PARSER_MEDIA_TYPE) === -1 ? p : Y.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? km : vo, Je = di(Y, "ALLOWED_TAGS", Ce, {
      transform: y
    }), Me = di(Y, "ALLOWED_ATTR", nn, {
      transform: y
    }), Vn = di(Y, "ALLOWED_NAMESPACES", Cn, {
      transform: km
    }), jn = di(Y, "ADD_URI_SAFE_ATTR", qn, {
      transform: y,
      base: qn
    }), dn = di(Y, "ADD_DATA_URI_TAGS", un, {
      transform: y,
      base: un
    }), kn = di(Y, "FORBID_CONTENTS", Ve, {
      transform: y
    }), le = di(Y, "FORBID_TAGS", Ht({}), {
      transform: y
    }), Se = di(Y, "FORBID_ATTR", Ht({}), {
      transform: y
    }), en = It(Y, "USE_PROFILES") ? Y.USE_PROFILES && typeof Y.USE_PROFILES == "object" ? Ht(Y.USE_PROFILES) : Y.USE_PROFILES : !1, Pe = Y.ALLOW_ARIA_ATTR !== !1, gn = Y.ALLOW_DATA_ATTR !== !1, J = Y.ALLOW_UNKNOWN_PROTOCOLS || !1, T = Y.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = Y.SAFE_FOR_TEMPLATES || !1, X = Y.SAFE_FOR_XML !== !1, ae = Y.WHOLE_DOCUMENT || !1, Te = Y.RETURN_DOM || !1, tn = Y.RETURN_DOM_FRAGMENT || !1, vn = Y.RETURN_TRUSTED_TYPE || !1, _e = Y.FORCE_BODY || !1, on = Y.SANITIZE_DOM !== !1, pn = Y.SANITIZE_NAMED_PROPS || !1, _n = Y.KEEP_CONTENT !== !1, En = Y.IN_PLACE || !1, Ae = X5(Y.ALLOWED_URI_REGEXP) ? Y.ALLOWED_URI_REGEXP : pS, Sn = typeof Y.NAMESPACE == "string" ? Y.NAMESPACE : bn, zn = It(Y, "MATHML_TEXT_INTEGRATION_POINTS") && Y.MATHML_TEXT_INTEGRATION_POINTS && typeof Y.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(Y.MATHML_TEXT_INTEGRATION_POINTS) : Wn({}, wn), Un = It(Y, "HTML_INTEGRATION_POINTS") && Y.HTML_INTEGRATION_POINTS && typeof Y.HTML_INTEGRATION_POINTS == "object" ? Ht(Y.HTML_INTEGRATION_POINTS) : Wn({}, Hn);
    const De = It(Y, "CUSTOM_ELEMENT_HANDLING") && Y.CUSTOM_ELEMENT_HANDLING && typeof Y.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(Y.CUSTOM_ELEMENT_HANDLING) : aa(null);
    if (se = aa(null), It(De, "tagNameCheck") && S(De.tagNameCheck) && (se.tagNameCheck = De.tagNameCheck), It(De, "attributeNameCheck") && S(De.attributeNameCheck) && (se.attributeNameCheck = De.attributeNameCheck), It(De, "allowCustomizedBuiltInElements") && typeof De.allowCustomizedBuiltInElements == "boolean" && (se.allowCustomizedBuiltInElements = De.allowCustomizedBuiltInElements), Vt(se), z && (gn = !1), tn && (Te = !0), en && (Je = Wn({}, dS), Me = aa(null), en.html === !0 && (Wn(Je, cS), Wn(Me, uS)), en.svg === !0 && (Wn(Je, bm), Wn(Me, Sm), Wn(Me, ys)), en.svgFilters === !0 && (Wn(Je, xm), Wn(Me, Sm), Wn(Me, ys)), en.mathMl === !0 && (Wn(Je, _m), Wn(Me, mS), Wn(Me, ys))), Le.tagCheck = null, Le.attributeCheck = null, It(Y, "ADD_TAGS") && (typeof Y.ADD_TAGS == "function" ? Le.tagCheck = Y.ADD_TAGS : mi(Y.ADD_TAGS) && (Je === Ce && (Je = Ht(Je)), Wn(Je, Y.ADD_TAGS, y))), It(Y, "ADD_ATTR") && (typeof Y.ADD_ATTR == "function" ? Le.attributeCheck = Y.ADD_ATTR : mi(Y.ADD_ATTR) && (Me === nn && (Me = Ht(Me)), Wn(Me, Y.ADD_ATTR, y))), It(Y, "ADD_URI_SAFE_ATTR") && mi(Y.ADD_URI_SAFE_ATTR) && Wn(jn, Y.ADD_URI_SAFE_ATTR, y), It(Y, "FORBID_CONTENTS") && mi(Y.FORBID_CONTENTS) && (kn === Ve && (kn = Ht(kn)), Wn(kn, Y.FORBID_CONTENTS, y)), It(Y, "ADD_FORBID_CONTENTS") && mi(Y.ADD_FORBID_CONTENTS) && (kn === Ve && (kn = Ht(kn)), Wn(kn, Y.ADD_FORBID_CONTENTS, y)), _n && (Je["#text"] = !0), ae && Wn(Je, ["html", "head", "body"]), Je.table && (Wn(Je, ["tbody"]), delete le.tbody), Y.TRUSTED_TYPES_POLICY) {
      if (typeof Y.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw ji('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof Y.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw ji('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const We = w;
      w = Y.TRUSTED_TYPES_POLICY;
      try {
        A = H("");
      } catch (cn) {
        throw w = We, cn;
      }
    } else Y.TRUSTED_TYPES_POLICY === null ? (w = void 0, A = "") : (w === void 0 && (w = q()), w && typeof A == "string" && (A = H("")));
    At && At(Y), E = Y;
  }, ne = Wn({}, [...bm, ...xm, ...Z5]), L = Wn({}, [..._m, ...eB]), M = function(Y, De, We) {
    return De.namespaceURI === bn ? Y === "svg" : De.namespaceURI === Nn ? Y === "svg" && (We === "annotation-xml" || zn[We]) : !!ne[Y];
  }, ce = function(Y, De, We) {
    return De.namespaceURI === bn ? Y === "math" : De.namespaceURI === Pn ? Y === "math" && Un[We] : !!L[Y];
  }, ze = function(Y, De, We) {
    return De.namespaceURI === Pn && !Un[We] || De.namespaceURI === Nn && !zn[We] ? !1 : !L[Y] && (Kn[Y] || !ne[Y]);
  }, Oe = function(Y) {
    let De = x(Y);
    (!De || !De.tagName) && (De = {
      namespaceURI: Sn,
      tagName: "template"
    });
    const We = vo(Y.tagName), cn = vo(De.tagName);
    return Vn[Y.namespaceURI] ? Y.namespaceURI === Pn ? M(We, De, cn) : Y.namespaceURI === Nn ? ce(We, De, cn) : Y.namespaceURI === bn ? ze(We, De, cn) : !!(t === "application/xhtml+xml" && Vn[Y.namespaceURI]) : !1;
  }, ie = function(Y) {
    ea(n.removed, {
      element: Y
    });
    try {
      x(Y).removeChild(Y);
    } catch {
      if (F(Y), !x(Y))
        throw ji("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, mn = function(Y) {
    const De = N(Y);
    if (De) {
      const cn = [];
      to(De, (Rn) => {
        ea(cn, Rn);
      }), to(cn, (Rn) => {
        try {
          F(Rn);
        } catch {
        }
      });
    }
    const We = O(Y);
    if (We)
      for (let cn = We.length - 1; cn >= 0; --cn) {
        const Rn = We[cn], tt = Rn && Rn.name;
        if (typeof tt == "string")
          try {
            Y.removeAttribute(tt);
          } catch {
          }
      }
  }, On = function(Y, De) {
    try {
      ea(n.removed, {
        attribute: De.getAttributeNode(Y),
        from: De
      });
    } catch {
      ea(n.removed, {
        attribute: null,
        from: De
      });
    }
    if (De.removeAttribute(Y), Y === "is")
      if (Te || tn)
        try {
          ie(De);
        } catch {
        }
      else
        try {
          De.setAttribute(Y, "");
        } catch {
        }
  }, Gn = function(Y) {
    const De = O(Y);
    if (De)
      for (let We = De.length - 1; We >= 0; --We) {
        const cn = De[We], Rn = cn && cn.name;
        if (!(typeof Rn != "string" || Me[y(Rn)]))
          try {
            Y.removeAttribute(Rn);
          } catch {
          }
      }
  }, KF = function(Y) {
    const De = [Y];
    for (; De.length > 0; ) {
      const We = De.pop();
      (I ? I(We) : We.nodeType) === Rr.element && Gn(We);
      const cn = N(We);
      if (cn)
        for (let Rn = cn.length - 1; Rn >= 0; --Rn)
          De.push(cn[Rn]);
    }
  }, Wg = function(Y) {
    let De = null, We = null;
    if (_e)
      Y = "<remove></remove>" + Y;
    else {
      const tt = aS(Y, /^[\r\n\t ]+/);
      We = tt && tt[0];
    }
    t === "application/xhtml+xml" && Sn === bn && (Y = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Y + "</body></html>");
    const cn = w ? H(Y) : Y;
    if (Sn === bn)
      try {
        De = new u().parseFromString(cn, t);
      } catch {
      }
    if (!De || !De.documentElement) {
      De = we.createDocument(Sn, "template", null);
      try {
        De.documentElement.innerHTML = Ln ? A : cn;
      } catch {
      }
    }
    const Rn = De.body || De.documentElement;
    return Y && We && Rn.insertBefore(r.createTextNode(We), Rn.childNodes[0] || null), Sn === bn ? ge.call(De, ae ? "html" : "body")[0] : ae ? De.documentElement : Rn;
  }, Kg = function(Y) {
    return ve.call(
      Y.ownerDocument || Y,
      Y,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, Yo = function(Y) {
    return Y = ro(Y, $e, " "), Y = ro(Y, W, " "), Y = ro(Y, Ge, " "), Y;
  }, Xl = function(Y) {
    var De;
    Y.normalize();
    const We = ve.call(
      Y.ownerDocument || Y,
      Y,
      // eslint-disable-next-line no-bitwise
      d.SHOW_TEXT | d.SHOW_COMMENT | d.SHOW_CDATA_SECTION | d.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let cn = We.nextNode();
    for (; cn; )
      cn.data = Yo(cn.data), cn = We.nextNode();
    const Rn = (De = Y.querySelectorAll) === null || De === void 0 ? void 0 : De.call(Y, "template");
    Rn && to(Rn, (tt) => {
      Ki(tt.content) && Xl(tt.content);
    });
  }, Qo = function(Y) {
    const De = C ? C(Y) : null;
    return typeof De != "string" || y(De) !== "form" ? !1 : typeof Y.nodeName != "string" || typeof Y.textContent != "string" || typeof Y.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    Y.attributes !== O(Y) || typeof Y.removeAttribute != "function" || typeof Y.setAttribute != "function" || typeof Y.namespaceURI != "string" || typeof Y.insertBefore != "function" || typeof Y.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    Y.nodeType !== I(Y) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    Y.childNodes !== N(Y);
  }, Ki = function(Y) {
    if (!I || typeof Y != "object" || Y === null)
      return !1;
    try {
      return I(Y) === Rr.documentFragment;
    } catch {
      return !1;
    }
  }, Da = function(Y) {
    if (!I || typeof Y != "object" || Y === null)
      return !1;
    try {
      return typeof I(Y) == "number";
    } catch {
      return !1;
    }
  };
  function Gr(Y, De, We) {
    Y.length !== 0 && to(Y, (cn) => {
      cn.call(n, De, We, E);
    });
  }
  const GF = function(Y, De) {
    return !!(X && Y.hasChildNodes() && !Da(Y.firstElementChild) && Tt(fS, Y.textContent) && Tt(fS, Y.innerHTML) || X && Y.namespaceURI === bn && De === "style" && Da(Y.firstElementChild) || Y.nodeType === Rr.processingInstruction || X && Y.nodeType === Rr.comment && Tt(dB, Y.data));
  }, YF = function(Y, De) {
    if (!le[De] && Qg(De) && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, De) || se.tagNameCheck instanceof Function && se.tagNameCheck(De)))
      return !1;
    if (_n && !kn[De]) {
      const We = x(Y), cn = N(Y);
      if (cn && We) {
        const Rn = cn.length;
        for (let tt = Rn - 1; tt >= 0; --tt) {
          const rt = En ? cn[tt] : k(cn[tt], !0);
          We.insertBefore(rt, j(Y));
        }
      }
    }
    return ie(Y), !0;
  }, Gg = function(Y) {
    if (Gr(be.beforeSanitizeElements, Y, null), Qo(Y))
      return ie(Y), !0;
    const De = y(C ? C(Y) : Y.nodeName);
    if (Gr(be.uponSanitizeElement, Y, {
      tagName: De,
      allowedTags: Je
    }), GF(Y, De))
      return ie(Y), !0;
    if (le[De] || !(Le.tagCheck instanceof Function && Le.tagCheck(De)) && !Je[De])
      return YF(Y, De);
    if ((I ? I(Y) : Y.nodeType) === Rr.element && !Oe(Y) || (De === "noscript" || De === "noembed" || De === "noframes") && Tt(uB, Y.innerHTML))
      return ie(Y), !0;
    if (z && Y.nodeType === Rr.text) {
      const We = Yo(Y.textContent);
      Y.textContent !== We && (ea(n.removed, {
        element: Y.cloneNode()
      }), Y.textContent = We);
    }
    return Gr(be.afterSanitizeElements, Y, null), !1;
  }, Yg = function(Y, De, We) {
    if (Se[De] || on && (De === "id" || De === "name") && (We in r || We in D))
      return !1;
    const cn = Me[De] || Le.attributeCheck instanceof Function && Le.attributeCheck(De, Y);
    if (!(gn && Tt(sn, De)) && !(Pe && Tt(Fe, De))) {
      if (cn) {
        if (!jn[De] && !Tt(Ae, ro(We, Re, "")) && !((De === "src" || De === "xlink:href" || De === "href") && Y !== "script" && oS(We, "data:") === 0 && dn[Y]) && !(J && !Tt(Ue, ro(We, Re, ""))) && We)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(Qg(Y) && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, Y) || se.tagNameCheck instanceof Function && se.tagNameCheck(Y)) && (se.attributeNameCheck instanceof RegExp && Tt(se.attributeNameCheck, De) || se.attributeNameCheck instanceof Function && se.attributeNameCheck(De, Y)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        De === "is" && se.allowCustomizedBuiltInElements && (se.tagNameCheck instanceof RegExp && Tt(se.tagNameCheck, We) || se.tagNameCheck instanceof Function && se.tagNameCheck(We)))
      ) return !1;
    }
    return !0;
  }, QF = Wn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Qg = function(Y) {
    return !QF[vo(Y)] && Tt(Be, Y);
  }, JF = function(Y, De, We, cn) {
    if (w && typeof f == "object" && typeof f.getAttributeType == "function" && !We)
      switch (f.getAttributeType(Y, De)) {
        case "TrustedHTML":
          return H(cn);
        case "TrustedScriptURL":
          return R(cn);
      }
    return cn;
  }, XF = function(Y, De, We, cn) {
    try {
      We ? Y.setAttributeNS(We, De, cn) : Y.setAttribute(De, cn), Qo(Y) ? ie(Y) : iS(n.removed);
    } catch {
      On(De, Y);
    }
  }, Jg = function(Y) {
    Gr(be.beforeSanitizeAttributes, Y, null);
    const De = Y.attributes;
    if (!De || Qo(Y))
      return;
    const We = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let cn = De.length;
    const Rn = y(Y.nodeName);
    for (; cn--; ) {
      const tt = De[cn], rt = tt.name, bi = tt.namespaceURI, oi = tt.value, Jt = y(rt), si = oi;
      let qt = rt === "value" ? si : W5(si);
      if (We.attrName = Jt, We.attrValue = qt, We.keepAttr = !0, We.forceKeepAttr = void 0, Gr(be.uponSanitizeAttribute, Y, We), qt = We.attrValue, pn && (Jt === "id" || Jt === "name") && oS(qt, In) !== 0 && (On(rt, Y), qt = In + qt), X && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        On(rt, Y);
        continue;
      }
      if (Jt === "attributename" && aS(qt, "href")) {
        On(rt, Y);
        continue;
      }
      if (!We.forceKeepAttr) {
        if (!We.keepAttr) {
          On(rt, Y);
          continue;
        }
        if (!T && Tt(mB, qt)) {
          On(rt, Y);
          continue;
        }
        if (z && (qt = Yo(qt)), !Yg(Rn, Jt, qt)) {
          On(rt, Y);
          continue;
        }
        qt = JF(Rn, Jt, bi, qt), qt !== si && XF(Y, rt, bi, qt);
      }
    }
    Gr(be.afterSanitizeAttributes, Y, null);
  }, Jo = function(Y) {
    let De = null;
    const We = Kg(Y);
    for (Gr(be.beforeSanitizeShadowDOM, Y, null); De = We.nextNode(); )
      if (Gr(be.uponSanitizeShadowNode, De, null), Gg(De), Jg(De), Ki(De.content) && Jo(De.content), (I ? I(De) : De.nodeType) === Rr.element) {
        const cn = g(De);
        Ki(cn) && (Zl(cn), Jo(cn));
      }
    Gr(be.afterSanitizeShadowDOM, Y, null);
  }, Zl = function(Y) {
    const De = [{
      node: Y,
      shadow: null
    }];
    for (; De.length > 0; ) {
      const We = De.pop();
      if (We.shadow) {
        Jo(We.shadow);
        continue;
      }
      const cn = We.node, Rn = (I ? I(cn) : cn.nodeType) === Rr.element, tt = N(cn);
      if (tt)
        for (let rt = tt.length - 1; rt >= 0; --rt)
          De.push({
            node: tt[rt],
            shadow: null
          });
      if (Rn) {
        const rt = C ? C(cn) : null;
        if (typeof rt == "string" && y(rt) === "template") {
          const bi = cn.content;
          Ki(bi) && De.push({
            node: bi,
            shadow: null
          });
        }
      }
      if (Rn) {
        const rt = g(cn);
        Ki(rt) && De.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(Y) {
    let De = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, We = null, cn = null, Rn = null, tt = null;
    if (Ln = !Y, Ln && (Y = "<!-->"), typeof Y != "string" && !Da(Y) && (Y = J5(Y), typeof Y != "string"))
      throw ji("dirty is not a string, aborting");
    if (!n.isSupported)
      return Y;
    V ? (Je = Q, Me = me) : _(De), (be.uponSanitizeElement.length > 0 || be.uponSanitizeAttribute.length > 0) && (Je = Ht(Je)), be.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const rt = En && typeof Y != "string" && Da(Y);
    if (rt) {
      const Jt = C ? C(Y) : Y.nodeName;
      if (typeof Jt == "string") {
        const si = y(Jt);
        if (!Je[si] || le[si])
          throw ji("root node is forbidden and cannot be sanitized in-place");
      }
      if (Qo(Y))
        throw ji("root node is clobbered and cannot be sanitized in-place");
      try {
        Zl(Y);
      } catch (si) {
        throw mn(Y), si;
      }
    } else if (Da(Y))
      We = Wg("<!---->"), cn = We.ownerDocument.importNode(Y, !0), cn.nodeType === Rr.element && cn.nodeName === "BODY" || cn.nodeName === "HTML" ? We = cn : We.appendChild(cn), Zl(cn);
    else {
      if (!Te && !z && !ae && // eslint-disable-next-line unicorn/prefer-includes
      Y.indexOf("<") === -1)
        return w && vn ? H(Y) : Y;
      if (We = Wg(Y), !We)
        return Te ? null : vn ? A : "";
    }
    We && _e && ie(We.firstChild);
    const bi = Kg(rt ? Y : We);
    try {
      for (; Rn = bi.nextNode(); )
        Gg(Rn), Jg(Rn), Ki(Rn.content) && Jo(Rn.content);
    } catch (Jt) {
      throw rt && mn(Y), Jt;
    }
    if (rt)
      return to(n.removed, (Jt) => {
        Jt.element && KF(Jt.element);
      }), z && Xl(Y), Y;
    if (Te) {
      if (z && Xl(We), tn)
        for (tt = ue.call(We.ownerDocument); We.firstChild; )
          tt.appendChild(We.firstChild);
      else
        tt = We;
      return (Me.shadowroot || Me.shadowrootmode) && (tt = U.call(i, tt, !0)), tt;
    }
    let oi = ae ? We.outerHTML : We.innerHTML;
    return ae && Je["!doctype"] && We.ownerDocument && We.ownerDocument.doctype && We.ownerDocument.doctype.name && Tt(lB, We.ownerDocument.doctype.name) && (oi = "<!DOCTYPE " + We.ownerDocument.doctype.name + `>
` + oi), z && (oi = Yo(oi)), w && vn ? H(oi) : oi;
  }, n.setConfig = function() {
    let Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _(Y), V = !0, Q = Je, me = Me;
  }, n.clearConfig = function() {
    E = null, V = !1, Q = null, me = null, w = B, A = "";
  }, n.isValidAttribute = function(Y, De, We) {
    E || _({});
    const cn = y(Y), Rn = y(De);
    return Yg(cn, Rn, We);
  }, n.addHook = function(Y, De) {
    typeof De == "function" && It(be, Y) && ea(be[Y], De);
  }, n.removeHook = function(Y, De) {
    if (It(be, Y)) {
      if (De !== void 0) {
        const We = q5(be[Y], De);
        return We === -1 ? void 0 : H5(be[Y], We, 1)[0];
      }
      return iS(be[Y]);
    }
  }, n.removeHooks = function(Y) {
    It(be, Y) && (be[Y] = []);
  }, n.removeAllHooks = function() {
    be = hS();
  }, n;
}
var hB = z1();
const yB = "_messageContainer_1rxr4_1", gB = "_chip_1rxr4_7", vB = "_chipLabel_1rxr4_10", kB = "_chipValue_1rxr4_13", gs = {
  messageContainer: yB,
  chip: gB,
  chipLabel: vB,
  chipValue: kB
}, yS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, bB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ fn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ fn.jsx(Ze, { content: "Conversation Attributes", children: /* @__PURE__ */ fn.jsx(
        yy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ fn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ fn.jsx(Qn, { className: gs.chip, children: /* @__PURE__ */ fn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(lt, { className: gs.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ fn.jsx(lt, { className: gs.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ fn.jsx(
      b,
      {
        className: gs.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? yS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? yS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ fn.jsx($.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ fn.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ fn.jsx(wI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ fn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: hB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ fn.jsx(
      CI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ fn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, xB = "_conversation_1draa_1", _B = "_conversationSubLine_1draa_9", SB = "_modal_1draa_14", Nm = {
  conversation: xB,
  conversationSubLine: _B,
  modal: SB
}, NB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), jB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), wB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = de(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ fn.jsxs(b, { className: Nm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ fn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ fn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ fn.jsx($.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ fn.jsx(Bn, { size: "small", variant: "info", children: Jn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ fn.jsx(
          $.Heading,
          {
            variant: "heading-4",
            className: Nm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ fn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ fn.jsx(Qn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ fn.jsx(Ze, { content: "Show conversation preview", children: /* @__PURE__ */ fn.jsx(
        ir,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ fn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Nm.modal,
        children: [
          /* @__PURE__ */ fn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ fn.jsx(Ft, { children: /* @__PURE__ */ fn.jsx(
            bB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: NB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: jB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, CB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = de(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Yn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ fn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ fn.jsx(
      wB,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ fn.jsxs(
      et,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, FB = R5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), IB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = yn(), { data: l, loading: d, error: m } = s(FB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ fn.jsx(Tn, { error: m }) : d ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ fn.jsx(hn, {}) }) : r?.length === 0 ? /* @__PURE__ */ fn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ fn.jsx(
    CB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, ny = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], jm = "MIUROS", EB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, $B = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: EB
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: jm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: ny,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = (K) => fr(K, {
    fieldDefinitions: ny,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), B = l.watch("name");
  return /* @__PURE__ */ fn.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ fn.jsx(hr, { cause: k }),
        /* @__PURE__ */ fn.jsxs(nt, { children: [
          /* @__PURE__ */ fn.jsx(Z, { children: /* @__PURE__ */ fn.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ fn.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            Er,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3, children: /* @__PURE__ */ fn.jsx(
            An,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (K) => !Number.isNaN(Number.parseInt(K, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fn.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ fn.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: jm,
              label: "Authorize"
            }
          ),
          o && I !== null && /* @__PURE__ */ fn.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ fn.jsx(
          yr,
          {
            integrationType: jm,
            integrationId: e,
            widgetName: B,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wm = { exports: {} }, ao = {}, gS;
function TB() {
  if (gS) return ao;
  gS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ao.Fragment = r, ao.jsx = s, ao.jsxs = s, ao;
}
var vs = {}, vS;
function DB() {
  return vS || (vS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    vs.Fragment = i, vs.jsx = Un, vs.jsxs = Kn;
  })()), vs;
}
var kS;
function OB() {
  return kS || (kS = 1, process.env.NODE_ENV === "production" ? wm.exports = TB() : wm.exports = DB()), wm.exports;
}
var Ie = OB();
const RB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, PB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, AB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, LB = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": RB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": PB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": AB
};
function gg(e) {
  return LB[e] ?? {};
}
const VB = gg(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), zB = gg(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), UB = gg(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function ty(e = !1, n) {
  const [r, i] = de(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const MB = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, U1 = "DD MMM YYYY @ HH:mm", BB = "_list_2c4dq_1", qB = "_listItem_2c4dq_4", HB = "_copyIcon_2c4dq_12", Pi = {
  list: BB,
  listItem: qB,
  copyIcon: HB
}, ry = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = ty(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: F
  } = e ?? {}, j = `${d} ${m}`.trim() || void 0, N = `${h} ${k}`.trim() || void 0, x = [j, u, f, N, F].filter(
    Boolean
  );
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ye, { size: l, name: n }),
      i ? /* @__PURE__ */ Ie.jsx(hn, { size: l }) : /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: x.map((g, O) => /* @__PURE__ */ Ie.jsx(lt, { children: g }, O)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ie.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ie.jsx(Ze, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ie.jsx(
        ye,
        {
          size: l,
          name: "exclamation",
          className: Pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ie.jsx(
        ye,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(x.join(", ")),
          className: Pi.copyIcon
        }
      ) })
    ] })
  ] });
}, WB = "_wrapper_1nher_1", KB = {
  wrapper: WB
}, GB = ({
  customer: e,
  store: n
}) => {
  const { track: r } = Fn(), { isCopied: i, copy: a } = ty(), { isCopied: o, copy: s } = ty(), { useQuery: l } = yn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(zB, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, F = (h?.addresses?.length ?? 0) > 1;
  if (Qe(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ Ie.jsx(Tn, { error: u });
  if (!e)
    return null;
  const {
    id: j,
    phone: N,
    email: x,
    first_name: g,
    last_name: O,
    created_at: I,
    has_valid_payment_method: C
  } = e, w = 14, A = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${j}` : null, B = `${g || ""} ${O || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ie.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ie.jsxs(b, { className: KB.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-2", children: B }),
    I && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: Jn(I).format(U1) })
    ] }),
    x && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ye, { size: w, name: "mail" }),
        /* @__PURE__ */ Ie.jsx($.ExternalLink, { href: `mailto:${x}`, children: x })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ Ie.jsx(
        ye,
        {
          size: w,
          name: i ? "done" : "copy",
          onClick: () => a(x),
          className: Pi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ye, { size: w, name: "phone" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ie.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ Ie.jsx(
        ye,
        {
          size: w,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: Pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ie.jsx(
      ry,
      {
        address: k,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: F
      }
    ),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ie.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ie.jsx(ye, { size: w, name: "credit-card" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ie.jsx(
        ye,
        {
          size: w,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    A && /* @__PURE__ */ Ie.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ie.jsx(ye, { size: w, name: "external-link" }),
      /* @__PURE__ */ Ie.jsx(
        $.ExternalLink,
        {
          href: A,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, YB = "_order_1dlaa_1", QB = "_orderIsOpen_1dlaa_9", JB = "_orderHeader_1dlaa_12", XB = "_note_1dlaa_16", ks = {
  order: YB,
  orderIsOpen: QB,
  orderHeader: JB,
  note: XB
}, ZB = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = Fn(), [a, o] = de(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: F,
    is_prepaid: j
  } = e, N = 14, x = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ie.jsxs(
    b,
    {
      className: dt(ks.order, {
        [ks.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ie.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ks.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ie.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ie.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: Jn(f).format(U1) }) }),
                /* @__PURE__ */ Ie.jsxs($.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ie.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ie.jsx(Ze, { content: "Note", children: /* @__PURE__ */ Ie.jsx(
            $.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: ks.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ye, { size: N, name: "activity" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: MB(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ye, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: j ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ye, { size: N, name: "cog" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ie.jsx(ye, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ie.jsxs($.Paragraph, { variant: "4", children: [
                F,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ie.jsx(
            ry,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ie.jsx(
            ry,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          x && /* @__PURE__ */ Ie.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(x, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ie.jsx(ye, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, eq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = Fn(), { useQuery: i } = yn(), {
    loading: a,
    error: o,
    data: s
  } = i(UB, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ie.jsx(Tn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ie.jsx(Bn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(hn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ie.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ie.jsx($.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ie.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ie.jsx(
        ZB,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ie.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ie.jsx(ye, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, nq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ie.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ie.jsx($.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ie.jsxs(Xe, { className: Pi.list, children: [
      /* @__PURE__ */ Ie.jsx(Xe.Text, { variant: "dense", className: Pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ie.jsx(Xe.Text, { variant: "dense", className: Pi.listItem, children: /* @__PURE__ */ Ie.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ie.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, tq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(VB, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const k = m.graphQLErrors;
    return xl({ errors: k }) ? /* @__PURE__ */ Ie.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: k }) ? /* @__PURE__ */ Ie.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ie.jsx(Tn, { error: m });
  }
  return d ? /* @__PURE__ */ Ie.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ie.jsx(hn, {}) }) : f ? l ? /* @__PURE__ */ Ie.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ie.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ie.jsx(GB, { customer: f, store: h }),
        o && /* @__PURE__ */ Ie.jsx(nq, { customer: f }),
        s && /* @__PURE__ */ Ie.jsx(eq, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ie.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, iy = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], rq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, iq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: rq
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: iy,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: iy,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ Ie.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ Ie.jsx(hr, { cause: h }),
        /* @__PURE__ */ Ie.jsxs(nt, { children: [
          /* @__PURE__ */ Ie.jsx(Z, { children: /* @__PURE__ */ Ie.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(
            Er,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays details of a customer", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3, children: /* @__PURE__ */ Ie.jsx(He, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ie.jsx(
            xn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ie.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Ie.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ie.jsx(
          yr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cm = { exports: {} }, oo = {}, bS;
function aq() {
  if (bS) return oo;
  bS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var bs = {}, xS;
function oq() {
  return xS || (xS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    bs.Fragment = i, bs.jsx = Un, bs.jsxs = Kn;
  })()), bs;
}
var _S;
function sq() {
  return _S || (_S = 1, process.env.NODE_ENV === "production" ? Cm.exports = aq() : Cm.exports = oq()), Cm.exports;
}
var ke = sq(), M1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(M1 || {}), pa = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(pa || {});
const lq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, cq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, dq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, mq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": lq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': cq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": dq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": uq
};
function ql(e) {
  return mq[e] ?? {};
}
const pq = ql(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), fq = ql(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), hq = ql(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), yq = ql(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), gq = "_list_l5y5y_85", vq = "_listItem_l5y5y_95", kq = "_listItemHighlighted_l5y5y_103", bq = "_listItemEdit_l5y5y_106", xq = "_clickableIcon_l5y5y_120", Cr = {
  list: gq,
  listItem: vq,
  listItemHighlighted: kq,
  listItemEdit: bq,
  clickableIcon: xq
}, vg = "rivoLoyaltyShopifyApiHostName", B1 = "https://admin.shopify.com";
function q1(e) {
  return e.split(".")[0];
}
const _q = "_wrapper_1xucg_1", SS = {
  wrapper: _q
}, Sq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = Fn(), { isCopied: i, copy: a } = Qt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: d,
    verified_email: m
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ ke.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { className: SS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx(
      b,
      {
        justifyContent: "space-between",
        className: SS.block,
        alignItems: "center",
        children: /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    d && /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ ke.jsx(ye, { size: u, name: "mail" }),
        /* @__PURE__ */ ke.jsx($.ExternalLink, { href: `mailto:${d}`, children: d }),
        /* @__PURE__ */ ke.jsx(
          Ze,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ ke.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ke.jsx(
              ye,
              {
                size: u,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ ke.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ ke.jsx(
        ye,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Cr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(ye, { size: u, name: "sign-in" }),
        /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ ke.jsx(
        ye,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ ke.jsx(ye, { size: u, name: "external-link" }),
      /* @__PURE__ */ ke.jsx(
        $.ExternalLink,
        {
          href: Nq(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function Nq(e, n) {
  const r = q1(e);
  return `${B1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const jq = "_list_rxh85_1", wq = "_listItem_rxh85_6", NS = {
  list: jq,
  listItem: wq
}, Cq = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = yn(), {
    loading: i,
    error: a,
    data: o
  } = r(fq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, d = () => a ? /* @__PURE__ */ ke.jsx(Tn, { error: a }) : i ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(hn, {}) }) : s.length === 0 ? /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ ke.jsx(Xe, { className: NS.list, children: s.map((m) => /* @__PURE__ */ ke.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: NS.listItem,
      children: [
        /* @__PURE__ */ ke.jsx(ye, { size: l, name: "external-link" }),
        /* @__PURE__ */ ke.jsx(
          $.ExternalLink,
          {
            href: Fq(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Favorite products" }),
    d()
  ] }) });
};
function Fq(e, n) {
  const r = q1(e);
  return `${B1}/store/${r}/products/${n}`;
}
const Iq = "_modalBody_1clhs_1", Eq = {
  modalBody: Iq
};
function $q(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function Tq(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const Dq = M1, xs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, Oq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = de(r), [u, f] = de(""), [h, k] = de(!0), [F, j] = de(), N = {
    min: 0,
    max: 1e5
  }, [x, { loading: g }] = o(
    yq,
    {
      onCompleted: () => {
        const ee = d > r ? xs.addPoints : xs.removePoints;
        s({
          title: "Success",
          text: ee.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(ee.successEventName), K();
      }
    }
  ), O = () => {
    m(r), f(""), k(!0), j(void 0);
  };
  Qe(() => {
    n && O();
  }, [n]);
  const I = !!F, C = $q(d, N), w = Tq(r, d), A = () => {
    if (d !== r) {
      const ee = d > r ? xs.addPoints : xs.removePoints, G = !h;
      x({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: d - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: Dq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: G
          }
        }
      }).catch(() => {
        l(ee.failEventName), j([ee.failEventText]);
      });
    }
  }, B = () => {
    O(), i();
  }, K = () => {
    a(), B();
  };
  return /* @__PURE__ */ ke.jsxs(
    wt,
    {
      isOpen: n,
      onClose: B,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ ke.jsx(Ct, { title: "Change points", onClose: B }),
        /* @__PURE__ */ ke.jsxs(Ft, { className: Eq.modalBody, children: [
          /* @__PURE__ */ ke.jsxs(nt, { children: [
            /* @__PURE__ */ ke.jsx(Z, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ ke.jsx(
              tr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: N.min,
                max: N.max,
                meta: {
                  error: C,
                  warning: w
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (ee) => m(ee?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(Z, { span: 6, children: /* @__PURE__ */ ke.jsx(
              tr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (ee) => f(ee?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(Z, { span: 6, children: /* @__PURE__ */ ke.jsx(He, { label: "Notify the customer by email", children: /* @__PURE__ */ ke.jsx(
              wl,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => k(!h)
                }
              }
            ) }) })
          ] }),
          !g && I && /* @__PURE__ */ ke.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ ke.jsx(Xe, { children: F?.map((ee, G) => /* @__PURE__ */ ke.jsx(
            Xe.Item,
            {
              variant: "dense",
              title: ee,
              contentLeft: /* @__PURE__ */ ke.jsx(
                ye,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            G
          )) }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => A(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ ke.jsx(hn, { size: 16 }),
              disabled: !!(C || w)
            },
            cancelOnClick: B
          }
        )
      ]
    }
  );
}, na = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = gw(n);
  return /* @__PURE__ */ ke.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem, {
        [Cr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ ke.jsx(Ze, { content: r, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, jS = {
  [pa.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [pa.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [pa.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, Rq = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? jS[i.loyalty_status] : jS[pa.Guest], o = a?.name === pa.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, d = Math.trunc(i.points_tally ?? 0), m = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = m?.name ?? "None", [h, k] = de(!1), F = 10, j = () => /* @__PURE__ */ ke.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem),
      children: /* @__PURE__ */ ke.jsx(Ze, { content: a.tooltip, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ ke.jsx(Bn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), N = () => o ? j() : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(
      Xe.Text,
      {
        variant: "dense",
        className: dt(
          Cr.listItem,
          Cr.listItemHighlighted,
          {
            [Cr.listItemEdit]: n
          }
        ),
        onClick: () => n ? k(!0) : void 0,
        children: /* @__PURE__ */ ke.jsx(Ze, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ ke.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ ke.jsx(
                  ye,
                  {
                    name: "pen",
                    size: F,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: Li(d) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ ke.jsx(
      na,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ ke.jsx(
      na,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      na,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ ke.jsx(
      na,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    j(),
    /* @__PURE__ */ ke.jsx(
      na,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ ke.jsx(
      na,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ ke.jsx(Xe, { className: Cr.list, children: N() })
    ] }),
    /* @__PURE__ */ ke.jsx(
      Oq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: d,
        onClose: () => k(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, Pq = ({
  ordersCount: e
}) => /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ ke.jsx(Xe, { className: Cr.list, children: /* @__PURE__ */ ke.jsx(Xe.Text, { variant: "dense", className: Cr.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), Aq = "_reward_1gmba_1", Lq = "_voucherCode_1gmba_14", wS = {
  reward: Aq,
  voucherCode: Lq
}, Vq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Qt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ ke.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", className: wS.reward, children: [
    /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ke.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ke.jsx(ye, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ ke.jsxs(Bn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ ke.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ ke.jsx(ye, { size: 14, name: "tag" }),
            /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", className: wS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ ke.jsx(Ze, { content: "Copy reward code", children: /* @__PURE__ */ ke.jsx(
            ye,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Cr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, zq = ({
  customer: e
}) => {
  const { useQuery: n } = yn(), {
    loading: r,
    error: i,
    data: a
  } = n(hq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => Uq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ ke.jsx(Tn, { error: i }) : r ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(hn, {}) }) : o.length > 0 ? /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ ke.jsx(
    Vq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function Uq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const Mq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, d = r[vg].toString(), { useQuery: m } = yn(), { track: u } = Fn(), [f, h] = de(!1), k = n?.customer?.email, {
    loading: F,
    error: j,
    data: N,
    refetch: x
  } = m(pq, {
    skip: !k,
    variables: {
      email: k
    }
  }), g = !F && N ? N.RivoLoyalty?.return_customer?.data : void 0;
  Qe(() => {
    !F && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [F, g]);
  const O = () => /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (j) {
    const I = j.graphQLErrors;
    return ba({ errors: I }) ? O() : xl({ errors: I }) ? /* @__PURE__ */ ke.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: I }) ? /* @__PURE__ */ ke.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ke.jsx(Tn, { error: j });
  }
  return F ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ke.jsx(hn, {}) }) : !k || !g ? O() : /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ ke.jsx(
          Sq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        i && /* @__PURE__ */ ke.jsx(
          Pq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ ke.jsx(
          Rq,
          {
            customer: g,
            refetchCustomerData: x,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ ke.jsx(
          Cq,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        l && /* @__PURE__ */ ke.jsx(zq, { customer: g })
      ]
    }
  );
};
var Wo = (e) => e.type === "checkbox", Di = (e) => e instanceof Date, Yt = (e) => e == null;
const H1 = (e) => typeof e == "object";
var vt = (e) => !Yt(e) && !Array.isArray(e) && H1(e) && !Di(e), W1 = (e) => vt(e) && e.target ? Wo(e.target) ? e.target.checked : e.target.value : e, Bq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, K1 = (e, n) => e.has(Bq(n)), qq = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return vt(n) && n.hasOwnProperty("isPrototypeOf");
}, kg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Rt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(kg && (e instanceof Blob || i)) && (r || vt(e)))
    if (n = r ? [] : {}, !r && !qq(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Rt(e[a]));
  else
    return e;
  return n;
}
var Hl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, an = (e, n, r) => {
  if (!n || !vt(e))
    return r;
  const i = Hl(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", bg = (e) => /^\w*$/.test(e), G1 = (e) => Hl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = bg(n) ? [n] : G1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = vt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const pl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Hq = qe.createContext(null), xg = () => qe.useContext(Hq);
var Y1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Wq(e) {
  const n = xg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => Y1(s, r, d.current, !1), [s, r]);
}
var Mr = (e) => typeof e == "string", Q1 = (e, n, r, i, a) => Mr(e) ? (i && n.watch.add(e), an(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), an(r, o))) : (i && (n.watchAll = !0), r);
function Kq(e) {
  const n = xg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Q1(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Gq(e) {
  const n = xg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = K1(a._names.array, r), l = Kq({
    control: a,
    name: r,
    defaultValue: an(a._formValues, r, an(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = Wq({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!an(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!an(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!an(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!an(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => an(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((N) => u.current.onChange({
    target: {
      value: W1(N),
      name: r
    },
    type: pl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: an(a._formValues, r),
      name: r
    },
    type: pl.BLUR
  }), [r, a._formValues]), F = qe.useCallback((N) => {
    const x = an(a._fields, r);
    x && N && (x._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (g) => N.setCustomValidity(g),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), j = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: F
  }), [r, i, d.disabled, h, k, F, l]);
  return qe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...sr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const x = (g, O) => {
      const I = an(a._fields, g);
      I && I._f && (I._f.mount = O);
    };
    if (x(r, !0), N) {
      const g = Rt(an(a._options.defaultValues, r));
      at(a._defaultValues, r, g), ht(an(a._formValues, r)) && at(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : x(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: j,
    formState: d,
    fieldState: f
  }), [j, d, f]);
}
var Yq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, No = (e) => Array.isArray(e) ? e : [e], CS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ay = (e) => Yt(e) || !H1(e);
function pi(e, n) {
  if (ay(e) || ay(n))
    return e === n;
  if (Di(e) && Di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Di(o) && Di(s) || vt(o) && vt(s) || Array.isArray(o) && Array.isArray(s) ? !pi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => vt(e) && !Object.keys(e).length, _g = (e) => e.type === "file", Ir = (e) => typeof e == "function", fl = (e) => {
  if (!kg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, J1 = (e) => e.type === "select-multiple", Sg = (e) => e.type === "radio", Qq = (e) => Sg(e) || Wo(e), Fm = (e) => fl(e) && e.isConnected;
function Jq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function Xq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function Nt(e, n) {
  const r = Array.isArray(n) ? n : bg(n) ? [n] : G1(n), i = r.length === 1 ? e : Jq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (vt(i) && Kt(i) || Array.isArray(i) && Xq(i)) && Nt(e, r.slice(0, -1)), e;
}
var X1 = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function hl(e, n = {}) {
  const r = Array.isArray(e);
  if (vt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || vt(e[i]) && !X1(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, hl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function Z1(e, n, r) {
  const i = Array.isArray(e);
  if (vt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || vt(e[a]) && !X1(e[a]) ? ht(n) || ay(r[a]) ? r[a] = Array.isArray(e[a]) ? hl(e[a], []) : { ...hl(e[a]) } : Z1(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !pi(e[a], n[a]);
  return r;
}
var so = (e, n) => Z1(e, n, hl(n));
const FS = {
  value: !1,
  isValid: !1
}, IS = { value: !0, isValid: !0 };
var eF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? IS : { value: e[0].value, isValid: !0 } : IS
    ) : FS;
  }
  return FS;
}, nF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Mr(e) ? new Date(e) : i ? i(e) : e;
const ES = {
  isValid: !1,
  value: null
};
var tF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, ES) : ES;
function $S(e) {
  const n = e.ref;
  return _g(n) ? n.files : Sg(n) ? tF(e.refs).value : J1(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Wo(n) ? eF(e.refs).value : nF(ht(n.value) ? e.ref.value : n.value, e);
}
var Zq = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = an(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, yl = (e) => e instanceof RegExp, lo = (e) => ht(e) ? e : yl(e) ? e.source : vt(e) ? yl(e.value) ? e.value.source : e.value : e, TS = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const DS = "AsyncFunction";
var e6 = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === DS || vt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === DS)), n6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), OS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const jo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = an(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (jo(l, n))
          break;
      } else if (vt(l) && jo(l, n))
        break;
    }
  }
};
function RS(e, n, r) {
  const i = an(e, r);
  if (i || bg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = an(n, o), l = an(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var t6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, r6 = (e, n, r) => !e || !n || e === n || No(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), i6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, a6 = (e, n) => !Hl(an(e, n)).length && Nt(e, n), o6 = (e, n, r) => {
  const i = No(an(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, qs = (e) => Mr(e);
function PS(e, n, r = "validate") {
  if (qs(e) || Array.isArray(e) && e.every(qs) || sr(e) && !e)
    return {
      type: r,
      message: qs(e) ? e : "",
      ref: n
    };
}
var ta = (e) => vt(e) && !yl(e) ? e : {
  value: e,
  message: ""
}, AS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: F, name: j, valueAsNumber: N, mount: x } = e._f, g = an(r, j);
  if (!x || n.has(j))
    return {};
  const O = l ? l[0] : s, I = (H) => {
    a && O.reportValidity && (O.setCustomValidity(sr(H) ? "" : H || ""), O.reportValidity());
  }, C = {}, w = Sg(s), A = Wo(s), B = w || A, K = (N || _g(s)) && ht(s.value) && ht(g) || fl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, ee = Yq.bind(null, j, i, C), G = (H, R, q, te = Zr.maxLength, we = Zr.minLength) => {
    const ve = H ? R : q;
    C[j] = {
      type: H ? te : we,
      message: ve,
      ref: s,
      ...ee(H ? te : we, ve)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!B && (K || Yt(g)) || sr(g) && !g || A && !eF(l).isValid || w && !tF(l).isValid)) {
    const { value: H, message: R } = qs(d) ? { value: !!d, message: d } : ta(d);
    if (H && (C[j] = {
      type: Zr.required,
      message: R,
      ref: O,
      ...ee(Zr.required, R)
    }, !i))
      return I(R), C;
  }
  if (!K && (!Yt(f) || !Yt(h))) {
    let H, R;
    const q = ta(h), te = ta(f);
    if (!Yt(g) && !isNaN(g)) {
      const we = s.valueAsNumber || g && +g;
      Yt(q.value) || (H = we > q.value), Yt(te.value) || (R = we < te.value);
    } else {
      const we = s.valueAsDate || new Date(g), ve = (U) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + U), ue = s.type == "time", ge = s.type == "week";
      Mr(q.value) && g && (H = ue ? ve(g) > ve(q.value) : ge ? g > q.value : we > new Date(q.value)), Mr(te.value) && g && (R = ue ? ve(g) < ve(te.value) : ge ? g < te.value : we < new Date(te.value));
    }
    if ((H || R) && (G(!!H, q.message, te.message, Zr.max, Zr.min), !i))
      return I(C[j].message), C;
  }
  if ((m || u) && !K && (Mr(g) || o && Array.isArray(g))) {
    const H = ta(m), R = ta(u), q = !Yt(H.value) && g.length > +H.value, te = !Yt(R.value) && g.length < +R.value;
    if ((q || te) && (G(q, H.message, R.message), !i))
      return I(C[j].message), C;
  }
  if (k && !K && Mr(g)) {
    const { value: H, message: R } = ta(k);
    if (yl(H) && !g.match(H) && (C[j] = {
      type: Zr.pattern,
      message: R,
      ref: s,
      ...ee(Zr.pattern, R)
    }, !i))
      return I(R), C;
  }
  if (F) {
    if (Ir(F)) {
      const H = await F(g, r), R = PS(H, O);
      if (R && (C[j] = {
        ...R,
        ...ee(Zr.validate, R.message)
      }, !i))
        return I(R.message), C;
    } else if (vt(F)) {
      let H = {};
      for (const R in F) {
        if (!Kt(H) && !i)
          break;
        const q = PS(await F[R](g, r), O, R);
        q && (H = {
          ...q,
          ...ee(R, q.message)
        }, I(q.message), i && (C[j] = H));
      }
      if (!Kt(H) && (C[j] = {
        ref: O,
        ...H
      }, !i))
        return C;
    }
  }
  return I(!0), C;
};
const s6 = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function l6(e = {}) {
  let n = {
    ...s6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = vt(n.defaultValues) || vt(n.values) ? Rt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Rt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: CS(),
    state: CS()
  }, k = TS(n.mode), F = TS(n.reValidateMode), j = n.criteriaMode === Fr.all, N = (J) => (T) => {
    clearTimeout(m), m = setTimeout(J, T);
  }, x = async (J) => {
    if (!n.disabled && (u.isValid || f.isValid || J)) {
      const T = n.resolver ? Kt((await K()).errors) : await G(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, g = (J, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((J || Array.from(l.mount)).forEach((z) => {
      z && (T ? at(r.validatingFields, z, T) : Nt(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, O = (J, T = [], z, X, ae = !0, V = !0) => {
    if (X && z && !n.disabled) {
      if (s.action = !0, V && Array.isArray(an(i, J))) {
        const Q = z(an(i, J), X.argA, X.argB);
        ae && at(i, J, Q);
      }
      if (V && Array.isArray(an(r.errors, J))) {
        const Q = z(an(r.errors, J), X.argA, X.argB);
        ae && at(r.errors, J, Q), a6(r.errors, J);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(an(r.touchedFields, J))) {
        const Q = z(an(r.touchedFields, J), X.argA, X.argB);
        ae && at(r.touchedFields, J, Q);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = so(a, o)), h.state.next({
        name: J,
        isDirty: R(J, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, J, T);
  }, I = (J, T) => {
    at(r.errors, J, T), h.state.next({
      errors: r.errors
    });
  }, C = (J) => {
    r.errors = J, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, w = (J, T, z, X) => {
    const ae = an(i, J);
    if (ae) {
      const V = an(o, J, ht(z) ? an(a, J) : z);
      ht(V) || X && X.defaultChecked || T ? at(o, J, T ? V : $S(ae._f)) : we(J, V), s.mount && x();
    }
  }, A = (J, T, z, X, ae) => {
    let V = !1, Q = !1;
    const me = {
      name: J
    };
    if (!n.disabled) {
      if (!z || X) {
        (u.isDirty || f.isDirty) && (Q = r.isDirty, r.isDirty = me.isDirty = R(), V = Q !== me.isDirty);
        const _e = pi(an(a, J), T);
        Q = !!an(r.dirtyFields, J), _e ? Nt(r.dirtyFields, J) : at(r.dirtyFields, J, !0), me.dirtyFields = r.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && Q !== !_e;
      }
      if (z) {
        const _e = an(r.touchedFields, J);
        _e || (at(r.touchedFields, J, z), me.touchedFields = r.touchedFields, V = V || (u.touchedFields || f.touchedFields) && _e !== z);
      }
      V && ae && h.state.next(me);
    }
    return V ? me : {};
  }, B = (J, T, z, X) => {
    const ae = an(r.errors, J), V = (u.isValid || f.isValid) && sr(T) && r.isValid !== T;
    if (n.delayError && z ? (d = N(() => I(J, z)), d(n.delayError)) : (clearTimeout(m), d = null, z ? at(r.errors, J, z) : Nt(r.errors, J)), (z ? !pi(ae, z) : ae) || !Kt(X) || V) {
      const Q = {
        ...X,
        ...V && sr(T) ? { isValid: T } : {},
        errors: r.errors,
        name: J
      };
      r = {
        ...r,
        ...Q
      }, h.state.next(Q);
    }
  }, K = async (J) => {
    g(J, !0);
    const T = await n.resolver(o, n.context, Zq(J || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(J), T;
  }, ee = async (J) => {
    const { errors: T } = await K(J);
    if (J)
      for (const z of J) {
        const X = an(T, z);
        X ? at(r.errors, z, X) : Nt(r.errors, z);
      }
    else
      r.errors = T;
    return T;
  }, G = async (J, T, z = {
    valid: !0
  }) => {
    for (const X in J) {
      const ae = J[X];
      if (ae) {
        const { _f: V, ...Q } = ae;
        if (V) {
          const me = l.array.has(V.name), _e = ae._f && e6(ae._f);
          _e && u.validatingFields && g([X], !0);
          const Te = await AS(ae, l.disabled, o, j, n.shouldUseNativeValidation && !T, me);
          if (_e && u.validatingFields && g([X]), Te[V.name] && (z.valid = !1, T))
            break;
          !T && (an(Te, V.name) ? me ? o6(r.errors, Te, V.name) : at(r.errors, V.name, Te[V.name]) : Nt(r.errors, V.name));
        }
        !Kt(Q) && await G(Q, T, z);
      }
    }
    return z.valid;
  }, H = () => {
    for (const J of l.unMount) {
      const T = an(i, J);
      T && (T._f.refs ? T._f.refs.every((z) => !Fm(z)) : !Fm(T._f.ref)) && Be(J);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, R = (J, T) => !n.disabled && (J && T && at(o, J, T), !pi($e(), a)), q = (J, T, z) => Q1(J, l, {
    ...s.mount ? o : ht(T) ? a : Mr(J) ? { [J]: T } : T
  }, z, T), te = (J) => Hl(an(s.mount ? o : a, J, n.shouldUnregister ? an(a, J, []) : [])), we = (J, T, z = {}) => {
    const X = an(i, J);
    let ae = T;
    if (X) {
      const V = X._f;
      V && (!V.disabled && at(o, J, nF(T, V)), ae = fl(V.ref) && Yt(T) ? "" : T, J1(V.ref) ? [...V.ref.options].forEach((Q) => Q.selected = ae.includes(Q.value)) : V.refs ? Wo(V.ref) ? V.refs.length > 1 ? V.refs.forEach((Q) => (!Q.defaultChecked || !Q.disabled) && (Q.checked = Array.isArray(ae) ? !!ae.find((me) => me === Q.value) : ae === Q.value)) : V.refs[0] && (V.refs[0].checked = !!ae) : V.refs.forEach((Q) => Q.checked = Q.value === ae) : _g(V.ref) ? V.ref.value = "" : (V.ref.value = ae, V.ref.type || h.state.next({
        name: J,
        values: Rt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && A(J, ae, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && be(J);
  }, ve = (J, T, z) => {
    for (const X in T) {
      const ae = T[X], V = `${J}.${X}`, Q = an(i, V);
      (l.array.has(J) || vt(ae) || Q && !Q._f) && !Di(ae) ? ve(V, ae, z) : we(V, ae, z);
    }
  }, ue = (J, T, z = {}) => {
    const X = an(i, J), ae = l.array.has(J), V = Rt(T);
    at(o, J, V), ae ? (h.array.next({
      name: J,
      values: Rt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: J,
      dirtyFields: so(a, o),
      isDirty: R(J, V)
    })) : X && !X._f && !Yt(V) ? ve(J, V, z) : we(J, V, z), OS(J, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? J : void 0,
      values: Rt(o)
    });
  }, ge = async (J) => {
    s.mount = !0;
    const T = J.target;
    let z = T.name, X = !0;
    const ae = an(i, z), V = (Q) => {
      X = Number.isNaN(Q) || Di(Q) && isNaN(Q.getTime()) || pi(Q, an(o, z, Q));
    };
    if (ae) {
      let Q, me;
      const _e = T.type ? $S(ae._f) : W1(J), Te = J.type === pl.BLUR || J.type === pl.FOCUS_OUT, tn = !n6(ae._f) && !n.resolver && !an(r.errors, z) && !ae._f.deps || i6(Te, an(r.touchedFields, z), r.isSubmitted, F, k), vn = OS(z, l, Te);
      at(o, z, _e), Te ? (ae._f.onBlur && ae._f.onBlur(J), d && d(0)) : ae._f.onChange && ae._f.onChange(J);
      const on = A(z, _e, Te), pn = !Kt(on) || vn;
      if (!Te && h.state.next({
        name: z,
        type: J.type,
        values: Rt(o)
      }), tn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Te && x() : Te || x()), pn && h.state.next({ name: z, ...vn ? {} : on });
      if (!Te && vn && h.state.next({ ...r }), n.resolver) {
        const { errors: In } = await K([z]);
        if (V(_e), X) {
          const _n = RS(r.errors, i, z), En = RS(In, i, _n.name || z);
          Q = En.error, z = En.name, me = Kt(In);
        }
      } else
        g([z], !0), Q = (await AS(ae, l.disabled, o, j, n.shouldUseNativeValidation))[z], g([z]), V(_e), X && (Q ? me = !1 : (u.isValid || f.isValid) && (me = await G(i, !0)));
      X && (ae._f.deps && be(ae._f.deps), B(z, me, Q, on));
    }
  }, U = (J, T) => {
    if (an(r.errors, T) && J.focus)
      return J.focus(), 1;
  }, be = async (J, T = {}) => {
    let z, X;
    const ae = No(J);
    if (n.resolver) {
      const V = await ee(ht(J) ? J : ae);
      z = Kt(V), X = J ? !ae.some((Q) => an(V, Q)) : z;
    } else J ? (X = (await Promise.all(ae.map(async (V) => {
      const Q = an(i, V);
      return await G(Q && Q._f ? { [V]: Q } : Q);
    }))).every(Boolean), !(!X && !r.isValid) && x()) : X = z = await G(i);
    return h.state.next({
      ...!Mr(J) || (u.isValid || f.isValid) && z !== r.isValid ? {} : { name: J },
      ...n.resolver || !J ? { isValid: z } : {},
      errors: r.errors
    }), T.shouldFocus && !X && jo(i, U, J ? ae : l.mount), X;
  }, $e = (J) => {
    const T = {
      ...s.mount ? o : a
    };
    return ht(J) ? T : Mr(J) ? an(T, J) : J.map((z) => an(T, z));
  }, W = (J, T) => ({
    invalid: !!an((T || r).errors, J),
    isDirty: !!an((T || r).dirtyFields, J),
    error: an((T || r).errors, J),
    isValidating: !!an(r.validatingFields, J),
    isTouched: !!an((T || r).touchedFields, J)
  }), Ge = (J) => {
    J && No(J).forEach((T) => Nt(r.errors, T)), h.state.next({
      errors: J ? r.errors : {}
    });
  }, sn = (J, T, z) => {
    const X = (an(i, J, { _f: {} })._f || {}).ref, ae = an(r.errors, J) || {}, { ref: V, message: Q, type: me, ..._e } = ae;
    at(r.errors, J, {
      ..._e,
      ...T,
      ref: X
    }), h.state.next({
      name: J,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && X && X.focus && X.focus();
  }, Fe = (J, T) => Ir(J) ? h.state.subscribe({
    next: (z) => J(q(void 0, T), z)
  }) : q(J, T, !0), Ue = (J) => h.state.subscribe({
    next: (T) => {
      r6(J.name, T.name, J.exact) && t6(T, J.formState || u, Pe, J.reRenderRoot) && J.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, Re = (J) => (s.mount = !0, f = {
    ...f,
    ...J.formState
  }, Ue({
    ...J,
    formState: f
  })), Be = (J, T = {}) => {
    for (const z of J ? No(J) : l.mount)
      l.mount.delete(z), l.array.delete(z), T.keepValue || (Nt(i, z), Nt(o, z)), !T.keepError && Nt(r.errors, z), !T.keepDirty && Nt(r.dirtyFields, z), !T.keepTouched && Nt(r.touchedFields, z), !T.keepIsValidating && Nt(r.validatingFields, z), !n.shouldUnregister && !T.keepDefaultValue && Nt(a, z);
    h.state.next({
      values: Rt(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: R() } : {}
    }), !T.keepIsValid && x();
  }, Ae = ({ disabled: J, name: T }) => {
    (sr(J) && s.mount || J || l.disabled.has(T)) && (J ? l.disabled.add(T) : l.disabled.delete(T));
  }, Je = (J, T = {}) => {
    let z = an(i, J);
    const X = sr(T.disabled) || sr(n.disabled);
    return at(i, J, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: J } },
        name: J,
        mount: !0,
        ...T
      }
    }), l.mount.add(J), z ? Ae({
      disabled: sr(T.disabled) ? T.disabled : n.disabled,
      name: J
    }) : w(J, !0, T.value), {
      ...X ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: lo(T.min),
        max: lo(T.max),
        minLength: lo(T.minLength),
        maxLength: lo(T.maxLength),
        pattern: lo(T.pattern)
      } : {},
      name: J,
      onChange: ge,
      onBlur: ge,
      ref: (ae) => {
        if (ae) {
          Je(J, T), z = an(i, J);
          const V = ht(ae.value) && ae.querySelectorAll && ae.querySelectorAll("input,select,textarea")[0] || ae, Q = Qq(V), me = z._f.refs || [];
          if (Q ? me.find((_e) => _e === V) : V === z._f.ref)
            return;
          at(i, J, {
            _f: {
              ...z._f,
              ...Q ? {
                refs: [
                  ...me.filter(Fm),
                  V,
                  ...Array.isArray(an(a, J)) ? [{}] : []
                ],
                ref: { type: V.type, name: J }
              } : { ref: V }
            }
          }), w(J, !1, void 0, V);
        } else
          z = an(i, J, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(K1(l.array, J) && s.action) && l.unMount.add(J);
      }
    };
  }, Ce = () => n.shouldFocusError && jo(i, U, l.mount), Me = (J) => {
    sr(J) && (h.state.next({ disabled: J }), jo(i, (T, z) => {
      const X = an(i, z);
      X && (T.disabled = X._f.disabled || J, Array.isArray(X._f.refs) && X._f.refs.forEach((ae) => {
        ae.disabled = X._f.disabled || J;
      }));
    }, 0, !1));
  }, nn = (J, T) => async (z) => {
    let X;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let ae = Rt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: Q } = await K();
      r.errors = V, ae = Q;
    } else
      await G(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        at(ae, V, void 0);
    if (Nt(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await J(ae, z);
      } catch (V) {
        X = V;
      }
    } else
      T && await T({ ...r.errors }, z), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, se = (J, T = {}) => {
    an(i, J) && (ht(T.defaultValue) ? ue(J, Rt(an(a, J))) : (ue(J, T.defaultValue), at(a, J, Rt(T.defaultValue))), T.keepTouched || Nt(r.touchedFields, J), T.keepDirty || (Nt(r.dirtyFields, J), r.isDirty = T.defaultValue ? R(J, Rt(an(a, J))) : R()), T.keepError || (Nt(r.errors, J), u.isValid && x()), h.state.next({ ...r }));
  }, le = (J, T = {}) => {
    const z = J ? Rt(J) : a, X = Rt(z), ae = Kt(J), V = ae ? a : X;
    if (T.keepDefaultValues || (a = z), !T.keepValues) {
      if (T.keepDirtyValues) {
        const Q = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(so(a, o))
        ]);
        for (const me of Array.from(Q))
          an(r.dirtyFields, me) ? at(V, me, an(o, me)) : ue(me, an(V, me));
      } else {
        if (kg && ht(J))
          for (const Q of l.mount) {
            const me = an(i, Q);
            if (me && me._f) {
              const _e = Array.isArray(me._f.refs) ? me._f.refs[0] : me._f.ref;
              if (fl(_e)) {
                const Te = _e.closest("form");
                if (Te) {
                  Te.reset();
                  break;
                }
              }
            }
          }
        for (const Q of l.mount)
          ue(Q, an(V, Q));
      }
      o = Rt(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: ae ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !pi(J, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ae ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? so(a, o) : r.dirtyFields : T.keepDefaultValues && J ? so(a, J) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (J, T) => le(Ir(J) ? J(o) : J, T), Le = (J, T = {}) => {
    const z = an(i, J), X = z && z._f;
    if (X) {
      const ae = X.refs ? X.refs[0] : X.ref;
      ae.focus && (ae.focus(), T.shouldSelect && Ir(ae.select) && ae.select());
    }
  }, Pe = (J) => {
    r = {
      ...r,
      ...J
    };
  }, gn = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: W,
      handleSubmit: nn,
      setError: sn,
      _subscribe: Ue,
      _runSchema: K,
      _getWatch: q,
      _getDirty: R,
      _setValid: x,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: C,
      _getFieldArray: te,
      _reset: le,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((J) => {
        Se(J, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: H,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(J) {
        s = J;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(J) {
        l = J;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(J) {
        n = {
          ...n,
          ...J
        };
      }
    },
    subscribe: Re,
    trigger: be,
    register: Je,
    handleSubmit: nn,
    watch: Fe,
    setValue: ue,
    getValues: $e,
    reset: Se,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Le,
    getFieldState: W
  };
  return {
    ...gn,
    formControl: gn
  };
}
function c6(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : l6(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !pi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Y1(i, o), n.current;
}
var _s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Im = { exports: {} }, co = {}, LS;
function d6() {
  if (LS) return co;
  LS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var Ss = {}, VS;
function u6() {
  return VS || (VS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ss.Fragment = i, Ss.jsx = Un, Ss.jsxs = Kn;
  })()), Ss;
}
var zS;
function m6() {
  return zS || (zS = 1, process.env.NODE_ENV === "production" ? Im.exports = d6() : Im.exports = u6()), Im.exports;
}
var wo = m6();
function p6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Em, US;
function ki() {
  if (US) return Em;
  US = 1;
  var e = Array.isArray;
  return Em = e, Em;
}
var $m, MS;
function iF() {
  if (MS) return $m;
  MS = 1;
  var e = typeof _s == "object" && _s && _s.Object === Object && _s;
  return $m = e, $m;
}
var Tm, BS;
function Kr() {
  if (BS) return Tm;
  BS = 1;
  var e = iF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Tm = r, Tm;
}
var Dm, qS;
function Ko() {
  if (qS) return Dm;
  qS = 1;
  var e = Kr(), n = e.Symbol;
  return Dm = n, Dm;
}
var Om, HS;
function f6() {
  if (HS) return Om;
  HS = 1;
  var e = Ko(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Om = o, Om;
}
var Rm, WS;
function h6() {
  if (WS) return Rm;
  WS = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Rm = r, Rm;
}
var Pm, KS;
function Ea() {
  if (KS) return Pm;
  KS = 1;
  var e = Ko(), n = f6(), r = h6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Pm = s, Pm;
}
var Am, GS;
function Hi() {
  if (GS) return Am;
  GS = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Am = e, Am;
}
var Lm, YS;
function Ng() {
  if (YS) return Lm;
  YS = 1;
  var e = Ea(), n = Hi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Lm = i, Lm;
}
var Vm, QS;
function y6() {
  if (QS) return Vm;
  QS = 1;
  var e = ki(), n = Ng(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Vm = a, Vm;
}
var zm, JS;
function $a() {
  if (JS) return zm;
  JS = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return zm = e, zm;
}
var Um, XS;
function aF() {
  if (XS) return Um;
  XS = 1;
  var e = Ea(), n = $a(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Um = s, Um;
}
var Mm, ZS;
function g6() {
  if (ZS) return Mm;
  ZS = 1;
  var e = Kr(), n = e["__core-js_shared__"];
  return Mm = n, Mm;
}
var Bm, e0;
function v6() {
  if (e0) return Bm;
  e0 = 1;
  var e = g6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Bm = r, Bm;
}
var qm, n0;
function oF() {
  if (n0) return qm;
  n0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return qm = r, qm;
}
var Hm, t0;
function k6() {
  if (t0) return Hm;
  t0 = 1;
  var e = aF(), n = v6(), r = $a(), i = oF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Hm = f, Hm;
}
var Wm, r0;
function b6() {
  if (r0) return Wm;
  r0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Wm = e, Wm;
}
var Km, i0;
function Wi() {
  if (i0) return Km;
  i0 = 1;
  var e = k6(), n = b6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Km = r, Km;
}
var Gm, a0;
function Wl() {
  if (a0) return Gm;
  a0 = 1;
  var e = Wi(), n = e(Object, "create");
  return Gm = n, Gm;
}
var Ym, o0;
function x6() {
  if (o0) return Ym;
  o0 = 1;
  var e = Wl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ym = n, Ym;
}
var Qm, s0;
function _6() {
  if (s0) return Qm;
  s0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Qm = e, Qm;
}
var Jm, l0;
function S6() {
  if (l0) return Jm;
  l0 = 1;
  var e = Wl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Jm = a, Jm;
}
var Xm, c0;
function N6() {
  if (c0) return Xm;
  c0 = 1;
  var e = Wl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Xm = i, Xm;
}
var Zm, d0;
function j6() {
  if (d0) return Zm;
  d0 = 1;
  var e = Wl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Zm = r, Zm;
}
var ep, u0;
function w6() {
  if (u0) return ep;
  u0 = 1;
  var e = x6(), n = _6(), r = S6(), i = N6(), a = j6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ep = o, ep;
}
var np, m0;
function C6() {
  if (m0) return np;
  m0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return np = e, np;
}
var tp, p0;
function sF() {
  if (p0) return tp;
  p0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return tp = e, tp;
}
var rp, f0;
function Kl() {
  if (f0) return rp;
  f0 = 1;
  var e = sF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return rp = n, rp;
}
var ip, h0;
function F6() {
  if (h0) return ip;
  h0 = 1;
  var e = Kl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ip = i, ip;
}
var ap, y0;
function I6() {
  if (y0) return ap;
  y0 = 1;
  var e = Kl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return ap = n, ap;
}
var op, g0;
function E6() {
  if (g0) return op;
  g0 = 1;
  var e = Kl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return op = n, op;
}
var sp, v0;
function $6() {
  if (v0) return sp;
  v0 = 1;
  var e = Kl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return sp = n, sp;
}
var lp, k0;
function Gl() {
  if (k0) return lp;
  k0 = 1;
  var e = C6(), n = F6(), r = I6(), i = E6(), a = $6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, lp = o, lp;
}
var cp, b0;
function jg() {
  if (b0) return cp;
  b0 = 1;
  var e = Wi(), n = Kr(), r = e(n, "Map");
  return cp = r, cp;
}
var dp, x0;
function T6() {
  if (x0) return dp;
  x0 = 1;
  var e = w6(), n = Gl(), r = jg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return dp = i, dp;
}
var up, _0;
function D6() {
  if (_0) return up;
  _0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return up = e, up;
}
var mp, S0;
function Yl() {
  if (S0) return mp;
  S0 = 1;
  var e = D6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return mp = n, mp;
}
var pp, N0;
function O6() {
  if (N0) return pp;
  N0 = 1;
  var e = Yl();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return pp = n, pp;
}
var fp, j0;
function R6() {
  if (j0) return fp;
  j0 = 1;
  var e = Yl();
  function n(r) {
    return e(this, r).get(r);
  }
  return fp = n, fp;
}
var hp, w0;
function P6() {
  if (w0) return hp;
  w0 = 1;
  var e = Yl();
  function n(r) {
    return e(this, r).has(r);
  }
  return hp = n, hp;
}
var yp, C0;
function A6() {
  if (C0) return yp;
  C0 = 1;
  var e = Yl();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return yp = n, yp;
}
var gp, F0;
function lF() {
  if (F0) return gp;
  F0 = 1;
  var e = T6(), n = O6(), r = R6(), i = P6(), a = A6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, gp = o, gp;
}
var vp, I0;
function L6() {
  if (I0) return vp;
  I0 = 1;
  var e = lF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, vp = r, vp;
}
var kp, E0;
function V6() {
  if (E0) return kp;
  E0 = 1;
  var e = L6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return kp = r, kp;
}
var bp, $0;
function z6() {
  if ($0) return bp;
  $0 = 1;
  var e = V6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return bp = i, bp;
}
var xp, T0;
function cF() {
  if (T0) return xp;
  T0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return xp = e, xp;
}
var _p, D0;
function U6() {
  if (D0) return _p;
  D0 = 1;
  var e = Ko(), n = cF(), r = ki(), i = Ng(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return _p = s, _p;
}
var Sp, O0;
function M6() {
  if (O0) return Sp;
  O0 = 1;
  var e = U6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Sp = n, Sp;
}
var Np, R0;
function Ta() {
  if (R0) return Np;
  R0 = 1;
  var e = ki(), n = y6(), r = z6(), i = M6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Np = a, Np;
}
var jp, P0;
function Ql() {
  if (P0) return jp;
  P0 = 1;
  var e = Ng();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return jp = n, jp;
}
var wp, A0;
function dF() {
  if (A0) return wp;
  A0 = 1;
  var e = Ta(), n = Ql();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return wp = r, wp;
}
var Cp, L0;
function uF() {
  if (L0) return Cp;
  L0 = 1;
  var e = Wi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Cp = n, Cp;
}
var Fp, V0;
function mF() {
  if (V0) return Fp;
  V0 = 1;
  var e = uF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Fp = n, Fp;
}
var Ip, z0;
function wg() {
  if (z0) return Ip;
  z0 = 1;
  var e = mF(), n = sF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Ip = a, Ip;
}
var Ep, U0;
function Cg() {
  if (U0) return Ep;
  U0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Ep = r, Ep;
}
var $p, M0;
function B6() {
  if (M0) return $p;
  M0 = 1;
  var e = wg(), n = Ta(), r = Cg(), i = $a(), a = Ql();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var F = a(l[u]), j = d;
      if (F === "__proto__" || F === "constructor" || F === "prototype")
        return s;
      if (u != h) {
        var N = k[F];
        j = m ? m(N, F, k) : void 0, j === void 0 && (j = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(k, F, j), k = k[F];
    }
    return s;
  }
  return $p = o, $p;
}
var Tp, B0;
function q6() {
  if (B0) return Tp;
  B0 = 1;
  var e = dF(), n = B6(), r = Ta();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Tp = i, Tp;
}
var Dp, q0;
function H6() {
  if (q0) return Dp;
  q0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Dp = e, Dp;
}
var Op, H0;
function W6() {
  if (H0) return Op;
  H0 = 1;
  var e = Ea(), n = Hi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Op = i, Op;
}
var Rp, W0;
function Fg() {
  if (W0) return Rp;
  W0 = 1;
  var e = W6(), n = Hi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Rp = o, Rp;
}
var Pp, K0;
function Ig() {
  if (K0) return Pp;
  K0 = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Pp = n, Pp;
}
var Ap, G0;
function K6() {
  if (G0) return Ap;
  G0 = 1;
  var e = Ta(), n = Fg(), r = ki(), i = Cg(), a = Ig(), o = Ql();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Ap = s, Ap;
}
var Lp, Y0;
function G6() {
  if (Y0) return Lp;
  Y0 = 1;
  var e = H6(), n = K6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Lp = r, Lp;
}
var Vp, Q0;
function Y6() {
  if (Q0) return Vp;
  Q0 = 1;
  var e = q6(), n = G6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Vp = r, Vp;
}
var zp, J0;
function Eg() {
  if (J0) return zp;
  J0 = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return zp = e, zp;
}
var Up, X0;
function Q6() {
  if (X0) return Up;
  X0 = 1;
  var e = Ko(), n = Fg(), r = ki(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Up = a, Up;
}
var Mp, Z0;
function J6() {
  if (Z0) return Mp;
  Z0 = 1;
  var e = Eg(), n = Q6();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Mp = r, Mp;
}
var Bp, eN;
function X6() {
  if (eN) return Bp;
  eN = 1;
  var e = J6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Bp = n, Bp;
}
var qp, nN;
function Z6() {
  if (nN) return qp;
  nN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return qp = e, qp;
}
var Hp, tN;
function eH() {
  if (tN) return Hp;
  tN = 1;
  var e = Z6(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Hp = r, Hp;
}
var Wp, rN;
function nH() {
  if (rN) return Wp;
  rN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Wp = e, Wp;
}
var Kp, iN;
function pF() {
  if (iN) return Kp;
  iN = 1;
  function e(n) {
    return n;
  }
  return Kp = e, Kp;
}
var Gp, aN;
function tH() {
  if (aN) return Gp;
  aN = 1;
  var e = nH(), n = uF(), r = pF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Gp = i, Gp;
}
var Yp, oN;
function rH() {
  if (oN) return Yp;
  oN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Yp = i, Yp;
}
var Qp, sN;
function iH() {
  if (sN) return Qp;
  sN = 1;
  var e = tH(), n = rH(), r = n(e);
  return Qp = r, Qp;
}
var Jp, lN;
function fF() {
  if (lN) return Jp;
  lN = 1;
  var e = X6(), n = eH(), r = iH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Jp = i, Jp;
}
var Xp, cN;
function aH() {
  if (cN) return Xp;
  cN = 1;
  var e = Y6(), n = fF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Xp = r, Xp;
}
var oH = aH();
const hF = /* @__PURE__ */ rF(oH), sH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function yF(e) {
  const n = hF(e, sH);
  return {
    controller: Gq(n),
    controllerProps: n
  };
}
const lH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function cH(e) {
  const { controller: n, controllerProps: r } = yF(e), i = {
    ...hF(e, lH),
    required: p6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Zp, dN;
function dH() {
  if (dN) return Zp;
  dN = 1;
  var e = Gl();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Zp = n, Zp;
}
var ef, uN;
function uH() {
  if (uN) return ef;
  uN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return ef = e, ef;
}
var nf, mN;
function mH() {
  if (mN) return nf;
  mN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return nf = e, nf;
}
var tf, pN;
function pH() {
  if (pN) return tf;
  pN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return tf = e, tf;
}
var rf, fN;
function fH() {
  if (fN) return rf;
  fN = 1;
  var e = Gl(), n = jg(), r = lF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return rf = a, rf;
}
var af, hN;
function hH() {
  if (hN) return af;
  hN = 1;
  var e = Gl(), n = dH(), r = uH(), i = mH(), a = pH(), o = fH();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, af = s, af;
}
var of, yN;
function yH() {
  if (yN) return of;
  yN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return of = e, of;
}
var sf, gN;
function Go() {
  if (gN) return sf;
  gN = 1;
  var e = wg(), n = mF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return sf = r, sf;
}
var lf, vN;
function gH() {
  if (vN) return lf;
  vN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return lf = e, lf;
}
var Hs = { exports: {} }, cf, kN;
function vH() {
  if (kN) return cf;
  kN = 1;
  function e() {
    return !1;
  }
  return cf = e, cf;
}
Hs.exports;
var bN;
function gF() {
  return bN || (bN = 1, (function(e, n) {
    var r = Kr(), i = vH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Hs, Hs.exports)), Hs.exports;
}
var df, xN;
function kH() {
  if (xN) return df;
  xN = 1;
  var e = Ea(), n = Ig(), r = Hi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", F = "[object String]", j = "[object WeakMap]", N = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", I = "[object Int8Array]", C = "[object Int16Array]", w = "[object Int32Array]", A = "[object Uint8Array]", B = "[object Uint8ClampedArray]", K = "[object Uint16Array]", ee = "[object Uint32Array]", G = {};
  G[g] = G[O] = G[I] = G[C] = G[w] = G[A] = G[B] = G[K] = G[ee] = !0, G[i] = G[a] = G[N] = G[o] = G[x] = G[s] = G[l] = G[d] = G[m] = G[u] = G[f] = G[h] = G[k] = G[F] = G[j] = !1;
  function H(R) {
    return r(R) && n(R.length) && !!G[e(R)];
  }
  return df = H, df;
}
var uf, _N;
function $g() {
  if (_N) return uf;
  _N = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return uf = e, uf;
}
var Ws = { exports: {} };
Ws.exports;
var SN;
function Tg() {
  return SN || (SN = 1, (function(e, n) {
    var r = iF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Ws, Ws.exports)), Ws.exports;
}
var mf, NN;
function bH() {
  if (NN) return mf;
  NN = 1;
  var e = kH(), n = $g(), r = Tg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return mf = a, mf;
}
var pf, jN;
function vF() {
  if (jN) return pf;
  jN = 1;
  var e = gH(), n = Fg(), r = ki(), i = gF(), a = Cg(), o = bH(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), F = !f && !h && !k && o(m), j = f || h || k || F, N = j ? e(m.length, String) : [], x = N.length;
    for (var g in m)
      (u || l.call(m, g)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      F && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, x))) && N.push(g);
    return N;
  }
  return pf = d, pf;
}
var ff, wN;
function Dg() {
  if (wN) return ff;
  wN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return ff = n, ff;
}
var hf, CN;
function kF() {
  if (CN) return hf;
  CN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return hf = e, hf;
}
var yf, FN;
function xH() {
  if (FN) return yf;
  FN = 1;
  var e = kF(), n = e(Object.keys, Object);
  return yf = n, yf;
}
var gf, IN;
function _H() {
  if (IN) return gf;
  IN = 1;
  var e = Dg(), n = xH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return gf = a, gf;
}
var vf, EN;
function bF() {
  if (EN) return vf;
  EN = 1;
  var e = aF(), n = Ig();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return vf = r, vf;
}
var kf, $N;
function Og() {
  if ($N) return kf;
  $N = 1;
  var e = vF(), n = _H(), r = bF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return kf = i, kf;
}
var bf, TN;
function SH() {
  if (TN) return bf;
  TN = 1;
  var e = Go(), n = Og();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return bf = r, bf;
}
var xf, DN;
function NH() {
  if (DN) return xf;
  DN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return xf = e, xf;
}
var _f, ON;
function jH() {
  if (ON) return _f;
  ON = 1;
  var e = $a(), n = Dg(), r = NH(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return _f = o, _f;
}
var Sf, RN;
function Rg() {
  if (RN) return Sf;
  RN = 1;
  var e = vF(), n = jH(), r = bF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Sf = i, Sf;
}
var Nf, PN;
function wH() {
  if (PN) return Nf;
  PN = 1;
  var e = Go(), n = Rg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Nf = r, Nf;
}
var Ks = { exports: {} };
Ks.exports;
var AN;
function CH() {
  return AN || (AN = 1, (function(e, n) {
    var r = Kr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Ks, Ks.exports)), Ks.exports;
}
var jf, LN;
function FH() {
  if (LN) return jf;
  LN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return jf = e, jf;
}
var wf, VN;
function IH() {
  if (VN) return wf;
  VN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return wf = e, wf;
}
var Cf, zN;
function xF() {
  if (zN) return Cf;
  zN = 1;
  function e() {
    return [];
  }
  return Cf = e, Cf;
}
var Ff, UN;
function Pg() {
  if (UN) return Ff;
  UN = 1;
  var e = IH(), n = xF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Ff = o, Ff;
}
var If, MN;
function EH() {
  if (MN) return If;
  MN = 1;
  var e = Go(), n = Pg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return If = r, If;
}
var Ef, BN;
function Ag() {
  if (BN) return Ef;
  BN = 1;
  var e = kF(), n = e(Object.getPrototypeOf, Object);
  return Ef = n, Ef;
}
var $f, qN;
function _F() {
  if (qN) return $f;
  qN = 1;
  var e = Eg(), n = Ag(), r = Pg(), i = xF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return $f = o, $f;
}
var Tf, HN;
function $H() {
  if (HN) return Tf;
  HN = 1;
  var e = Go(), n = _F();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Tf = r, Tf;
}
var Df, WN;
function SF() {
  if (WN) return Df;
  WN = 1;
  var e = Eg(), n = ki();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Df = r, Df;
}
var Of, KN;
function TH() {
  if (KN) return Of;
  KN = 1;
  var e = SF(), n = Pg(), r = Og();
  function i(a) {
    return e(a, r, n);
  }
  return Of = i, Of;
}
var Rf, GN;
function NF() {
  if (GN) return Rf;
  GN = 1;
  var e = SF(), n = _F(), r = Rg();
  function i(a) {
    return e(a, r, n);
  }
  return Rf = i, Rf;
}
var Pf, YN;
function DH() {
  if (YN) return Pf;
  YN = 1;
  var e = Wi(), n = Kr(), r = e(n, "DataView");
  return Pf = r, Pf;
}
var Af, QN;
function OH() {
  if (QN) return Af;
  QN = 1;
  var e = Wi(), n = Kr(), r = e(n, "Promise");
  return Af = r, Af;
}
var Lf, JN;
function RH() {
  if (JN) return Lf;
  JN = 1;
  var e = Wi(), n = Kr(), r = e(n, "Set");
  return Lf = r, Lf;
}
var Vf, XN;
function PH() {
  if (XN) return Vf;
  XN = 1;
  var e = Wi(), n = Kr(), r = e(n, "WeakMap");
  return Vf = r, Vf;
}
var zf, ZN;
function Lg() {
  if (ZN) return zf;
  ZN = 1;
  var e = DH(), n = jg(), r = OH(), i = RH(), a = PH(), o = Ea(), s = oF(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), F = s(n), j = s(r), N = s(i), x = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var I = o(O), C = I == d ? O.constructor : void 0, w = C ? s(C) : "";
    if (w)
      switch (w) {
        case k:
          return h;
        case F:
          return l;
        case j:
          return m;
        case N:
          return u;
        case x:
          return f;
      }
    return I;
  }), zf = g, zf;
}
var Uf, ej;
function AH() {
  if (ej) return Uf;
  ej = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Uf = r, Uf;
}
var Mf, nj;
function LH() {
  if (nj) return Mf;
  nj = 1;
  var e = Kr(), n = e.Uint8Array;
  return Mf = n, Mf;
}
var Bf, tj;
function Vg() {
  if (tj) return Bf;
  tj = 1;
  var e = LH();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Bf = n, Bf;
}
var qf, rj;
function VH() {
  if (rj) return qf;
  rj = 1;
  var e = Vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return qf = n, qf;
}
var Hf, ij;
function zH() {
  if (ij) return Hf;
  ij = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Hf = n, Hf;
}
var Wf, aj;
function UH() {
  if (aj) return Wf;
  aj = 1;
  var e = Ko(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Wf = i, Wf;
}
var Kf, oj;
function MH() {
  if (oj) return Kf;
  oj = 1;
  var e = Vg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Kf = n, Kf;
}
var Gf, sj;
function BH() {
  if (sj) return Gf;
  sj = 1;
  var e = Vg(), n = VH(), r = zH(), i = UH(), a = MH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", F = "[object DataView]", j = "[object Float32Array]", N = "[object Float64Array]", x = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", I = "[object Uint8Array]", C = "[object Uint8ClampedArray]", w = "[object Uint16Array]", A = "[object Uint32Array]";
  function B(K, ee, G) {
    var H = K.constructor;
    switch (ee) {
      case k:
        return e(K);
      case o:
      case s:
        return new H(+K);
      case F:
        return n(K, G);
      case j:
      case N:
      case x:
      case g:
      case O:
      case I:
      case C:
      case w:
      case A:
        return a(K, G);
      case l:
        return new H();
      case d:
      case f:
        return new H(K);
      case m:
        return r(K);
      case u:
        return new H();
      case h:
        return i(K);
    }
  }
  return Gf = B, Gf;
}
var Yf, lj;
function qH() {
  if (lj) return Yf;
  lj = 1;
  var e = $a(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Yf = r, Yf;
}
var Qf, cj;
function HH() {
  if (cj) return Qf;
  cj = 1;
  var e = qH(), n = Ag(), r = Dg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Qf = i, Qf;
}
var Jf, dj;
function WH() {
  if (dj) return Jf;
  dj = 1;
  var e = Lg(), n = Hi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jf = i, Jf;
}
var Xf, uj;
function KH() {
  if (uj) return Xf;
  uj = 1;
  var e = WH(), n = $g(), r = Tg(), i = r && r.isMap, a = i ? n(i) : e;
  return Xf = a, Xf;
}
var Zf, mj;
function GH() {
  if (mj) return Zf;
  mj = 1;
  var e = Lg(), n = Hi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Zf = i, Zf;
}
var eh, pj;
function YH() {
  if (pj) return eh;
  pj = 1;
  var e = GH(), n = $g(), r = Tg(), i = r && r.isSet, a = i ? n(i) : e;
  return eh = a, eh;
}
var nh, fj;
function QH() {
  if (fj) return nh;
  fj = 1;
  var e = hH(), n = yH(), r = wg(), i = SH(), a = wH(), o = CH(), s = FH(), l = EH(), d = $H(), m = TH(), u = NF(), f = Lg(), h = AH(), k = BH(), F = HH(), j = ki(), N = gF(), x = KH(), g = $a(), O = YH(), I = Og(), C = Rg(), w = 1, A = 2, B = 4, K = "[object Arguments]", ee = "[object Array]", G = "[object Boolean]", H = "[object Date]", R = "[object Error]", q = "[object Function]", te = "[object GeneratorFunction]", we = "[object Map]", ve = "[object Number]", ue = "[object Object]", ge = "[object RegExp]", U = "[object Set]", be = "[object String]", $e = "[object Symbol]", W = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Fe = "[object Float32Array]", Ue = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", Ce = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", nn = "[object Uint32Array]", se = {};
  se[K] = se[ee] = se[Ge] = se[sn] = se[G] = se[H] = se[Fe] = se[Ue] = se[Re] = se[Be] = se[Ae] = se[we] = se[ve] = se[ue] = se[ge] = se[U] = se[be] = se[$e] = se[Je] = se[Ce] = se[Me] = se[nn] = !0, se[R] = se[q] = se[W] = !1;
  function le(Se, Le, Pe, gn, J, T) {
    var z, X = Le & w, ae = Le & A, V = Le & B;
    if (Pe && (z = J ? Pe(Se, gn, J, T) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var Q = j(Se);
    if (Q) {
      if (z = h(Se), !X)
        return s(Se, z);
    } else {
      var me = f(Se), _e = me == q || me == te;
      if (N(Se))
        return o(Se, X);
      if (me == ue || me == K || _e && !J) {
        if (z = ae || _e ? {} : F(Se), !X)
          return ae ? d(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[me])
          return J ? Se : {};
        z = k(Se, me, X);
      }
    }
    T || (T = new e());
    var Te = T.get(Se);
    if (Te)
      return Te;
    T.set(Se, z), O(Se) ? Se.forEach(function(on) {
      z.add(le(on, Le, Pe, on, Se, T));
    }) : x(Se) && Se.forEach(function(on, pn) {
      z.set(pn, le(on, Le, Pe, pn, Se, T));
    });
    var tn = V ? ae ? u : m : ae ? C : I, vn = Q ? void 0 : tn(Se);
    return n(vn || Se, function(on, pn) {
      vn && (pn = on, on = Se[pn]), r(z, pn, le(on, Le, Pe, pn, Se, T));
    }), z;
  }
  return nh = le, nh;
}
var th, hj;
function JH() {
  if (hj) return th;
  hj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return th = e, th;
}
var rh, yj;
function XH() {
  if (yj) return rh;
  yj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return rh = e, rh;
}
var ih, gj;
function ZH() {
  if (gj) return ih;
  gj = 1;
  var e = dF(), n = XH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return ih = r, ih;
}
var ah, vj;
function eW() {
  if (vj) return ah;
  vj = 1;
  var e = Ta(), n = JH(), r = ZH(), i = Ql(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return ah = s, ah;
}
var oh, kj;
function nW() {
  if (kj) return oh;
  kj = 1;
  var e = Ea(), n = Ag(), r = Hi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return oh = m, oh;
}
var sh, bj;
function tW() {
  if (bj) return sh;
  bj = 1;
  var e = nW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return sh = n, sh;
}
var lh, xj;
function rW() {
  if (xj) return lh;
  xj = 1;
  var e = cF(), n = QH(), r = eW(), i = Ta(), a = Go(), o = tW(), s = fF(), l = NF(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var F = {};
    if (h == null)
      return F;
    var j = !1;
    k = e(k, function(x) {
      return x = i(x, h), j || (j = x.length > 1), x;
    }), a(h, l(h), F), j && (F = n(F, d | m | u, o));
    for (var N = k.length; N--; )
      r(F, k[N]);
    return F;
  });
  return lh = f, lh;
}
rW();
var iW = pF();
const aW = /* @__PURE__ */ rF(iW), ra = ({
  transformValue: e = aW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = yF(a);
  return /* @__PURE__ */ wo.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ wo.jsx(
      Io,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ wo.jsx(bw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, _j = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = cH(e);
  return /* @__PURE__ */ wo.jsx(He, { ...i, children: /* @__PURE__ */ wo.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
}, oy = [
  {
    key: "rivoLoyaltyApiKey",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: vg,
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Sj = "RIVOLOYALTY", Ns = "Rivo Loyalty", oW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [vg]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, sW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = c6({
    mode: "onChange",
    defaultValues: oW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: Sj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: oy,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: oy,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ ke.jsx(hr, { cause: h }),
        /* @__PURE__ */ ke.jsxs(nt, { children: [
          /* @__PURE__ */ ke.jsx(Z, { children: /* @__PURE__ */ ke.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
            _j,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
            _j,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: "Shopify API host name",
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (B) => bl(B) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(
            Er,
            {
              name: "rivoLoyaltyApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: "Show orders overview", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: "Show loyalty", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: "Allow adjusting loyalty points", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: "Show favorite products", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ke.jsx(Z, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: "Show available rewards", children: /* @__PURE__ */ ke.jsx(
            ra,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && O !== null && /* @__PURE__ */ ke.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          yr,
          {
            integrationType: Sj,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ke.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ke.jsx(
                ye,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ns,
                  " integration, all links between Dixa and ",
                  Ns,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ke.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ns,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ke.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ns,
                  " ",
                  'integration "',
                  A,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ch = { exports: {} }, uo = {}, Nj;
function lW() {
  if (Nj) return uo;
  Nj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return uo.Fragment = r, uo.jsx = s, uo.jsxs = s, uo;
}
var js = {}, jj;
function cW() {
  return jj || (jj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    js.Fragment = i, js.jsx = Un, js.jsxs = Kn;
  })()), js;
}
var wj;
function dW() {
  return wj || (wj = 1, process.env.NODE_ENV === "production" ? ch.exports = lW() : ch.exports = cW()), ch.exports;
}
var v = dW();
const Cj = "__PairingContext__", uW = () => globalThis[Cj] ?? (() => {
  const e = kw({});
  return globalThis[Cj] = e, e;
})(), mW = uW(), pW = () => hy(mW), fW = "_banner_d9pot_1", hW = "_list_d9pot_8", Fj = {
  banner: fW,
  list: hW
}, Ij = "https://apps.shopify.com/dixa-dashboard", yW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, gl = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = pW(), [i, a] = de(!1), [o, s] = de(null), l = yW[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Ij,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Ij, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: Fj.banner, children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(ye, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx($.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx($.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(m, { className: Fj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx($.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      et,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, vl = [
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Ej = "SHOPIFY", gW = [
  { name: "displayRefundOrder", label: "Display the refund order button" },
  {
    name: "displayPartialRefundOrder",
    label: "Displays the partial refund order button"
  },
  { name: "displayCancelOrder", label: "Displays the cancel order button" },
  {
    name: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button'
  },
  { name: "displayOrdersOverview", label: "Displays short orders overview" },
  {
    name: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer"
  },
  {
    name: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer"
  },
  { name: "displayDiscountCodes", label: "Displays available discount codes" },
  {
    name: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button"
  },
  { name: "displayCreateOrder", label: "Displays the create order button" },
  {
    name: "displayCreateDraftOrder",
    label: "Displays the create draft order button"
  },
  {
    name: "displayDuplicateOrder",
    label: "Displays the duplicate order button"
  }
], vW = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    vl
  )
}, kW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: vW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: Ej,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: vl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = g?.additionalProperties, A = w?.tokenSource === "marketplace_app", B = !!w?.isUsingOAuth, K = !A, ee = (H) => fr(H, {
    fieldDefinitions: vl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), G = s.watch("name");
  return /* @__PURE__ */ v.jsx(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: ee,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: o ? /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(
        gl,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(hr, { cause: h }),
        /* @__PURE__ */ v.jsxs(nt, { children: [
          K && /* @__PURE__ */ v.jsx(
            gl,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ v.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          K && B && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientId",
                label: "Client ID",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientSecret",
                label: "Client Secret",
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          K && !B && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "apiAccessToken",
                label: "API Access Token",
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          A ? /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            An,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (H) => bl(H) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          gW.map(({ name: H, label: R }) => /* @__PURE__ */ v.jsxs(vw, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(He, { label: R, children: /* @__PURE__ */ v.jsx(
              xn,
              {
                name: H,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }, H)),
          a && O !== null && /* @__PURE__ */ v.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ v.jsx(
          yr,
          {
            integrationType: Ej,
            integrationId: e,
            widgetName: G,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ] })
    }
  );
}, bW = (e) => /* @__PURE__ */ v.jsx(gl, { ...e, bannerVariant: "install" }), xW = (e) => /* @__PURE__ */ v.jsx(gl, { ...e, bannerVariant: "migration" }), _W = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], SW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], NW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: bW
  }
], jW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], $j = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: xW,
    additionalProperties: { renderAboveForm: !0 }
  }
], jF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Tj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => bl(e)
  },
  ...jF
];
var oa = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(oa || {}), Ai = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Ai || {}), zr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(zr || {}), wF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(wF || {}), sy = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(sy || {}), Ei = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Ei || {}), ei = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(ei || {}), Gs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Gs || {}), CF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(CF || {});
const wW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, CW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, FW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, IW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, EW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, $W = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, TW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, DW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, RW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, PW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, AW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, LW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, VW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, zW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, UW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, MW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, BW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": wW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": CW,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": FW,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": IW,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": EW,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": $W,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": TW,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": DW,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": OW,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": RW,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": PW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": AW,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": LW,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": VW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zW,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": UW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": MW
};
function gr(e) {
  return BW[e] ?? {};
}
const qW = gr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), HW = gr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), WW = gr(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), KW = gr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), GW = gr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), zg = gr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), YW = gr(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), QW = gr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), JW = gr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), XW = gr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), ZW = gr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), e9 = gr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), n9 = gr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), FF = Fl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, t9 = Fl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, r9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = yn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: d,
    error: m,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(qW, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: d,
    customerError: m,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, i9 = () => {
  const { useLazyQuery: e } = yn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(HW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Br(e = !1, n) {
  const [r, i] = de(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const IF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: CF.Refund,
  orderId: e,
  parentId: a?.id
})), EF = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), a9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: IF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Dj = [
  {
    value: ei.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: ei.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: ei.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: ei.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: ei.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: ei.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: ei.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Oj = [
  {
    value: Gs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Gs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Gs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], $F = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), sa = (e) => o9(s9(e)), o9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), s9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, TF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = yn(), {
    data: s,
    previousData: l,
    loading: d,
    error: m
  } = o(WW, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Yn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: IF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: d, error: m };
}, l9 = {
  nodes: [],
  hasMoreResults: !1
}, Rj = (e) => "codes" in e.discount ? e.discount.codes.nodes[0]?.code ?? "" : "", c9 = (e) => [...e].sort(
  (n, r) => Rj(n).localeCompare(Rj(r))
), d9 = (e) => {
  const n = e?.Shopify?.discountNodes;
  return {
    nodes: c9(n?.nodes ?? []),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, u9 = 300, Pj = 2, m9 = 250, DF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = yn(), [i, a] = de(""), [o, s] = de([]), [l, d] = de(!1), [m, u] = de(!1), f = ri(null), h = ri(0), [k] = n(YW, {
    fetchPolicy: "no-cache"
  }), F = (N) => {
    s(N.nodes), d(N.hasMoreResults);
  }, j = async (N, x) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const O = await k({
        variables: { query: N, first: m9 }
      });
      if (g !== h.current)
        return;
      if (O.error)
        throw O.error;
      const I = d9(O.data);
      x && (f.current = I), F(I);
    } catch {
      if (g !== h.current)
        return;
      F(l9), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return gi(
    () => {
      if (!e)
        return;
      const N = i.trim(), x = N.length === 0;
      if (!(!x && N.length < Pj)) {
        if (x && f.current) {
          F(f.current);
          return;
        }
        j(
          x ? void 0 : N,
          x
        );
      }
    },
    u9,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: m,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Pj
  };
}, p9 = "_list_alvh6_1", f9 = "_listItem_alvh6_4", h9 = "_fullWidth_alvh6_15", y9 = "_boxWrapper_alvh6_19", Mt = {
  list: p9,
  listItem: f9,
  fullWidth: h9,
  boxWrapper: y9
}, g9 = "_modal_1vkwz_1", v9 = "_disabled_1vkwz_5", dh = {
  modal: g9,
  disabled: v9
}, Aj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Ai.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Ai.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Ai.Unknown
  }
], Lj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: zr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: zr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: zr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: zr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: zr.Unsubscribed
  }
], k9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = Fn(), { useMutation: l, showNotification: d } = yn(), [m, u] = de(), [f, h] = de(), [k, F] = Fx(!0), [j, N] = Fx(!0), x = !!m, g = e.customer?.email, O = e.customer?.phone_number, I = e.customer?.given_name, C = e.customer?.family_name, w = {
    email: g ?? "",
    phone: O ?? "",
    firstName: I ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, A = mt({
    defaultValues: w
  });
  Qe(() => {
    f?.forEach((R) => {
      const q = R?.field?.[0];
      q && (A.setError(q, {
        type: "server",
        message: R.message
      }), A.setFocus(q));
    });
  }, [f, A]);
  const [B, { error: K, reset: ee }] = l(e9, {
    onError: (R) => {
      u(R.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (R) => {
      const q = R?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), G = yt(
    (R) => {
      a(!0), u(void 0), B({
        variables: {
          input: {
            firstName: R.firstName,
            lastName: R.lastName,
            ...k && { email: R.email },
            ...j && { phone: R.phone },
            ...R.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: R.smsMarketingState,
                marketingOptInLevel: R.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [B, a, j, k]
  ), H = () => {
    r(!1), ee(), u(void 0), A.reset(w);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: H, className: dh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Create new customer", onClose: H }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "First name",
          name: "firstName",
          control: A.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Last name",
          name: "lastName",
          control: A.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Email",
          name: "email",
          control: A.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [dh.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Io,
                {
                  disabled: !j,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => F()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          label: "Phone",
          name: "phone",
          control: A.control,
          rules: {
            required: j ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [dh.disabled]: !j
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Io,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: j,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: A.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = Lj.find(
                (te) => te.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Lj.map((R) => /* @__PURE__ */ v.jsx(ut.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: A.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (R, q) => R === q,
            getItemTitleByValue: (R) => {
              const q = Aj.find(
                (te) => te.value === R
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Aj.map((R) => /* @__PURE__ */ v.jsx(ut.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      x && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ye, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(A.formState.isValid && A.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: A.handleSubmit(G),
        cancelOnClick: H,
        confirmName: K ? "Close" : "Save",
        cancelName: K ? void 0 : "Cancel"
      }
    )
  ] });
}, b9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = de(!1), [a, o] = de(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(ye, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      k9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Ug = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, ly = "DD MMM YYYY @ HH:mm", x9 = "_wrapper_10fld_1", _9 = "_copyIcon_10fld_7", ws = {
  wrapper: x9,
  copyIcon: _9
}, S9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Br(), { isCopied: l, copy: d } = Br(), { track: m } = Fn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: F = [],
    verifiedEmail: j
  } = e, N = h?.emailAddress, x = k?.phoneNumber, g = Ug(u), O = `https://${n}/admin/customers/${g ?? ""}`, I = i && a === rr.refetch, C = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: ws.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: f }),
        I ? /* @__PURE__ */ v.jsx(hn, { size: C }) : /* @__PURE__ */ v.jsx(Ze, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: C,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: ws.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ye, { size: C, name: "mail" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ v.jsx(
            Ze,
            {
              content: j ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                ye,
                {
                  size: C,
                  color: j ? "green.500" : "red.500",
                  name: j ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: ws.copyIcon
          }
        ) })
      ] }),
      x && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ye, { size: C, name: "phone" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `tel:${x}`, children: x })
        ] }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => d(x),
            className: ws.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(ye, { size: C, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          $.ExternalLink,
          {
            href: O,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    F.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: F.map((w) => /* @__PURE__ */ v.jsx(Qn, { children: w }, `${u}-${w}`)) })
    ] })
  ] });
}, N9 = "_creationModal_pbe64_1", j9 = "_detailsModal_pbe64_5", w9 = "_percentageSuffix_pbe64_9", uh = {
  creationModal: N9,
  detailsModal: j9,
  percentageSuffix: w9
}, C9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, F9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: wF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Vj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], zj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Uj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], I9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Qt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(Xe, { children: [
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            ye,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: Jn(e?.startsAt).format(jt) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(He, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      cr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, E9 = "shopify-discount-code-form", Mj = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, $9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = Fn(), { useMutation: i, showNotification: a } = yn(), [o, s] = de(
    []
  ), [l, d] = de(), m = mt({
    mode: "all",
    defaultValues: Mj
  });
  Qe(() => {
    o?.forEach((C) => {
      const w = C?.field?.[1];
      w && m.setError(w, {
        type: "server",
        message: C.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), k = Yn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    F,
    {
      loading: j,
      error: N,
      reset: x
    }
  ] = i(n9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const w = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (w && w.length > 0)
        s(w);
      else {
        const A = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        A && "codes" in A && d(A), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", C9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, O = (C) => {
    F({
      variables: {
        input: F9(C)
      }
    });
  }, I = () => {
    m.reset(Mj), s([]), x(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: I,
      className: dt({
        [uh.creationModal]: !u,
        [uh.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: I
          }
        ),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          u && /* @__PURE__ */ v.jsx(I9, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: E9, onSubmit: m.handleSubmit(O), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              jl,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx($.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(nt, { children: [
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, w) => C === w,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const w = Vj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Vj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: uh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, w) => C === w,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const w = zj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: zj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                An,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                _r,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, w) => C === w,
                    getItemTitleByValue: (C) => {
                      const w = Uj.find(
                        (A) => A.value === C
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: w?.label }) });
                    }
                  },
                  children: Uj.map((C) => /* @__PURE__ */ v.jsx(ut.Item, { value: C.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ v.jsx(Tn, { error: N })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? I : m.handleSubmit(O),
            cancelOnClick: u ? void 0 : I
          }
        )
      ]
    }
  );
}, T9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Br();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(ye, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          ir,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, D9 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ v.jsx(Xe, { children: r.map((i) => /* @__PURE__ */ v.jsx(Xe.Item, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(T9, { code: i.code }) }, i.code)) })
  ] });
}, O9 = "_modal_11d6e_1", R9 = "_modalBody_11d6e_4", P9 = "_codeContainer_11d6e_9", mh = {
  modal: O9,
  modalBody: R9,
  codeContainer: P9
}, A9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = DF({ enabled: e }), l = r.length === 0, d = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: e, onClose: d, className: mh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Discount codes", onClose: d }),
    /* @__PURE__ */ v.jsxs(Ft, { className: mh.modalBody, children: [
      /* @__PURE__ */ v.jsx(
        cr,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (m) => {
            o(m.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
      !i && l && /* @__PURE__ */ v.jsx(
        Eo,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((m) => /* @__PURE__ */ v.jsx("div", { className: mh.codeContainer, children: /* @__PURE__ */ v.jsx(D9, { discountCode: m }) }, m.id))
    ] }),
    /* @__PURE__ */ v.jsx(Et, { confirmName: "Close", confirmOnClick: d })
  ] });
}, L9 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = de(!1), [i, a] = de(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          et,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          et,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      A9,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      $9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, V9 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? fw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case oa.Invalid:
      case oa.NotSubscribed:
      case zr.NotSubscribed:
        return "red.500";
      case oa.Pending:
      case zr.Pending:
      case oa.Unsubscribed:
      case zr.Unsubscribed:
        return "orange.500";
      case oa.Subscribed:
      case zr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Ai.SingleOptIn:
      case Ai.ConfirmedOptIn:
        return "green.500";
      case Ai.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ye, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "info", children: Jn(l).format(ly) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Qn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Qn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ye, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "info", children: Jn(u).format(ly) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Qn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Ze, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Qn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, z9 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== sy.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, U9 = (e) => {
  const n = e.map(z9).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, OF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, M9 = (e) => e ? [e.code] : void 0, cy = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, RF = ({
  enabled: e
}) => {
  const n = Dr(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = DF({ enabled: e }), l = Yn(
    () => U9(r),
    [r]
  ), d = a.trim().length > 0;
  if (!i && !d && l.length === 0)
    return null;
  const m = !i && l.length === 0;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
          u.code,
          " · ",
          cy(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        i && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ v.jsx(ut.Item, { value: u, children: /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              d ? /* @__PURE__ */ v.jsx(
                xw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "tertiary", children: cy(u) })
            ]
          }
        ) }, u.code)),
        m && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, wi = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  xt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      tr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), B9 = "_modal_1wlra_1", q9 = {
  modal: B9
};
function Bj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const qj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Hj = "shopify-shiping-address-form", H9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = yn(), { track: f } = Fn(), [h, k] = de(!1), [F, j] = de({}), N = !l, [
    x,
    { error: g, reset: O }
  ] = m(QW, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (G) => {
      k(!1);
      const H = G?.Shopify?.orderUpdate?.userErrors;
      if (H != null && H.length > 0) {
        const R = H.reduce(
          (q, te) => {
            const we = te.field;
            if (we == null || we.length === 0)
              return q;
            const ve = we[we.length - 1];
            return ve != null && (q[ve] = te.message), q;
          },
          {}
        );
        j(R);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ee();
    }
  }), I = yt(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: qj.find(
        (G) => G === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: w, formState: A, reset: B } = mt({
    mode: "all",
    defaultValues: I()
  }), K = w((G) => {
    if (N) {
      if (k(!0), !o || !a) {
        k(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: H, ...R } = G, q = {
        ...R,
        countryCode: H
      };
      x({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(G), ee();
  });
  Qe(() => {
    r && B(I());
  }, [r, n, B, I]);
  const ee = () => {
    B(I()), j({}), O(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: ee,
      className: q9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: e, onClose: () => ee() }),
        /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: Hj, onSubmit: K, children: [
          g && /* @__PURE__ */ v.jsx(Tn, { error: g }),
          /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              wi,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: F
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              _r,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (G) => G ? Bj(G) : ""
                },
                children: qj.filter((G) => s.includes(G)).map((G) => /* @__PURE__ */ v.jsx(ut.Item, { value: G, children: /* @__PURE__ */ v.jsx($.Paragraph, { children: Bj(G) }) }, G))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !(A.isValid && A.isDirty),
              type: "submit",
              form: Hj,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
            },
            confirmOnClick: () => {
              g && ee();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ee();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, W9 = "_clickableIcon_33mqm_1", ph = {
  clickableIcon: W9
}, Wj = ({
  formFieldName: e,
  ...n
}) => {
  const r = Dr(), { field: i } = Ry({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    dy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, dy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = de(!1), [h, k] = de(m), { isCopied: F, copy: j } = Br(), { track: N } = Fn(), x = 14, g = o && (!!r || !!l), O = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), I = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && uI(n.countryCodeV2), w = yt(() => [
    I,
    n?.company,
    n?.address1,
    n?.address2,
    O,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, I, O, C]);
  if (!n)
    return null;
  const A = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ye, { size: x, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: ph.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  ye,
                  {
                    size: x,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            I && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: I }),
            n?.company && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address2 }),
            O && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: O }),
            n?.province && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Ze, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: x,
            name: "pen",
            onClick: () => A(),
            className: ph.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: x,
            name: F ? "done" : "copy",
            onClick: () => j(w()),
            className: ph.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      H9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, PF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Dr(), i = fi({ control: r.control, name: "lineItems" }), a = fi({
    control: r.control,
    name: "billingAddress"
  }), o = fi({
    control: r.control,
    name: "shippingAddress"
  }), s = fi({
    control: r.control,
    name: "discountCode"
  }), l = Yn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), d = Yn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, k = f.quantity || 0;
    return u + h * k;
  }, 0), [l]), m = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        Wj,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        Wj,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Cl, {}),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: `${d.toFixed(2)} ${m}` })
    ] }),
    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: cy(s) })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, K9 = "_productTableHeader_6h6pl_1", G9 = "_productImage_6h6pl_5", Co = {
  productTableHeader: K9,
  productImage: G9
}, Mg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, Y9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Dr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Mg(e);
  return /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ v.jsx(
        xa,
        {
          src: d,
          alt: e.title,
          className: Co.productImage
        }
      ),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
      An,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(ir, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, Q9 = 300, mo = 2, J9 = 25, X9 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = yn(), [i, a] = de(""), [o, s] = de([]), l = Dr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(zg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (j) => {
      const N = j?.Shopify?.products?.nodes || [];
      s(
        N.filter((x) => !!x).sort((x, g) => x.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  gi(
    () => {
      i.trim().length >= mo && !u && f === rr.ready ? m({
        variables: {
          query: i.trim(),
          productCount: J9,
          mediaCount: 1
        }
      }) : i.trim().length < mo && s([]);
    },
    Q9,
    [i]
  ), Qe(() => {
    if (!d) return;
    const j = o.find(
      (N) => N.id === d
    );
    j && e(j), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== rr.ready, k = i.trim().length >= mo, F = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${mo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (j) => {
          const N = o.find(
            (x) => x.id === j
          );
          return N ? /* @__PURE__ */ v.jsx($.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (j) => {
            a(j.target.value);
          }
        },
        onToggleDropdown: (j) => {
          !j && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }) }),
        !h && o.map((j) => {
          const N = j.totalInventory <= 0, x = Mg(j);
          return /* @__PURE__ */ v.jsx(
            ut.Item,
            {
              value: j.id,
              isDisabled: N,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  x && /* @__PURE__ */ v.jsx(
                    xa,
                    {
                      src: x,
                      alt: j.title,
                      className: Co.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    xw,
                    {
                      text: j.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: j.title })
                ] }),
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: N ? "Out of stock" : `${j.totalInventory} in stock` })
              ] })
            },
            j.id
          );
        }),
        F && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "Search for products",
            description: `Type at least ${mo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Bg = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Dr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], k = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), F = h.some(
    (N) => a.includes(N?.id)
  ) && !k, j = yt(
    (N) => {
      const x = m.getValues("lineItems"), g = x.findIndex(
        (O) => O?.id === N.id
      );
      if (g > -1) {
        const O = m.getValues(`lineItems.${g}.quantity`) || 0, I = [...x];
        I[g] = {
          ...I[g],
          quantity: O + 1
        }, m.setValue("lineItems", I);
      } else
        m.setValue("lineItems", [
          ...x,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(X9, { onProductSelected: j }),
    !f && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(hn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          Eo,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      ot,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Co.productTable,
        children: [
          /* @__PURE__ */ v.jsx(ot.Thead, { className: Co.productTableHeader, children: /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(ot.Th, { children: /* @__PURE__ */ v.jsx(
              Xg,
              {
                checked: k,
                indeterminate: F,
                onChange: () => d?.(!k)
              }
            ) }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(ot.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(ot.Tbody, { children: u?.map((N, x) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                Y9,
                {
                  product: N,
                  index: x,
                  onRemove: () => {
                    const H = u.filter(
                      (R, q) => q !== x
                    );
                    m.setValue("lineItems", H);
                  }
                },
                `${N?.id}-${x}`
              );
            const g = N, O = g.priceRangeV2.minVariantPrice.amount, I = g.priceRangeV2.minVariantPrice.currencyCode, C = `lineItems.${x}.quantity`, w = m.watch(C) || 0, A = O * w, B = Mg(g), K = a.includes(g.id), ee = o.includes(g.id), G = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ v.jsxs(
              ot.Tr,
              {
                style: ee ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    Xg,
                    {
                      checked: K,
                      disabled: ee,
                      onChange: () => l?.(g.id, !K)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    B && /* @__PURE__ */ v.jsx(
                      xa,
                      {
                        src: B,
                        alt: g.title,
                        className: Co.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.title }),
                      ee && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${O} ${I}` }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    An,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ee || G <= 1,
                      name: C,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: G,
                        tabIndex: 0
                      }
                    },
                    `${C}-${m.watch(C)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${A} ${I}` }) }),
                  !r && /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    ir,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const H = u.filter(
                          (R, q) => q !== x
                        );
                        m.setValue("lineItems", H), K && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${x}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, AF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Dr();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Dj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Dj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(ut.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, LF = () => {
  const e = Dr();
  return /* @__PURE__ */ v.jsx(
    _r,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Oj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Oj.map((n) => /* @__PURE__ */ v.jsx(ut.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, Z9 = "_modal_1mprq_1", e7 = {
  modal: Z9
}, fh = "create-shopify-order-form", n7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), [d, m] = de(!1), [
    u,
    f
  ] = de(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: ei.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [F, j] = de([]), N = mt({
    mode: "all",
    defaultValues: k
  }), x = N.watch("lineItems").length > 0, g = () => {
    N.reset(k), j([]), i(!1);
  };
  Qe(() => {
    F.length > 0 && N.setValue("tags", F, { shouldDirty: !0 });
  }, [F, N]);
  const [O, { error: I }] = o(
    FF,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), g();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), g();
      }
    }
  ), [C, { error: w }] = o(
    t9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), A = (K) => {
    const ee = K.lineItems.map((R) => ({
      productId: R.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: R.priceRangeV2.maxVariantPrice.amount,
          currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: R.quantity
    }));
    m(!0);
    const G = sa(K?.billingAddress), H = sa(
      K?.shippingAddress
    );
    O({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: K.customNote,
          tags: K.tags,
          financialStatus: K.financialStatus,
          fulfillmentStatus: K.fulfillmentStatus,
          discountCode: OF(K.discountCode),
          shippingAddress: H,
          billingAddress: G
        }
      }
    });
  }, B = (K) => {
    const ee = K.lineItems.map((R) => ({
      title: R.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: R.priceRangeV2.maxVariantPrice.amount,
        currencyCode: R.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: R.quantity
    }));
    f(!0);
    const G = sa(K?.billingAddress), H = sa(
      K?.shippingAddress
    );
    C({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: K.customNote,
          tags: K.tags,
          lineItems: ee,
          discountCodes: M9(K.discountCode),
          shippingAddress: H,
          billingAddress: G
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: g,
      className: e7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Oy, { ...N, children: /* @__PURE__ */ v.jsx("form", { id: fh, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(Bg, {}) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: K } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: K?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Nl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: F,
                            onChange: (ee) => {
                              j(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(AF, {}),
              /* @__PURE__ */ v.jsx(LF, {}),
              /* @__PURE__ */ v.jsx(RF, { enabled: e }),
              /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(PF, {})
              }
            ) }) })
          ] }) }) }),
          (I || w) && /* @__PURE__ */ v.jsx(Tn, { error: I || w })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: fh,
              disabled: !x || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(A),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(B)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: fh,
                disabled: !x || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, t7 = "_modal_al73g_1", r7 = {
  modal: t7
}, Kj = [
  {
    label: "Customer",
    value: Ei.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Ei.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Ei.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Ei.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Ei.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Ei.Staff,
    description: "Staff made an error."
  }
], i7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = Fn(), { useMutation: d, showNotification: m } = yn(), [u, f] = de([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, F = mt({
    defaultValues: k
  }), [j, { error: N, reset: x }] = d(XW, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (I) => {
      const C = I.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const w = I.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, w ? 0 : 4e3), m({
          title: "Success",
          text: `${w ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = yt(
    (I) => {
      I.reason != null && (o(!0), j({
        variables: {
          orderId: I.orderId,
          reason: I.reason,
          refundMethod: I.refundMethod,
          restock: I.restock,
          notifyCustomer: I.notifyCustomer,
          staffNote: I.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), O = () => {
    i(!1), x(), f([]), F.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: O, className: r7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Cancel order ${r}`, onClose: O }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        _r,
        {
          control: F.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (I, C) => I === C,
            getItemTitleByValue: (I) => {
              if (!I)
                return "";
              const C = Kj.find(
                (w) => w.value === I
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: Kj.map((I) => /* @__PURE__ */ v.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
          ] }) }, I.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        xn,
        {
          control: F.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Restock items", children: /* @__PURE__ */ v.jsx(xn, { control: F.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(He, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(xn, { control: F.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        An,
        {
          name: "staffNote",
          label: "Staff note",
          control: F.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map((I) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(ye, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.code }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
              "(",
              I.field?.join(","),
              ") ",
              I.message
            ] })
          ]
        },
        I.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(F.formState.isValid && F.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: F.handleSubmit(g),
        cancelOnClick: O,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, a7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = de(!1), [s, l] = de(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      i7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, o7 = "_modal_1mprq_1", s7 = {
  modal: o7
}, l7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = yn(), { track: m } = Fn(), [u, f] = de(!1), [h, k] = de(e?.tags || []), F = "duplicate-shopify-order-form", j = (H) => ({
    firstName: H?.firstName,
    lastName: H?.lastName,
    company: H?.company,
    address1: H?.address1,
    address2: H?.address2,
    city: H?.city,
    provinceCode: H?.provinceCode,
    zip: H?.zip,
    countryCode: H?.countryCodeV2,
    phone: H?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: j(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: j(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, x = mt({
    mode: "all",
    defaultValues: N
  }), g = x.watch("lineItems").length > 0, O = Yn(
    () => (e?.lineItems || []).map((H) => H.product?.id).filter((H) => !!H),
    [e]
  ), I = Yn(
    () => $F(O),
    [O]
  ), {
    data: C,
    loading: w,
    error: A
  } = d(zg, {
    skip: !I,
    variables: {
      query: I,
      productCount: O.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    A && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [A, l]), Qe(() => {
    if (!r || w || !C || x.getValues("lineItems")?.length)
      return;
    const H = C?.Shopify?.products?.nodes || [], R = [];
    e?.lineItems?.forEach((q) => {
      const te = H.find(
        (we) => we.id === q.product?.id
      );
      te && R.push({
        ...te,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), R.length > 0 && x.setValue("lineItems", R, { shouldDirty: !0 });
  }, [r, C, w, e, x]), Qe(() => {
    (h.length > 0 || (x.getValues("tags") || []).length > 0) && x.setValue("tags", h, { shouldDirty: !0 });
  }, [h, x]);
  const [B, { error: K }] = s(
    FF,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), G();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), G();
      }
    }
  ), ee = (H) => {
    const R = H.lineItems.map((te) => ({
      productId: te.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: te.discountedUnitPrice?.amount ?? te.priceRangeV2.maxVariantPrice.amount,
          currencyCode: te.discountedUnitPrice?.currencyCode ?? te.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: te.quantity,
      sku: te.sku
    })), q = (e?.shippingLines ?? []).map(
      (te) => ({
        title: te.title,
        code: te.code,
        source: te.source,
        priceSet: {
          shopMoney: {
            amount: te.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: te.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), B({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: R,
          shippingLines: q,
          note: H.customNote,
          tags: H.tags,
          financialStatus: H.financialStatus,
          fulfillmentStatus: H.fulfillmentStatus,
          discountCode: OF(H.discountCode),
          shippingAddress: sa(H?.shippingAddress),
          billingAddress: sa(H?.billingAddress)
        }
      }
    });
  }, G = () => {
    x.reset(N), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: G,
      className: s7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: `Duplicate order ${n}`, onClose: G }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Oy, { ...x, children: /* @__PURE__ */ v.jsx("form", { id: F, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(Bg, { loading: w }) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              xt,
              {
                name: "tags",
                render: ({ fieldState: { error: H } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: H?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (R) => {
                          R.key === "Enter" && (R.preventDefault(), R.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Nl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (R) => {
                              k(R);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(RF, { enabled: r }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                AF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(LF, {}),
              /* @__PURE__ */ v.jsx(
                An,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(PF, {})
              }
            ) }) })
          ] }) }) }),
          K && /* @__PURE__ */ v.jsx(Tn, { error: K })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: F,
              disabled: !g || u || w,
              isLoading: u || w,
              loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: x.handleSubmit(ee)
          }
        )
      ]
    }
  );
}, c7 = "_copyIcon_1dlzg_1", d7 = {
  copyIcon: c7
}, u7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Br();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (d) => d > 0
  ), s = n.every(
    ({ id: d, quantity: m }) => (r[d] || 0) >= m
  ), l = n.map(
    ({ title: d, quantity: m, variantTitle: u }) => u ? `${m}x ${d} (${u})` : `${m}x ${d}`
  ).join(`
`);
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(ye, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ v.jsx(Ze, { content: "Copy line items", children: /* @__PURE__ */ v.jsx(
            ye,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: d7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Qn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(Xe, { children: n.map(({ id: d, title: m, quantity: u, variantTitle: f, image: h }) => {
      const k = r[d], F = k > 0, j = k > 1 ? `Refunded (${k} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        Xe.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ v.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
            m,
            " ",
            f && `(${f})`,
            F && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", color: "red.500", children: j })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ v.jsx(xa, { src: `${h?.url}&height=48`, alt: m })
        },
        `list-${e}-${d}`
      );
    }) })
  ] });
}, m7 = Fl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, p7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, VF = (e) => {
  const n = {}, r = p7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Cs = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, zF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Cs(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Cs(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(
          Io,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: Cs(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: Cs(e?.amount || "0", o) })
    ] })
  ] });
}, f7 = "_modal_1mprq_1", h7 = {
  modal: f7
}, Gj = "partial-refund-shopify-order-form", y7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), { useQuery: d } = yn(), [m, u] = de(!1), [f, h] = de([]), [k, F] = de(!1), j = Yn(
    () => e?.refunds ? VF(e) : {},
    [e]
  ), N = Yn(
    () => (e?.lineItems || []).filter((ue) => (j[ue.id] || 0) >= (ue.quantity || 0)).map((ue) => ue.product?.id).filter((ue) => !!ue),
    [e, j]
  ), x = Yn(() => {
    const ue = {};
    return (e?.lineItems || []).forEach((ge) => {
      if (ge.product?.id) {
        const U = j[ge.id] || 0, be = Math.max(
          0,
          (ge.quantity || 0) - U
        );
        ue[ge.product.id] = be;
      }
    }), ue;
  }, [e, j]), g = Yn(
    () => (e?.lineItems || []).map((ue) => ue.product?.id).filter((ue) => !!ue),
    [e]
  ), O = Yn(
    () => $F(g),
    [g]
  ), {
    data: I,
    loading: C,
    error: w
  } = d(zg, {
    skip: !O,
    variables: {
      query: O,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    w && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [w, s]);
  const A = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, B = mt({
    mode: "all",
    defaultValues: A
  }), K = f.length > 0;
  Qe(() => {
    !K && k && F(!1);
  }, [K, k]);
  const ee = fi({
    control: B.control,
    name: "lineItems"
  }), G = Yn(
    () => (ee || []).filter(
      (ue) => f.includes(ue.id)
    ).map((ue) => {
      const ge = e?.lineItems?.find(
        (W) => W.product?.id === ue.id
      ), U = j[ge?.id || ""] || 0, be = (ge?.quantity || 0) - U, $e = Math.max(
        0,
        Math.min(be, ue.quantity || 0)
      );
      return ge && $e > 0 ? { lineItemId: ge.id, quantity: $e } : void 0;
    }).filter(
      (ue) => !!ue
    ),
    [ee, f, e, j]
  ), { suggestedRefund: H, isLoading: R } = TF({
    orderId: e.id,
    refundShipping: k,
    refundLineItems: G,
    skip: !K
  }), [q, { error: te }] = o(
    m7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), ve();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), ve();
      }
    }
  );
  Qe(() => {
    if (!r || C || !I || B.getValues("lineItems")?.length)
      return;
    const ue = I?.Shopify?.products?.nodes || [], ge = [];
    e?.lineItems?.forEach((U) => {
      const be = ue.find(
        ($e) => $e.id === U.product?.id
      );
      if (be) {
        const $e = j[U.id] || 0, W = (U.quantity || 1) - $e;
        ge.push({
          ...be,
          quantity: W > 0 ? W : U.quantity || 1
        });
      }
    }), ge.length > 0 && (B.setValue("lineItems", ge, { shouldDirty: !0 }), h([]));
  }, [
    r,
    I,
    C,
    e,
    B,
    j
  ]);
  const we = (ue) => {
    u(!0), q({
      variables: {
        input: EF({
          orderId: e.id,
          transactions: H?.transactions,
          refundLineItems: G,
          refundShipping: k,
          note: ue.customNote || void 0,
          notify: !0
        })
      }
    });
  }, ve = () => {
    B.reset(A), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: ve, className: h7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${n}`, onClose: ve }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(Oy, { ...B, children: /* @__PURE__ */ v.jsx("form", { id: Gj, children: /* @__PURE__ */ v.jsxs(nt, { children: [
        /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
          Bg,
          {
            loading: C,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: N,
            maxQuantities: x,
            onToggleSelect: (ue, ge) => {
              h((U) => ge ? Array.from(/* @__PURE__ */ new Set([...U, ue])) : U.filter((be) => be !== ue));
            },
            onToggleSelectAll: (ue) => {
              const ge = (B.getValues("lineItems") || []).map((U) => U.id).filter((U) => !N.includes(U));
              h(ue ? ge : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          An,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              zF,
              {
                refund: H,
                currencyCode: e.currencyCode,
                refundShipping: k,
                onToggleShipping: F,
                isLoading: R
              }
            )
          }
        ) }) })
      ] }) }) }),
      te && /* @__PURE__ */ v.jsx(Tn, { error: te })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          type: "submit",
          form: Gj,
          disabled: !K || m || C || R || !H,
          isLoading: m || C,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: B.handleSubmit(we)
      }
    )
  ] });
}, g7 = "_modal_al73g_1", v7 = {
  modal: g7
}, k7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = yn(), { track: d } = Fn(), { id: m, name: u, currencyCode: f } = e, [h, k] = de(!0), [F, j] = de(), { suggestedRefund: N, isLoading: x } = TF({
    orderId: m,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: O }] = s(
    JW,
    {
      onError: (w) => j(w),
      onCompleted: (w) => {
        const A = w.Shopify?.refundCreate?.userErrors;
        if (A && A.length > 0) {
          j(
            new jw({
              graphQLErrors: A.map((B) => ({
                message: B.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), I();
      }
    }
  ), I = () => {
    k(!0), j(void 0), a(!1);
  }, C = () => {
    N && (d("shopify:order:refund:confirmed", { shopifyId: n, orderId: m }), g({
      variables: {
        input: EF({
          orderId: m,
          transactions: N.transactions,
          refundLineItems: N.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: i, onClose: I, className: v7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${u}`, onClose: I }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ v.jsx(
        zF,
        {
          refund: N,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: k,
          isLoading: x
        }
      ),
      F && /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ v.jsx(Tn, { error: F }),
        /* @__PURE__ */ v.jsx(
          Lt,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ v.jsx(ye, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !N || x || O,
          isLoading: O || x,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: C
      }
    )
  ] });
}, b7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = yn(), { track: o } = Fn(), { suggestedRefund: s, id: l } = e, [d, m] = de(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = yt(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? m(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ v.jsx($.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ v.jsx(ye, { size: 14, name: "undo" }),
        className: Mt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ v.jsx(
      k7,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: d,
        setIsOpen: m,
        refetchOrders: i
      }
    )
  ] });
}, x7 = "_modal_al73g_1", _7 = {
  modal: x7
}, S7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = Fn(), { useMutation: s, showNotification: l } = yn(), [d, m] = de(n), [u, f] = de(!1), h = mt({
    defaultValues: {
      tags: n
    }
  });
  Qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [k, { error: F, reset: j }] = s(ZW, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = yt(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((O) => {
        const I = O.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: I });
      });
    },
    [e, h, k]
  ), x = () => {
    i(!1), j();
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: x, className: _7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Manage tags for order", onClose: x }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        xt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            He,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                Nl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (O) => m(O)
                }
              )
            }
          )
        }
      ) }) }),
      F && /* @__PURE__ */ v.jsx(Tn, { error: F })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(hn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: x,
        confirmName: F ? "Close" : "Save",
        cancelName: F ? void 0 : "Cancel"
      }
    )
  ] });
}, N7 = "_editIcon_1yp2k_1", j7 = "_copyIcon_1yp2k_2", Yj = {
  editIcon: N7,
  copyIcon: j7
}, w7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = de(!1), { isCopied: o, copy: s } = Br(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ye, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ v.jsx(Bn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Ze, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: l,
            name: "pen",
            className: Yj.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ v.jsx(Ze, { content: "Copy tags", children: /* @__PURE__ */ v.jsx(
          ye,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Yj.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      S7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, C7 = "_icon_cddi1_1", F7 = "_link_cddi1_6", Qj = {
  icon: C7,
  link: F7
}, I7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Br(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    Xe.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        $.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Qj.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        ye,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Qj.icon
        }
      ) })
    }
  );
}, E7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(ye, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(Xe, { children: e.map((n) => /* @__PURE__ */ v.jsx(I7, { trackingInfo: n }, n.number)) })
] }), $7 = "_copyIcon_u5m0p_1", T7 = "_strikethrough_u5m0p_6", D7 = "_order_u5m0p_10", O7 = "_orderIsOpen_u5m0p_18", R7 = "_orderHeader_u5m0p_21", Ci = {
  copyIcon: $7,
  strikethrough: T7,
  order: D7,
  orderIsOpen: O7,
  orderHeader: R7
}, P7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = Fn(), { isCopied: h, copy: k } = Br(), { isCopied: F, copy: j } = Br(), { isCopied: N, copy: x } = Br(), [g, O] = de(!1), [I, C] = de(!1), [w, A] = de(r), {
    id: B,
    name: K,
    createdAt: ee,
    status: G,
    currentTotalPriceSet: H,
    currencyCode: R,
    lineItems: q,
    billingAddress: te,
    shippingAddress: we,
    trackingInfos: ve,
    tags: ue,
    discountCodes: ge,
    currentTotalDiscountsSet: U
  } = e, be = !!we, $e = Ug(B), W = `https://${l}/admin/orders/${$e ?? ""}`, Ge = H?.shopMoney?.amount ?? 0, sn = G.includes("cancelled"), Fe = (nn) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: R
  }).format(nn), Ue = Number(
    U?.shopMoney?.amount ?? 0
  ), Re = Ue > 0, Be = ge?.join(", ") ?? "", Ae = Fe(Number(Ge)), Je = Fe(
    Number(Ge) + Ue
  ), Ce = e?.refunds ? VF(e) : {}, Me = !!q?.length && q.every((nn) => (Ce[nn.id] || 0) >= (nn.quantity || 0));
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: dt(Ci.order, {
        [Ci.orderIsOpen]: w
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ci.orderHeader,
            onClick: () => A(!w),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ee && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Jn(ee).format(ly) }) }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "1", children: [
                  "Order ",
                  K
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: w ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ye, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: K.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order number", children: /* @__PURE__ */ v.jsx(
                  ye,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => k(K.replace("#", "")),
                    className: Ci.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ye, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: G })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order status", children: /* @__PURE__ */ v.jsx(
                  ye,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => x(G),
                    className: Ci.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ye, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order value" }),
                    Re && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: Ci.strikethrough, children: Je }),
                    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Ze, { content: "Copy order value", children: /* @__PURE__ */ v.jsx(
                  ye,
                  {
                    size: 14,
                    name: F ? "done" : "copy",
                    onClick: () => j(Ge),
                    className: Ci.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsx(
            w7,
            {
              orderId: B,
              tags: ue,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            dy,
            {
              openByDefault: !be,
              labelText: "Billing address",
              address: te,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            dy,
            {
              openByDefault: be,
              shopifyId: n,
              orderId: B,
              icon: "map-pin",
              labelText: "Shipping address",
              address: we,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            u7,
            {
              orderId: B,
              lineItems: q,
              refundedQuantities: Ce
            }
          ),
          /* @__PURE__ */ v.jsx(E7, { trackingInfos: ve }),
          (o || m) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              b7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: W
              }
            ),
            m && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              et,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => C(!0),
                className: Mt.fullWidth,
                disabled: sn || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              et,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => O(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              a7,
              {
                orderId: B,
                orderName: K,
                disabled: sn,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(W, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ye, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: B
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ v.jsx(
          l7,
          {
            order: e,
            shopifyId: n,
            orderName: K,
            isOpen: g,
            setIsOpen: O,
            refetchOrders: u
          }
        ),
        I && /* @__PURE__ */ v.jsx(
          y7,
          {
            order: e,
            orderName: K,
            isOpen: I,
            setIsOpen: C,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, A7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = Fn(), [f, h] = de([]), [k, F] = de(!1), j = Ug(m?.id), N = `https://${n}/admin/orders?customer_id=${j ?? ""}`, {
    getCustomerOrders: x,
    isCustomerOrdersLoading: g,
    customerOrdersError: O,
    customerOrders: I,
    refetchCustomerOrders: C
  } = i9();
  return Qe(() => {
    !g && j && x({
      variables: {
        query: `customer_id:${j}`
      }
    });
  }, [j]), Qe(() => {
    const w = I?.Shopify?.orders?.edges;
    w && h(a9({ ordersData: w }));
  }, [I]), m ? O ? /* @__PURE__ */ v.jsx(Tn, { error: O }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Bn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      et,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => F(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((w, A) => /* @__PURE__ */ v.jsx(
        P7,
        {
          order: w,
          openByDefault: A === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${A}-${w.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(ye, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      n7,
      {
        isOpen: k,
        setIsOpen: F,
        shopifyCustomer: m,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, L7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(Xe, { className: Mt.list, children: [
      /* @__PURE__ */ v.jsx(Xe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(Xe.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, V7 = "_segmentName_1dkhk_1", z7 = {
  segmentName: V7
}, U7 = 100, Fs = 10, M7 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = yn(), [i, a] = de([]), [o, s] = de(Fs), [l, d] = de(!1), m = Yn(
    () => i.filter((j) => j.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    KW,
    {
      skip: !e,
      variables: {
        first: U7
      },
      onCompleted: (j) => {
        const N = j?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const x = N.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, O) => g.name.localeCompare(O.name));
          a(x), h({
            variables: {
              customerId: e,
              segmentIds: x.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: F }
  ] = r(GW, {
    onCompleted: (j) => {
      const N = j?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const x = i.map((g) => {
          const O = N.find(
            (I) => I.segmentId === g.id
          );
          return {
            ...g,
            ...O?.isMember && { isMember: O.isMember }
          };
        }).sort(
          (g, O) => g.isMember === O.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(x);
      }
    }
  });
  return Qe(() => {
    s(l ? i.length : Fs);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Bn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(hn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx(Tn, { error: f }),
    F && /* @__PURE__ */ v.jsx(Tn, { error: F }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(Xe, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: j, name: N, isMember: x }) => /* @__PURE__ */ v.jsx(Xe.Text, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(
        Ze,
        {
          content: `${x ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: z7.segmentName, children: N }),
            k && /* @__PURE__ */ v.jsx(hn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              ye,
              {
                color: x ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, j)),
      i.length > Fs && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        et,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Fs} more`
        }
      ) })
    ] })
  ] }) : null;
}, B7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = de(!1);
  Qe(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: d
  } = r9({ conversationContext: e, forcePhoneLookup: r }), [m, u] = de(), [f, h] = de(
    []
  ), k = n.apiHostName, F = n.displayRefundOrder ?? !1, j = n.displayCancelOrder ?? !1, N = n.enableEditShippingAddress ?? !1, x = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, O = n.displaySegmentMembership ?? !1, I = n.displayDiscountCodeCreation ?? !1, C = n.displayDiscountCodes ?? !1, w = n.displayCreateOrder ?? !1, A = n.displayDuplicateOrder ?? !1, B = n.displayCreateDraftOrder ?? !1, K = n.displayPartialRefundOrder ?? !1;
  if (Qe(() => {
    const ee = s?.Shopify?.customers?.edges[0]?.node, G = !!e.customer?.phone_number && !!e.customer?.email;
    ee && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(ee)) : !ee && !a && G && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ v.jsx(Tn, { error: o, retry: l });
  if (!a && !o && !m) {
    const ee = `https://${k}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              b9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              Lt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(ee, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(ye, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && d !== rr.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(hn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          S9,
          {
            customer: m,
            shopifyDomain: k,
            refresh: l,
            loading: a,
            networkStatus: d
          }
        ),
        g && /* @__PURE__ */ v.jsx(
          L7,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        O && /* @__PURE__ */ v.jsx(M7, { shopifyId: m?.id }),
        x && /* @__PURE__ */ v.jsx(V9, { customer: m }),
        C && /* @__PURE__ */ v.jsx(
          L9,
          {
            displayDiscountCodeCreation: I
          }
        ),
        /* @__PURE__ */ v.jsx(
          A7,
          {
            shopifyCustomer: m,
            shopifyDomain: k,
            displayRefund: F,
            displayCancel: j,
            displayCreateOrder: w,
            displayCreateDraftOrder: B,
            enableEditShippingAddress: N,
            customerCountryCodes: f,
            displayDuplicateOrder: A,
            displayPartialRefundOrder: K
          }
        )
      ]
    }
  );
}, Dt = [];
for (let e = 0; e < 256; ++e)
  Dt.push((e + 256).toString(16).slice(1));
function q7(e, n = 0) {
  return (Dt[e[n + 0]] + Dt[e[n + 1]] + Dt[e[n + 2]] + Dt[e[n + 3]] + "-" + Dt[e[n + 4]] + Dt[e[n + 5]] + "-" + Dt[e[n + 6]] + Dt[e[n + 7]] + "-" + Dt[e[n + 8]] + Dt[e[n + 9]] + "-" + Dt[e[n + 10]] + Dt[e[n + 11]] + Dt[e[n + 12]] + Dt[e[n + 13]] + Dt[e[n + 14]] + Dt[e[n + 15]]).toLowerCase();
}
const H7 = new Uint8Array(16);
function W7() {
  return crypto.getRandomValues(H7);
}
function K7(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : G7(e);
}
function G7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? W7();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, q7(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hh = { exports: {} }, po = {}, Jj;
function Y7() {
  if (Jj) return po;
  Jj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return po.Fragment = r, po.jsx = s, po.jsxs = s, po;
}
var Is = {}, Xj;
function Q7() {
  return Xj || (Xj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Is.Fragment = i, Is.jsx = Un, Is.jsxs = Kn;
  })()), Is;
}
var Zj;
function J7() {
  return Zj || (Zj = 1, process.env.NODE_ENV === "production" ? hh.exports = Y7() : hh.exports = Q7()), hh.exports;
}
var P = J7(), UF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(UF || {}), uy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(uy || {});
const X7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, Z7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, eK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, nK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, tK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, rK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, iK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, aK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, oK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, sK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": X7,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": Z7,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": eK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": nK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": tK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": rK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": iK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": aK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": oK
};
function ai(e) {
  return sK[e] ?? {};
}
const lK = ai(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), cK = ai(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), dK = ai(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), uK = ai(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), mK = ai(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), pK = ai(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), fK = ai(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), hK = ai(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), yK = ai(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), gK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = de(), [o, s] = de(), [l, d] = de(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(lK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Qe(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !m && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && d(
      k?.consents?.filter(
        (F) => F !== null
      ) || void 0
    )), !m && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Yn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function Ys(e = !1, n) {
  const [r, i] = de(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const vK = {
  count: 0,
  items: []
}, kK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = de(vK), {
    loading: o,
    error: s,
    data: l
  } = n(uK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, bK = {
  count: 0,
  totalCount: 0,
  items: []
}, xK = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), { track: r } = Fn(), [i, a] = de(
    bK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(mK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, _K = ({
  conversationContext: e
}) => {
  const { useQuery: n } = yn(), [r, i] = de(void 0), [a, o] = de(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(dK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, SK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = yn(), [i, a] = de(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(cK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Yn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, NK = "_pointer_pn2q5_54", jK = "_list_pn2q5_59", wK = "_listItem_pn2q5_69", pt = {
  pointer: NK,
  list: jK,
  listItem: wK
}, CK = "_modalBody_1clhs_1", FK = {
  modalBody: CK
}, IK = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = yn(), { track: l } = Fn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = mt({
    defaultValues: u,
    mode: "onChange"
  }), F = fi({ control: f }), j = parseInt(F?.balance ?? "0", 10), N = m === j, x = N ? "Change the value to update the points" : "", g = j < 0, O = g ? "Points can not be negative" : "", I = F.description === "", C = I ? "Description can not be empty" : "";
  Qe(() => {
    j > m ? h(
      "transactionType",
      uy.Addition
    ) : j < m && h(
      "transactionType",
      uy.Deduction
    );
  }, [m, j, h]);
  const [w, { loading: A, error: B, reset: K }] = o(yK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (d) {
      const H = K7();
      w({
        variables: {
          input: {
            accountId: d,
            transactionId: H,
            amount: Math.abs(j - m),
            transactionType: F.transactionType,
            description: F.description,
            source: UF.UpdateBalance
          }
        }
      }).then(async (R) => {
        R?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), G());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, G = () => {
    k(u), K(), n();
  };
  return /* @__PURE__ */ P.jsxs(
    wt,
    {
      isOpen: e,
      onClose: G,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ P.jsx(Ct, { title: "Update points balance", onClose: G }),
        /* @__PURE__ */ P.jsxs(Ft, { className: FK.modalBody, children: [
          /* @__PURE__ */ P.jsxs(nt, { children: [
            /* @__PURE__ */ P.jsx(Z, { span: 6, children: /* @__PURE__ */ P.jsx(
              xt,
              {
                name: "balance",
                control: f,
                render: ({ field: H }) => /* @__PURE__ */ P.jsx(
                  tr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: x || O
                    },
                    input: {
                      ...H,
                      value: H.value.toString(),
                      onChange: (R) => H.onChange(R)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ P.jsx(Z, { span: 6, children: /* @__PURE__ */ P.jsx(
              xt,
              {
                name: "description",
                control: f,
                render: ({ field: H }) => /* @__PURE__ */ P.jsx(
                  tr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: H,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          B && /* @__PURE__ */ P.jsx(Tn, { error: B })
        ] }),
        /* @__PURE__ */ P.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: A,
              disabled: N || g || I,
              loadingIndicator: /* @__PURE__ */ P.jsx(hn, { size: 16 })
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, EK = "_wrapper_1ge6c_1", $K = "_block_1ge6c_12", ew = {
  wrapper: EK,
  block: $K
}, TK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = yn(), { isCopied: i, copy: a } = Ys(), { isCopied: o, copy: s } = Ys(), { isCopied: l, copy: d } = Ys(), [m, u] = de(!1), [f, h] = de(), [k, F] = de(!1), {
    loading: j,
    data: N,
    refetch: x
  } = r(fK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Qe(() => {
    if (N) {
      const te = N?.Voyado?.PointAccountV_GetPointAccounts;
      te && te?.length > 0 && h(te[0]);
    }
  }, [N]);
  const g = !!f?.id, O = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: I,
    lastName: C,
    street: w,
    zipCode: A,
    city: B,
    country: K,
    isRegistrationCompleted: ee,
    email: G,
    mobilePhone: H
  } = e, R = 14, q = `${I || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", className: ew.wrapper, children: [
    /* @__PURE__ */ P.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ew.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-2", children: q }),
          j && /* @__PURE__ */ P.jsx(hn, { size: 12 }),
          g && !j && /* @__PURE__ */ P.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ P.jsxs(Bn, { size: "small", variant: "warning", children: [
              O,
              " points"
            ] }),
            /* @__PURE__ */ P.jsx(Ze, { content: "Update points balance", children: /* @__PURE__ */ P.jsx(
              ye,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: pt.pointer
              }
            ) }),
            k && /* @__PURE__ */ P.jsx(Ze, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ P.jsx(
              ye,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (w || B || A || K || H || G) && /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
      H && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ye, { size: R, name: "phone" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: H })
        ] }),
        /* @__PURE__ */ P.jsx(
          ye,
          {
            size: R,
            name: o ? "done" : "copy",
            onClick: () => s(H),
            className: pt.pointer
          }
        )
      ] }),
      G && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ye, { size: R, name: "mail" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ P.jsx(
          ye,
          {
            size: R,
            name: i ? "done" : "copy",
            onClick: () => a(G),
            className: pt.pointer
          }
        )
      ] }),
      (w || B || A || K) && /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ P.jsx(ye, { size: R, name: "home" }),
          /* @__PURE__ */ P.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ P.jsx(lt, { children: w }),
            /* @__PURE__ */ P.jsxs(lt, { children: [
              A,
              " ",
              B
            ] }),
            /* @__PURE__ */ P.jsx(lt, { children: K })
          ] })
        ] }),
        /* @__PURE__ */ P.jsx(
          ye,
          {
            size: R,
            name: l ? "done" : "copy",
            onClick: () => d(`${w}, ${A} ${B}, ${K}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ P.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx(ye, { size: R, name: "sign-in" }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ P.jsx(
          ye,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ P.jsx(
      IK,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: F,
        refetchPointsQuery: x
      }
    )
  ] });
}, DK = "_list_yud4a_7", OK = "_listItem_yud4a_11", RK = "_listItemTooltip_yud4a_15", PK = "_listItemTimestamp_yud4a_18", Es = {
  list: DK,
  listItem: OK,
  listItemTooltip: RK,
  listItemTimestamp: PK
}, AK = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ P.jsx(Xe, { className: Es.list, children: e.map((n, r) => /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: Es.listItem, children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ P.jsx(Ze, { content: n?.comment, children: /* @__PURE__ */ P.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [Es.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ P.jsx($.Paragraph, { className: Es.listItemTimestamp, children: Jn(n.date).format(jt) }),
          n?.comment && /* @__PURE__ */ P.jsx(ye, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ P.jsx(
      ye,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), LK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Jn(e.latestChange).format(jt) : null, o = e?.expires ? `${Jn(e.expires).fromNow()} (${Jn(e.expires).format(jt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ P.jsx(Ze, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ P.jsx(
        ye,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ P.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ P.jsxs(Xe, { className: pt.list, children: [
      s && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: "", children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, VK = "_tagHover_kzbzk_1", zK = "_channelUnsubscribed_kzbzk_6", nw = {
  tagHover: VK,
  channelUnsubscribed: zK
}, yh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = Fn(), { useMutation: l } = yn(), [d, m] = de(!1), [u, { loading: f }] = l(hK), h = async ({
    newPreference: F,
    isSubscribed: j,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...F
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? j ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : j ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, k = d || f;
  return /* @__PURE__ */ P.jsx(Ze, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ P.jsx(
    Qn,
    {
      className: nw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ P.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [nw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ P.jsx(hn, { size: 16 }) : /* @__PURE__ */ P.jsx(ye, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, UK = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ P.jsx(
        yh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, MK = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = gK({ contactId: e }), {
    isLoading: k,
    error: F,
    memberLevel: j
  } = SK({ contactId: e, skip: !s }), N = k || l, x = Yn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || F ? ba({
    errors: d?.graphQLErrors || F?.graphQLErrors || []
  }) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: d || F }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    r && /* @__PURE__ */ P.jsx(
      TK,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ P.jsx(LK, { memberLevel: j }),
    i && /* @__PURE__ */ P.jsx(
      UK,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ P.jsx(AK, { contactConsents: x })
  ] });
}, my = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, BK = "_list_zu4s7_1", qK = "_listItem_zu4s7_4", HK = "_listSum_zu4s7_7", $s = {
  list: BK,
  listItem: qK,
  listSum: HK
}, WK = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ P.jsxs(Xe, { className: $s.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ P.jsx(Xe.Text, { variant: "dense", className: $s.listItem, children: /* @__PURE__ */ P.jsx(Ze, { content: s, children: /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ P.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ P.jsx(b, { flex: "auto", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ P.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: my(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ P.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt($s.listItem, $s.listSum),
      children: /* @__PURE__ */ P.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: my(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), KK = "_transaction_1kr8d_1", GK = "_transactionIsOpen_1kr8d_9", YK = "_transactionHeader_1kr8d_12", QK = "_transactionHeaderSubLine_1kr8d_15", JK = "_transactionHeaderAlignItemRight_1kr8d_19", ia = {
  transaction: KK,
  transactionIsOpen: GK,
  transactionHeader: YK,
  transactionHeaderSubLine: QK,
  transactionHeaderAlignItemRight: JK
}, XK = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, F = m?.length ? m : [];
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(ia.transaction, {
        [ia.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ia.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ P.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Jn(o).format(jt) }),
                  /* @__PURE__ */ P.jsxs(
                    $.Heading,
                    {
                      variant: "heading-4",
                      className: ia.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ P.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ia.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-4", children: my(k, h) }),
                      /* @__PURE__ */ P.jsxs(
                        $.Heading,
                        {
                          variant: "heading-4",
                          className: ia.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ P.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ P.jsx(Cl, {}),
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ P.jsx(Qn, { children: /* @__PURE__ */ P.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ P.jsx(
                  WK,
                  {
                    lineItems: F,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, ZK = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = xK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ P.jsx(Tn, { error: r }) : /* @__PURE__ */ P.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
          s === 0 && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ P.jsx(
            XK,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, eG = "_message_4z55u_54", nG = "_messageIsOpen_4z55u_62", tG = "_messageHeader_4z55u_66", rG = "_messageText_4z55u_70", iG = "_buttonLink_4z55u_93", fo = {
  message: eG,
  messageIsOpen: nG,
  messageHeader: tG,
  messageText: rG,
  buttonLink: iG
}, gh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, vh = (e, n) => n && e in gh && n in gh[e] ? gh[e][n] : null, aG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = de(n), { track: a } = Fn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? vh("type", l) : null, F = d ? vh("source", d) : null, j = u ? vh("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(fo.message, {
        [fo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: fo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ P.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
                    /* @__PURE__ */ P.jsx(ye, { name: k, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Jn(s).format(jt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ P.jsx(Cl, {}),
          /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            j && /* @__PURE__ */ P.jsx(Qn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ye, { name: j }),
              " ",
              u
            ] }) }),
            F && /* @__PURE__ */ P.jsx(Qn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ye, { name: F }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ P.jsx(Qn, { children: /* @__PURE__ */ P.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ P.jsx(ye, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", className: fo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ P.jsx(
            Lt,
            {
              slotEnd: /* @__PURE__ */ P.jsx(ye, { name: "external-link" }),
              variant: "tertiary",
              className: fo.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, oG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = kK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ P.jsx(Tn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ P.jsx(Bn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ P.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ P.jsx(
        aG,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Jl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, tw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = Ys(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = yt(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ P.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(ye, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ P.jsx(Ze, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ P.jsx(
      ye,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, sG = "_order_19t4p_1", lG = "_orderIsOpen_19t4p_9", cG = "_orderHeader_19t4p_12", dG = "_orderIconColor_19t4p_15", Lr = {
  order: sG,
  orderIsOpen: lG,
  orderHeader: cG,
  orderIconColor: dG
}, uG = "_delivery_1m9nb_1", mG = "_deliveryCode_1m9nb_4", kh = {
  delivery: uG,
  deliveryCode: mG
}, pG = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Qt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ P.jsx(
      ye,
      {
        size: l,
        name: "eye",
        className: Lr.orderIconColor
      }
    ),
    /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ P.jsx(
        Ze,
        {
          content: /* @__PURE__ */ P.jsxs($.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Jn(s).format(jt)
          ] }),
          children: /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ P.jsx(
              $.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ P.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: kh.delivery,
                    children: [
                      /* @__PURE__ */ P.jsx(ye, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ P.jsx(
              $.Paragraph,
              {
                variant: "4",
                className: dt(kh.delivery, kh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ P.jsx(Ze, { content: "Copy tracking code", children: /* @__PURE__ */ P.jsx(
      ye,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, fG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ye,
        {
          size: 14,
          name: "file-text",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ P.jsx(Xe.Item, { className: pt.listItem, children: /* @__PURE__ */ P.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ P.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ P.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Jl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, hG = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ye,
        {
          size: 14,
          name: "tag",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ P.jsx(
      Xe.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ P.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ P.jsx(
          Ze,
          {
            content: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ P.jsx(b, { children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: Jl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ P.jsx(
          xa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, yG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ P.jsx(
        ye,
        {
          size: 14,
          name: "credit-card",
          className: Lr.orderIconColor
        }
      ),
      /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ P.jsx(Xe, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ P.jsx(
      Xe.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ P.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ P.jsx($.Paragraph, { variant: "5", children: Jn(i?.paidAt).format(jt) }),
                    /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Jl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, gG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = de(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: F
  } = e, j = 14;
  return /* @__PURE__ */ P.jsxs(
    b,
    {
      className: dt(Lr.order, {
        [Lr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ P.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Lr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ P.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ P.jsx(b, { alignItems: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Jn(m).format(jt) }) }),
                /* @__PURE__ */ P.jsx($.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ P.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ P.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ye,
              {
                size: j,
                name: "activity",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ P.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ P.jsx(Ze, { content: "Internal status", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ P.jsx(Ze, { content: "External status", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: s }) }) }),
                /* @__PURE__ */ P.jsx(Ze, { content: "Last updated at", children: /* @__PURE__ */ P.jsx($.Paragraph, { as: "span", variant: "5", children: Jn(u).format(jt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ye,
              {
                size: j,
                name: "chart-bar",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: Jl({
                value: F,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ P.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ P.jsx(
              ye,
              {
                size: j,
                name: "channels",
                className: Lr.orderIconColor
              }
            ),
            /* @__PURE__ */ P.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "info", children: /* @__PURE__ */ P.jsx(P.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ P.jsx(tw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ P.jsx(
            tw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ P.jsx(pG, { delivery: e.delivery }),
          /* @__PURE__ */ P.jsx(hG, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ P.jsx(fG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ P.jsx(
            yG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, vG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || ba({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: e }) : /* @__PURE__ */ P.jsx(P.Fragment, { children: r }), kG = ({
  contactId: e
}) => {
  const { useQuery: n } = yn(), [r, i] = de([]), { track: a } = Fn(), {
    loading: o,
    error: s,
    data: l
  } = n(pK, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ P.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ P.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ P.jsx(Bn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsx(vG, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ P.jsx(
      gG,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, bG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = _K({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: F
  } = n;
  return s ? /* @__PURE__ */ P.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ P.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? ba({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ P.jsx(Tn, { error: o }) : !d && !m && !u && !f && !h && !k ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ P.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ P.jsx(hn, {}) }) : /* @__PURE__ */ P.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ P.jsx(MK, { contactId: i, settings: n }),
        h && /* @__PURE__ */ P.jsx(oG, { contactId: i }),
        k && /* @__PURE__ */ P.jsx(ZK, { contactId: i }),
        F && /* @__PURE__ */ P.jsx(kG, { contactId: i }),
        !l && /* @__PURE__ */ P.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ P.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, py = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], xG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, _G = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: xG
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = dr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: F,
    error: j,
    isWidgetUnknown: N,
    refetch: x,
    widgetConfiguration: g
  } = ur({
    integrationId: e,
    fieldDefinitions: py,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: C } = mr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), w = (B) => fr(B, {
    fieldDefinitions: py,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: C
  }), A = s.watch("name");
  return /* @__PURE__ */ P.jsxs(
    pr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: w,
      error: j ?? f,
      onRetry: j ? x : void 0,
      isLoading: u || F,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ P.jsx(hr, { cause: h }),
        /* @__PURE__ */ P.jsxs(nt, { children: [
          /* @__PURE__ */ P.jsx(Z, { children: /* @__PURE__ */ P.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            Er,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(
            An,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show the customer attributes", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show preferences", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show audiences", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show consents", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show the last 5 messages", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show customer transactions", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show orders by contact", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          /* @__PURE__ */ P.jsx(Z, { span: 3, children: /* @__PURE__ */ P.jsx(He, { label: "Show member level", children: /* @__PURE__ */ P.jsx(
            xn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ P.jsx(Z, { span: 3 }),
          a && O !== null && /* @__PURE__ */ P.jsx(Z, { children: a({
            value: O,
            onChange: I,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ P.jsx(
          yr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bh = { exports: {} }, ho = {}, rw;
function SG() {
  if (rw) return ho;
  rw = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var Ts = {}, iw;
function NG() {
  return iw || (iw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), F = Symbol.iterator, j = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = F && t[F] || t[j];
      return typeof c == "function" ? c : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, c, p) {
      {
        var y = x.ReactDebugCurrentFrame, E = y.getStackAddendum();
        E !== "" && (c += "%s", p = p.concat([E]));
        var D = p.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, C = !1, w = !1, A = !1, B = !1, K;
    K = /* @__PURE__ */ Symbol.for("react.module.reference");
    function ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || B || t === a || t === m || t === u || A || t === k || I || C || w || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === K || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var E = c.displayName || c.name || "";
      return E !== "" ? p + "(" + E + ")" : p;
    }
    function H(t) {
      return t.displayName || "Context";
    }
    function R(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return H(c) + ".Consumer";
          case s:
            var p = t;
            return H(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : R(t.type) || "Memo";
          case h: {
            var E = t, D = E._payload, S = E._init;
            try {
              return R(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, te = 0, we, ve, ue, ge, U, be, $e;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ge() {
      {
        if (te === 0) {
          we = console.log, ve = console.info, ue = console.warn, ge = console.error, U = console.group, be = console.groupCollapsed, $e = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function sn() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: we
            }),
            info: q({}, t, {
              value: ve
            }),
            warn: q({}, t, {
              value: ue
            }),
            error: q({}, t, {
              value: ge
            }),
            group: q({}, t, {
              value: U
            }),
            groupCollapsed: q({}, t, {
              value: be
            }),
            groupEnd: q({}, t, {
              value: $e
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Fe = x.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (E) {
            var y = E.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ce(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var E = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Fe.current, Fe.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ie) {
              y = ie;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ie) {
              y = ie;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ie) {
            y = ie;
          }
          t();
        }
      } catch (ie) {
        if (ie && y && typeof ie.stack == "string") {
          for (var _ = ie.stack.split(`
`), ne = y.stack.split(`
`), L = _.length - 1, M = ne.length - 1; L >= 1 && M >= 0 && _[L] !== ne[M]; )
            M--;
          for (; L >= 1 && M >= 0; L--, M--)
            if (_[L] !== ne[M]) {
              if (L !== 1 || M !== 1)
                do
                  if (L--, M--, M < 0 || _[L] !== ne[M]) {
                    var ce = `
` + _[L].replace(" at new ", " at ");
                    return t.displayName && ce.includes("<anonymous>") && (ce = ce.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ce), ce;
                  }
                while (L >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Fe.current = D, sn(), Error.prepareStackTrace = E;
      }
      var ze = t ? t.displayName || t.name : "", Oe = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Oe), Oe;
    }
    function Me(t, c, p) {
      return Ce(t, !1);
    }
    function nn(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function se(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ce(t, nn(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return se(t.type, c, p);
          case h: {
            var y = t, E = y._payload, D = y._init;
            try {
              return se(D(E), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, Se = {}, Le = x.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function gn(t, c, p, y, E) {
      {
        var D = Function.call.bind(le);
        for (var S in t)
          if (D(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              _ = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              _ = L;
            }
            _ && !(_ instanceof Error) && (Pe(E), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof _), Pe(null)), _ instanceof Error && !(_.message in Se) && (Se[_.message] = !0, Pe(E), g("Failed %s type: %s", p, _.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return ae(t), !1;
      } catch {
        return !0;
      }
    }
    function ae(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ae(t);
    }
    var Q = x.ReactCurrentOwner, me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, _e, Te;
    function tn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function vn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function on(t, c) {
      typeof t.ref == "string" && Q.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          _e || (_e = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function In(t, c) {
      {
        var p = function() {
          Te || (Te = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, E, D, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function En(t, c, p, y, E) {
      {
        var D, S = {}, _ = null, ne = null;
        p !== void 0 && (V(p), _ = "" + p), vn(c) && (V(c.key), _ = "" + c.key), tn(c) && (ne = c.ref, on(c));
        for (D in c)
          le.call(c, D) && !me.hasOwnProperty(D) && (S[D] = c[D]);
        if (t && t.defaultProps) {
          var L = t.defaultProps;
          for (D in L)
            S[D] === void 0 && (S[D] = L[D]);
        }
        if (_ || ne) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && pn(S, M), ne && In(S, M);
        }
        return _n(t, _, ne, E, y, Q.current, S);
      }
    }
    var en = x.ReactCurrentOwner, kn = x.ReactDebugCurrentFrame;
    function Ve(t) {
      if (t) {
        var c = t._owner, p = se(t.type, t._source, c ? c.type : null);
        kn.setExtraStackFrame(p);
      } else
        kn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function un(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function jn() {
      {
        if (en.current) {
          var t = R(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var Nn = {};
    function Pn(t) {
      {
        var c = jn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function bn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Pn(c);
        if (Nn[p])
          return;
        Nn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== en.current && (y = " It was passed a child from " + R(t._owner.type) + "."), Ve(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Ve(null);
      }
    }
    function Sn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            un(y) && bn(y, c);
          }
        else if (un(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var E = N(t);
          if (typeof E == "function" && E !== t.entries)
            for (var D = E.call(t), S; !(S = D.next()).done; )
              un(S.value) && bn(S.value, c);
        }
      }
    }
    function Ln(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = R(c);
          gn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !dn) {
          dn = !0;
          var E = R(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", E || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Ve(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Ve(null);
            break;
          }
        }
        t.ref !== null && (Ve(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    var Cn = {};
    function wn(t, c, p, y, E, D) {
      {
        var S = ee(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? _ += ne : _ += jn();
          var L;
          t === null ? L = "null" : T(t) ? L = "array" : t !== void 0 && t.$$typeof === n ? (L = "<" + (R(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : L = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, _);
        }
        var M = En(t, c, p, E, D);
        if (M == null)
          return M;
        if (S) {
          var ce = c.children;
          if (ce !== void 0)
            if (y)
              if (T(ce)) {
                for (var ze = 0; ze < ce.length; ze++)
                  Sn(ce[ze], t);
                Object.freeze && Object.freeze(ce);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sn(ce, t);
        }
        if (le.call(c, "key")) {
          var Oe = R(t), ie = Object.keys(c).filter(function(Gn) {
            return Gn !== "key";
          }), mn = ie.length > 0 ? "{key: someKey, " + ie.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Oe + mn]) {
            var On = ie.length > 0 ? "{" + ie.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, mn, Oe, On, Oe), Cn[Oe + mn] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, c, p) {
      return wn(t, c, p, !0);
    }
    function Hn(t, c, p) {
      return wn(t, c, p, !1);
    }
    var Un = Hn, Kn = zn;
    Ts.Fragment = i, Ts.jsx = Un, Ts.jsxs = Kn;
  })()), Ts;
}
var aw;
function jG() {
  return aw || (aw = 1, process.env.NODE_ENV === "production" ? bh.exports = SG() : bh.exports = NG()), bh.exports;
}
var Ne = jG();
const wG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, CG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": wG
};
function FG(e) {
  return CG[e] ?? {};
}
const IG = FG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), EG = "_copyIcon_1pfts_54", $G = "_list_1pfts_59", TG = "_listItem_1pfts_69", DG = "_listItemHighlighted_1pfts_78", ka = {
  copyIcon: EG,
  list: $G,
  listItem: TG,
  listItemHighlighted: DG
}, OG = "_wrapper_1xucg_1", RG = "_externalLink_1xucg_7", xh = {
  wrapper: OG,
  externalLink: RG
}, PG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Qt(), { isCopied: i, copy: a } = Qt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: xh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "space-between",
        className: xh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: Jn(m).format(jt) })
    ] }),
    l && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(ye, { size: u, name: "mail" }),
        /* @__PURE__ */ Ne.jsx("span", { className: xh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ze, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        ye,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ka.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(ye, { size: u, name: "phone" }),
        /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Ne.jsx(Ze, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        ye,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: ka.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = gw(n);
  return /* @__PURE__ */ Ne.jsx(
    Xe.Text,
    {
      variant: "dense",
      className: dt(ka.listItem, {
        [ka.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ne.jsx(Ze, { content: r, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Li(n)
      ] }) })
    }
  );
}, AG = ({
  loyalty: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Xe, { className: ka.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), LG = 0.8, VG = 0.4, ow = (e) => {
  if (e != null)
    return e >= LG ? /* @__PURE__ */ Ne.jsx(Bn, { variant: "success", size: "small", children: "Positive" }) : e <= VG ? /* @__PURE__ */ Ne.jsx(Bn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ne.jsx(Bn, { variant: "warning", size: "small", children: "Neutral" });
}, zG = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Xe, { className: ka.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: ow(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: ow(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Jn(e.last_review_date).format(
          jt
        )
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ne.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ne.jsx(Bn, { variant: "info", size: "small", children: /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), UG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = yn(), { track: i } = Fn(), [a, o] = de(), [s, l] = de(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showUserGeneratedContent ?? !1, F = n?.displayLoyalty ?? !1, j = n?.displaySubscriptions ?? !1, N = !f, x = !h && !k && !F && !j, {
    loading: g,
    error: O,
    data: I
  } = r(IG, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Qe(() => {
    const C = I?.Yotpo?.getCustomers?.customers?.[0];
    C ? (o(C), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [I?.Yotpo, g]), N)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(
      Tn,
      {
        error: new jw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (x)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(hn, {}) });
  if (s)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (O) {
    const C = O.graphQLErrors;
    return xl({ errors: C }) ? /* @__PURE__ */ Ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : _l({ errors: C }) ? /* @__PURE__ */ Ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx(Tn, { error: O });
  }
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ne.jsx(PG, { customerDetails: a }),
        k && /* @__PURE__ */ Ne.jsx(
          zG,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        F && /* @__PURE__ */ Ne.jsx(AG, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, MG = "_settingsWrapper_1ycvy_1", BG = "_settingsWrapperHeader_1ycvy_6", qG = "_settingsWrapperContent_1ycvy_10", HG = "_settingsWrapperContentCode_1ycvy_18", WG = "_settingsWrapperContentCURL_1ycvy_26", yo = {
  settingsWrapper: MG,
  settingsWrapperHeader: BG,
  settingsWrapperContent: qG,
  settingsWrapperContentCode: HG,
  settingsWrapperContentCURL: WG
}, MF = ({
  handleChangeText: e
}) => {
  const [n, r] = de(!1), { isCopied: i, copy: a } = Qt(), { control: o } = mt({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = fi({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = yt(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(Z, { span: 6, children: /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", className: yo.settingsWrapper, children: [
    /* @__PURE__ */ Ne.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: yo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ne.jsx(ye, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ne.jsxs(
      b,
      {
        flexDirection: "column",
        className: yo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ne.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ne.jsx(
            jl,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ne.jsxs("ol", { children: [
                /* @__PURE__ */ Ne.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ne.jsx("span", { className: yo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ne.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(
            xt,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                tr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            xt,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                tr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(He, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ne.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: yo.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ne.jsx(
              Ze,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ne.jsx(
                  et,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, kl = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], KG = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: hi
  }
], GG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: MF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], _h = "YOTPO", YG = {
  enabled: !1,
  name: "",
  ...Sl(
    [],
    kl
  )
}, QG = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: YG
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: F
  } = dr({
    integrationId: e,
    integrationType: _h,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: j,
    error: N,
    isWidgetUnknown: x,
    refetch: g,
    widgetConfiguration: O
  } = ur({
    integrationId: e,
    fieldDefinitions: kl,
    form: l,
    onMisconfigured: F
  }), { renderConditions: I, setRenderConditions: C, renderConditionsForSubmit: w } = mr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), A = s || !!O?.additionalProperties?.isUsingOAuth, B = (ee) => fr(ee, {
    fieldDefinitions: kl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: w
  }), K = l.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    pr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: B,
      error: N ?? h,
      onRetry: N ? g : void 0,
      isLoading: f || j,
      isWidgetUnknown: x,
      children: [
        k && /* @__PURE__ */ Ne.jsx(hr, { cause: k }),
        /* @__PURE__ */ Ne.jsxs(nt, { children: [
          /* @__PURE__ */ Ne.jsx(Z, { children: /* @__PURE__ */ Ne.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            xn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            An,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          !A && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(
              MF,
              {
                handleChangeText: (ee) => l.setValue("yotpoStoreId", ee?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              An,
              {
                name: "yotpoStoreId",
                label: "Yotpo store ID",
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              Er,
              {
                name: "yotpoAccessToken",
                label: "Yotpo access token",
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: "Show customer details", children: /* @__PURE__ */ Ne.jsx(
            xn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: "Show user generated content", children: /* @__PURE__ */ Ne.jsx(
            xn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: "Show loyalty data", children: /* @__PURE__ */ Ne.jsx(
            xn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(Z, { span: 3 }),
          A && !s && e && /* @__PURE__ */ Ne.jsx(
            hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: _h,
              label: "Authorize with OAuth"
            }
          ),
          o && I !== null && /* @__PURE__ */ Ne.jsx(Z, { children: o({
            value: I,
            onChange: C,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          yr,
          {
            integrationType: _h,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, JG = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, XG = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, ZG = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: NW,
  featureSettings: []
} : n ? {
  authSettings: jW,
  featureSettings: [...jF]
} : e ? {
  authSettings: [
    ...$j,
    ..._W
  ],
  featureSettings: [...Tj]
} : {
  authSettings: [
    ...$j,
    ...SW
  ],
  featureSettings: [...Tj]
}, BF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, e8 = BF(
  KG,
  GG
), n8 = BF(
  bV,
  xV
), qF = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = XG(a?.value, r), s = i !== void 0 ? i : JG(
    r
  );
  return o !== void 0 ? o : s;
}, qg = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = ZG(n), s = e8(r), l = n8(i);
  return {
    SHOPIFY: {
      widget: B7,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: vl,
      WidgetSettings: kW,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: M2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Ph,
      WidgetSettings: H2
    },
    GITHUB: {
      widget: qP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Dh,
      WidgetSettings: WP
    },
    MIUROS: {
      widget: IB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: ny,
      WidgetSettings: $B
    },
    KLAVIYO: {
      widget: fV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: sl,
      WidgetSettings: SV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: G4,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Jh,
      WidgetSettings: Q4
    },
    VOYADO: {
      widget: bG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: py,
      WidgetSettings: _G
    },
    LOYALTYLION: {
      widget: C5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Xh,
      WidgetSettings: I5
    },
    RECHARGE: {
      widget: tq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: iy,
      WidgetSettings: iq
    },
    BRAZE: {
      widget: gR,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: il,
      WidgetSettings: kR
    },
    YOTPO: {
      widget: UG,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: kl,
      WidgetSettings: QG,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: kA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Oh,
      WidgetSettings: xA
    },
    RIVOLOYALTY: {
      widget: Mq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: oy,
      WidgetSettings: sW
    }
  };
}, t8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? mI(r, e.defaultValue) : pI(r, e.defaultValue);
}, r8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: t8(r, n)
})), i8 = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: qF({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), a8 = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? r8(
  e.filter(({ secret: i }) => !i),
  r
) : i8(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), o8 = (e) => {
  const n = qg();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: a8(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, tY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = ri(
    {}
  ), h = (w) => (f.current[w] || (f.current[w] = { current: null }), f.current[w]), { track: k } = Fn(), F = Yn(
    () => o8(e),
    [e]
  ), j = {
    headline: "",
    text: "",
    onConfirm: () => C(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, x] = de(j), [g, O] = de(!1), I = (w) => {
    O(!0), x(w);
  }, C = () => {
    O(!1), x(j);
  };
  return /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    F.map(
      ({
        id: w,
        name: A,
        type: B,
        widget: K,
        settings: ee,
        misconfigured: G,
        renderConditions: H,
        icon: R,
        iconColors: q,
        integrationKey: te
      }, we) => {
        const ve = `partner-integration-${B}`, ue = u?.get(w) === !1, ge = /* @__PURE__ */ Ke.jsx(yy, { icon: R, color: q }), U = ee?.reduce(
          (be, $e) => (be[$e.key] = $e.value, be),
          {}
        );
        return s ? /* @__PURE__ */ Ke.jsx("div", { className: "icon-holder", children: ge }, `partner-icon-${w}`) : /* @__PURE__ */ Ke.jsxs(
          xr,
          {
            onToggle: () => {
              k(
                o(te) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: w,
                  widgetType: B.toLowerCase()
                }
              ), a(te);
            },
            isOpen: o(te),
            className: ve,
            containerRef: (be) => {
              h(te).current = be;
            },
            children: [
              /* @__PURE__ */ Ke.jsx(
                xr.Header,
                {
                  className: dt({
                    [$T.unmatchedHeader]: ue
                  }),
                  wrap: "normal",
                  avatar: ge,
                  slotBeforeTitle: d?.(
                    te,
                    we,
                    h(te)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ke.jsx(Ke.Fragment, { children: l?.(te) }),
                  children: /* @__PURE__ */ Ke.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    A,
                    m?.(
                      H ?? [],
                      w
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ke.jsx(xr.Content, { children: G ? /* @__PURE__ */ Ke.jsx(Tn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ke.jsx(
                _w.Provider,
                {
                  value: {
                    onError: (be, $e) => console.warn(
                      `Something went wrong with a partner widget of type '${B}' and id '${w}'`,
                      be,
                      $e
                    )
                  },
                  children: /* @__PURE__ */ Ke.jsx(
                    iC,
                    {
                      integrationId: w,
                      type: B,
                      configuration: n,
                      showNotification: i,
                      showModal: I,
                      children: _I(K, {
                        conversationContext: r,
                        settings: U
                      })
                    }
                  )
                }
              ) })
            ]
          },
          te
        );
      }
    ),
    /* @__PURE__ */ Ke.jsx(
      yw,
      {
        isOpen: g,
        setIsOpen: O,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            O(!1), x(j);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            O(!1), x(j);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, s8 = Fl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function rY(e, { skip: n = !1 } = {}) {
  const [r, i] = de([]), [a, o] = de(!1);
  return Qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), rC(e).query({
      query: s8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const l8 = ({
  widgetConfiguration: e
}) => {
  const n = Yn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Yn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, c8 = "FULL_ACCESS", d8 = "2", u8 = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [c8],
        version: d8
      })
    }).then((l) => l.json())
  };
}, m8 = "dixaApiToken", Hg = "dixaApiTokenId", HF = "dixaApiTokenName", sw = (e) => [Hg, HF].every(
  (r) => e.find((i) => i?.key === r)
);
function p8({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = f8(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const f8 = (e) => [
  {
    key: m8,
    value: e.value,
    secret: !0
  },
  {
    key: Hg,
    value: e.id,
    secret: !1
  },
  {
    key: HF,
    value: e.name,
    secret: !1
  }
], h8 = "_wrapper_1lmim_1", y8 = "_wrapperBox_1lmim_4", g8 = "_wrapperBoxErrorBorder_1lmim_9", Sh = {
  wrapper: h8,
  wrapperBox: y8,
  wrapperBoxErrorBorder: g8
}, v8 = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (O) => O.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: k } = f, F = `Insert your ${h.label.toLowerCase()}`, j = `Insert your ${k.label.toLowerCase()}`, [N, x] = de({
    username: "",
    password: ""
  }), g = yt(
    (O) => {
      m({
        target: {
          name: s,
          value: O
        }
      });
    },
    [s, m]
  );
  return Qe(() => {
    g(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ke.jsx(
    He,
    {
      required: e,
      label: a,
      meta: l,
      className: Sh.wrapper,
      children: /* @__PURE__ */ Ke.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: dt(Sh.wrapperBox, {
            [Sh.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: F,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (O) => x({
                    username: O?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ke.jsx(
              tr,
              {
                noAlert: !0,
                required: e,
                label: k.label,
                readOnly: n,
                placeholder: j,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (O) => x({
                    username: N.username,
                    password: O?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function lw({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: k,
  isCreationMode: F,
  prefix: j,
  integrationId: N,
  integrationType: x,
  configuration: g,
  settings: O,
  otherProps: I
}) {
  const C = k === "custom" && I?.component, w = u(n)?.value;
  return C ? /* @__PURE__ */ Ke.jsx(
    C,
    {
      configuration: g,
      integrationId: N,
      integrationType: x,
      label: r,
      settings: O,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
    /* @__PURE__ */ Ke.jsx(Z, { span: 3, children: /* @__PURE__ */ Ke.jsx(
      k8,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: F,
        children: k === "input" ? /* @__PURE__ */ Ke.jsx(
          tr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: w,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: j,
            ...e && !F && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : k === "basicAuthInput" ? /* @__PURE__ */ Ke.jsx(
          v8,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: F,
            label: r,
            widgetSettingsKey: n,
            settings: O,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : k === "switch" ? /* @__PURE__ */ Ke.jsx(He, { label: r, children: /* @__PURE__ */ Ke.jsx(
          wl,
          {
            input: {
              name: n,
              value: "",
              checked: w,
              onChange: l
            }
          }
        ) }) : k === "select" ? /* @__PURE__ */ Ke.jsx(He, { label: r, children: /* @__PURE__ */ Ke.jsx(
          ni,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (A) => d(n, A),
            getItemTitleByValue: (A) => A ? /* @__PURE__ */ Ke.jsx($.Paragraph, { children: A.label }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {}),
            value: w ? [
              {
                label: (I?.selectItems || []).find(
                  (A) => A.value === w
                )?.label,
                value: w
              }
            ] : [],
            equalityFn: (A, B) => A.value === B.value,
            children: (I?.selectItems || []).map((A) => /* @__PURE__ */ Ke.jsx(ut.Item, { value: A, children: A.label }, A.value))
          }
        ) }) : /* @__PURE__ */ Ke.jsx(Ke.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ke.jsx(Z, { span: 3 })
  ] });
}
function k8({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ke.jsx(He, { label: n, children: /* @__PURE__ */ Ke.jsxs(
    et,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Fo = "partner-integrations-widget-name-form-field", cw = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: qF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), b8 = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = de(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = de({}), s = (I) => i(I), l = (I) => !I || I === "", d = (I) => {
    const { [I]: C, ...w } = a;
    o(w);
  }, m = (I) => ({
    ...I,
    settings: I.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: w, secret: A }) => ({
      key: C,
      value: w,
      secret: A
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (I) => {
    if (!I)
      return;
    const {
      target: { name: C, value: w }
    } = I;
    a[C] && !l(w) && d(C), i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === C ? { ...A, value: w } : A
      )
    });
  }, h = (I) => {
    if (!I)
      return;
    const {
      target: { name: C, checked: w }
    } = I;
    i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === C ? { ...A, value: w } : A
      )
    });
  }, k = (I, C) => {
    if (!C)
      return;
    const { selectedValues: w } = C, A = w?.[0];
    if (A) {
      const B = r.settings.map(
        (K) => K.key === I ? { ...K, value: A?.value } : K
      );
      i({
        ...r,
        settings: B
      });
    } else {
      const B = r.settings.filter(
        (K) => K.key !== I
      );
      i({
        ...r,
        settings: B
      });
    }
  }, F = (I) => {
    i({
      ...r,
      enabled: I
    });
  }, j = (I) => {
    if (!I)
      return;
    const {
      target: { value: C }
    } = I;
    a[Fo] && !l(C) && d(Fo), i({
      ...r,
      name: C
    });
  }, N = (I, C) => {
    const { settings: w } = r, A = w.map((B) => B.key === C ? {
      ...B,
      isEditing: I,
      ...!I && { value: "" }
    } : B);
    a[C] && !I && d(C), i({
      ...r,
      settings: A
    });
  }, x = (I) => r.settings.find(
    (C) => C.key === I
  ), g = async (I) => {
    I.preventDefault(), O() && n(m(r));
  }, O = () => {
    const I = {}, { name: C, settings: w } = r;
    return l(C) && (I[Fo] = u.input), w.forEach(
      ({ key: A, value: B, required: K, isEditing: ee, type: G, customValidation: H }) => {
        if (K && ee)
          if (H) {
            const R = H(B);
            typeof R == "string" && (I[A] = R);
          } else
            typeof B == "string" && l(B) && (I[A] = u[G]);
      }
    ), o(I), !Object.keys(I)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: F,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: k,
    handleEditSecret: N,
    handleChangeName: j,
    handleSubmit: g,
    getSettingValueByKey: x,
    initializeFormData: s,
    validate: O
  };
}, x8 = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], dw = "The configuration of the integration is not correct. Please check the settings.", _8 = (e) => {
  const n = qg()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ke.jsx(n, { ...e }) : /* @__PURE__ */ Ke.jsx(S8, { ...e });
}, S8 = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = Fn(), { deleteDixaApiToken: d, createDixaApiToken: m } = u8({
    type: n,
    baseUrl: a.baseUrl
  }), f = AI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, k = x8.includes(n), [F, j] = de(), [N, x] = de(!1), [g, O] = de(!1), [I, C] = de(!1), [w, A] = de(null), [B, K] = de(), [ee, G] = de(h ? [] : null);
  Qe(() => {
    G(h ? [] : null);
  }, [e, h]), Qe(() => {
    B && ee === null && G(B.renderConditions ?? []);
  }, [B, ee]);
  const { isInboundOAuth: H } = fI(), R = H && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: q,
    isShopifyMarketplaceApp: te,
    initialValuesForShopify: we
  } = l8({
    featureFlags: a.featureFlags,
    widgetConfiguration: B
  }), ve = n === "YOTPO" && !!B?.additionalProperties?.isUsingOAuth, ue = n === "KLAVIYO" && !!B?.additionalProperties?.isUsingOAuth, ge = h && n === "SHOPIFY", $e = qg({
    SHOPIFY: {
      hasShopifyOAuth: q,
      isShopifyMarketplaceApp: te,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: ve,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ue,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], W = $e.filter(({ type: X }) => X !== "hidden").filter(({ hideOnCreate: X }) => h ? !X : !0), Ge = W.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm === !0
  ), sn = W.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm !== !0
  ), {
    error: Fe,
    loading: Ue,
    refetch: Re
  } = OI(hI, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (X) => {
      if (Object.keys(X).length === 0)
        C(!0);
      else {
        C(!1);
        const ae = X?.Management?.widgetConfigurations?.[0];
        ae && K({
          ...ae,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${ae.id}`,
          additionalProperties: ae.additionalProperties ?? void 0
        });
      }
    }
  }), [Be, { error: Ae }] = Zg(
    h ? yI : gI,
    {
      onError: (X) => {
        j(X), x(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (X) => {
        if (x(!1), Object.keys(X).length !== 0) {
          if (h && r(
            X.Management?.createWidgetConfiguration?.id
          ), !h) {
            const V = X.Management?.updateWidgetConfiguration;
            V?.misconfigured ? A(
              V.misconfigurationCause ?? dw
            ) : A(null);
          }
          if ((h || s) && ee) {
            const ae = (B?.renderConditions?.length ?? 0) > 0;
            vI(
              l,
              h,
              ee,
              ae
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [Je] = Zg(kI, {
    onError: (X) => {
      j(X), x(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      x(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ce,
    handleIsEnabled: Me,
    errors: nn,
    handleChangeText: se,
    handleChangeBoolean: le,
    handleChangeSelect: Se,
    handleEditSecret: Le,
    handleChangeName: Pe,
    handleSubmit: gn,
    getSettingValueByKey: J,
    initializeFormData: T
  } = b8({
    onSubmit: async (X) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), x(!0);
      const ae = X.settings.map(
        (_e) => typeof _e.value == "boolean" ? { ..._e, value: _e.value.toString() } : _e
      ), V = sw(ae) && h;
      let Q = [];
      if (V) {
        const _e = await m().catch(
          (Te) => {
            x(!1), console.warn("API-Token (creation) error resonse", Te), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        _e?.data && (Q = p8({
          token: _e.data,
          settings: ae
        }));
      }
      const me = {
        ...X,
        settings: [
          ...Q.length > 0 ? Q : ae
        ]
      };
      (V && Q.length > 1 || !V && Q.length === 0) && (Be({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...me,
          ...(h || !!s) && ee !== null && { renderConditions: ee }
        }
      }), ae.forEach(
        (Te) => Te.secret && Le(!1, Te.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: cw({
          settingsFromBackend: we,
          settingsConfiguration: $e,
          creating: !0
        })
      }
    }
  });
  Qe(() => {
    if (B) {
      const X = cw({
        settingsFromBackend: B.settings,
        settingsConfiguration: $e
      });
      T({
        enabled: !!B.enabled,
        name: B.name,
        settings: X
      }), B.misconfigured ? A(
        B?.misconfigurationCause ?? dw
      ) : A(null);
    }
  }, [B]);
  const z = Yn(() => o ? !o.isCoupled : !0, [o]);
  return Fe || Ae || F ? /* @__PURE__ */ Ke.jsx(
    Tn,
    {
      error: Fe || F,
      retry: Fe ? Re : void 0
    }
  ) : N || Ue ? /* @__PURE__ */ Ke.jsx(hn, { "data-testid": "widget-settings-loading" }) : I ? /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ke.jsx(Qn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ke.jsxs("form", { children: [
    w && /* @__PURE__ */ Ke.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ke.jsx(
      jl,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ke.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ke.jsx($.Paragraph, { children: w }),
          /* @__PURE__ */ Ke.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ke.jsx($.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ke.jsx($.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ke.jsxs(
      nt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          Ge.map(
            ({ key: X, label: ae, ...V }) => /* @__PURE__ */ Ke.jsx(
              lw,
              {
                widgetSettingsKey: X,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: J,
                isSecret: !1,
                label: ae,
                placeholder: "",
                required: !1,
                errors: nn,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: $e,
                otherProps: V
              },
              X
            )
          ),
          !ge && /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
            /* @__PURE__ */ Ke.jsx(Z, { children: /* @__PURE__ */ Ke.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ke.jsx(
              wl,
              {
                input: {
                  name: "enabled",
                  checked: Ce.enabled,
                  value: "dummy",
                  onChange: (X) => Me(X.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ke.jsx(Z, { span: 3, children: /* @__PURE__ */ Ke.jsx(
              tr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Fo,
                  value: Ce.name,
                  onChange: Pe
                },
                meta: {
                  error: nn[Fo]
                }
              }
            ) }),
            /* @__PURE__ */ Ke.jsx(Z, { span: 3 })
          ] }),
          !ge && s && ee !== null && /* @__PURE__ */ Ke.jsx(Z, { children: s({
            value: ee,
            onChange: G,
            configurationKey: B?.id
          }) }),
          sn?.map(
            ({
              key: X,
              secret: ae,
              label: V,
              placeholder: Q = "",
              required: me = !1,
              type: _e,
              prefix: Te,
              readOnly: tn,
              ...vn
            }) => {
              const { settings: on } = Ce, pn = on.find(
                (In) => In.key === X
              );
              return /* @__PURE__ */ Ke.jsx(vw, { children: /* @__PURE__ */ Ke.jsx(
                lw,
                {
                  widgetSettingsKey: X,
                  isEditingField: !!pn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: se,
                  handleChangeBoolean: le,
                  handleChangeSelect: Se,
                  getValueByKey: J,
                  isSecret: ae,
                  label: V,
                  placeholder: Q,
                  required: me,
                  errors: nn,
                  type: _e,
                  isCreationMode: h,
                  prefix: Te,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: tn,
                  settings: $e,
                  otherProps: vn
                }
              ) }, X);
            }
          )
        ]
      }
    ),
    !ge && /* @__PURE__ */ Ke.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ke.jsx(et, { onClick: gn, children: R }),
      !h && /* @__PURE__ */ Ke.jsx(
        Ze,
        {
          content: "The widget is used in automations",
          disabled: z,
          children: /* @__PURE__ */ Ke.jsx(
            et,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), O(!0);
              },
              disabled: !z,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ke.jsx(
      yw,
      {
        isOpen: g,
        setIsOpen: O,
        confirmVariant: k ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), sw(Ce.settings)) {
            const X = Ce.settings.find(
              ({ key: ae }) => ae === Hg
            )?.value;
            X && d(X).catch((ae) => {
              console.warn("API-Token (deletion) error response", ae), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          Je({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ke.jsx(b, { children: k ? /* @__PURE__ */ Ke.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ke.jsx(
            ye,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ke.jsxs($.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ke.jsxs($.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ce.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ke.jsxs(Ke.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ce.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, iY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ke.jsx(
  _w.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ Ke.jsx(
      iC,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ke.jsx(
          _8,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), uw = "__PairingContext__", WF = globalThis[uw] ?? (() => {
  const e = kw({});
  return globalThis[uw] = e, e;
})(), aY = () => hy(WF), oY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ke.jsx(WF.Provider, { value: e, children: n });
var Ds = { exports: {} }, mw;
function N8() {
  if (mw) return Ds.exports;
  mw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, w, A) {
    return Function.prototype.apply.call(C, w, A);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : r = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i(I) {
    console && console.warn && console.warn(I);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  Ds.exports = o, Ds.exports.once = x, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(I) {
    if (typeof I != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof I);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(I) {
      if (typeof I != "number" || I < 0 || a(I))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + I + ".");
      s = I;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function d(I) {
    return I._maxListeners === void 0 ? o.defaultMaxListeners : I._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(C) {
    for (var w = [], A = 1; A < arguments.length; A++) w.push(arguments[A]);
    var B = C === "error", K = this._events;
    if (K !== void 0)
      B = B && K.error === void 0;
    else if (!B)
      return !1;
    if (B) {
      var ee;
      if (w.length > 0 && (ee = w[0]), ee instanceof Error)
        throw ee;
      var G = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw G.context = ee, G;
    }
    var H = K[C];
    if (H === void 0)
      return !1;
    if (typeof H == "function")
      n(H, this, w);
    else
      for (var R = H.length, q = F(H, R), A = 0; A < R; ++A)
        n(q[A], this, w);
    return !0;
  };
  function m(I, C, w, A) {
    var B, K, ee;
    if (l(w), K = I._events, K === void 0 ? (K = I._events = /* @__PURE__ */ Object.create(null), I._eventsCount = 0) : (K.newListener !== void 0 && (I.emit(
      "newListener",
      C,
      w.listener ? w.listener : w
    ), K = I._events), ee = K[C]), ee === void 0)
      ee = K[C] = w, ++I._eventsCount;
    else if (typeof ee == "function" ? ee = K[C] = A ? [w, ee] : [ee, w] : A ? ee.unshift(w) : ee.push(w), B = d(I), B > 0 && ee.length > B && !ee.warned) {
      ee.warned = !0;
      var G = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      G.name = "MaxListenersExceededWarning", G.emitter = I, G.type = C, G.count = ee.length, i(G);
    }
    return I;
  }
  o.prototype.addListener = function(C, w) {
    return m(this, C, w, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, w) {
    return m(this, C, w, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(I, C, w) {
    var A = { fired: !1, wrapFn: void 0, target: I, type: C, listener: w }, B = u.bind(A);
    return B.listener = w, A.wrapFn = B, B;
  }
  o.prototype.once = function(C, w) {
    return l(w), this.on(C, f(this, C, w)), this;
  }, o.prototype.prependOnceListener = function(C, w) {
    return l(w), this.prependListener(C, f(this, C, w)), this;
  }, o.prototype.removeListener = function(C, w) {
    var A, B, K, ee, G;
    if (l(w), B = this._events, B === void 0)
      return this;
    if (A = B[C], A === void 0)
      return this;
    if (A === w || A.listener === w)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete B[C], B.removeListener && this.emit("removeListener", C, A.listener || w));
    else if (typeof A != "function") {
      for (K = -1, ee = A.length - 1; ee >= 0; ee--)
        if (A[ee] === w || A[ee].listener === w) {
          G = A[ee].listener, K = ee;
          break;
        }
      if (K < 0)
        return this;
      K === 0 ? A.shift() : j(A, K), A.length === 1 && (B[C] = A[0]), B.removeListener !== void 0 && this.emit("removeListener", C, G || w);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var w, A, B;
    if (A = this._events, A === void 0)
      return this;
    if (A.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : A[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete A[C]), this;
    if (arguments.length === 0) {
      var K = Object.keys(A), ee;
      for (B = 0; B < K.length; ++B)
        ee = K[B], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (w = A[C], typeof w == "function")
      this.removeListener(C, w);
    else if (w !== void 0)
      for (B = w.length - 1; B >= 0; B--)
        this.removeListener(C, w[B]);
    return this;
  };
  function h(I, C, w) {
    var A = I._events;
    if (A === void 0)
      return [];
    var B = A[C];
    return B === void 0 ? [] : typeof B == "function" ? w ? [B.listener || B] : [B] : w ? N(B) : F(B, B.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function(I, C) {
    return typeof I.listenerCount == "function" ? I.listenerCount(C) : k.call(I, C);
  }, o.prototype.listenerCount = k;
  function k(I) {
    var C = this._events;
    if (C !== void 0) {
      var w = C[I];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function F(I, C) {
    for (var w = new Array(C), A = 0; A < C; ++A)
      w[A] = I[A];
    return w;
  }
  function j(I, C) {
    for (; C + 1 < I.length; C++)
      I[C] = I[C + 1];
    I.pop();
  }
  function N(I) {
    for (var C = new Array(I.length), w = 0; w < C.length; ++w)
      C[w] = I[w].listener || I[w];
    return C;
  }
  function x(I, C) {
    return new Promise(function(w, A) {
      function B(ee) {
        I.removeListener(C, K), A(ee);
      }
      function K() {
        typeof I.removeListener == "function" && I.removeListener("error", B), w([].slice.call(arguments));
      }
      O(I, C, K, { once: !0 }), C !== "error" && g(I, B, { once: !0 });
    });
  }
  function g(I, C, w) {
    typeof I.on == "function" && O(I, "error", C, w);
  }
  function O(I, C, w, A) {
    if (typeof I.on == "function")
      A.once ? I.once(C, w) : I.on(C, w);
    else if (typeof I.addEventListener == "function")
      I.addEventListener(C, function B(K) {
        A.once && I.removeEventListener(C, B), w(K);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof I);
  }
  return Ds.exports;
}
var j8 = N8();
function sY() {
  const e = new j8.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  wT as GraphQLClientProvider,
  WF as PairingContext,
  oY as PairingProvider,
  tY as PartnerIntegrations,
  iY as PartnerIntegrationsSettings,
  qg as getWidgetDefinitions,
  sY as initializePartnerEventEmitter,
  aY as usePairing,
  rY as usePartnerIntegrationWidgetConfigurations,
  l8 as useShopifyConfiguration
};
